/* eslint-disable */
// prettier-ignore
import { Client } from "./client";
import * as m from "../../core/model/model";
import { CountrySubdivision, Day } from "../../core/model/types";
import { convertByKeys } from "./client/normalize";
CountrySubdivision;


export namespace Accounting {
	export namespace AlienDebtController {
		export namespace OutstandingDebts {
			export function Get(org: string): Promise<m.Envelope<m.Core.ViewData.AlienDebt, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/AlienDebt/OutstandingDebts`);
			}
		}
	}
	export namespace AttestationOrgTreeController {
		export namespace GetCompanyUsers {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Accounting.Contract.AttestationOrgTree.AttestationCompanyUserDto[], m.SimpleError>> {
				return Client.get(`/${org}/Accounting/AttestationOrgTree/GetCompanyUsers`);
			}
		}
		export namespace GetOrgTree {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Accounting.Contract.AttestationOrgTree.AttestationOrgTreeDto, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/AttestationOrgTree/GetOrgTree`);
			}
		}
		export namespace GetSettings {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Accounting.Contract.AttestationOrgTree.AttestationSettingsDto, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/AttestationOrgTree/GetSettings`);
			}
		}
		export namespace PreviewImpact {
			export function Post(org: string, request: m.Bokio.Accounting.Contract.AttestationOrgTree.SaveOrgTreeRequestDto): Promise<m.Envelope<m.Bokio.Accounting.Contract.AttestationOrgTree.AttestationTreeImpactPreviewDto, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/AttestationOrgTree/PreviewImpact`, request);
			}
		}
		export namespace SaveOrgTree {
			export function Post(org: string, request: m.Bokio.Accounting.Contract.AttestationOrgTree.SaveOrgTreeRequestDto): Promise<m.Envelope<string, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/AttestationOrgTree/SaveOrgTree`, request);
			}
		}
		export namespace SetEnabled {
			export function Post(org: string, request: m.Bokio.Accounting.Contract.AttestationOrgTree.SetAttestationEnabledRequestDto): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/AttestationOrgTree/SetEnabled`, request);
			}
		}
	}
	export namespace AttestationRequestController {
		export namespace Approve {
			export function Post(org: string, request: m.Bokio.Accounting.Contract.AttestationRequest.ApproveStepApiDto): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/AttestationRequest/Approve`, request);
			}
		}
		export namespace AssignCostOwners {
			export function Post(org: string, request: m.Bokio.Accounting.Contract.AttestationRequest.AssignCostOwnersApiDto): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/AttestationRequest/AssignCostOwners`, request);
			}
		}
		export namespace Deny {
			export function Post(org: string, request: m.Bokio.Accounting.Contract.AttestationRequest.DenyStepApiDto): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/AttestationRequest/Deny`, request);
			}
		}
		export namespace Escalate {
			export function Post(org: string, request: m.Bokio.Accounting.Contract.AttestationRequest.EscalateStepApiDto): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/AttestationRequest/Escalate`, request);
			}
		}
		export namespace GetAssignableCostOwners {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Accounting.Contract.AttestationOrgTree.AttestationAssignableCostOwnerDto[], m.SimpleError>> {
				return Client.get(`/${org}/Accounting/AttestationRequest/GetAssignableCostOwners`);
			}
		}
		export namespace GetForEntity {
			export function Get(org: string, entityType: m.Entities.AttestationFlow.AttestableEntityType, entityId: string): Promise<m.Envelope<m.Bokio.Accounting.Contract.AttestationRequest.AttestationRequestDto[], m.SimpleError>> {
				return Client.get(`/${org}/Accounting/AttestationRequest/GetForEntity`)
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.CreatedAtUtc"}, {"type":"Date","key":"Data.CompletedAtUtc"}, {"type":"Date","key":"Data.Steps.ActionAtUtc"}, {"type":"Date","key":"Data.Steps.DeadlineUtc"}, {"type":"Date","key":"Data.Steps.CreatedAtUtc"}));
			}
		}
		export namespace IsEnabled {
			export function Get(org: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/AttestationRequest/IsEnabled`);
			}
		}
		export namespace Reassign {
			export function Post(org: string, request: m.Bokio.Accounting.Contract.AttestationRequest.ReassignCostOwnerApiDto): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/AttestationRequest/Reassign`, request);
			}
		}
	}
	export namespace AttestationSimulatorController {
		export namespace CleanupSimulations {
			export function Post(org: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/AttestationSimulator/CleanupSimulations`, {  });
			}
		}
		export namespace CreateSimulation {
			export function Post(org: string, request: m.Bokio.Accounting.Contract.AttestationSimulator.CreateSimulationRequestDto): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/AttestationSimulator/CreateSimulation`, request);
			}
		}
		export namespace GetSimulations {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Accounting.Contract.AttestationRequest.AttestationRequestDto[], m.SimpleError>> {
				return Client.get(`/${org}/Accounting/AttestationSimulator/GetSimulations`)
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.CreatedAtUtc"}, {"type":"Date","key":"Data.CompletedAtUtc"}, {"type":"Date","key":"Data.Steps.ActionAtUtc"}, {"type":"Date","key":"Data.Steps.DeadlineUtc"}, {"type":"Date","key":"Data.Steps.CreatedAtUtc"}));
			}
		}
		export namespace SimulateApprove {
			export function Post(org: string, request: m.Bokio.Accounting.Contract.AttestationSimulator.SimulationActionRequestDto): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/AttestationSimulator/SimulateApprove`, request);
			}
		}
		export namespace SimulateDeny {
			export function Post(org: string, request: m.Bokio.Accounting.Contract.AttestationSimulator.SimulationDenyRequestDto): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/AttestationSimulator/SimulateDeny`, request);
			}
		}
		export namespace SimulateEscalate {
			export function Post(org: string, request: m.Bokio.Accounting.Contract.AttestationSimulator.SimulationActionRequestDto): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/AttestationSimulator/SimulateEscalate`, request);
			}
		}
	}
	export namespace BookkeepingTutorialController {
		export namespace GetOngoingTutorial {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Accounting.Contract.BoookkeepingTutorial.Dtos.ActiveTutorialDto, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/BookkeepingTutorial/GetOngoingTutorial`);
			}
		}
		export namespace ListTutorials {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Accounting.Contract.BoookkeepingTutorial.Dtos.TutorialStateDto, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/BookkeepingTutorial/ListTutorials`);
			}
		}
		export namespace StartBookkeepingTutorial {
			export function Post(org: string, request: m.Bokio.Accounting.Web.Accounting.Controllers.StartBookkeepingTutorialDto): Promise<m.Envelope<m.Bokio.Accounting.Contract.BoookkeepingTutorial.Dtos.ActiveTutorialDto, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/BookkeepingTutorial/StartBookkeepingTutorial`, request);
			}
		}
	}
	export namespace CashflowController {
		export namespace ChartData {
			export function Get(org: string, from?: Date): Promise<m.Accounting.Controllers.CashflowViewModel> {
				return Client.get(`/${org}/Accounting/Cashflow/ChartData`, { from })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Points.Date"}, {"type":"Day","key":"FuturePoints.Date"}, {"type":"Day","key":"StartDate"}, {"type":"Day","key":"EndDate"}));
			}
		}
		export namespace DayData {
			export function Get(org: string, date: Day): Promise<m.Accounting.Controllers.CashflowDayViewModel> {
				return Client.get(`/${org}/Accounting/Cashflow/DayData`, { date })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Date"}, {"type":"Date","key":"Groups.Items.Date"}));
			}
		}
	}
	export namespace ClosureController {
		export namespace ActivateNeAttachment {
			export function Post(org: string, settingsId: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(Client.getPathWithQueryString(`/${org}/Accounting/Closure/ActivateNeAttachment`, { settingsId }), {  });
			}
		}
		export namespace All {
			export function Get(org: string): Promise<m.Envelope<m.Core.Services.Closures.ClosureForListDto[], m.SimpleError>> {
				return Client.get(`/${org}/Accounting/Closure/All`)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.FiscalYear.StartDate"}, {"type":"Day","key":"Data.FiscalYear.EndDate"}));
			}
		}
		export namespace BookkeepDividendsDecision {
			export function Post(org: string, request: m.Model.Commands.Accounting.Closures.BookkeepDividendsDecisionPart): Promise<m.Envelope<m.Core.ViewData.ClosureForView, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/Closure/BookkeepDividendsDecision`, request)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.ArsredovisningOnlinePart.AnnualGeneralMeetingDate"}, {"type":"Day","key":"Data.FiscalYear.StartDate"}, {"type":"Day","key":"Data.FiscalYear.EndDate"}, {"type":"Day","key":"Data.AnnualGeneralMeetingDate"}));
			}
		}
		export namespace BookkeepEquityAccountResult {
			export function Post(org: string, settingId: string): Promise<m.Envelope<m.Core.ViewData.ClosureForView, m.Core.Recipes.FailReason>> {
				return Client.post(Client.getPathWithQueryString(`/${org}/Accounting/Closure/BookkeepEquityAccountResult`, { settingId }), {  })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.ArsredovisningOnlinePart.AnnualGeneralMeetingDate"}, {"type":"Day","key":"Data.FiscalYear.StartDate"}, {"type":"Day","key":"Data.FiscalYear.EndDate"}, {"type":"Day","key":"Data.AnnualGeneralMeetingDate"}));
			}
		}
		export namespace BookkeepTransferBalancedResult {
			export function Post(org: string, request: m.Model.Commands.Accounting.Closures.BookkeepTransferBalancedResultPart): Promise<m.Envelope<m.Core.ViewData.ClosureForView, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/Closure/BookkeepTransferBalancedResult`, request)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.ArsredovisningOnlinePart.AnnualGeneralMeetingDate"}, {"type":"Day","key":"Data.FiscalYear.StartDate"}, {"type":"Day","key":"Data.FiscalYear.EndDate"}, {"type":"Day","key":"Data.AnnualGeneralMeetingDate"}));
			}
		}
		export namespace ChooseArsredovisningOnlineClosure {
			export function Post(org: string, command: m.Model.Commands.Accounting.Closures.ChooseArsredovisningOnlineClosure): Promise<m.Core.ViewData.ClosureForView> {
				return Client.post(`/${org}/Accounting/Closure/ChooseArsredovisningOnlineClosure`, command)
				             .then(data => convertByKeys(data, {"type":"Day","key":"ArsredovisningOnlinePart.AnnualGeneralMeetingDate"}, {"type":"Day","key":"FiscalYear.StartDate"}, {"type":"Day","key":"FiscalYear.EndDate"}, {"type":"Day","key":"AnnualGeneralMeetingDate"}));
			}
		}
		export namespace ChooseBokioClosure {
			export function Post(org: string, command: m.Model.Commands.Accounting.Closures.ChooseBokioClosure): Promise<m.Core.ViewData.ClosureForView> {
				return Client.post(`/${org}/Accounting/Closure/ChooseBokioClosure`, command)
				             .then(data => convertByKeys(data, {"type":"Day","key":"ArsredovisningOnlinePart.AnnualGeneralMeetingDate"}, {"type":"Day","key":"FiscalYear.StartDate"}, {"type":"Day","key":"FiscalYear.EndDate"}, {"type":"Day","key":"AnnualGeneralMeetingDate"}));
			}
		}
		export namespace ChooseManualClosure {
			export function Post(org: string, command: m.Model.Commands.Accounting.Closures.ChooseManualClosure): Promise<m.Core.ViewData.ClosureForView> {
				return Client.post(`/${org}/Accounting/Closure/ChooseManualClosure`, command)
				             .then(data => convertByKeys(data, {"type":"Day","key":"ArsredovisningOnlinePart.AnnualGeneralMeetingDate"}, {"type":"Day","key":"FiscalYear.StartDate"}, {"type":"Day","key":"FiscalYear.EndDate"}, {"type":"Day","key":"AnnualGeneralMeetingDate"}));
			}
		}
		export namespace ConnectToArsredovisningOnline {
			export function Post(org: string, request: m.Core.Closures.ConnectToAORequest): Promise<m.Accounting.Controllers.ConnectToArsredovisningOnlineResult> {
				return Client.post(`/${org}/Accounting/Closure/ConnectToArsredovisningOnline`, request);
			}
		}
		export namespace DismissClosureTodoItem {
			export function Post(org: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/Closure/DismissClosureTodoItem`, {  });
			}
		}
		export namespace FinishAccountingPart {
			export function Post(org: string, command: m.Model.Commands.Accounting.Closures.FinishAccountingPart): Promise<m.Core.ViewData.ClosureForView> {
				return Client.post(`/${org}/Accounting/Closure/FinishAccountingPart`, command)
				             .then(data => convertByKeys(data, {"type":"Day","key":"ArsredovisningOnlinePart.AnnualGeneralMeetingDate"}, {"type":"Day","key":"FiscalYear.StartDate"}, {"type":"Day","key":"FiscalYear.EndDate"}, {"type":"Day","key":"AnnualGeneralMeetingDate"}));
			}
		}
		export namespace FinishArsredovisningOnlinePart {
			export function Post(org: string, command: m.Model.Commands.Accounting.Closures.FinishArsredovisningOnlinePart): Promise<m.Core.ViewData.ClosureForView> {
				return Client.post(`/${org}/Accounting/Closure/FinishArsredovisningOnlinePart`, command)
				             .then(data => convertByKeys(data, {"type":"Day","key":"ArsredovisningOnlinePart.AnnualGeneralMeetingDate"}, {"type":"Day","key":"FiscalYear.StartDate"}, {"type":"Day","key":"FiscalYear.EndDate"}, {"type":"Day","key":"AnnualGeneralMeetingDate"}));
			}
		}
		export namespace FinishChecklistPart {
			export function Post(org: string, command: m.Model.Commands.Accounting.Closures.FinishChecklistPart): Promise<m.Core.ViewData.ClosureForView> {
				return Client.post(`/${org}/Accounting/Closure/FinishChecklistPart`, command)
				             .then(data => convertByKeys(data, {"type":"Day","key":"ArsredovisningOnlinePart.AnnualGeneralMeetingDate"}, {"type":"Day","key":"FiscalYear.StartDate"}, {"type":"Day","key":"FiscalYear.EndDate"}, {"type":"Day","key":"AnnualGeneralMeetingDate"}));
			}
		}
		export namespace FinishClosure {
			export function Post(org: string, request: m.Bokio.Accounting.Contract.Receipts.DTOs.FinishClosureDto): Promise<m.Envelope<m.Core.ViewData.ClosureForView, m.Bokio.Accounting.Contract.FiscalYears.Errors.ClosureError>> {
				return Client.post(`/${org}/Accounting/Closure/FinishClosure`, request)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.ArsredovisningOnlinePart.AnnualGeneralMeetingDate"}, {"type":"Day","key":"Data.FiscalYear.StartDate"}, {"type":"Day","key":"Data.FiscalYear.EndDate"}, {"type":"Day","key":"Data.AnnualGeneralMeetingDate"}));
			}
		}
		export namespace FinishDepreciationPart {
			export function Post(org: string, command: m.Model.Commands.Accounting.Closures.FinishDepreciationPart): Promise<m.Core.ViewData.ClosureForView> {
				return Client.post(`/${org}/Accounting/Closure/FinishDepreciationPart`, command)
				             .then(data => convertByKeys(data, {"type":"Day","key":"ArsredovisningOnlinePart.AnnualGeneralMeetingDate"}, {"type":"Day","key":"FiscalYear.StartDate"}, {"type":"Day","key":"FiscalYear.EndDate"}, {"type":"Day","key":"AnnualGeneralMeetingDate"}));
			}
		}
		export namespace FinishPeriodisationPart {
			export function Post(org: string, command: m.Model.Commands.Accounting.Closures.FinishPeriodisationPart): Promise<m.Core.ViewData.ClosureForView> {
				return Client.post(`/${org}/Accounting/Closure/FinishPeriodisationPart`, command)
				             .then(data => convertByKeys(data, {"type":"Day","key":"ArsredovisningOnlinePart.AnnualGeneralMeetingDate"}, {"type":"Day","key":"FiscalYear.StartDate"}, {"type":"Day","key":"FiscalYear.EndDate"}, {"type":"Day","key":"AnnualGeneralMeetingDate"}));
			}
		}
		export namespace FinishProvisionPart {
			export function Post(org: string, command: m.Model.Commands.Accounting.Closures.FinishProvisionPart): Promise<m.Core.ViewData.ClosureForView> {
				return Client.post(`/${org}/Accounting/Closure/FinishProvisionPart`, command)
				             .then(data => convertByKeys(data, {"type":"Day","key":"ArsredovisningOnlinePart.AnnualGeneralMeetingDate"}, {"type":"Day","key":"FiscalYear.StartDate"}, {"type":"Day","key":"FiscalYear.EndDate"}, {"type":"Day","key":"AnnualGeneralMeetingDate"}));
			}
		}
		export namespace FinishResultPart {
			export function Post(org: string, command: m.Model.Commands.Accounting.Closures.FinishResultPart): Promise<m.Core.ViewData.ClosureForView> {
				return Client.post(`/${org}/Accounting/Closure/FinishResultPart`, command)
				             .then(data => convertByKeys(data, {"type":"Day","key":"ArsredovisningOnlinePart.AnnualGeneralMeetingDate"}, {"type":"Day","key":"FiscalYear.StartDate"}, {"type":"Day","key":"FiscalYear.EndDate"}, {"type":"Day","key":"AnnualGeneralMeetingDate"}));
			}
		}
		export namespace FinishStartPart {
			export function Post(org: string, command: m.Model.Commands.Accounting.Closures.FinishStartPart): Promise<m.Core.ViewData.ClosureForView> {
				return Client.post(`/${org}/Accounting/Closure/FinishStartPart`, command)
				             .then(data => convertByKeys(data, {"type":"Day","key":"ArsredovisningOnlinePart.AnnualGeneralMeetingDate"}, {"type":"Day","key":"FiscalYear.StartDate"}, {"type":"Day","key":"FiscalYear.EndDate"}, {"type":"Day","key":"AnnualGeneralMeetingDate"}));
			}
		}
		export namespace FinishTaxPart {
			export function Post(org: string, command: m.Model.Commands.Accounting.Closures.FinishTaxPart): Promise<m.Core.ViewData.ClosureForView> {
				return Client.post(`/${org}/Accounting/Closure/FinishTaxPart`, command)
				             .then(data => convertByKeys(data, {"type":"Day","key":"ArsredovisningOnlinePart.AnnualGeneralMeetingDate"}, {"type":"Day","key":"FiscalYear.StartDate"}, {"type":"Day","key":"FiscalYear.EndDate"}, {"type":"Day","key":"AnnualGeneralMeetingDate"}));
			}
		}
		export namespace ForView {
			export function Get(org: string, settingId: string): Promise<m.Envelope<m.Core.ViewData.ClosureForView, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/Closure/ForView`, { settingId })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.ArsredovisningOnlinePart.AnnualGeneralMeetingDate"}, {"type":"Day","key":"Data.FiscalYear.StartDate"}, {"type":"Day","key":"Data.FiscalYear.EndDate"}, {"type":"Day","key":"Data.AnnualGeneralMeetingDate"}));
			}
		}
		export namespace GetArsredovisningOnlineStatus {
			export function Get(org: string, fiscal: string): Promise<m.Accounting.Controllers.AoState> {
				return Client.get(`/${org}/Accounting/Closure/GetArsredovisningOnlineStatus`, { fiscal })
				             .then(data => convertByKeys(data, {"type":"Day","key":"VerificationsInfo.VerificationDate"}));
			}
		}
		export namespace GetById {
			export function Get(org: string, closureId: string): Promise<m.Envelope<m.Core.ViewData.ClosureForView, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/Closure/GetById`, { closureId })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.ArsredovisningOnlinePart.AnnualGeneralMeetingDate"}, {"type":"Day","key":"Data.FiscalYear.StartDate"}, {"type":"Day","key":"Data.FiscalYear.EndDate"}, {"type":"Day","key":"Data.AnnualGeneralMeetingDate"}));
			}
		}
		export namespace GetResultVerifications {
			export function Get(org: string, settingId: string): Promise<m.Bokio.Accounting.Contract.Verifications.DTOs.VerificationPreviewDto> {
				return Client.get(`/${org}/Accounting/Closure/GetResultVerifications`, { settingId })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Date"}));
			}
		}
		export namespace HasAccessToNEAppendix {
			export function Post(org: string, settingsId: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(Client.getPathWithQueryString(`/${org}/Accounting/Closure/HasAccessToNEAppendix`, { settingsId }), {  });
			}
		}
		export namespace ImportArsredovisningBookkeeping {
			export function Post(org: string, request: m.Bokio.Accounting.Web.Accounting.Models.ImportArsredovisningBookkeepingDto): Promise<m.Envelope<boolean, m.Core.Recipes.FailReason>> {
				return Client.post(`/${org}/Accounting/Closure/ImportArsredovisningBookkeeping`, request);
			}
		}
		export namespace NEAttachment {
			export function Post(org: string, yearStart: number, yearEnd: number): Promise<m.Envelope<m.Accounting.Controllers.NEAttachmentViewModel, m.SimpleError>> {
				return Client.post(Client.getPathWithQueryString(`/${org}/Accounting/Closure/NEAttachment`, { yearStart, yearEnd }), {  })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.Period.Start"}, {"type":"Day","key":"Data.Period.End"}));
			}
		}
		export namespace PeriodisationTransactions {
			export function Get(org: string, dto: m.Entities.Accounting.PeriodisationsDto): Promise<m.Entities.Transaction[]> {
				return Client.get(`/${org}/Accounting/Closure/PeriodisationTransactions`, { dto });
			}
		}
		export namespace PreviewDividendsDecisionVerification {
			export function Get(org: string, closureId: string, dividendsAmount: number): Promise<m.Envelope<m.Accounting.Viewmodels.Verifications.PreviewDto, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/Closure/PreviewDividendsDecisionVerification`, { closureId, dividendsAmount })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.Verification.Date"}, {"type":"Day","key":"Data.Verification.ExpectPaymentAt"}, {"type":"Date","key":"Data.Verification.CreatedUtc"}, {"type":"Day","key":"Data.PaymentVerification.Date"}, {"type":"Day","key":"Data.PaymentVerification.ExpectPaymentAt"}, {"type":"Date","key":"Data.PaymentVerification.CreatedUtc"}));
			}
		}
		export namespace PreviewEquityAccountResult {
			export function Get(org: string, settingId: string): Promise<m.Accounting.Viewmodels.Verifications.PreviewDto> {
				return Client.get(`/${org}/Accounting/Closure/PreviewEquityAccountResult`, { settingId })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Verification.Date"}, {"type":"Day","key":"Verification.ExpectPaymentAt"}, {"type":"Date","key":"Verification.CreatedUtc"}, {"type":"Day","key":"PaymentVerification.Date"}, {"type":"Day","key":"PaymentVerification.ExpectPaymentAt"}, {"type":"Date","key":"PaymentVerification.CreatedUtc"}));
			}
		}
		export namespace PreviewTransferBalancedResult {
			export function Get(org: string, closureId: string): Promise<m.Envelope<m.Accounting.Viewmodels.Verifications.PreviewDto, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/Closure/PreviewTransferBalancedResult`, { closureId })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.Verification.Date"}, {"type":"Day","key":"Data.Verification.ExpectPaymentAt"}, {"type":"Date","key":"Data.Verification.CreatedUtc"}, {"type":"Day","key":"Data.PaymentVerification.Date"}, {"type":"Day","key":"Data.PaymentVerification.ExpectPaymentAt"}, {"type":"Date","key":"Data.PaymentVerification.CreatedUtc"}));
			}
		}
		export namespace ReactivateAccountingPart {
			export function Post(org: string, command: m.Model.Commands.Accounting.Closures.ReactivateAccountingPart): Promise<m.Core.ViewData.ClosureForView> {
				return Client.post(`/${org}/Accounting/Closure/ReactivateAccountingPart`, command)
				             .then(data => convertByKeys(data, {"type":"Day","key":"ArsredovisningOnlinePart.AnnualGeneralMeetingDate"}, {"type":"Day","key":"FiscalYear.StartDate"}, {"type":"Day","key":"FiscalYear.EndDate"}, {"type":"Day","key":"AnnualGeneralMeetingDate"}));
			}
		}
		export namespace ReactivateArsredovisningOnlinePart {
			export function Post(org: string, command: m.Model.Commands.Accounting.Closures.ReactivateArsredovisningOnlinePart): Promise<m.Core.ViewData.ClosureForView> {
				return Client.post(`/${org}/Accounting/Closure/ReactivateArsredovisningOnlinePart`, command)
				             .then(data => convertByKeys(data, {"type":"Day","key":"ArsredovisningOnlinePart.AnnualGeneralMeetingDate"}, {"type":"Day","key":"FiscalYear.StartDate"}, {"type":"Day","key":"FiscalYear.EndDate"}, {"type":"Day","key":"AnnualGeneralMeetingDate"}));
			}
		}
		export namespace ReactivateClosure {
			export function Post(org: string, command: m.Bokio.Accounting.Contract.Closures.Commands.ReactivateClosure): Promise<m.Envelope<m.Core.ViewData.ClosureForView, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/Closure/ReactivateClosure`, command)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.ArsredovisningOnlinePart.AnnualGeneralMeetingDate"}, {"type":"Day","key":"Data.FiscalYear.StartDate"}, {"type":"Day","key":"Data.FiscalYear.EndDate"}, {"type":"Day","key":"Data.AnnualGeneralMeetingDate"}));
			}
		}
		export namespace ReactivateClosurePackage {
			export function Post(org: string, command: m.Model.Commands.Accounting.Closures.ReactivateClosurePackage): Promise<m.Core.ViewData.ClosureForView> {
				return Client.post(`/${org}/Accounting/Closure/ReactivateClosurePackage`, command)
				             .then(data => convertByKeys(data, {"type":"Day","key":"ArsredovisningOnlinePart.AnnualGeneralMeetingDate"}, {"type":"Day","key":"FiscalYear.StartDate"}, {"type":"Day","key":"FiscalYear.EndDate"}, {"type":"Day","key":"AnnualGeneralMeetingDate"}));
			}
		}
		export namespace ReactivateDepreciationPart {
			export function Post(org: string, command: m.Model.Commands.Accounting.Closures.ReactivateDepreciationPart): Promise<m.Core.ViewData.ClosureForView> {
				return Client.post(`/${org}/Accounting/Closure/ReactivateDepreciationPart`, command)
				             .then(data => convertByKeys(data, {"type":"Day","key":"ArsredovisningOnlinePart.AnnualGeneralMeetingDate"}, {"type":"Day","key":"FiscalYear.StartDate"}, {"type":"Day","key":"FiscalYear.EndDate"}, {"type":"Day","key":"AnnualGeneralMeetingDate"}));
			}
		}
		export namespace ReactivatePeriodisationPart {
			export function Post(org: string, command: m.Model.Commands.Accounting.Closures.ReactivatePeriodisationPart): Promise<m.Core.ViewData.ClosureForView> {
				return Client.post(`/${org}/Accounting/Closure/ReactivatePeriodisationPart`, command)
				             .then(data => convertByKeys(data, {"type":"Day","key":"ArsredovisningOnlinePart.AnnualGeneralMeetingDate"}, {"type":"Day","key":"FiscalYear.StartDate"}, {"type":"Day","key":"FiscalYear.EndDate"}, {"type":"Day","key":"AnnualGeneralMeetingDate"}));
			}
		}
		export namespace ReactivateProvisionPart {
			export function Post(org: string, command: m.Model.Commands.Accounting.Closures.ReactivateProvisionPart): Promise<m.Core.ViewData.ClosureForView> {
				return Client.post(`/${org}/Accounting/Closure/ReactivateProvisionPart`, command)
				             .then(data => convertByKeys(data, {"type":"Day","key":"ArsredovisningOnlinePart.AnnualGeneralMeetingDate"}, {"type":"Day","key":"FiscalYear.StartDate"}, {"type":"Day","key":"FiscalYear.EndDate"}, {"type":"Day","key":"AnnualGeneralMeetingDate"}));
			}
		}
		export namespace ReactivateResultPart {
			export function Post(org: string, command: m.Model.Commands.Accounting.Closures.ReactivateResultPart): Promise<m.Core.ViewData.ClosureForView> {
				return Client.post(`/${org}/Accounting/Closure/ReactivateResultPart`, command)
				             .then(data => convertByKeys(data, {"type":"Day","key":"ArsredovisningOnlinePart.AnnualGeneralMeetingDate"}, {"type":"Day","key":"FiscalYear.StartDate"}, {"type":"Day","key":"FiscalYear.EndDate"}, {"type":"Day","key":"AnnualGeneralMeetingDate"}));
			}
		}
		export namespace ReactivateTaxPart {
			export function Post(org: string, command: m.Model.Commands.Accounting.Closures.ReactivateTaxPart): Promise<m.Core.ViewData.ClosureForView> {
				return Client.post(`/${org}/Accounting/Closure/ReactivateTaxPart`, command)
				             .then(data => convertByKeys(data, {"type":"Day","key":"ArsredovisningOnlinePart.AnnualGeneralMeetingDate"}, {"type":"Day","key":"FiscalYear.StartDate"}, {"type":"Day","key":"FiscalYear.EndDate"}, {"type":"Day","key":"AnnualGeneralMeetingDate"}));
			}
		}
		export namespace SavePayDividendFields {
			export function Post(org: string, request: m.Bokio.Accounting.Contract.Closures.Commands.SavePayDividendsPart): Promise<m.Envelope<m.Core.ViewData.ClosureForView, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/Closure/SavePayDividendFields`, request)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.ArsredovisningOnlinePart.AnnualGeneralMeetingDate"}, {"type":"Day","key":"Data.FiscalYear.StartDate"}, {"type":"Day","key":"Data.FiscalYear.EndDate"}, {"type":"Day","key":"Data.AnnualGeneralMeetingDate"}));
			}
		}
		export namespace SkipAccountingPart {
			export function Post(org: string, command: m.Model.Commands.Accounting.Closures.SkipAccountingPart): Promise<m.Core.ViewData.ClosureForView> {
				return Client.post(`/${org}/Accounting/Closure/SkipAccountingPart`, command)
				             .then(data => convertByKeys(data, {"type":"Day","key":"ArsredovisningOnlinePart.AnnualGeneralMeetingDate"}, {"type":"Day","key":"FiscalYear.StartDate"}, {"type":"Day","key":"FiscalYear.EndDate"}, {"type":"Day","key":"AnnualGeneralMeetingDate"}));
			}
		}
		export namespace SkipDividendsDecisionPart {
			export function Post(org: string, command: m.Model.Commands.Accounting.Closures.SkipDividendsDecisionPart): Promise<m.Envelope<m.Core.ViewData.ClosureForView, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/Closure/SkipDividendsDecisionPart`, command)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.ArsredovisningOnlinePart.AnnualGeneralMeetingDate"}, {"type":"Day","key":"Data.FiscalYear.StartDate"}, {"type":"Day","key":"Data.FiscalYear.EndDate"}, {"type":"Day","key":"Data.AnnualGeneralMeetingDate"}));
			}
		}
		export namespace SkipTaxPart {
			export function Post(org: string, command: m.Model.Commands.Accounting.Closures.SkipTaxPart): Promise<m.Core.ViewData.ClosureForView> {
				return Client.post(`/${org}/Accounting/Closure/SkipTaxPart`, command)
				             .then(data => convertByKeys(data, {"type":"Day","key":"ArsredovisningOnlinePart.AnnualGeneralMeetingDate"}, {"type":"Day","key":"FiscalYear.StartDate"}, {"type":"Day","key":"FiscalYear.EndDate"}, {"type":"Day","key":"AnnualGeneralMeetingDate"}));
			}
		}
		export namespace SkipTransferBalancedResultPart {
			export function Post(org: string, command: m.Model.Commands.Accounting.Closures.SkipTransferBalancedResultPart): Promise<m.Envelope<m.Core.ViewData.ClosureForView, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/Closure/SkipTransferBalancedResultPart`, command)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.ArsredovisningOnlinePart.AnnualGeneralMeetingDate"}, {"type":"Day","key":"Data.FiscalYear.StartDate"}, {"type":"Day","key":"Data.FiscalYear.EndDate"}, {"type":"Day","key":"Data.AnnualGeneralMeetingDate"}));
			}
		}
		export namespace SkipTransferResultPart {
			export function Post(org: string, command: m.Model.Commands.Accounting.Closures.SkipTransferResultPart): Promise<m.Envelope<m.Core.ViewData.ClosureForView, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/Closure/SkipTransferResultPart`, command)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.ArsredovisningOnlinePart.AnnualGeneralMeetingDate"}, {"type":"Day","key":"Data.FiscalYear.StartDate"}, {"type":"Day","key":"Data.FiscalYear.EndDate"}, {"type":"Day","key":"Data.AnnualGeneralMeetingDate"}));
			}
		}
		export namespace UndoBookkeepDividendsDecision {
			export function Post(org: string, command: m.Model.Commands.Accounting.Closures.UndoBookkeepDividendsDecisionPart): Promise<m.Envelope<m.Core.ViewData.ClosureForView, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/Closure/UndoBookkeepDividendsDecision`, command)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.ArsredovisningOnlinePart.AnnualGeneralMeetingDate"}, {"type":"Day","key":"Data.FiscalYear.StartDate"}, {"type":"Day","key":"Data.FiscalYear.EndDate"}, {"type":"Day","key":"Data.AnnualGeneralMeetingDate"}));
			}
		}
		export namespace UndoBookkeepEquityVerification {
			export function Post(org: string, command: m.Bokio.Accounting.Contract.Commands.Accounting.Closures.UndoBookkeepTransferEquityPart): Promise<m.Envelope<m.Core.ViewData.ClosureForView, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/Closure/UndoBookkeepEquityVerification`, command)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.ArsredovisningOnlinePart.AnnualGeneralMeetingDate"}, {"type":"Day","key":"Data.FiscalYear.StartDate"}, {"type":"Day","key":"Data.FiscalYear.EndDate"}, {"type":"Day","key":"Data.AnnualGeneralMeetingDate"}));
			}
		}
		export namespace UndoBookkeepTransferBalancedResult {
			export function Post(org: string, command: m.Model.Commands.Accounting.Closures.UndoBookkeepTransferBalancedResult): Promise<m.Envelope<m.Core.ViewData.ClosureForView, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/Closure/UndoBookkeepTransferBalancedResult`, command)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.ArsredovisningOnlinePart.AnnualGeneralMeetingDate"}, {"type":"Day","key":"Data.FiscalYear.StartDate"}, {"type":"Day","key":"Data.FiscalYear.EndDate"}, {"type":"Day","key":"Data.AnnualGeneralMeetingDate"}));
			}
		}
		export namespace UpdateStartPartState {
			export function Post(org: string, command: m.Model.Commands.Accounting.Closures.UpdateStartPartState): Promise<m.Core.ViewData.ClosureForView> {
				return Client.post(`/${org}/Accounting/Closure/UpdateStartPartState`, command)
				             .then(data => convertByKeys(data, {"type":"Day","key":"ArsredovisningOnlinePart.AnnualGeneralMeetingDate"}, {"type":"Day","key":"FiscalYear.StartDate"}, {"type":"Day","key":"FiscalYear.EndDate"}, {"type":"Day","key":"AnnualGeneralMeetingDate"}));
			}
		}
		export namespace UploadToArsredovisningOnline {
			export function Post(org: string, fiscal: string): Promise<m.Accounting.Controllers.UploadReportToArsredovisningOnlineResult> {
				return Client.post(`/${org}/Accounting/Closure/UploadToArsredovisningOnline`, { fiscal });
			}
		}
	}
	export namespace ClosureFileController {
		export namespace FetchFileList {
			export function Get(org: string, settingId: string): Promise<m.Envelope<m.Bokio.Accounting.Contract.AnnualReport.Dtos.ClosureFileDto[], m.SimpleError>> {
				return Client.get(`/${org}/Accounting/ClosureFile/FetchFileList`, { settingId });
			}
		}
	}
	export namespace CustomRecipeController {
		export namespace Delete {
			export function Post(org: string, customRecipeId: string): Promise<m.Envelope<boolean, m.Bokio.Accounting.Contract.Recipes.CustomRecipeError>> {
				return Client.post(`/${org}/Accounting/CustomRecipe/Delete`, { customRecipeId });
			}
		}
		export namespace GetAdvancedCustomRecipe {
			export function Get(org: string, customRecipeId: string): Promise<m.Envelope<m.Bokio.Accounting.Contract.Recipes.Dtos.AdvancedCustomRecipeDto, m.Bokio.Accounting.Contract.Recipes.CustomRecipeError>> {
				return Client.get(`/${org}/Accounting/CustomRecipe/GetAdvancedCustomRecipe`, { customRecipeId });
			}
		}
		export namespace GetCustomRecipe {
			export function Get(org: string, customRecipeId: string): Promise<m.Envelope<m.Bokio.Accounting.Contract.Recipes.ViewModels.CustomRecipeViewModel, m.Bokio.Accounting.Contract.Recipes.CustomRecipeError>> {
				return Client.get(`/${org}/Accounting/CustomRecipe/GetCustomRecipe`, { customRecipeId });
			}
		}
		export namespace GetSharedCustomRecipe {
			export function Get(org: string, customRecipeId: string): Promise<m.Envelope<m.Bokio.Accounting.Contract.Recipes.Dtos.SharedCustomRecipeViewModel, m.Bokio.Accounting.Contract.Recipes.CustomRecipeError>> {
				return Client.get(`/${org}/Accounting/CustomRecipe/GetSharedCustomRecipe`, { customRecipeId });
			}
		}
		export namespace ListCustomRecipes {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Accounting.Contract.Recipes.Dtos.CustomRecipeListItemDto[], m.Bokio.Accounting.Contract.Recipes.CustomRecipeError>> {
				return Client.get(`/${org}/Accounting/CustomRecipe/ListCustomRecipes`);
			}
		}
		export namespace PreviewAdvancedCustomRecipe {
			export function Post(org: string, previewRequest: m.Core.Recipes.Requests.AdvancedCustomRecipePreviewRequest): Promise<m.Envelope<m.Bokio.Accounting.Contract.Verifications.DTOs.VerificationPreviewDto, m.Bokio.Accounting.Contract.Recipes.CustomRecipeError>> {
				return Client.post(`/${org}/Accounting/CustomRecipe/PreviewAdvancedCustomRecipe`, previewRequest)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.Date"}));
			}
		}
		export namespace PreviewCostOrIncomeRecipe {
			export function Post(org: string, previewRequest: m.Core.Recipes.Requests.PreviewCostOrIncomeRecipeDto): Promise<m.Envelope<m.Bokio.Accounting.Contract.Verifications.DTOs.VerificationPreviewDto, m.Bokio.Accounting.Contract.Recipes.CustomRecipeError>> {
				return Client.post(`/${org}/Accounting/CustomRecipe/PreviewCostOrIncomeRecipe`, previewRequest)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.Date"}));
			}
		}
		export namespace PreviewTransferRecipe {
			export function Post(org: string, previewRequest: m.Core.Recipes.Requests.PreviewTransferRecipeDto): Promise<m.Envelope<m.Bokio.Accounting.Contract.Verifications.DTOs.VerificationPreviewDto, m.Bokio.Accounting.Contract.Recipes.CustomRecipeError>> {
				return Client.post(`/${org}/Accounting/CustomRecipe/PreviewTransferRecipe`, previewRequest)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.Date"}));
			}
		}
		export namespace SaveAdvancedCustomRecipe {
			export function Post(org: string, request: m.Bokio.Accounting.Contract.Recipes.Requests.SaveAdvancedCustomRecipeRequest): Promise<m.Envelope<string, m.Bokio.Accounting.Contract.Recipes.CustomRecipeError>> {
				return Client.post(`/${org}/Accounting/CustomRecipe/SaveAdvancedCustomRecipe`, request);
			}
		}
		export namespace SaveCustomCostOrIncomeRecipe {
			export function Post(org: string, dto: m.Bokio.Accounting.Contract.Recipes.Dtos.CostOrIncomeRecipeDto): Promise<m.Envelope<string, m.Bokio.Accounting.Contract.Recipes.CustomRecipeError>> {
				return Client.post(`/${org}/Accounting/CustomRecipe/SaveCustomCostOrIncomeRecipe`, dto);
			}
		}
		export namespace SaveCustomTransferRecipe {
			export function Post(org: string, dto: m.Bokio.Accounting.Contract.Recipes.Dtos.TransferRecipeDto): Promise<m.Envelope<string, m.Bokio.Accounting.Contract.Recipes.CustomRecipeError>> {
				return Client.post(`/${org}/Accounting/CustomRecipe/SaveCustomTransferRecipe`, dto);
			}
		}
		export namespace ShareCustomRecipe {
			export function Post(org: string, shareRequest: m.Core.Recipes.Requests.CustomRecipeShareRequest): Promise<m.Envelope<boolean, m.Bokio.Accounting.Contract.Recipes.CustomRecipeError>> {
				return Client.post(`/${org}/Accounting/CustomRecipe/ShareCustomRecipe`, shareRequest);
			}
		}
	}
	export namespace DisbursementController {
		export namespace Bookkeep {
			export function Post(org: string, request: m.Accounting.Models.BookkeepDisbursementRequest): Promise<m.Envelope<m.Accounting.Viewmodels.Disbursements.DisbursementViewModel, m.Core.Recipes.FailReason>> {
				return Client.post(`/${org}/Accounting/Disbursement/Bookkeep`, request)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.PayDate"}));
			}
		}
		export namespace CancelTellerPayment {
			export function Post(org: string, id: string): Promise<m.Envelope<boolean, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.post(`/${org}/Accounting/Disbursement/CancelTellerPayment/${id}`, {  });
			}
		}
		export namespace ConnectToAutoVerificationRow {
			export function Post(org: string, request: m.Accounting.Models.ConnectDisbursementToAutoVerificationRowRequest): Promise<m.Envelope<m.Bokio.Common.Contract.ViewData.VerificationRecordingResult, m.Accounting.Models.ConnectDisbursementToAutoVerificationError>> {
				return Client.post(`/${org}/Accounting/Disbursement/ConnectToAutoVerificationRow`, request);
			}
		}
		export namespace Create {
			export function Post(org: string, command: m.Model.Commands.Accounting.Disbursements.CreateDisbursement): Promise<m.Envelope<m.Accounting.Viewmodels.Disbursements.DisbursementViewModel, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/Disbursement/Create`, command)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.PayDate"}));
			}
		}
		export namespace CreateDisbursements {
			export function Post(org: string, request: m.Accounting.Models.CreateDisbursementsRequest): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/Disbursement/CreateDisbursements`, request);
			}
		}
		export namespace CreateTellerDisbursements {
			export function Post(org: string, request: m.Accounting.Models.CreateTellerDisbursementsRequest): Promise<m.Envelope<boolean, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.post(`/${org}/Accounting/Disbursement/CreateTellerDisbursements`, request);
			}
		}
		export namespace Delete {
			export function Post(org: string, command: m.Model.Commands.Accounting.Disbursements.DeleteDisbursement): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/Disbursement/Delete`, command);
			}
		}
		export namespace Get {
			export function Get(org: string, id: string): Promise<m.Envelope<m.Accounting.Viewmodels.Disbursements.DisbursementViewModel, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/Disbursement/Get/${id}`)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.PayDate"}));
			}
		}
		export namespace GetBgSpec {
			export function Get(org: string, date: Day): Promise<m.Classes.Payments.ExternalPaymentFileSpecification> {
				return Client.get(`/${org}/Accounting/Disbursement/GetBgSpec`, { date })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Payments.Date"}));
			}
		}
		export namespace GetWithExpenses {
			export function Get(org: string, id: string): Promise<m.Envelope<m.Accounting.Viewmodels.Disbursements.DisbursementWithExpensesViewModel, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/Disbursement/GetWithExpenses/${id}`)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.Disbursement.PayDate"}, {"type":"Day","key":"Data.Expenses.ClaimDate"}, {"type":"Day","key":"Data.Expenses.ExpenseDate"}, {"type":"Day","key":"Data.Expenses.PaymentDate"}, {"type":"Day","key":"Data.Expenses.ExpenseBookkeepingDate"}));
			}
		}
		export namespace History {
			export function Get(org: string): Promise<m.Envelope<m.Accounting.Viewmodels.Disbursements.DisbursementHistoryViewModel, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/Disbursement/History`)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.CompletedDisbursements.PayDate"}));
			}
		}
		export namespace Index {
			export function Get(org: string): Promise<m.Envelope<m.Accounting.Viewmodels.Disbursements.DisbursementListViewModel, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/Disbursement`)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.ExpensesNeedingPayment.ClaimDate"}, {"type":"Day","key":"Data.ExpensesNeedingPayment.ExpenseDate"}, {"type":"Day","key":"Data.ExpensesNeedingPayment.PaymentDate"}, {"type":"Day","key":"Data.ExpensesNeedingPayment.ExpenseBookkeepingDate"}, {"type":"Day","key":"Data.PlannedDisbursements.PayDate"}));
			}
		}
		export namespace MarkAsManuallyRecorded {
			export function Post(org: string, request: m.Accounting.Models.MarkAsManuallyRecordedRequest): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/Disbursement/MarkAsManuallyRecorded`, request);
			}
		}
		export namespace PreviewTellerDisbursements {
			export function Post(org: string, request: m.Accounting.Models.CreateTellerDisbursementsRequest): Promise<m.Envelope<m.Accounting.Models.CreateDisbursementPreviewDto[], m.SimpleError>> {
				return Client.post(`/${org}/Accounting/Disbursement/PreviewTellerDisbursements`, request);
			}
		}
		export namespace SetAsPaid {
			export function Post(org: string, command: m.Model.Commands.Accounting.Disbursements.SetDisbursementAsPaid): Promise<m.Accounting.Viewmodels.Disbursements.DisbursementViewModel> {
				return Client.post(`/${org}/Accounting/Disbursement/SetAsPaid`, command)
				             .then(data => convertByKeys(data, {"type":"Day","key":"PayDate"}));
			}
		}
		export namespace Undo {
			export function Put(org: string, command: m.Model.Commands.Accounting.Disbursements.UndoDisbursement): Promise<m.Envelope<m.Accounting.Viewmodels.Disbursements.DisbursementViewModel, m.SimpleError>> {
				return Client.put(`/${org}/Accounting/Disbursement/Undo`, command)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.PayDate"}));
			}
		}
	}
	export namespace ExpenseAccountController {
		export namespace Account {
			export function Get(org: string, id: string): Promise<m.Accounting.Controllers.EmployeeExpenseAccountViewModel> {
				return Client.get(`/${org}/Accounting/ExpenseAccount/Account/${id}`);
			}
		}
		export namespace AccountsForEmployee {
			export function Get(org: string, request: m.Accounting.Controllers.GetAccountsForEmployeeRequest): Promise<m.Accounting.Controllers.EmployeeExpenseAccountViewModel[]> {
				return Client.get(`/${org}/Accounting/ExpenseAccount/AccountsForEmployee`, { request });
			}
		}
		export namespace CompanyCardAccounts {
			export function Get(org: string, includeDeleted?: boolean): Promise<m.Accounting.Controllers.EmployeeExpenseAccountViewModel[]> {
				return Client.get(`/${org}/Accounting/ExpenseAccount/CompanyCardAccounts`, { includeDeleted });
			}
		}
		export namespace CreateAccount {
			export function Post(org: string, request: m.Accounting.Controllers.CreateEmployeeExpenseAccountRequest): Promise<m.Accounting.Controllers.EmployeeExpenseAccountViewModel> {
				return Client.post(`/${org}/Accounting/ExpenseAccount/CreateAccount`, request);
			}
		}
		export namespace CreateCompanyCard {
			export function Post(org: string, request: m.Accounting.Controllers.CreateCompanyCardRequest): Promise<m.Accounting.Controllers.EmployeeExpenseAccountViewModel> {
				return Client.post(`/${org}/Accounting/ExpenseAccount/CreateCompanyCard`, request);
			}
		}
		export namespace DeleteAccount {
			export function Post(org: string, id: string): Promise<boolean> {
				return Client.post(`/${org}/Accounting/ExpenseAccount/DeleteAccount/${id}`, {  });
			}
		}
		export namespace DeleteCompanyCard {
			export function Post(org: string, id: string, employeeId: string): Promise<boolean> {
				return Client.post(`/${org}/Accounting/ExpenseAccount/DeleteCompanyCard/${id}`, { employeeId });
			}
		}
		export namespace EditAccount {
			export function Post(org: string, id: string, title: string): Promise<m.Accounting.Controllers.EmployeeExpenseAccountViewModel> {
				return Client.post(`/${org}/Accounting/ExpenseAccount/EditAccount/${id}`, { title });
			}
		}
		export namespace EditCompanyCard {
			export function Post(org: string, id: string, request: m.Accounting.Controllers.EditCompanyCardRequest): Promise<m.Accounting.Controllers.EmployeeExpenseAccountViewModel> {
				return Client.post(`/${org}/Accounting/ExpenseAccount/EditCompanyCard/${id}`, request);
			}
		}
		export namespace ExpenseEmployees {
			export function Get(org: string): Promise<m.Bokio.Salary.Web.Viewmodels.Employees.EmployeeForList[]> {
				return Client.get(`/${org}/Accounting/ExpenseAccount/ExpenseEmployees`);
			}
		}
		export namespace MyAccounts {
			export function Get(org: string, includeDeleted?: boolean): Promise<m.Accounting.Controllers.EmployeeExpenseAccountViewModel[]> {
				return Client.get(`/${org}/Accounting/ExpenseAccount/MyAccounts`, { includeDeleted });
			}
		}
		export namespace UndeleteAccount {
			export function Post(org: string, id: string): Promise<boolean> {
				return Client.post(`/${org}/Accounting/ExpenseAccount/UndeleteAccount/${id}`, {  });
			}
		}
		export namespace UndeleteCompanyCard {
			export function Post(org: string, id: string, employeeId: string): Promise<boolean> {
				return Client.post(`/${org}/Accounting/ExpenseAccount/UndeleteCompanyCard/${id}`, { employeeId });
			}
		}
	}
	export namespace ExpenseController {
		export namespace AddFriskvardBalanceAdjustment {
			export function Post(org: string, request: m.Accounting.Viewmodels.Expenses.AddFriskvardBalanceAdjustmentRequestDto): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/Expense/AddFriskvardBalanceAdjustment`, request);
			}
		}
		export namespace AdjustExpense {
			export function Post(org: string, id: string, request: m.Accounting.Viewmodels.Expenses.AdjustExpenseRequestDto): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/Expense/AdjustExpense/${id}`, request);
			}
		}
		export namespace CalculateMileage {
			export function Post(org: string, request: m.Accounting.Viewmodels.Expenses.CalculateMileageRequest): Promise<m.Envelope<m.Accounting.Viewmodels.Expenses.CalculateMileageResultDto, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/Expense/CalculateMileage`, request);
			}
		}
		export namespace CalculatePerDiem {
			export function Post(org: string, request: m.Accounting.Viewmodels.Expenses.CalculatePerDiemRequest): Promise<m.Envelope<m.Accounting.Viewmodels.Expenses.CalculatePerDiemResultDto, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/Expense/CalculatePerDiem`, request)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.Days.Date"}));
			}
		}
		export namespace CompleteExpenseOnboarding {
			export function Post(org: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/Expense/CompleteExpenseOnboarding`, {  });
			}
		}
		export namespace ConvertFromReceiptData {
			export function Get(org: string, receiptId: string): Promise<m.Envelope<m.Accounting.Viewmodels.Expenses.ConvertToExpenseViewModel, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/Expense/ConvertFromReceiptData`, { receiptId });
			}
		}
		export namespace ConvertToReceipt {
			export function Post(org: string, expenseId: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/Expense/ConvertToReceipt`, { expenseId });
			}
		}
		export namespace CreateBusinessTrip {
			export function Post(org: string, request: m.Accounting.Viewmodels.Expenses.CreateBusinessTripRequest): Promise<m.Envelope<m.Accounting.Viewmodels.Expenses.BusinessTripResultDto, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/Expense/CreateBusinessTrip`, request);
			}
		}
		export namespace CreateWithReceipt {
			export function Post(org: string, request: m.Accounting.Controllers.CreateWithReceiptRequest): Promise<m.Envelope<m.Accounting.Viewmodels.Receipts.ExpenseListViewModel, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/Expense/CreateWithReceipt`, request)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.ClaimDate"}, {"type":"Day","key":"Data.ExpenseDate"}, {"type":"Day","key":"Data.PaymentDate"}, {"type":"Day","key":"Data.ExpenseBookkeepingDate"}));
			}
		}
		export namespace DeleteMyExpense {
			export function Post(org: string, expenseId: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/Expense/DeleteMyExpense`, { expenseId });
			}
		}
		export namespace Expense {
			export function Get(org: string, id: string): Promise<m.Envelope<m.Accounting.Viewmodels.Receipts.ExpenseListViewModel, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/Expense/Expense/${id}`)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.ClaimDate"}, {"type":"Day","key":"Data.ExpenseDate"}, {"type":"Day","key":"Data.PaymentDate"}, {"type":"Day","key":"Data.ExpenseBookkeepingDate"}));
			}
		}
		export namespace Expenses {
			export function Get(org: string, request: m.Accounting.Controllers.GetExpensesRequest): Promise<m.Envelope<m.Accounting.Viewmodels.Receipts.ExpenseListViewModel[], m.SimpleError>> {
				return Client.get(`/${org}/Accounting/Expense/Expenses`, { request })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.ClaimDate"}, {"type":"Day","key":"Data.ExpenseDate"}, {"type":"Day","key":"Data.PaymentDate"}, {"type":"Day","key":"Data.ExpenseBookkeepingDate"}));
			}
		}
		export namespace GetBusinessTrip {
			export function Get(org: string, businessTripId: string): Promise<m.Envelope<m.Accounting.Viewmodels.Expenses.BusinessTripDto, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/Expense/GetBusinessTrip`, { businessTripId })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.Mileage.Legs.Date"}, {"type":"Date","key":"Data.PerDiem.DepartureDateTime"}, {"type":"Date","key":"Data.PerDiem.ReturnDateTime"}, {"type":"Day","key":"Data.PerDiem.Days.Date"}));
			}
		}
		export namespace GetExpenseAdjustments {
			export function Get(org: string, expenseId: string): Promise<m.Envelope<m.Accounting.Viewmodels.Expenses.ExpenseAdjustmentDto[], m.SimpleError>> {
				return Client.get(`/${org}/Accounting/Expense/GetExpenseAdjustments`, { expenseId })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.PreviousDate"}, {"type":"Day","key":"Data.NewDate"}, {"type":"Date","key":"Data.AdjustedAt"}));
			}
		}
		export namespace GetExpenseEmployees {
			export function Get(org: string): Promise<m.Envelope<m.Accounting.Viewmodels.Expenses.ExpensesEmployeeListItem[], m.SimpleError>> {
				return Client.get(`/${org}/Accounting/Expense/GetExpenseEmployees`);
			}
		}
		export namespace GetExpenseExchangeRate {
			export function Get(org: string, currency: string, date: Day): Promise<m.Envelope<m.Entities.ExchangeRate, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/Expense/GetExpenseExchangeRate`, { currency, date })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.Date"}));
			}
		}
		export namespace GetFriskvardBalanceAdjustments {
			export function Get(org: string): Promise<m.Envelope<m.Accounting.Viewmodels.Expenses.FriskvardBalanceAdjustmentDto[], m.SimpleError>> {
				return Client.get(`/${org}/Accounting/Expense/GetFriskvardBalanceAdjustments`)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.PeriodStart"}, {"type":"Date","key":"Data.AdjustedAt"}));
			}
		}
		export namespace GetFriskvardOverview {
			export function Get(org: string): Promise<m.Envelope<m.Accounting.Viewmodels.Expenses.FriskvardOverviewDto, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/Expense/GetFriskvardOverview`)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.PeriodStart"}, {"type":"Day","key":"Data.PeriodEnd"}));
			}
		}
		export namespace GetFriskvardSettings {
			export function Get(org: string): Promise<m.Envelope<m.Accounting.Viewmodels.Expenses.FriskvardSettingsDto, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/Expense/GetFriskvardSettings`);
			}
		}
		export namespace GetFriskvardUsage {
			export function Get(org: string, employeeId: string): Promise<m.Envelope<m.Accounting.Viewmodels.Expenses.FriskvardUsageDto, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/Expense/GetFriskvardUsage`, { employeeId })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.PeriodStart"}, {"type":"Day","key":"Data.PeriodEnd"}));
			}
		}
		export namespace GetMileageDetails {
			export function Get(org: string, expenseId: string): Promise<m.Envelope<m.Accounting.Viewmodels.Expenses.MileageDetailsDto, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/Expense/GetMileageDetails`, { expenseId })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.Legs.Date"}));
			}
		}
		export namespace GetMileageRates {
			export function Get(org: string): Promise<m.Envelope<m.Accounting.Viewmodels.Expenses.MileageRatesDto, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/Expense/GetMileageRates`);
			}
		}
		export namespace GetPerDiemDetails {
			export function Get(org: string, expenseId: string): Promise<m.Envelope<m.Accounting.Viewmodels.Expenses.PerDiemDetailsDto, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/Expense/GetPerDiemDetails`, { expenseId })
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.DepartureDateTime"}, {"type":"Date","key":"Data.ReturnDateTime"}, {"type":"Day","key":"Data.Days.Date"}));
			}
		}
		export namespace GetPerDiemRates {
			export function Get(org: string): Promise<m.Envelope<m.Accounting.Viewmodels.Expenses.PerDiemRatesDto, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/Expense/GetPerDiemRates`);
			}
		}
		export namespace GetRecordingPeriodStatusForDate {
			export function Get(org: string, date: Day): Promise<m.Envelope<m.Bokio.Accounting.Contract.EventsToRecord.Dtos.RecordingPeriodStatus, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/Expense/GetRecordingPeriodStatusForDate`, { date })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.FirstOpenFiscalYearDate"}, {"type":"Day","key":"Data.FirstDateAfterLockPeriod"}, {"type":"Day","key":"Data.FirstDateAfterVatPeriod"}, {"type":"Day","key":"Data.NextRecordableDate"}));
			}
		}
		export namespace GetSupportedCurrencies {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Common.CurrencyInfo[], m.SimpleError>> {
				return Client.get(`/${org}/Accounting/Expense/GetSupportedCurrencies`);
			}
		}
		export namespace OnboardingState {
			export function Get(org: string): Promise<m.Accounting.Controllers.ExpensesOnboardingState> {
				return Client.get(`/${org}/Accounting/Expense/OnboardingState`);
			}
		}
		export namespace UpdateBusinessTrip {
			export function Post(org: string, request: m.Accounting.Viewmodels.Expenses.UpdateBusinessTripRequest): Promise<m.Envelope<m.Accounting.Viewmodels.Expenses.BusinessTripResultDto, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/Expense/UpdateBusinessTrip`, request);
			}
		}
		export namespace UpdateExpense {
			export function Post(org: string, request: m.Accounting.Models.UpdateExpenseRequest): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/Expense/UpdateExpense`, request);
			}
		}
		export namespace UpdateFriskvardSettings {
			export function Post(org: string, request: m.Accounting.Viewmodels.Expenses.UpdateFriskvardSettingsRequestDto): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/Expense/UpdateFriskvardSettings`, request);
			}
		}
	}
	export namespace ExpenseIntegrationTestSetupController {
		export namespace SetupExpenses {
			export function Post(org: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/ExpenseIntegrationTestSetup/SetupExpenses`, {  });
			}
		}
	}
	export namespace HmrcVatController {
		export namespace CompleteVatReportHMRC {
			export function Post(org: string, reportId: string): Promise<m.Envelope<boolean, m.Accounting.Viewmodels.Reports.HMRCErrorBase>> {
				return Client.post(`/${org}/Accounting/HmrcVat/CompleteVatReportHMRC`, { reportId });
			}
		}
		export namespace ConnectWithHMRC {
			export function Post(org: string, data: m.Accounting.Viewmodels.Reports.ConnectWithHMRC): Promise<m.Envelope<m.Accounting.Viewmodels.Reports.ConnectWithHMRCResult, m.Accounting.Viewmodels.Reports.ConnectWithHMRCError>> {
				return Client.post(`/${org}/Accounting/HmrcVat/ConnectWithHMRC`, data);
			}
		}
		export namespace Debug {
			export function Get(org: string, periodKey: string): Promise<m.Envelope<m.Accounting.Viewmodels.Reports.VATReportDebugViewModel, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/HmrcVat/Debug`, { periodKey })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.VerificationDebugList.Date"}, {"type":"Day","key":"Data.PeriodDateRange.Start"}, {"type":"Day","key":"Data.PeriodDateRange.End"}));
			}
		}
		export namespace GetPeriodsHMRC {
			export function Get(org: string, redirectUrl: string, forceRefresh?: boolean): Promise<m.Envelope<m.Accounting.Viewmodels.Reports.VATPeriodsForList, m.Accounting.Viewmodels.Reports.VATPeriodsError>> {
				return Client.getFingerprintHeaders()
				             .then(fingerprintHeaders => Client.getWithOptions(`/${org}/Accounting/HmrcVat/GetPeriodsHMRC`, { queryData: { redirectUrl, forceRefresh }, headers: fingerprintHeaders }))
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.Periods.FromDate"}, {"type":"Day","key":"Data.Periods.ToDate"}, {"type":"Day","key":"Data.Periods.DueDate"}, {"type":"Day","key":"Data.Periods.Received"}, {"type":"Date","key":"Data.Periods.LastSyncedUTC"}));
			}
		}
		export namespace GetVatReportHMRC {
			export function Get(org: string, periodKey: string): Promise<m.Envelope<m.Accounting.Viewmodels.Reports.VATReportViewModelHMRC, m.Accounting.Viewmodels.Reports.VATReportErrorHMRC>> {
				return Client.getFingerprintHeaders()
				             .then(fingerprintHeaders => Client.getWithOptions(`/${org}/Accounting/HmrcVat/GetVatReportHMRC`, { queryData: { periodKey }, headers: fingerprintHeaders }))
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.Layout.Period.Start"}, {"type":"Day","key":"Data.Layout.Period.End"}, {"type":"Day","key":"Data.DateRange.Start"}, {"type":"Day","key":"Data.DateRange.End"}, {"type":"Day","key":"Data.DueDate"}, {"type":"Day","key":"Data.SubmissionDate"}));
			}
		}
		export namespace PreviewHMRCVerification {
			export function Get(org: string, periodKey: string): Promise<m.Envelope<m.Accounting.Viewmodels.Reports.PreviewHMRCVerificationResult, m.SimpleError>> {
				return Client.getFingerprintHeaders()
				             .then(fingerprintHeaders => Client.getWithOptions(`/${org}/Accounting/HmrcVat/PreviewHMRCVerification`, { queryData: { periodKey }, headers: fingerprintHeaders }))
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.VATJournalEntry.Date"}, {"type":"Day","key":"Data.VATJournalEntry.ExpectPaymentAt"}, {"type":"Date","key":"Data.VATJournalEntry.CreatedUtc"}));
			}
		}
		export namespace SubmitVatReportToHMRC {
			export function Post(org: string, request: m.Accounting.Viewmodels.Reports.SubmitVatReportToHMRC): Promise<m.Envelope<m.Accounting.Viewmodels.Reports.SubmitVatReportToHMRCResult, m.Accounting.Viewmodels.Reports.SubmitVatReportToHMRCError>> {
				return Client.getFingerprintHeaders()
				             .then(fingerprintHeaders => Client.postWithOptions(`/${org}/Accounting/HmrcVat/SubmitVatReportToHMRC`, { data: request, headers: fingerprintHeaders }));
			}
		}
		export namespace TestFraudHeaders {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Integration.HMRC.VATFraudHeaderTestResponse, m.Accounting.Viewmodels.Reports.HMRCErrorBase>> {
				return Client.getFingerprintHeaders()
				             .then(fingerprintHeaders => Client.getWithOptions(`/${org}/Accounting/HmrcVat/TestFraudHeaders`, { headers: fingerprintHeaders }));
			}
		}
		export namespace UndoPaymentStep {
			export function Post(org: string, reportId: string): Promise<m.Envelope<boolean, m.Accounting.Viewmodels.Reports.HMRCErrorBase>> {
				return Client.post(`/${org}/Accounting/HmrcVat/UndoPaymentStep`, { reportId });
			}
		}
	}
	export namespace ImportCompanyFromSeController {
		export namespace ImportCompanyFromSeFile {
			export function Post(files: (File | Blob | string)[], draftId: string): Promise<m.Envelope<m.Bokio.Accounting.Web.Accounting.Services.ImportCompanyResponse, m.Settings.Controllers.UploadedFileError>> {
				const form = new FormData();
				files.forEach(item => form.append("files", item));
				form.append("draftId", draftId);
				return Client.post("/Accounting/ImportCompanyFromSe/ImportCompanyFromSeFile", form, true);
			}
		}
	}
	export namespace ManualMatchController {
		export namespace GetBankRowMatches {
			export function Get(org: string, autoVerificationRowId: string, min: Day, max: Day): Promise<m.Envelope<m.Core.Services.ManualMatch.BankRowPossibleMatch, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/ManualMatch/GetBankRowMatches`, { autoVerificationRowId, min, max })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.Matches.Date"}, {"type":"Day","key":"Data.Matches.Data.Date"}));
			}
		}
		export namespace GetGroupedBankRowMatches {
			export function Post(org: string, request: m.Bokio.Bank.Contract.AutoVerificationRows.Requests.AutoVerificationGroupMatchesRequest, min: Day, max: Day): Promise<m.Envelope<m.Bokio.Bank.Contract.AutoVerificationRows.Matching.AutoVerificationGroupMatches, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/ManualMatch/GetGroupedBankRowMatches`, { request, min, max })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.Matches.Date"}, {"type":"Day","key":"Data.Matches.Data.Date"}));
			}
		}
		export namespace GetInvoiceMatches {
			export function Get(org: string, invoiceId: string, min: Day, max: Day): Promise<m.Envelope<m.Core.Services.ManualMatch.BankRowPossibleMatch, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/ManualMatch/GetInvoiceMatches`, { invoiceId, min, max })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.Matches.Date"}, {"type":"Day","key":"Data.Matches.Data.Date"}));
			}
		}
		export namespace GetSupplierInvoiceMatches {
			export function Get(org: string, supplierInvoiceId: string, min: Day, max: Day): Promise<m.Envelope<m.Core.Services.ManualMatch.BankRowPossibleMatch, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/ManualMatch/GetSupplierInvoiceMatches`, { supplierInvoiceId, min, max })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.Matches.Date"}, {"type":"Day","key":"Data.Matches.Data.Date"}));
			}
		}
		export namespace SearchMatches {
			export function Get(org: string, autoVerificationRowId: string, search: string): Promise<m.Envelope<m.Bokio.Bank.Contract.AutoVerificationRows.Matching.AutoVerificationMatch[], m.SimpleError>> {
				return Client.get(`/${org}/Accounting/ManualMatch/SearchMatches`, { autoVerificationRowId, search })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.Data.Date"}, {"type":"Day","key":"Data.RowData.Date"}));
			}
		}
	}
	export namespace PostmarkWebhookController {
		export namespace StoreEmail {
			export function Post(): Promise<m.Accounting.Controllers.WebhookResponseData> {
				return Client.post("/Accounting/PostmarkWebhook/StoreEmail", {  });
			}
		}
	}
	export namespace ReceiptController {
		export namespace Attest {
			export function Post(org: string, command: m.Model.Commands.Accounting.Reciepts.AttestReceipt): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/Receipt/Attest`, command);
			}
		}
		export namespace BankRowMatches {
			export function Get(org: string, receiptId: string): Promise<m.Envelope<m.Bokio.Accounting.Contract.Receipts.DTOs.ReceiptBankRowMatchingView, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/Receipt/BankRowMatches`, { receiptId })
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.Matches.Date"}));
			}
		}
		export namespace BatchDelete {
			export function Post(org: string, command: m.Model.Commands.Accounting.Reciepts.DeleteReceipts): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/Receipt/BatchDelete`, command);
			}
		}
		export namespace CloseSupportTicket {
			export function Post(org: string, command: m.Model.Commands.Support.CloseSupportTicket): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/Receipt/CloseSupportTicket`, command);
			}
		}
		export namespace ConnectToVerification {
			export function Post(org: string, request: m.Accounting.Controllers.ConnectToVerificationRequest): Promise<m.Envelope<string, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/Receipt/ConnectToVerification`, request);
			}
		}
		export namespace CreateSupportTicket {
			export function Post(org: string, command: m.Model.Commands.Support.CreateSupportTicket): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/Receipt/CreateSupportTicket`, command);
			}
		}
		export namespace Delete {
			export function Post(org: string, command: m.Model.Commands.Accounting.Reciepts.DeleteReceipt): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/Receipt/Delete`, command);
			}
		}
		export namespace DeleteExtraPage {
			export function Post(org: string, extraPageId: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/Receipt/DeleteExtraPage`, { extraPageId });
			}
		}
		export namespace DeleteMainPage {
			export function Post(org: string, request: m.Accounting.Controllers.DeleteMainPageRequest): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/Receipt/DeleteMainPage`, request);
			}
		}
		export namespace ForVerification {
			export function Get(org: string, id: string): Promise<m.Accounting.Viewmodels.ReceiptViewModel[]> {
				return Client.get(`/${org}/Accounting/Receipt/ForVerification/${id}`)
				             .then(data => convertByKeys(data, {"type":"Day","key":"ExpenseDate"}));
			}
		}
		export namespace GetAllMissingPredictions {
			export function Post(org: string): Promise<m.Envelope<m.Accounting.Controllers.GetAllMissingPredictionsResponse, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/Receipt/GetAllMissingPredictions`, {  });
			}
		}
		export namespace GetReceipt {
			export function Get(org: string, id: string): Promise<m.Envelope<m.Accounting.Controllers.ScanResult, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/Receipt/GetReceipt/${id}`)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.Receipt.ExpenseDate"}));
			}
		}
		export namespace GetReceiptContentType {
			export function Get(org: string, id: string): Promise<m.Envelope<string, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/Receipt/GetReceiptContentType/${id}`);
			}
		}
		export namespace GetReceiptExtraPages {
			export function Get(org: string, id: string): Promise<m.Accounting.Viewmodels.ReceiptExtraPageViewModel[]> {
				return Client.get(`/${org}/Accounting/Receipt/GetReceiptExtraPages/${id}`);
			}
		}
		export namespace GetReceiptFieldsPrediction {
			export function Get(org: string, id: string, effort: m.Accounting.Models.ReceiptImagePredictionEffort, tryMatchSupplier?: boolean): Promise<m.Envelope<m.Classes.AI.ReceiptFieldsPrediction, m.Accounting.Models.ReceiptFieldsPredictionError>> {
				return Client.get(`/${org}/Accounting/Receipt/GetReceiptFieldsPrediction/${id}`, { effort, tryMatchSupplier })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.Dates.Value"}, {"type":"Day","key":"Data.PaymentDates.Value"}, {"type":"Day","key":"Data.DueDates.Value"}, {"type":"Day","key":"Data.PredictedAt"}, {"type":"Day","key":"Data.UserEnteredPaymentDate"}, {"type":"Date","key":"Data.PaymentInformation.PaymentDetailsMatchData.Date"}, {"type":"Date","key":"Data.PaymentInformation.PaymentDetailsMatchData.DueDate"}));
			}
		}
		export namespace GetReceiptForUploadsScene {
			export function Get(org: string, id: string): Promise<m.Envelope<m.Bokio.Accounting.Contract.ViewData.ReceiptWithUploadInfo, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/Receipt/GetReceiptForUploadsScene/${id}`)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.PredictedPaymentDate"}, {"type":"Day","key":"Data.PredictedDate"}, {"type":"Day","key":"Data.PaymentDate"}, {"type":"Date","key":"Data.UploadedDate"}, {"type":"Day","key":"Data.Date"}));
			}
		}
		export namespace GetReceiptForView {
			export function Get(org: string, id: string): Promise<m.Accounting.Viewmodels.ReceiptForView> {
				return Client.get(`/${org}/Accounting/Receipt/GetReceiptForView/${id}`)
				             .then(data => convertByKeys(data, {"type":"Date","key":"UploadedDate"}));
			}
		}
		export namespace GetReceiptIdFromAutoVerificationRow {
			export function Get(org: string, id: string): Promise<m.Envelope<string, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/Receipt/GetReceiptIdFromAutoVerificationRow/${id}`);
			}
		}
		export namespace GetReceiptIdFromSupplierInvoice {
			export function Get(org: string, id: string): Promise<m.Envelope<string, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/Receipt/GetReceiptIdFromSupplierInvoice/${id}`);
			}
		}
		export namespace GetReceiptType {
			export function Get(org: string, id: string): Promise<m.Envelope<string, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/Receipt/GetReceiptType/${id}`);
			}
		}
		export namespace GetSupportTicket {
			export function Get(org: string, id: string): Promise<m.Bokio.Accounting.Contract.Support.SupportTicketViewModel> {
				return Client.get(`/${org}/Accounting/Receipt/GetSupportTicket/${id}`)
				             .then(data => convertByKeys(data, {"type":"Date","key":"CreatedUtc"}, {"type":"Date","key":"UpdatedUtc"}, {"type":"Date","key":"Revisions.CreatedUtc"}, {"type":"Day","key":"Verification.Date"}, {"type":"Day","key":"Verification.ExpectPaymentAt"}, {"type":"Date","key":"Verification.CreatedUtc"}));
			}
		}
		export namespace GetSupportTicketForReceipt {
			export function Get(org: string, receiptId: string): Promise<m.Envelope<m.Bokio.Accounting.Contract.Support.SupportTicketViewModel, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/Receipt/GetSupportTicketForReceipt`, { receiptId })
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.CreatedUtc"}, {"type":"Date","key":"Data.UpdatedUtc"}, {"type":"Date","key":"Data.Revisions.CreatedUtc"}, {"type":"Day","key":"Data.Verification.Date"}, {"type":"Day","key":"Data.Verification.ExpectPaymentAt"}, {"type":"Date","key":"Data.Verification.CreatedUtc"}));
			}
		}
		export namespace GetTemporaryReceiptExtraPages {
			export function Get(org: string, receiptId: string): Promise<m.Envelope<m.Accounting.Viewmodels.ReceiptExtraPageViewModel[], m.SimpleError>> {
				return Client.get(`/${org}/Accounting/Receipt/GetTemporaryReceiptExtraPages`, { receiptId });
			}
		}
		export namespace List {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Accounting.Contract.ViewData.ReceiptListWithUploadInfo, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/Receipt/List`)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.Receipts.PredictedPaymentDate"}, {"type":"Day","key":"Data.Receipts.PredictedDate"}, {"type":"Day","key":"Data.Receipts.PaymentDate"}, {"type":"Date","key":"Data.Receipts.UploadedDate"}, {"type":"Day","key":"Data.Receipts.Date"}));
			}
		}
		export namespace ListAllReceiptsForUploadsScene {
			export function Get(org: string, includeBookkeptItems: boolean): Promise<m.Envelope<m.Bokio.Accounting.Contract.ViewData.ReceiptListWithUploadInfo, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/Receipt/ListAllReceiptsForUploadsScene`, { includeBookkeptItems })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.Receipts.PredictedPaymentDate"}, {"type":"Day","key":"Data.Receipts.PredictedDate"}, {"type":"Day","key":"Data.Receipts.PaymentDate"}, {"type":"Date","key":"Data.Receipts.UploadedDate"}, {"type":"Day","key":"Data.Receipts.Date"}));
			}
		}
		export namespace ListWithMatchScores {
			export function Get(org: string, itemId: string, itemType: m.Bokio.Accounting.Contract.EventsToRecord.Dtos.EventType): Promise<m.Envelope<m.Bokio.Accounting.Contract.Receipts.DTOs.ReceiptListWithMatchScoresDto, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/Receipt/ListWithMatchScores`, { itemId, itemType })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.Receipts.PredictedPaymentDate"}, {"type":"Day","key":"Data.Receipts.PredictedDate"}, {"type":"Day","key":"Data.Receipts.PaymentDate"}, {"type":"Date","key":"Data.Receipts.UploadedDate"}, {"type":"Day","key":"Data.Receipts.Date"}));
			}
		}
		export namespace MergeReceipts {
			export function Post(org: string, command: m.Bokio.Accounting.Contract.Receipts.Commands.MergeReceipts): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/Receipt/MergeReceipts`, command);
			}
		}
		export namespace RemoveTemporaryPages {
			export function Post(org: string, receiptId: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/Receipt/RemoveTemporaryPages`, { receiptId });
			}
		}
		export namespace ResetReceiptConnections {
			export function Post(org: string, receiptId: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/Receipt/ResetReceiptConnections`, { receiptId });
			}
		}
		export namespace Rotate {
			export function Post(org: string, receiptId: string): Promise<m.Envelope<number, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/Receipt/Rotate`, { receiptId });
			}
		}
		export namespace RotateExtraPage {
			export function Post(org: string, extraPageId: string): Promise<m.Envelope<number, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/Receipt/RotateExtraPage`, { extraPageId });
			}
		}
		export namespace SetType {
			export function Post(org: string, request: m.Accounting.Controllers.SetReceiptTypeRequest): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/Receipt/SetType`, request);
			}
		}
		export namespace UndoDeleteExtraPage {
			export function Post(org: string, command: m.Model.Commands.Accounting.Reciepts.UndoDeleteExtraPage): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/Receipt/UndoDeleteExtraPage`, command);
			}
		}
		export namespace Update {
			export function Put(org: string, request: m.Accounting.Controllers.UpdateReceiptRequest): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.put(`/${org}/Accounting/Receipt/Update`, request);
			}
		}
		export namespace UpdateSupportTicket {
			export function Post(org: string, command: m.Model.Commands.Support.UpdateSupportTicket): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/Receipt/UpdateSupportTicket`, command);
			}
		}
		export namespace UploadExpenseImage {
			export function Post(org: string, request: m.Accounting.Controllers.UploadExpenseImageRequest): Promise<m.Envelope<m.Accounting.Viewmodels.Receipts.ExpenseListViewModel, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/Receipt/UploadExpenseImage`, request)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.ClaimDate"}, {"type":"Day","key":"Data.ExpenseDate"}, {"type":"Day","key":"Data.PaymentDate"}, {"type":"Day","key":"Data.ExpenseBookkeepingDate"}));
			}
		}
		export namespace UploadExpenseImageWithFile {
			export function Post(org: string, file: (File | Blob | string), expenseForEmployeeId: string, startRecepiptPredictionsNow?: boolean): Promise<m.Envelope<m.Accounting.Viewmodels.Receipts.ExpenseListViewModel, m.SimpleError>> {
				const form = new FormData();
				form.append("file", file);
				form.append("expenseForEmployeeId", expenseForEmployeeId);
				startRecepiptPredictionsNow && form.append("startRecepiptPredictionsNow", startRecepiptPredictionsNow.toString());
				return Client.post(`/${org}/Accounting/Receipt/UploadExpenseImageWithFile`, form, true)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.ClaimDate"}, {"type":"Day","key":"Data.ExpenseDate"}, {"type":"Day","key":"Data.PaymentDate"}, {"type":"Day","key":"Data.ExpenseBookkeepingDate"}));
			}
		}
		export namespace UploadExpensesPdf {
			export function Post(org: string, file: (File | Blob | string), expenseForEmployeeId: string, startRecepiptPredictionsNow?: boolean): Promise<m.Envelope<m.Accounting.Viewmodels.Receipts.ExpenseListViewModel, m.SimpleError>> {
				const form = new FormData();
				form.append("file", file);
				form.append("expenseForEmployeeId", expenseForEmployeeId);
				startRecepiptPredictionsNow && form.append("startRecepiptPredictionsNow", startRecepiptPredictionsNow.toString());
				return Client.post(`/${org}/Accounting/Receipt/UploadExpensesPdf`, form, true)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.ClaimDate"}, {"type":"Day","key":"Data.ExpenseDate"}, {"type":"Day","key":"Data.PaymentDate"}, {"type":"Day","key":"Data.ExpenseBookkeepingDate"}));
			}
		}
		export namespace UploadNewReceipt {
			export function Post(org: string, files: (File | Blob | string)[]): Promise<m.Envelope<string, m.SimpleError>> {
				const form = new FormData();
				files.forEach(item => form.append("files", item));
				return Client.post(`/${org}/Accounting/Receipt/UploadNewReceipt`, form, true);
			}
		}
		export namespace UploadPdf {
			export function Post(org: string, file: (File | Blob | string), selectedType: string, account?: number, verificationId?: string, autoVerificationRowId?: string, startRecepiptPredictionsNow?: boolean): Promise<m.Accounting.Viewmodels.ReceiptViewModel> {
				const form = new FormData();
				form.append("file", file);
				form.append("selectedType", selectedType);
				verificationId && form.append("verificationId", verificationId);
				autoVerificationRowId && form.append("autoVerificationRowId", autoVerificationRowId);
				startRecepiptPredictionsNow && form.append("startRecepiptPredictionsNow", startRecepiptPredictionsNow.toString());
				return Client.post(`/${org}/Accounting/Receipt/UploadPdf`, form, true)
				             .then(data => convertByKeys(data, {"type":"Day","key":"ExpenseDate"}));
			}
		}
		export namespace UploadPdfExtraPage {
			export function Post(org: string, pdf: (File | Blob | string), receiptId: string, temporary: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				const form = new FormData();
				form.append("pdf", pdf);
				form.append("receiptId", receiptId);
				form.append("temporary", temporary);
				return Client.post(`/${org}/Accounting/Receipt/UploadPdfExtraPage`, form, true);
			}
		}
		export namespace UploadReceiptExtraPage {
			export function Post(org: string, request: m.Accounting.Controllers.UploadReceiptExtraPageRequest): Promise<m.Accounting.Viewmodels.ReceiptExtraPageViewModel> {
				return Client.post(`/${org}/Accounting/Receipt/UploadReceiptExtraPage`, request);
			}
		}
		export namespace UploadReceiptExtraPageWithFile {
			export function Post(org: string, file: (File | Blob | string), receiptId: string, temporary?: boolean): Promise<m.Accounting.Viewmodels.ReceiptExtraPageViewModel> {
				const form = new FormData();
				form.append("file", file);
				form.append("receiptId", receiptId);
				temporary && form.append("temporary", temporary.toString());
				return Client.post(`/${org}/Accounting/Receipt/UploadReceiptExtraPageWithFile`, form, true);
			}
		}
		export namespace UploadReceiptWithFile {
			export function Post(org: string, file: (File | Blob | string), selectedType: string, verificationId?: string, autoVerificationRowId?: string, description?: string, startRecepiptPredictionsNow?: boolean): Promise<m.Accounting.Viewmodels.ReceiptViewModel> {
				const form = new FormData();
				form.append("file", file);
				form.append("selectedType", selectedType);
				verificationId && form.append("verificationId", verificationId);
				autoVerificationRowId && form.append("autoVerificationRowId", autoVerificationRowId);
				description && form.append("description", description);
				startRecepiptPredictionsNow && form.append("startRecepiptPredictionsNow", startRecepiptPredictionsNow.toString());
				return Client.post(`/${org}/Accounting/Receipt/UploadReceiptWithFile`, form, true)
				             .then(data => convertByKeys(data, {"type":"Day","key":"ExpenseDate"}));
			}
		}
		export namespace UploadReciept {
			export function Post(org: string, uploadReceiptRequest: m.Accounting.Controllers.UploadReceiptRequest): Promise<m.Accounting.Viewmodels.ReceiptViewModel> {
				return Client.post(`/${org}/Accounting/Receipt/UploadReciept`, uploadReceiptRequest)
				             .then(data => convertByKeys(data, {"type":"Day","key":"ExpenseDate"}));
			}
		}
	}
	export namespace RecordingPeriodisationController {
		export namespace CombinedPreview {
			export function Post(org: string, request: m.Accounting.Controllers.CombinedPreviewRequest): Promise<m.Envelope<m.Accounting.Controllers.CombinedPreviewResponse, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/RecordingPeriodisation/CombinedPreview`, request)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.AdjustmentVerification.Date"}, {"type":"Day","key":"Data.PlannedVerifications.Date"}));
			}
		}
		export namespace Create {
			export function Post(org: string, request: m.Accounting.Controllers.CreatePeriodisationRequest): Promise<m.Envelope<m.Accounting.Controllers.CreatePeriodisationResponse, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/RecordingPeriodisation/Create`, request);
			}
		}
		export namespace FinishEarly {
			export function Post(org: string, request: m.Accounting.Controllers.FinishEarlyRequest): Promise<m.Envelope<m.Accounting.Controllers.FinishEarlyResponse, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/RecordingPeriodisation/FinishEarly`, request)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.EffectiveDate"}));
			}
		}
		export namespace GetAll {
			export function Get(org: string, status?: m.Entities.Accounting.RecordingPeriodisationStatus): Promise<m.Envelope<m.Accounting.Controllers.GetAllPeriodisationsResponse, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/RecordingPeriodisation/GetAll`, { status })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.Periodisations.StartMonth"}, {"type":"Day","key":"Data.Periodisations.EndMonth"}, {"type":"Day","key":"Data.Periodisations.Entries.Date"}));
			}
		}
		export namespace GetById {
			export function Get(org: string, id: string): Promise<m.Envelope<m.Accounting.Controllers.PeriodisationDetailItem, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/RecordingPeriodisation/GetById/${id}`)
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.CreatedAtUtc"}, {"type":"Day","key":"Data.StartMonth"}, {"type":"Day","key":"Data.EndMonth"}, {"type":"Day","key":"Data.Entries.Date"}));
			}
		}
		export namespace GetByVerification {
			export function Get(org: string, verificationId: string): Promise<m.Envelope<m.Accounting.Controllers.PeriodisationStatusResponse, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/RecordingPeriodisation/GetByVerification`, { verificationId })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.StartMonth"}, {"type":"Day","key":"Data.EndMonth"}));
			}
		}
		export namespace GetDraftVerifications {
			export function Get(org: string): Promise<m.Envelope<m.Accounting.Controllers.PeriodisationDraftVerificationsResponse, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/RecordingPeriodisation/GetDraftVerifications`)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.DraftVerifications.Date"}));
			}
		}
		export namespace Preview {
			export function Post(org: string, request: m.Accounting.Controllers.CreatePeriodisationRequest): Promise<m.Envelope<m.Accounting.Controllers.PreviewPeriodisationResponse, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/RecordingPeriodisation/Preview`, request)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.AdjustmentVerification.Date"}, {"type":"Day","key":"Data.PlannedVerifications.Date"}));
			}
		}
		export namespace PreviewUndo {
			export function Post(org: string, periodisationId: string): Promise<m.Envelope<m.Accounting.Controllers.PreviewUndoResponse, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/RecordingPeriodisation/PreviewUndo`, { periodisationId })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.ReversalDate"}, {"type":"Day","key":"Data.OriginalDate"}, {"type":"Day","key":"Data.Entries.Date"}));
			}
		}
		export namespace PreviewUndoLastEntry {
			export function Post(org: string, periodisationId: string): Promise<m.Envelope<m.Accounting.Controllers.PreviewUndoLastEntryResponse, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/RecordingPeriodisation/PreviewUndoLastEntry`, { periodisationId })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.VerificationDate"}, {"type":"Day","key":"Data.ReversalDate"}));
			}
		}
		export namespace Undo {
			export function Post(org: string, periodisationId: string): Promise<m.Envelope<m.Accounting.Controllers.UndoPeriodisationResponse, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/RecordingPeriodisation/Undo`, { periodisationId })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.ReversalDate"}));
			}
		}
		export namespace UndoLastEntry {
			export function Post(org: string, periodisationId: string): Promise<m.Envelope<m.Accounting.Controllers.UndoLastEntryResponse, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/RecordingPeriodisation/UndoLastEntry`, { periodisationId })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.ReversalDate"}));
			}
		}
	}
	export namespace ReportMappingsController {
		export namespace GetNEMappings {
			export function Get(org: string, cellKey: string, yearStart: number, yearEnd: number): Promise<m.Envelope<m.Bokio.Accounting.Contract.Reports.ReportBoxMappingsDto, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/ReportMappings/GetNEMappings`, { cellKey, yearStart, yearEnd })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.Mappings.VerificationDate"}));
			}
		}
		export namespace GetVatMappings {
			export function Get(org: string, cellKey: string, periodEnd: Day): Promise<m.Envelope<m.Bokio.Accounting.Contract.Reports.ReportBoxMappingsDto, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/ReportMappings/GetVatMappings`, { cellKey, periodEnd })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.Mappings.VerificationDate"}));
			}
		}
	}
	export namespace ReportsController {
		export namespace AccountBalances {
			export function Get(org: string, fromDate?: Day, toDate?: Day): Promise<m.Accounting.Viewmodels.Reports.LedgerReportRow[]> {
				return Client.get(`/${org}/Accounting/Reports/AccountBalances`, { fromDate, toDate })
				             .then(data => convertByKeys(data, {"type":"Day","key":"SubRows.TransactionDate"}));
			}
		}
		export namespace AccountsPayable {
			export function Get(org: string, date: Day): Promise<m.Envelope<m.Accounting.Viewmodels.Reports.AccountsPayableResult, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/Reports/AccountsPayable`, { date })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.Suppliers.Invoices.InvoiceDate"}, {"type":"Date","key":"Data.Suppliers.Invoices.Deadline"}));
			}
		}
		export namespace Balance {
			export function Get(org: string, fromDate?: Day, toDate?: Day): Promise<m.Accounting.Viewmodels.Reports.BalanceReportViewModel> {
				return Client.get(`/${org}/Accounting/Reports/Balance`, { fromDate, toDate })
				             .then(data => convertByKeys(data, {"type":"Day","key":"ReportSpan.StartDate"}, {"type":"Day","key":"ReportSpan.EndDate"}, {"type":"Day","key":"FiscalYears.FiscalYear.StartDate"}, {"type":"Day","key":"FiscalYears.FiscalYear.EndDate"}, {"type":"Day","key":"Rows.Date"}, {"type":"Day","key":"Rows.SubRows.Date"}, {"type":"Day","key":"Rows.SubRows.SubRows.Date"}, {"type":"Day","key":"Rows.SubRows.SubRows.SubRows.Date"}));
			}
		}
		export namespace BalanceBalanced {
			export function Get(org: string, fromDate?: Day, toDate?: Day): Promise<m.Envelope<m.Accounting.Viewmodels.Reports.BalanceReportViewModel, m.Bokio.Accounting.Contract.Reports.ReportControllerErrors>> {
				return Client.get(`/${org}/Accounting/Reports/BalanceBalanced`, { fromDate, toDate })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.ReportSpan.StartDate"}, {"type":"Day","key":"Data.ReportSpan.EndDate"}, {"type":"Day","key":"Data.FiscalYears.FiscalYear.StartDate"}, {"type":"Day","key":"Data.FiscalYears.FiscalYear.EndDate"}, {"type":"Day","key":"Data.Rows.Date"}, {"type":"Day","key":"Data.Rows.SubRows.Date"}, {"type":"Day","key":"Data.Rows.SubRows.SubRows.Date"}, {"type":"Day","key":"Data.Rows.SubRows.SubRows.SubRows.Date"}));
			}
		}
		export namespace BalanceReportAccountRow {
			export function Get(org: string, fromDate: Day, toDate: Day, key: string): Promise<m.Core.ViewData.BalanceReportRowDto> {
				return Client.get(`/${org}/Accounting/Reports/BalanceReportAccountRow`, { fromDate, toDate, key })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Date"}, {"type":"Day","key":"SubRows.Date"}, {"type":"Day","key":"SubRows.SubRows.Date"}, {"type":"Day","key":"SubRows.SubRows.SubRows.Date"}, {"type":"Day","key":"SubRows.SubRows.SubRows.SubRows.Date"}));
			}
		}
		export namespace BalanceSubRows {
			export function Get(org: string, fromDate: Day, toDate: Day, key: string, showInactive?: boolean): Promise<m.Core.ViewData.BalanceReportRowDto[]> {
				return Client.get(`/${org}/Accounting/Reports/BalanceSubRows`, { fromDate, toDate, key, showInactive })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Date"}, {"type":"Day","key":"SubRows.Date"}, {"type":"Day","key":"SubRows.SubRows.Date"}, {"type":"Day","key":"SubRows.SubRows.SubRows.Date"}, {"type":"Day","key":"SubRows.SubRows.SubRows.SubRows.Date"}));
			}
		}
		export namespace GetPeriods {
			export function Get(org: string): Promise<m.Accounting.Controllers.ReportPeriodWithMonthSubs[]> {
				return Client.get(`/${org}/Accounting/Reports/GetPeriods`)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Subs.StartDate"}, {"type":"Day","key":"Subs.EndDate"}, {"type":"Day","key":"StartDate"}, {"type":"Day","key":"EndDate"}));
			}
		}
		export namespace Ledger {
			export function Get(org: string, fromDate?: Day, toDate?: Day, showDeleted?: boolean): Promise<m.Envelope<m.Accounting.Viewmodels.Reports.LedgerReportViewModel, m.Bokio.Accounting.Contract.Reports.ReportControllerErrors>> {
				return Client.get(`/${org}/Accounting/Reports/Ledger`, { fromDate, toDate, showDeleted })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.Rows.SubRows.TransactionDate"}, {"type":"Day","key":"Data.PrintData.ReportSpan.StartDate"}, {"type":"Day","key":"Data.PrintData.ReportSpan.EndDate"}, {"type":"Day","key":"Data.PrintData.FiscalYears.FiscalYear.StartDate"}, {"type":"Day","key":"Data.PrintData.FiscalYears.FiscalYear.EndDate"}));
			}
		}
		export namespace Result {
			export function Get(org: string, fromDate?: Day, toDate?: Day, allowedTagTypeValueId?: string): Promise<m.Envelope<m.Accounting.Viewmodels.Reports.ResultReportViewModel, m.Bokio.Accounting.Contract.Reports.ReportControllerErrors>> {
				return Client.get(`/${org}/Accounting/Reports/Result`, { fromDate, toDate, allowedTagTypeValueId })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.FiscalYears.FiscalYear.StartDate"}, {"type":"Day","key":"Data.FiscalYears.FiscalYear.EndDate"}, {"type":"Day","key":"Data.Periods.FromDate"}, {"type":"Day","key":"Data.Periods.ToDate"}));
			}
		}
		export namespace ResultReportAccountRow {
			export function Get(org: string, fromDate: Day, toDate: Day, key: string, allowedTagTypeValueId?: string): Promise<m.Core.ViewData.ResultReportRowDto> {
				return Client.get(`/${org}/Accounting/Reports/ResultReportAccountRow`, { fromDate, toDate, key, allowedTagTypeValueId });
			}
		}
		export namespace TagReport {
			export function Post(org: string, fromDate: Day, toDate: Day, tagConfig: m.Bokio.Accounting.Web.Accounting.Controllers.TagReportTagConfig): Promise<m.Envelope<m.Accounting.Viewmodels.Reports.ResultReportViewModel, m.Bokio.Accounting.Contract.Reports.ReportControllerErrors>> {
				return Client.post(Client.getPathWithQueryString(`/${org}/Accounting/Reports/TagReport`, { fromDate, toDate }), tagConfig)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.FiscalYears.FiscalYear.StartDate"}, {"type":"Day","key":"Data.FiscalYears.FiscalYear.EndDate"}, {"type":"Day","key":"Data.Periods.FromDate"}, {"type":"Day","key":"Data.Periods.ToDate"}));
			}
		}
		export namespace TagReportVerificationsInAccount {
			export function Post(org: string, fromDate: Day, toDate: Day, tagConfig: m.Bokio.Accounting.Web.Accounting.Controllers.TagReportAccountRowConfig): Promise<m.Envelope<m.Core.Reports.VerificationForReport[], m.SimpleError>> {
				return Client.post(Client.getPathWithQueryString(`/${org}/Accounting/Reports/TagReportVerificationsInAccount`, { fromDate, toDate }), tagConfig)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.Date"}));
			}
		}
		export namespace VerificationsInAccount {
			export function Get(org: string, fromDate: Day, toDate: Day, key: string, showInactive?: boolean, allowedTagTypeValueId?: string): Promise<m.Core.Reports.VerificationForReport[]> {
				return Client.get(`/${org}/Accounting/Reports/VerificationsInAccount`, { fromDate, toDate, key, showInactive, allowedTagTypeValueId })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Date"}));
			}
		}
	}
	export namespace SeVatController {
		export namespace DoDownloadReport {
			export function Post(org: string, request: m.Accounting.Viewmodels.Files.SeVatReportRequest): Promise<m.Envelope<m.Accounting.Viewmodels.Reports.SeVatReportStateTransitionViewModel, m.Accounting.Viewmodels.Reports.SeVatReportError>> {
				return Client.post(`/${org}/Accounting/SeVat/DoDownloadReport`, request);
			}
		}
		export namespace DoLockReport {
			export function Post(org: string, request: m.Accounting.Viewmodels.Files.SeVatReportLockRequest): Promise<m.Envelope<m.Accounting.Viewmodels.Reports.SeVatReportStateTransitionViewModel, m.Accounting.Viewmodels.Reports.SeVatReportError>> {
				return Client.post(`/${org}/Accounting/SeVat/DoLockReport`, request);
			}
		}
		export namespace DoMarkAsComplete {
			export function Post(org: string, request: m.Accounting.Viewmodels.Files.SeVatRequest): Promise<m.Envelope<m.Accounting.Viewmodels.Reports.SeVatReportStateTransitionViewModel, m.Accounting.Viewmodels.Reports.SeVatReportError>> {
				return Client.post(`/${org}/Accounting/SeVat/DoMarkAsComplete`, request);
			}
		}
		export namespace DoReconcile {
			export function Post(org: string, request: m.Accounting.Viewmodels.Files.SeVatRequest): Promise<m.Envelope<m.Accounting.Viewmodels.Reports.SeVatReportStateTransitionViewModel, m.Accounting.Viewmodels.Reports.SeVatReportError>> {
				return Client.post(`/${org}/Accounting/SeVat/DoReconcile`, request);
			}
		}
		export namespace MarkAsTaxesAsRecordedManually {
			export function Post(org: string, id: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/SeVat/MarkAsTaxesAsRecordedManually/${id}`, {  });
			}
		}
		export namespace PreviewTaxVerifications {
			export function Get(org: string, id: string): Promise<m.Envelope<m.Core.ViewData.VerificationForList[], m.SimpleError>> {
				return Client.get(`/${org}/Accounting/SeVat/PreviewTaxVerifications/${id}`)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.Date"}, {"type":"Day","key":"Data.ExpectPaymentAt"}, {"type":"Date","key":"Data.CreatedUtc"}));
			}
		}
		export namespace RecordTaxes {
			export function Post(org: string, id: string, dto: m.Accounting.Viewmodels.Files.RecordVatTaxesDto): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/SeVat/RecordTaxes/${id}`, dto);
			}
		}
		export namespace RecordTaxesFromBankRow {
			export function Post(org: string, id: string, dto: m.Accounting.Viewmodels.Files.RecordVatTaxesFromAutoVerificationDto): Promise<m.Envelope<m.Bokio.Common.Contract.ViewData.VerificationRecordingResult, m.Bokio.Accounting.Web.Accounting.Controllers.RecordVatTaxesFromBankRowError>> {
				return Client.post(`/${org}/Accounting/SeVat/RecordTaxesFromBankRow/${id}`, dto);
			}
		}
		export namespace ScheduleVatPeriodBBAPayment {
			export function Post(org: string, id: string, request: m.Accounting.Viewmodels.Reports.ScheduleVatPaymentRequest): Promise<m.Envelope<string, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/SeVat/ScheduleVatPeriodBBAPayment/${id}`, request);
			}
		}
		export namespace UndoDownloadReport {
			export function Post(org: string, request: m.Accounting.Viewmodels.Files.SeVatReportRequest): Promise<m.Envelope<m.Accounting.Viewmodels.Reports.SeVatReportStateTransitionViewModel, m.Accounting.Viewmodels.Reports.SeVatReportError>> {
				return Client.post(`/${org}/Accounting/SeVat/UndoDownloadReport`, request);
			}
		}
		export namespace UndoLockReport {
			export function Post(org: string, request: m.Accounting.Viewmodels.Files.SeVatReportRequest): Promise<m.Envelope<m.Accounting.Viewmodels.Reports.SeVatReportStateTransitionViewModel, m.Accounting.Viewmodels.Reports.SeVatReportError>> {
				return Client.post(`/${org}/Accounting/SeVat/UndoLockReport`, request);
			}
		}
		export namespace UndoMarkAsComplete {
			export function Post(org: string, request: m.Accounting.Viewmodels.Files.SeVatReportRequest): Promise<m.Envelope<m.Accounting.Viewmodels.Reports.SeVatReportStateTransitionViewModel, m.Accounting.Viewmodels.Reports.SeVatReportError>> {
				return Client.post(`/${org}/Accounting/SeVat/UndoMarkAsComplete`, request);
			}
		}
		export namespace UndoMarkAsTaxesAsRecordedManually {
			export function Post(org: string, id: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/SeVat/UndoMarkAsTaxesAsRecordedManually/${id}`, {  });
			}
		}
		export namespace UndoReconcile {
			export function Post(org: string, request: m.Accounting.Viewmodels.Files.SeVatReportRequest): Promise<m.Envelope<m.Accounting.Viewmodels.Reports.SeVatReportStateTransitionViewModel, m.Accounting.Viewmodels.Reports.SeVatReportError>> {
				return Client.post(`/${org}/Accounting/SeVat/UndoReconcile`, request);
			}
		}
	}
	export namespace SupplierInvoiceController {
		export namespace AbortScheduledSupplierInvoicePayment {
			export function Post(org: string, supplierInvoiceSchedulePaymentId: string): Promise<m.Envelope<boolean, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.post(`/${org}/Accounting/SupplierInvoice/AbortScheduledSupplierInvoicePayment`, { supplierInvoiceSchedulePaymentId });
			}
		}
		export namespace Add {
			export function Post(org: string, request: m.Bokio.Accounting.Contract.SupplierInvoices.Requests.AddSupplierInvoiceRequest): Promise<m.Envelope<string, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/SupplierInvoice/Add`, request);
			}
		}
		export namespace AddPayment {
			export function Post(org: string, request: m.Bokio.Accounting.Contract.SupplierInvoices.Requests.AddSupplierInvoicePaymentRequest): Promise<m.Envelope<m.Bokio.Accounting.Contract.SupplierInvoices.Dtos.SupplierPaymentDto, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/SupplierInvoice/AddPayment`, request)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.Date"}));
			}
		}
		export namespace ApproverLimitedView {
			export function Get(org: string, invoiceId: string): Promise<m.Envelope<m.Bokio.Accounting.Contract.AttestationRequest.AttestationApprovalViewDto, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/SupplierInvoice/ApproverLimitedView`, { invoiceId })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.Invoice.Date"}, {"type":"Day","key":"Data.Invoice.Deadline"}, {"type":"Date","key":"Data.Groups.Requests.CreatedAtUtc"}, {"type":"Date","key":"Data.Groups.Requests.CompletedAtUtc"}, {"type":"Date","key":"Data.Groups.Requests.Steps.ActionAtUtc"}, {"type":"Date","key":"Data.Groups.Requests.Steps.DeadlineUtc"}, {"type":"Date","key":"Data.Groups.Requests.Steps.CreatedAtUtc"}));
			}
		}
		export namespace CheckDuplicate {
			export function Get(org: string, supplierId: string, date: Day, sum: number): Promise<m.Envelope<m.Bokio.Accounting.Contract.SupplierInvoices.Dtos.DuplicateSupplierInvoiceCheckResult, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/SupplierInvoice/CheckDuplicate`, { supplierId, date, sum });
			}
		}
		export namespace ConnectCreditToOriginal {
			export function Post(org: string, request: m.Bokio.Accounting.Contract.SupplierInvoices.Requests.ConnectCreditToOriginalRequest): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/SupplierInvoice/ConnectCreditToOriginal`, request);
			}
		}
		export namespace ConnectToAutoVerification {
			export function Post(org: string, request: m.Bokio.Accounting.Contract.SupplierInvoices.Dtos.ConnectToAutoVerificationRowRequest): Promise<m.Envelope<m.Bokio.Accounting.Contract.SupplierInvoices.Dtos.ConnectToAutoVerificationRowResult, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/SupplierInvoice/ConnectToAutoVerification`, request);
			}
		}
		export namespace ConnectToAutoVerificationRowPreview {
			export function Get(org: string, supplierInvoiceId: string, autoverificationRowId: string, settlementType?: m.Bokio.Accounting.Contract.SupplierInvoices.Dtos.SupplierInvoiceSettlementType): Promise<m.Envelope<m.Bokio.Accounting.Contract.SupplierInvoices.Dtos.ConnectSupplierInvoiceToAutoverificationRowPreviewDto, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/SupplierInvoice/ConnectToAutoVerificationRowPreview`, { supplierInvoiceId, autoverificationRowId, settlementType })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.PaymentDate"}, {"type":"Day","key":"Data.InvoiceDate"}, {"type":"Day","key":"Data.InvoiceDueDate"}));
			}
		}
		export namespace ConnectToReceipt {
			export function Post(org: string, request: m.Bokio.Accounting.Contract.SupplierInvoices.Requests.ConnectSupplierInvoicesToReceipt): Promise<m.Envelope<string, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/SupplierInvoice/ConnectToReceipt`, request);
			}
		}
		export namespace ConnectVerificationToInvoice {
			export function Post(org: string, request: m.Bokio.Accounting.Contract.SupplierInvoices.Requests.ConnectExistingVerificationToInvoiceRequest): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/SupplierInvoice/ConnectVerificationToInvoice`, request);
			}
		}
		export namespace CreateAlienSupplierInvoice {
			export function Post(org: string, request: m.Bokio.Accounting.Contract.SupplierInvoices.Requests.CreateAlienSupplierInvoiceRequest): Promise<m.Envelope<string, m.Core.ViewData.AlienInvoiceError[]>> {
				return Client.post(`/${org}/Accounting/SupplierInvoice/CreateAlienSupplierInvoice`, request);
			}
		}
		export namespace CreateSupplierInvoiceAndAddPayment {
			export function Post(org: string, request: m.Bokio.Accounting.Contract.SupplierInvoices.Requests.CreateSupplierInvoiceAndAddPaymentRequest): Promise<m.Envelope<m.Bokio.Accounting.Contract.SupplierInvoices.Dtos.AddSupplierInvoicePaymentDto, m.Bokio.Accounting.Contract.Suppliers.Dtos.AddOrEditSupplierError>> {
				return Client.post(`/${org}/Accounting/SupplierInvoice/CreateSupplierInvoiceAndAddPayment`, request);
			}
		}
		export namespace Delete {
			export function Post(org: string, invoiceId: string): Promise<m.Envelope<boolean, m.Accounting.Controllers.SupplierInvoiceDeleteError>> {
				return Client.post(`/${org}/Accounting/SupplierInvoice/Delete`, { invoiceId });
			}
		}
		export namespace DeletePayment {
			export function Post(org: string, paymentId: string): Promise<m.Envelope<string, m.Accounting.Controllers.SupplierInvoiceDeleteError>> {
				return Client.post(`/${org}/Accounting/SupplierInvoice/DeletePayment`, { paymentId });
			}
		}
		export namespace DeletePaymentPreview {
			export function Get(org: string, id: string): Promise<m.Bokio.Accounting.Contract.SupplierInvoices.Dtos.DeletePaymentPreviewDto> {
				return Client.get(`/${org}/Accounting/SupplierInvoice/DeletePaymentPreview/${id}`);
			}
		}
		export namespace DeletePreview {
			export function Get(org: string, supplierInvoiceId: string): Promise<m.Envelope<m.Bokio.Accounting.Contract.SupplierInvoices.Dtos.DeleteSupplierInvoicePreviewDto, m.Bokio.Accounting.Contract.SupplierInvoices.Requests.DeleteSupplierInvoicePreviewError>> {
				return Client.get(`/${org}/Accounting/SupplierInvoice/DeletePreview`, { supplierInvoiceId })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.Payments.Date"}));
			}
		}
		export namespace DeleteScheduledSupplierInvoicePayment {
			export function Post(org: string, scheduledPaymentId: string): Promise<m.Envelope<boolean, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.post(`/${org}/Accounting/SupplierInvoice/DeleteScheduledSupplierInvoicePayment`, { scheduledPaymentId });
			}
		}
		export namespace DeleteSupplierInvoiceRecording {
			export function Post(org: string, invoiceId: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/SupplierInvoice/DeleteSupplierInvoiceRecording`, { invoiceId });
			}
		}
		export namespace Edit {
			export function Post(org: string, request: m.Bokio.Accounting.Contract.SupplierInvoices.Requests.EditSupplierInvoiceRequest): Promise<m.Envelope<string, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/SupplierInvoice/Edit`, request);
			}
		}
		export namespace EditAlienSupplierInvoice {
			export function Post(org: string, request: m.Bokio.Accounting.Contract.SupplierInvoices.Requests.EditAlienSupplierInvoiceRequest): Promise<m.Envelope<string, m.Core.ViewData.AlienInvoiceError[]>> {
				return Client.post(`/${org}/Accounting/SupplierInvoice/EditAlienSupplierInvoice`, request);
			}
		}
		export namespace Get {
			export function Get(org: string, id: string): Promise<m.Envelope<m.Bokio.Accounting.Contract.SupplierInvoices.Dtos.SupplierInvoiceDetailsDto, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/SupplierInvoice/Get/${id}`)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.Date"}, {"type":"Day","key":"Data.Deadline"}, {"type":"Date","key":"Data.Saved"}, {"type":"Date","key":"Data.History.Date"}, {"type":"Date","key":"Data.History.PaymentDate"}, {"type":"Day","key":"Data.Payments.Date"}, {"type":"Date","key":"Data.AttestationRequests.Requests.CreatedAtUtc"}, {"type":"Date","key":"Data.AttestationRequests.Requests.CompletedAtUtc"}, {"type":"Date","key":"Data.AttestationRequests.Requests.Steps.ActionAtUtc"}, {"type":"Date","key":"Data.AttestationRequests.Requests.Steps.DeadlineUtc"}, {"type":"Date","key":"Data.AttestationRequests.Requests.Steps.CreatedAtUtc"}));
			}
		}
		export namespace GetAvailableSettlementTypes {
			export function Get(org: string, supplierInvoiceId: string, paymentAmount: number): Promise<m.Envelope<m.Bokio.Accounting.Contract.SupplierInvoices.Dtos.SupplierInvoiceSettlementType[], m.SimpleError>> {
				return Client.get(`/${org}/Accounting/SupplierInvoice/GetAvailableSettlementTypes`, { supplierInvoiceId, paymentAmount });
			}
		}
		export namespace GetPeriodisationStatus {
			export function Get(org: string, id: string): Promise<m.Envelope<m.Bokio.Accounting.Web.SupplierInvoices.Controllers.ToggleSupplierInvoicePeriodisationResult, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/SupplierInvoice/GetPeriodisationStatus/${id}`);
			}
		}
		export namespace GetStatusForInvoice {
			export function Get(org: string, id: string): Promise<m.Envelope<m.Core.ViewData.SupplierInvoiceStatus[], m.SimpleError>> {
				return Client.get(`/${org}/Accounting/SupplierInvoice/GetStatusForInvoice/${id}`);
			}
		}
		export namespace GetVerificationsForSupplierInvoice {
			export function Get(org: string, supplierInvoiceId: string): Promise<m.Envelope<m.Bokio.Accounting.Contract.SupplierInvoices.Dtos.SupplierInvoiceVerificationsDto, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/SupplierInvoice/GetVerificationsForSupplierInvoice`, { supplierInvoiceId });
			}
		}
		export namespace GetVerificationsMatchingPayment {
			export function Get(org: string, supplierInvoiceId: string): Promise<m.Envelope<m.Bokio.Accounting.Contract.SupplierInvoices.Dtos.MatchingPaymentVerificationDto[], m.SimpleError>> {
				return Client.get(`/${org}/Accounting/SupplierInvoice/GetVerificationsMatchingPayment`, { supplierInvoiceId })
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.Date"}));
			}
		}
		export namespace ListAlienSupplierInvoices {
			export function Get(org: string): Promise<m.Envelope<m.Invoices.ViewModels.AlienInvoiceForList[], m.SimpleError>> {
				return Client.get(`/${org}/Accounting/SupplierInvoice/ListAlienSupplierInvoices`)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.InvoiceDate"}, {"type":"Day","key":"Data.Deadline"}));
			}
		}
		export namespace ScheduleTellerSupplierInvoicePayment {
			export function Post(org: string, request: m.Bokio.Accounting.Contract.SupplierInvoices.Requests.ScheduleTellerSupplierInvoicePaymentRequest): Promise<m.Envelope<string, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.post(`/${org}/Accounting/SupplierInvoice/ScheduleTellerSupplierInvoicePayment`, request);
			}
		}
		export namespace SetScheduledPayment {
			export function Post(org: string, command: m.Bokio.Accounting.Contract.SupplierInvoices.Commands.SetSupplierInvoiceScheduledPayment): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/SupplierInvoice/SetScheduledPayment`, command);
			}
		}
		export namespace ShouldFollowUpReceivingEInvoiceRating {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Common.Contract.Metrics.Feedback.Dtos.RatingInstructionDto, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/SupplierInvoice/ShouldFollowUpReceivingEInvoiceRating`);
			}
		}
		export namespace TogglePeriodisationStatus {
			export function Post(org: string, request: m.Bokio.Accounting.Contract.SupplierInvoices.Requests.ToggleSupplierInvoicePeriodisationRequest): Promise<m.Envelope<m.Bokio.Accounting.Web.SupplierInvoices.Controllers.ToggleSupplierInvoicePeriodisationResult, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/SupplierInvoice/TogglePeriodisationStatus`, request);
			}
		}
		export namespace UpdateBookkeepingVariables {
			export function Post(org: string, request: m.Bokio.Accounting.Contract.SupplierInvoices.Requests.UpdateSupplierInvoiceRequest): Promise<m.Core.Recipes.RegisteredRecipeResult> {
				return Client.post(`/${org}/Accounting/SupplierInvoice/UpdateBookkeepingVariables`, request);
			}
		}
	}
	export namespace SuppliersController {
		export namespace Add {
			export function Post(org: string, request: m.Bokio.Accounting.Contract.Suppliers.Requests.AddSupplierRequest): Promise<m.Envelope<string, m.Bokio.Accounting.Contract.Suppliers.Dtos.AddOrEditSupplierError>> {
				return Client.post(`/${org}/Accounting/Suppliers/Add`, request);
			}
		}
		export namespace DeleteSupplier {
			export function Post(org: string, supplierId: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/Suppliers/DeleteSupplier`, { supplierId });
			}
		}
		export namespace Edit {
			export function Post(org: string, request: m.Bokio.Accounting.Contract.Suppliers.Requests.EditSupplierRequest): Promise<m.Envelope<string, m.Bokio.Accounting.Contract.Suppliers.Dtos.AddOrEditSupplierError>> {
				return Client.post(`/${org}/Accounting/Suppliers/Edit`, request);
			}
		}
		export namespace GetStatusOfSupplier {
			export function Get(org: string, supplierId: string): Promise<m.Envelope<m.Accounting.Controllers.SupplierStatus, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/Suppliers/GetStatusOfSupplier`, { supplierId });
			}
		}
		export namespace GetStatusOfSuppliers {
			export function Get(org: string): Promise<m.Envelope<m.Accounting.Controllers.SupplierStatus[], m.SimpleError>> {
				return Client.get(`/${org}/Accounting/Suppliers/GetStatusOfSuppliers`);
			}
		}
		export namespace GetSupplier {
			export function Get(org: string, supplierId: string): Promise<m.Envelope<m.Bokio.Accounting.Contract.Suppliers.Dtos.SupplierDto, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/Suppliers/GetSupplier`, { supplierId });
			}
		}
		export namespace GetSupplierInvoicesForList {
			export function Get(org: string, request: m.Bokio.Accounting.Contract.SupplierInvoices.Requests.SupplierInvoiceListRequest): Promise<m.Envelope<m.Bokio.Accounting.Contract.SupplierInvoices.Dtos.SupplierInvoiceListDto, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/Suppliers/GetSupplierInvoicesForList`, { request })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.Invoices.Deadline"}, {"type":"Day","key":"Data.Invoices.Date"}));
			}
		}
		export namespace GetSuppliers {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Accounting.Contract.Suppliers.Dtos.SupplierDto[], m.SimpleError>> {
				return Client.get(`/${org}/Accounting/Suppliers/GetSuppliers`);
			}
		}
	}
	export namespace TaxAccountController {
		export namespace CheckForNonExistingAccounts {
			export function Get(org: string): Promise<m.Bokio.Accounting.Web.Accounting.Viewmodels.Accounts.NonExistingAccountViewModel> {
				return Client.get(`/${org}/Accounting/TaxAccount/CheckForNonExistingAccounts`);
			}
		}
		export namespace CreateNonExistingAccounts {
			export function Post(org: string): Promise<m.Bokio.Accounting.Web.Accounting.Viewmodels.Accounts.NonExistingAccountViewModel> {
				return Client.post(`/${org}/Accounting/TaxAccount/CreateNonExistingAccounts`, {  });
			}
		}
		export namespace GetAccountBalance {
			export function Get(org: string, account: number, balanceDate: Day): Promise<number> {
				return Client.get(`/${org}/Accounting/TaxAccount/GetAccountBalance`, { account, balanceDate });
			}
		}
		export namespace ListAccounts {
			export function Get(org: string): Promise<m.Bokio.Accounting.Web.Accounting.Viewmodels.Accounts.BookkeepingAccountForListViewModel[]> {
				return Client.get(`/${org}/Accounting/TaxAccount/ListAccounts`);
			}
		}
		export namespace PreviewAccountBalance {
			export function Get(org: string, accounts: number[], balanceDate: Day): Promise<m.Accounting.Viewmodels.TaxAccounts.PreviewAccountDetails[]> {
				return Client.get(`/${org}/Accounting/TaxAccount/PreviewAccountBalance`, { accounts, balanceDate });
			}
		}
		export namespace Search {
			export function Get(org: string, search: string, defaultAccountsOnly?: boolean, country?: string): Promise<m.Accounting.Viewmodels.TaxAccounts.SearchViewModel> {
				return Client.get(`/${org}/Accounting/TaxAccount/Search`, { search, defaultAccountsOnly, country });
			}
		}
	}
	export namespace ToAttestController {
		export namespace List {
			export function Get(org: string): Promise<m.Accounting.Viewmodels.Verifications.ToAttestViewModel> {
				return Client.get(`/${org}/Accounting/ToAttest/List`)
				             .then(data => convertByKeys(data, {"type":"Date","key":"ToAttest.AuditDate"}, {"type":"Date","key":"ToAttest.ExpenseDate"}));
			}
		}
	}
	export namespace VATController {
		export namespace Debug {
			export function Get(org: string, year: number, period: number): Promise<m.Accounting.Viewmodels.Reports.VATReportDebugViewModel> {
				return Client.get(`/${org}/Accounting/VAT/Debug`, { year, period })
				             .then(data => convertByKeys(data, {"type":"Day","key":"VerificationDebugList.Date"}, {"type":"Day","key":"PeriodDateRange.Start"}, {"type":"Day","key":"PeriodDateRange.End"}));
			}
		}
		export namespace DeleteVatReport {
			export function Post(org: string, request: m.Accounting.Viewmodels.Reports.DeleteVatReportRequest): Promise<m.Envelope<string, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/VAT/DeleteVatReport`, request);
			}
		}
		export namespace List {
			export function Get(org: string, settingsId?: string, useNewStatuses?: boolean): Promise<m.Envelope<m.Core.Services.VAT.VatReportListDto, m.Core.Services.VAT.VatServiceError>> {
				return Client.get(`/${org}/Accounting/VAT/List`, { settingsId, useNewStatuses })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.ActiveFiscalYearRange.StartDate"}, {"type":"Day","key":"Data.ActiveFiscalYearRange.EndDate"}, {"type":"Day","key":"Data.Periods.FromDate"}, {"type":"Day","key":"Data.Periods.ToDate"}, {"type":"Date","key":"Data.Periods.Changed"}, {"type":"Day","key":"Data.Periods.DefaultVatTaxDate"}, {"type":"Day","key":"Data.Periods.VatTaxDate"}, {"type":"Day","key":"Data.Periods.NonEUTradeVatTaxDate"}));
			}
		}
		export namespace MarkAsTaxesPaid {
			export function Post(org: string, request: m.Accounting.Viewmodels.Reports.MarkVatTaxesAsPaid): Promise<m.Envelope<string, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/VAT/MarkAsTaxesPaid`, request);
			}
		}
		export namespace Preview {
			export function Get(org: string, year: number, period: number, cells: m.Entities.CellData[]): Promise<m.Envelope<m.Core.ViewData.VerificationForList, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/VAT/Preview`, { year, period, cells })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.Date"}, {"type":"Day","key":"Data.ExpectPaymentAt"}, {"type":"Date","key":"Data.CreatedUtc"}));
			}
		}
		export namespace RegisterVatReportPayment {
			export function Post(org: string, data: m.Accounting.Viewmodels.Reports.RegisterVatReportPayment): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/VAT/RegisterVatReportPayment`, data);
			}
		}
		export namespace Report2 {
			export function Get(org: string, year?: number, period?: number): Promise<m.Envelope<m.Accounting.Viewmodels.Reports.VATReportViewModel2, m.Bokio.Accounting.Web.Accounting.Controllers.VatReportError>> {
				return Client.get(`/${org}/Accounting/VAT/Report2`, { year, period })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.ReportViewModel.Layout.Period.Start"}, {"type":"Day","key":"Data.ReportViewModel.Layout.Period.End"}, {"type":"Day","key":"Data.ReportViewModel.ActivePeriod.FromDate"}, {"type":"Day","key":"Data.ReportViewModel.ActivePeriod.ToDate"}, {"type":"Day","key":"Data.ReportViewModel.ActivePeriod.Setting.FiscalYear.StartDate"}, {"type":"Day","key":"Data.ReportViewModel.ActivePeriod.Setting.FiscalYear.EndDate"}, {"type":"Day","key":"Data.ReportViewModel.ActivePeriod.DefaultVatTaxDate"}, {"type":"Day","key":"Data.ReportViewModel.ActivePeriod.VatTaxDate"}, {"type":"Day","key":"Data.ReportViewModel.ActivePeriod.NonEUTradeVatTaxDate"}, {"type":"Day","key":"Data.ReportViewModel.SavedReport.Verification.Date"}, {"type":"Day","key":"Data.ReportViewModel.SavedReport.Verification.ExpectPaymentAt"}, {"type":"Date","key":"Data.ReportViewModel.SavedReport.Verification.CreatedUtc"}, {"type":"Day","key":"Data.TaxInfo.TaxDeadline"}, {"type":"Day","key":"Data.TaxInfo.NonEUTradeTaxDeadline"}, {"type":"Day","key":"Data.TaxInfo.SuggestedTaxPaymentDate"}, {"type":"Day","key":"Data.TaxInfo.ScheduledPayments.RequestedDate"}, {"type":"Day","key":"Data.TaxInfo.TaxVerifications.VerificationDate"}));
			}
		}
		export namespace UndoMarkAsTaxesPaid {
			export function Post(org: string, request: m.Accounting.Viewmodels.Reports.UndoMarkVatTaxesAsPaid): Promise<m.Envelope<string, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/VAT/UndoMarkAsTaxesPaid`, request);
			}
		}
	}
	export namespace VerificationController {
		export namespace CorrectiveActions {
			export function Get(org: string, id: string): Promise<m.Envelope<m.Accounting.Controllers.VerificationEditActionsViewModel, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/Verification/CorrectiveActions/${id}`);
			}
		}
		export namespace Delete {
			export function Post(org: string, request: m.Bokio.Accounting.Contract.Verifications.Requests.DeleteVerificationRequest): Promise<m.Envelope<m.Accounting.Viewmodels.Verifications.DeleteResult, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/Verification/Delete`, request);
			}
		}
		export namespace Edit {
			export function Post(org: string, request: m.Bokio.Accounting.Contract.Verifications.Requests.EditVerificationRequest): Promise<m.Envelope<boolean, m.Core.Recipes.FailReason>> {
				return Client.post(`/${org}/Accounting/Verification/Edit`, request);
			}
		}
		export namespace Get {
			export function Get(org: string, id: string): Promise<m.Envelope<m.Core.ViewData.VerificationForList, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/Verification/Get/${id}`)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.Date"}, {"type":"Day","key":"Data.ExpectPaymentAt"}, {"type":"Date","key":"Data.CreatedUtc"}));
			}
		}
		export namespace GetPaymentInfo {
			export function Get(org: string, id: string): Promise<m.Envelope<m.Accounting.Viewmodels.Verifications.RegisterPaymentViewModel, m.Accounting.Controllers.GetPaymentInfoErrors>> {
				return Client.get(`/${org}/Accounting/Verification/GetPaymentInfo/${id}`)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.Date"}));
			}
		}
		export namespace GetVerificationEditRules {
			export function Get(org: string, id: string): Promise<m.Bokio.Accounting.Contract.Verifications.DTOs.VerificationEditRules> {
				return Client.get(`/${org}/Accounting/Verification/GetVerificationEditRules/${id}`)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Verification.Date"}, {"type":"Day","key":"Verification.ExpectPaymentAt"}, {"type":"Date","key":"Verification.CreatedUtc"}));
			}
		}
		export namespace List {
			export function Get(org: string, yearStart?: number, yearEnd?: number): Promise<m.Accounting.Viewmodels.Verifications.ListViewModel> {
				return Client.get(`/${org}/Accounting/Verification/List`, { yearStart, yearEnd })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Verifications.Date"}, {"type":"Day","key":"Verifications.ExpectPaymentAt"}, {"type":"Date","key":"Verifications.CreatedUtc"}));
			}
		}
		export namespace ListBasicInfo {
			export function Get(org: string, verificationIds: string[]): Promise<m.Accounting.Viewmodels.Verifications.BasicVerificationInfo[]> {
				return Client.get(`/${org}/Accounting/Verification/ListBasicInfo`, { verificationIds })
				             .then(data => convertByKeys(data, {"type":"Day","key":"VerificationDate"}));
			}
		}
		export namespace Preview {
			export function Post(org: string, model: m.Accounting.Models.PreviewVerificationDto): Promise<m.Accounting.Viewmodels.Verifications.PreviewDto> {
				return Client.post(`/${org}/Accounting/Verification/Preview`, model)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Verification.Date"}, {"type":"Day","key":"Verification.ExpectPaymentAt"}, {"type":"Date","key":"Verification.CreatedUtc"}, {"type":"Day","key":"PaymentVerification.Date"}, {"type":"Day","key":"PaymentVerification.ExpectPaymentAt"}, {"type":"Date","key":"PaymentVerification.CreatedUtc"}));
			}
		}
		export namespace PreviewByIds {
			export function Post(org: string, request: m.Accounting.Controllers.PreviewByIdsRequest): Promise<m.Envelope<m.Bokio.Accounting.Contract.Verifications.DTOs.VerificationPreviewDto[], m.SimpleError>> {
				return Client.post(`/${org}/Accounting/Verification/PreviewByIds`, request)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.Date"}));
			}
		}
		export namespace PreviewDelete {
			export function Get(org: string, id: string): Promise<m.Accounting.Viewmodels.Verifications.DeleteVerificationPreviewViewModel> {
				return Client.get(`/${org}/Accounting/Verification/PreviewDelete/${id}`)
				             .then(data => convertByKeys(data, {"type":"Day","key":"CancelVerification.Verification.Date"}, {"type":"Day","key":"CancelVerification.Verification.ExpectPaymentAt"}, {"type":"Date","key":"CancelVerification.Verification.CreatedUtc"}, {"type":"Day","key":"OriginalVerification.Verification.Date"}, {"type":"Day","key":"OriginalVerification.Verification.ExpectPaymentAt"}, {"type":"Date","key":"OriginalVerification.Verification.CreatedUtc"}));
			}
		}
		export namespace PreviewDeleteOld {
			export function Get(org: string, id: string, isHardDelete?: boolean): Promise<m.Accounting.Viewmodels.Verifications.DeletePreviewViewModel> {
				return Client.get(`/${org}/Accounting/Verification/PreviewDeleteOld/${id}`, { isHardDelete })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Preview.Date"}, {"type":"Day","key":"Preview.ExpectPaymentAt"}, {"type":"Date","key":"Preview.CreatedUtc"}));
			}
		}
		export namespace PreviewEdit {
			export function Post(org: string, request: m.Bokio.Accounting.Contract.Verifications.Requests.EditVerificationRequest): Promise<m.Accounting.Viewmodels.Verifications.VerificationPreviewViewModel> {
				return Client.post(`/${org}/Accounting/Verification/PreviewEdit`, request)
				             .then(data => convertByKeys(data, {"type":"Day","key":"NewVerification.Verification.Date"}, {"type":"Day","key":"NewVerification.Verification.ExpectPaymentAt"}, {"type":"Date","key":"NewVerification.Verification.CreatedUtc"}, {"type":"Day","key":"CancelVerification.Verification.Date"}, {"type":"Day","key":"CancelVerification.Verification.ExpectPaymentAt"}, {"type":"Date","key":"CancelVerification.Verification.CreatedUtc"}, {"type":"Day","key":"OriginalVerification.Verification.Date"}, {"type":"Day","key":"OriginalVerification.Verification.ExpectPaymentAt"}, {"type":"Date","key":"OriginalVerification.Verification.CreatedUtc"}));
			}
		}
		export namespace Register {
			export function Post(org: string, model: m.Core.ViewData.RegisterViewModel): Promise<m.Core.ViewData.RegisteredVerificationResult> {
				return Client.post(`/${org}/Accounting/Verification/Register`, model)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Verification.Date"}, {"type":"Day","key":"Verification.ExpectPaymentAt"}, {"type":"Date","key":"Verification.CreatedUtc"}));
			}
		}
		export namespace RegisterPayment {
			export function Post(org: string, request: m.Bokio.Accounting.Web.Accounting.Models.RegisterPaymentDto): Promise<m.Core.Recipes.RegisteredRecipeResult> {
				return Client.post(`/${org}/Accounting/Verification/RegisterPayment`, request);
			}
		}
		export namespace RegisterSupplierInvoice {
			export function Post(org: string, model: m.Core.ViewData.RegisterSupplierInvoiceDto): Promise<m.Core.ViewData.RegisteredVerificationResult> {
				return Client.post(`/${org}/Accounting/Verification/RegisterSupplierInvoice`, model)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Verification.Date"}, {"type":"Day","key":"Verification.ExpectPaymentAt"}, {"type":"Date","key":"Verification.CreatedUtc"}));
			}
		}
		export namespace RemoveImport {
			export function Post(org: string, request: m.Bokio.Accounting.Contract.Verifications.Requests.RemoveImportRequest): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/Verification/RemoveImport`, request);
			}
		}
		export namespace UserHasCreatedVerifications {
			export function Get(org: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/Verification/UserHasCreatedVerifications`);
			}
		}
	}
}
export namespace BackOffice {
	export namespace AgencyController {
		export namespace AcceptClientRequest {
			export function Post(partnerId: string, requestId: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${partnerId}/BackOffice/Agency/AcceptClientRequest`, { requestId });
			}
		}
		export namespace CreateAgency {
			export function Post(partnerId: string, request: m.Bokio.BackOffice.Requests.CreateAgencyRequest): Promise<m.Envelope<string, m.SimpleError>> {
				return Client.post(`/${partnerId}/BackOffice/Agency/CreateAgency`, request);
			}
		}
		export namespace EditAgencyDetails {
			export function Post(partnerId: string, request: m.Bokio.BackOffice.Requests.EditAgencyDetailsRequest): Promise<m.Envelope<m.Bokio.BackOffice.AgencyDetailsDto, m.SimpleError>> {
				return Client.post(`/${partnerId}/BackOffice/Agency/EditAgencyDetails`, request);
			}
		}
		export namespace GetAgencyDetails {
			export function Get(partnerId: string): Promise<m.Envelope<m.Bokio.BackOffice.AgencyDetailsDto, m.SimpleError>> {
				return Client.get(`/${partnerId}/BackOffice/Agency/GetAgencyDetails`);
			}
		}
		export namespace GetTiersInfo {
			export function Get(partnerId: string): Promise<m.Envelope<number, m.SimpleError>> {
				return Client.get(`/${partnerId}/BackOffice/Agency/GetTiersInfo`);
			}
		}
		export namespace ListClientCompanies {
			export function Get(partnerId: string): Promise<m.Envelope<m.Bokio.BackOffice.Models.ClientCompanyDto[], m.SimpleError>> {
				return Client.get(`/${partnerId}/BackOffice/Agency/ListClientCompanies`)
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.NotesStatus.LastStatusTime"}, {"type":"Date","key":"Data.PlanEndDate"}, {"type":"Date","key":"Data.FiscalYearEnd"}, {"type":"Date","key":"Data.ConnectionDate"}));
			}
		}
		export namespace ListClientRequests {
			export function Get(partnerId: string): Promise<m.Envelope<m.Bokio.BackOffice.Models.ClientRequestDto[], m.SimpleError>> {
				return Client.get(`/${partnerId}/BackOffice/Agency/ListClientRequests`);
			}
		}
		export namespace ListClients {
			export function Get(partnerId: string): Promise<m.Envelope<m.Bokio.BackOffice.Models.ClientDto[], m.SimpleError>> {
				return Client.get(`/${partnerId}/BackOffice/Agency/ListClients`);
			}
		}
		export namespace ListPendingClientCompanies {
			export function Get(partnerId: string): Promise<m.Envelope<m.Bokio.BackOffice.Models.PendingClientCompanyDto[], m.SimpleError>> {
				return Client.get(`/${partnerId}/BackOffice/Agency/ListPendingClientCompanies`);
			}
		}
		export namespace RejectClientRequest {
			export function Post(partnerId: string, requestId: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${partnerId}/BackOffice/Agency/RejectClientRequest`, { requestId });
			}
		}
	}
	export namespace AgencyDashboardController {
		export namespace GetAgencySummary {
			export function Get(partnerId: string): Promise<m.Envelope<m.Bokio.BackOffice.Models.AgencyOverviewDto, m.SimpleError>> {
				return Client.get(`/${partnerId}/BackOffice/AgencyDashboard/GetAgencySummary`)
				             .then(data => convertByKeys(data, {"type":"CountryCode","key":"Data.Country"}));
			}
		}
	}
	export namespace AgencyDetailsController {
		export namespace AgencyClients {
			export function Get(partnerId: string, agencyId: string): Promise<m.Envelope<m.Bokio.BackOffice.PartnerCompanyDetailsDto[], m.SimpleError>> {
				return Client.get(`/${partnerId}/BackOffice/AgencyDetails/AgencyClients`, { agencyId })
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.StartedAt"}, {"type":"CountrySubdivision","key":"Data.SenderData.CountrySubdivision"}, {"type":"Day","key":"Data.FiscalYear.EndDate"}, {"type":"Day","key":"Data.FiscalYear.StartDate"}, {"type":"Day","key":"Data.Contracts.StartDate"}, {"type":"Day","key":"Data.Contracts.EndDate"}, {"type":"CountryCode","key":"Data.Country"}, {"type":"CountryCode","key":"Data.Partner.Country"}, {"type":"Day","key":"Data.BokioPlan.PlannedChange.Date"}, {"type":"Day","key":"Data.BokioPlan.TrialPlanInfo.Start"}, {"type":"Day","key":"Data.BokioPlan.TrialPlanInfo.End"}));
			}
		}
		export namespace AgencyDetails {
			export function Get(partnerId: string, agencyId: string): Promise<m.Envelope<m.Bokio.BackOffice.PartnerDto, m.SimpleError>> {
				return Client.get(`/${partnerId}/BackOffice/AgencyDetails/AgencyDetails`, { agencyId })
				             .then(data => convertByKeys(data, {"type":"CountryCode","key":"Data.Country"}));
			}
		}
		export namespace GetAgencyOwnerDetails {
			export function Get(partnerId: string, agencyId: string): Promise<m.Envelope<m.Bokio.BackOffice.AgencyOwner, m.SimpleError>> {
				return Client.get(`/${partnerId}/BackOffice/AgencyDetails/GetAgencyOwnerDetails`, { agencyId });
			}
		}
	}
	export namespace AgencyDraftController {
		export namespace CreateAgencyDraft {
			export function Post(request: m.Bokio.BackOffice.Requests.CreateAgencyDraftRequest): Promise<m.Envelope<m.Bokio.BackOffice.AgencyDraftDetailsDto, m.SimpleError>> {
				return Client.post("/BackOffice/AgencyDraft/CreateAgencyDraft", request);
			}
		}
		export namespace GetAgencyDraft {
			export function Get(id: string): Promise<m.Envelope<m.Bokio.BackOffice.AgencyDraftDetailsDto, m.SimpleError>> {
				return Client.get(`/BackOffice/AgencyDraft/GetAgencyDraft/${id}`);
			}
		}
		export namespace PickAgencyDraft {
			export function Post(id: string, orgNumber: string): Promise<m.Envelope<m.Bokio.BackOffice.AgencyDraftDetailsDto, m.SimpleError>> {
				return Client.post(`/BackOffice/AgencyDraft/PickAgencyDraft/${id}`, { orgNumber });
			}
		}
		export namespace SetAgencyDraftDetails {
			export function Post(id: string, request: m.Bokio.BackOffice.Requests.CreateAgencyRequest): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/BackOffice/AgencyDraft/SetAgencyDraftDetails/${id}`, request);
			}
		}
	}
	export namespace AgencyFeatureToggleController {
		export namespace List {
			export function Get(partnerId: string): Promise<m.Envelope<m.Core.Services.FeatureToggles.FeatureToggleViewModel[], m.SimpleError>> {
				return Client.get(`/${partnerId}/BackOffice/AgencyFeatureToggle/List`)
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.AlwaysEnabledFromDateTimeUtc"}));
			}
		}
		export namespace Toggle {
			export function Post(partnerId: string, request: m.Core.Services.FeatureToggles.ToggleFeatureDto): Promise<m.Envelope<m.Core.Services.FeatureToggles.FeatureToggleViewModel[], m.SimpleError>> {
				return Client.post(`/${partnerId}/BackOffice/AgencyFeatureToggle/Toggle`, request)
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.AlwaysEnabledFromDateTimeUtc"}));
			}
		}
	}
	export namespace AgencyHelpController {
		export namespace Create {
			export function Post(partnerId: string, agencyHelpRequest: m.Contracts.HelpRequest, files: (File | Blob | string)[]): Promise<m.Envelope<m.Settings.Controllers.HelpCreateResult, m.SimpleError>> {
				const form = new FormData();
				form.append("agencyHelpRequest", JSON.stringify(agencyHelpRequest));
				files.forEach(item => form.append("files", item));
				return Client.post(`/${partnerId}/BackOffice/AgencyHelp/Create`, form, true);
			}
		}
	}
	export namespace AgencyMetricsController {
		export namespace SaveAgencyAnalytics {
			export function Post(partnerId: string, request: m.Bokio.Common.Contract.Metrics.Analytics.Requests.AgencyAnalyticsRequest): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${partnerId}/BackOffice/AgencyMetrics/SaveAgencyAnalytics`, request);
			}
		}
		export namespace SaveAgencyFeedback {
			export function Post(partnerId: string, request: m.Core.Metrics.Feedback.AgencyFeedbackRequest): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${partnerId}/BackOffice/AgencyMetrics/SaveAgencyFeedback`, request);
			}
		}
	}
	export namespace AgencyOnboardingController {
		export namespace GetChecklist {
			export function Get(partnerId: string): Promise<m.Envelope<m.Bokio.BackOffice.Web.Controllers.AgencyOnboardingChecklistDto, m.SimpleError>> {
				return Client.get(`/${partnerId}/BackOffice/AgencyOnboarding/GetChecklist`);
			}
		}
		export namespace UpdateChecklistStep {
			export function Post(partnerId: string, dto: m.Bokio.BackOffice.Web.Controllers.AgencyUpdateChecklistItemDto): Promise<m.Envelope<m.Bokio.BackOffice.Web.Controllers.AgencyOnboardingChecklistDto, m.SimpleError>> {
				return Client.post(`/${partnerId}/BackOffice/AgencyOnboarding/UpdateChecklistStep`, dto);
			}
		}
	}
	export namespace AgencyPartnerOnboardingController {
		export namespace SubmitAgencyPartnerContract {
			export function Post(partnerId: string, contactPerson: string, contactPersonEmail: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${partnerId}/BackOffice/AgencyPartnerOnboarding/SubmitAgencyPartnerContract`, { contactPerson, contactPersonEmail });
			}
		}
	}
	export namespace AgencyQuotesController {
		export namespace CompanyApplications {
			export function Get(partnerId: string): Promise<m.Envelope<m.Bokio.BackOffice.PartnerCompanyApplicationListDto[], m.SimpleError>> {
				return Client.get(`/${partnerId}/BackOffice/AgencyQuotes/CompanyApplications`)
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.SubmitTime"}, {"type":"Date","key":"Data.NotesStatus.LastStatusTime"}));
			}
		}
		export namespace CompleteApplication {
			export function Post(partnerId: string, partnerCompanyId: string, applicationId: string, isRetainNotes: boolean): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(Client.getPathWithQueryString(`/${partnerId}/BackOffice/AgencyQuotes/CompleteApplication`, { partnerCompanyId, applicationId, isRetainNotes }), {  });
			}
		}
		export namespace EditApplicationWorkStatus {
			export function Post(partnerId: string, partnerCompanyId: string, applicationId: string, status: m.Entities.Partners.OnboardingQueueStatus): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(Client.getPathWithQueryString(`/${partnerId}/BackOffice/AgencyQuotes/EditApplicationWorkStatus`, { partnerCompanyId }), { applicationId, status });
			}
		}
		export namespace GetApplicationInformation {
			export function Get(partnerId: string, partnerCompanyId: string, applicationId: string): Promise<m.Envelope<m.Bokio.BackOffice.PartnerCompanyApplicationDto, m.SimpleError>> {
				return Client.get(`/${partnerId}/BackOffice/AgencyQuotes/GetApplicationInformation`, { partnerCompanyId, applicationId })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.PartnerStartDate"}));
			}
		}
		export namespace GetCompanyApplication {
			export function Get(partnerId: string, partnerCompanyId: string): Promise<m.Envelope<m.Bokio.BackOffice.PartnerCompanyApplicationDto, m.SimpleError>> {
				return Client.get(`/${partnerId}/BackOffice/AgencyQuotes/GetCompanyApplication`, { partnerCompanyId })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.PartnerStartDate"}));
			}
		}
		export namespace PartnerCompanyDetails {
			export function Get(partnerId: string, partnerCompanyId: string): Promise<m.Envelope<m.Bokio.BackOffice.PartnerCompanyDetailsDto, m.SimpleError>> {
				return Client.get(`/${partnerId}/BackOffice/AgencyQuotes/PartnerCompanyDetails`, { partnerCompanyId })
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.StartedAt"}, {"type":"CountrySubdivision","key":"Data.SenderData.CountrySubdivision"}, {"type":"Day","key":"Data.FiscalYear.EndDate"}, {"type":"Day","key":"Data.FiscalYear.StartDate"}, {"type":"Day","key":"Data.Contracts.StartDate"}, {"type":"Day","key":"Data.Contracts.EndDate"}, {"type":"CountryCode","key":"Data.Country"}, {"type":"CountryCode","key":"Data.Partner.Country"}, {"type":"Day","key":"Data.BokioPlan.PlannedChange.Date"}, {"type":"Day","key":"Data.BokioPlan.TrialPlanInfo.Start"}, {"type":"Day","key":"Data.BokioPlan.TrialPlanInfo.End"}));
			}
		}
		export namespace PartnerCompanyUsers {
			export function Get(partnerId: string, partnerCompanyId: string): Promise<m.Envelope<m.Bokio.BackOffice.CompanyMemberDto[], m.SimpleError>> {
				return Client.get(`/${partnerId}/BackOffice/AgencyQuotes/PartnerCompanyUsers`, { partnerCompanyId });
			}
		}
		export namespace RejectApplication {
			export function Post(partnerId: string, request: m.Bokio.BackOffice.Web.Controllers.RejectApplicationRequest): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${partnerId}/BackOffice/AgencyQuotes/RejectApplication`, request);
			}
		}
	}
	export namespace AgencyRatingController {
		export namespace HasUserRated {
			export function Get(partnerId: string, type: m.Entities.PartnerRatingType): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.get(`/${partnerId}/BackOffice/AgencyRating/HasUserRated`, { type });
			}
		}
		export namespace Rate {
			export function Post(partnerId: string, rating: m.Bokio.Common.Contract.Metrics.Feedback.Dtos.AgencyRatingDto): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${partnerId}/BackOffice/AgencyRating/Rate`, rating);
			}
		}
	}
	export namespace AgencySettingsController {
		export namespace ConnectClientCompanies {
			export function Post(partnerId: string, request: m.Bokio.BackOffice.Models.ClientCompaniesToConnectRequest): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${partnerId}/BackOffice/AgencySettings/ConnectClientCompanies`, request);
			}
		}
		export namespace CountEligibleClientCompaniesToConnect {
			export function Get(partnerId: string): Promise<m.Envelope<number, m.SimpleError>> {
				return Client.get(`/${partnerId}/BackOffice/AgencySettings/CountEligibleClientCompaniesToConnect`);
			}
		}
		export namespace ListNotConnectedClientCompanies {
			export function Get(partnerId: string): Promise<m.Envelope<m.Bokio.BackOffice.Models.ClientCompanyToConnectDto[], m.SimpleError>> {
				return Client.get(`/${partnerId}/BackOffice/AgencySettings/ListNotConnectedClientCompanies`);
			}
		}
	}
	export namespace AgencyTermsController {
		export namespace GetPartnerProgram {
			export function Get(): Promise<m.Envelope<string, m.SimpleError>> {
				return Client.get("/BackOffice/AgencyTerms/GetPartnerProgram");
			}
		}
	}
	export namespace AgencyUserPreferencesController {
		export namespace GetClientCompaniesColumns {
			export function Get(partnerId: string): Promise<m.Envelope<m.Entities.CustomClientColumns, m.SimpleError>> {
				return Client.get(`/${partnerId}/BackOffice/AgencyUserPreferences/GetClientCompaniesColumns`);
			}
		}
		export namespace GetPreference {
			export function Get(partnerId: string, type: m.Entities.AgencyUserPreferenceType): Promise<m.Envelope<m.Bokio.Common.Contract.Services.UserPreferences.AgencyUserPreferencesDto, m.SimpleError>> {
				return Client.get(`/${partnerId}/BackOffice/AgencyUserPreferences/GetPreference`, { type })
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.LastReadWhatsNewDateAgencyPreference.Value"}));
			}
		}
		export namespace SetClientCompaniesColumns {
			export function Post(partnerId: string, type: m.Entities.CustomClientColumns): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${partnerId}/BackOffice/AgencyUserPreferences/SetClientCompaniesColumns`, { type });
			}
		}
		export namespace SetPreference {
			export function Post(partnerId: string, type: m.Entities.AgencyUserPreferenceType, value: m.Bokio.Common.Contract.Services.UserPreferences.AgencyUserPreferencesDto): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${partnerId}/BackOffice/AgencyUserPreferences/SetPreference`, { type, value });
			}
		}
	}
	export namespace AssignSelfController {
		export namespace AssignSelf {
			export function Post(partnerId: string, partnerCompanyId: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(Client.getPathWithQueryString(`/${partnerId}/BackOffice/AssignSelf/AssignSelf`, { partnerCompanyId }), {  });
			}
		}
		export namespace RemoveSelf {
			export function Post(partnerId: string, partnerCompanyId: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(Client.getPathWithQueryString(`/${partnerId}/BackOffice/AssignSelf/RemoveSelf`, { partnerCompanyId }), {  });
			}
		}
	}
	export namespace CompaniesController {
		export namespace RemoveCompanyFromPartner {
			export function Delete(partnerId: string, companyId: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client._delete(`/${partnerId}/BackOffice/Companies/RemoveCompanyFromPartner`, { companyId });
			}
		}
	}
	export namespace CompanyDetailsController {
		export namespace AddComment {
			export function Post(partnerId: string, partnerCompanyId: string, request: m.Core.Services.Notes.CommentsStateDto): Promise<m.Envelope<string, m.SimpleError>> {
				return Client.post(Client.getPathWithQueryString(`/${partnerId}/BackOffice/CompanyDetails/AddComment`, { partnerCompanyId }), request);
			}
		}
		export namespace AddTask {
			export function Post(partnerId: string, partnerCompanyId: string, request: m.Core.Services.Notes.TasksStateDto): Promise<m.Envelope<string, m.SimpleError>> {
				return Client.post(Client.getPathWithQueryString(`/${partnerId}/BackOffice/CompanyDetails/AddTask`, { partnerCompanyId }), request);
			}
		}
		export namespace AgencyComments {
			export function Get(partnerId: string, companyId?: string): Promise<m.Envelope<m.Core.Services.Notes.AgencyCommentDto[], m.SimpleError>> {
				return Client.get(`/${partnerId}/BackOffice/CompanyDetails/AgencyComments`, { companyId })
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.TimeCreated"}, {"type":"Date","key":"Data.NotificationStatus.StatusUpdateDateTime"}, {"type":"Date","key":"Data.UpdateInfo.NoteUpdateDateTime"}));
			}
		}
		export namespace AgencyTasks {
			export function Get(partnerId: string, companyId?: string): Promise<m.Envelope<m.Bokio.BackOffice.Notes.AgencyTaskDto[], m.SimpleError>> {
				return Client.get(`/${partnerId}/BackOffice/CompanyDetails/AgencyTasks`, { companyId })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.State.DueDate"}, {"type":"Date","key":"Data.TimeCreated"}, {"type":"Date","key":"Data.NotificationStatus.StatusUpdateDateTime"}, {"type":"Date","key":"Data.UpdateInfo.NoteUpdateDateTime"}));
			}
		}
		export namespace DeleteNote {
			export function Post(partnerId: string, partnerCompanyId: string, noteId: string, isTask: boolean): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(Client.getPathWithQueryString(`/${partnerId}/BackOffice/CompanyDetails/DeleteNote`, { partnerCompanyId }), { noteId, isTask });
			}
		}
		export namespace EditResponsibilities {
			export function Post(partnerId: string, partnerCompanyId: string, responsibilities: m.Entities.PartnerCompanyResponsibilities[]): Promise<m.Envelope<m.Entities.PartnerCompanyResponsibilities[], m.SimpleError>> {
				return Client.post(`/${partnerId}/BackOffice/CompanyDetails/EditResponsibilities`, { partnerCompanyId, responsibilities });
			}
		}
		export namespace GetAgencyClientDetails {
			export function Get(partnerId: string, partnerCompanyId: string): Promise<m.Envelope<m.Bokio.BackOffice.AgencyClientDetailsDto, m.SimpleError>> {
				return Client.get(`/${partnerId}/BackOffice/CompanyDetails/GetAgencyClientDetails`, { partnerCompanyId })
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.StartedAt"}, {"type":"CountrySubdivision","key":"Data.SenderData.CountrySubdivision"}, {"type":"Day","key":"Data.FiscalYear.EndDate"}, {"type":"Day","key":"Data.FiscalYear.StartDate"}, {"type":"CountryCode","key":"Data.Country"}, {"type":"CountryCode","key":"Data.Partner.Country"}, {"type":"Day","key":"Data.BokioPlan.PlannedChange.Date"}, {"type":"Day","key":"Data.BokioPlan.TrialPlanInfo.Start"}, {"type":"Day","key":"Data.BokioPlan.TrialPlanInfo.End"}));
			}
		}
		export namespace GetClientCompanyUsers {
			export function Get(partnerId: string, clientCompanyId: string): Promise<m.Envelope<m.Classes.UserDto[], m.SimpleError>> {
				return Client.get(`/${partnerId}/BackOffice/CompanyDetails/GetClientCompanyUsers`, { clientCompanyId });
			}
		}
		export namespace PartnerCompanyDetails {
			export function Get(partnerId: string, partnerCompanyId: string): Promise<m.Envelope<m.Bokio.BackOffice.PartnerCompanyDetailsDto, m.SimpleError>> {
				return Client.get(`/${partnerId}/BackOffice/CompanyDetails/PartnerCompanyDetails`, { partnerCompanyId })
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.StartedAt"}, {"type":"CountrySubdivision","key":"Data.SenderData.CountrySubdivision"}, {"type":"Day","key":"Data.FiscalYear.EndDate"}, {"type":"Day","key":"Data.FiscalYear.StartDate"}, {"type":"Day","key":"Data.Contracts.StartDate"}, {"type":"Day","key":"Data.Contracts.EndDate"}, {"type":"CountryCode","key":"Data.Country"}, {"type":"CountryCode","key":"Data.Partner.Country"}, {"type":"Day","key":"Data.BokioPlan.PlannedChange.Date"}, {"type":"Day","key":"Data.BokioPlan.TrialPlanInfo.Start"}, {"type":"Day","key":"Data.BokioPlan.TrialPlanInfo.End"}));
			}
		}
		export namespace PartnerCompanyUsers {
			export function Get(partnerId: string, partnerCompanyId: string): Promise<m.Envelope<m.Bokio.BackOffice.CompanyMemberDto[], m.SimpleError>> {
				return Client.get(`/${partnerId}/BackOffice/CompanyDetails/PartnerCompanyUsers`, { partnerCompanyId });
			}
		}
		export namespace UpdateComment {
			export function Put(partnerId: string, partnerCompanyId: string, noteId: string, commentState: m.Core.Services.Notes.CommentsStateDto, oldText: string): Promise<m.Envelope<string, m.SimpleError>> {
				return Client.put(Client.getPathWithQueryString(`/${partnerId}/BackOffice/CompanyDetails/UpdateComment`, { partnerCompanyId }), { noteId, commentState, oldText });
			}
		}
		export namespace UpdateTask {
			export function Put(partnerId: string, partnerCompanyId: string, noteId: string, taskState: m.Core.Services.Notes.TasksStateDto, isAssigneeUpdated: boolean): Promise<m.Envelope<string, m.SimpleError>> {
				return Client.put(Client.getPathWithQueryString(`/${partnerId}/BackOffice/CompanyDetails/UpdateTask`, { partnerCompanyId }), { noteId, taskState, isAssigneeUpdated });
			}
		}
	}
	export namespace CompanyUsersController {
		export namespace AddUser {
			export function Post(partnerId: string, partnerCompanyId: string, userId: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(Client.getPathWithQueryString(`/${partnerId}/BackOffice/CompanyUsers/AddUser`, { partnerCompanyId }), { userId });
			}
		}
		export namespace RemoveUser {
			export function Post(partnerId: string, partnerCompanyId: string, userId: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(Client.getPathWithQueryString(`/${partnerId}/BackOffice/CompanyUsers/RemoveUser`, { partnerCompanyId }), { userId });
			}
		}
		export namespace Search {
			export function Get(partnerId: string, request: m.Bokio.BackOffice.SearchRequest): Promise<m.Envelope<m.Classes.UserDto[], m.SimpleError>> {
				return Client.get(`/${partnerId}/BackOffice/CompanyUsers/Search`, { request });
			}
		}
		export namespace SetResponsibleAccountants {
			export function Put(partnerId: string, partnerCompanyId: string, userIds: string[]): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.put(Client.getPathWithQueryString(`/${partnerId}/BackOffice/CompanyUsers/SetResponsibleAccountants`, { partnerCompanyId }), userIds);
			}
		}
		export namespace UpdateUser {
			export function Post(partnerId: string, partnerCompanyId: string, userId: string, membershipType: m.Entities.MembershipType): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(Client.getPathWithQueryString(`/${partnerId}/BackOffice/CompanyUsers/UpdateUser`, { partnerCompanyId }), { userId, membershipType });
			}
		}
	}
	export namespace DisconnectAgencyController {
		export namespace CanDelete {
			export function Get(partnerId: string): Promise<m.Envelope<m.Bokio.BackOffice.Models.RequiredDeleteAgencyActionDto[], m.SimpleError>> {
				return Client.get(`/${partnerId}/BackOffice/DisconnectAgency/CanDelete`);
			}
		}
		export namespace CanLeave {
			export function Get(partnerId: string): Promise<m.Envelope<m.Bokio.BackOffice.Web.Controllers.CanLeaveAgencyDto, m.SimpleError>> {
				return Client.get(`/${partnerId}/BackOffice/DisconnectAgency/CanLeave`);
			}
		}
		export namespace DeleteAgency {
			export function Post(partnerId: string, userId: string): Promise<m.Envelope<m.Bokio.Utils.RecentLoginProtectedResult<boolean>, m.SimpleError>> {
				return Client.post(`/${partnerId}/BackOffice/DisconnectAgency/DeleteAgency`, { userId });
			}
		}
		export namespace LeaveAgency {
			export function Post(partnerId: string, userId: string): Promise<m.Envelope<m.Bokio.Utils.RecentLoginProtectedResult<boolean>, m.SimpleError>> {
				return Client.post(`/${partnerId}/BackOffice/DisconnectAgency/LeaveAgency`, { userId });
			}
		}
	}
	export namespace FeatureRequestAdminController {
		export namespace Approve {
			export function Post(partnerId: string, request: m.Bokio.Common.Contract.Requests.FeatureRequests.ApproveFeatureRequest): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${partnerId}/BackOffice/FeatureRequestAdmin/Approve`, request);
			}
		}
		export namespace Categorize {
			export function Post(partnerId: string, request: m.Bokio.Common.Contract.Requests.FeatureRequests.CategorizeFeatureRequest): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${partnerId}/BackOffice/FeatureRequestAdmin/Categorize`, request);
			}
		}
		export namespace ListActive {
			export function Get(partnerId: string, featureCategories: m.Entities.FeatureCategory[], includePending: boolean, includeApproved: boolean): Promise<m.Envelope<m.Contracts.FeatureRequests.FeatureRequestForAdminDto[], m.SimpleError>> {
				return Client.get(`/${partnerId}/BackOffice/FeatureRequestAdmin/ListActive`, { featureCategories, includePending, includeApproved })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.CreatedAtDate"}));
			}
		}
		export namespace MarkAsCompleted {
			export function Post(partnerId: string, request: m.Bokio.Common.Contract.Requests.FeatureRequests.MarkAsCompletedRequest): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${partnerId}/BackOffice/FeatureRequestAdmin/MarkAsCompleted`, request);
			}
		}
		export namespace Merge {
			export function Post(partnerId: string, request: m.Bokio.Common.Contract.Requests.FeatureRequests.MergeFeatureRequest): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${partnerId}/BackOffice/FeatureRequestAdmin/Merge`, request);
			}
		}
		export namespace Reject {
			export function Post(partnerId: string, request: m.Bokio.Common.Contract.Requests.FeatureRequests.RejectFeatureRequest): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${partnerId}/BackOffice/FeatureRequestAdmin/Reject`, request);
			}
		}
	}
	export namespace NotificationController {
		export namespace GetNewNotificationsCount {
			export function Get(partnerId: string): Promise<m.Envelope<number, m.SimpleError>> {
				return Client.get(`/${partnerId}/BackOffice/Notification/GetNewNotificationsCount`);
			}
		}
		export namespace GetNotificationSettings {
			export function Get(partnerId: string): Promise<m.Envelope<m.Core.Services.Notifications.Dtos.AgencyNotificationSettingGroupByAreaDto[], m.SimpleError>> {
				return Client.get(`/${partnerId}/BackOffice/Notification/GetNotificationSettings`);
			}
		}
		export namespace GetNotificationsForUser {
			export function Get(partnerId: string): Promise<m.Envelope<m.Core.Services.Notifications.Dtos.NotificationDto[], m.SimpleError>> {
				return Client.get(`/${partnerId}/BackOffice/Notification/GetNotificationsForUser`)
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.Timestamp"}));
			}
		}
		export namespace SetNotificationsStatuses {
			export function Put(partnerId: string, notificationIds: string[], statusType: m.Entities.Notifications.NotificationStatusTypes): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.put(`/${partnerId}/BackOffice/Notification/SetNotificationsStatuses`, { notificationIds, statusType });
			}
		}
		export namespace UpdateNotificationSetting {
			export function Post(partnerId: string, area: m.Entities.Notifications.NotificationArea, areaType: m.Entities.Notifications.NotificationAreaType, target: m.Entities.Notifications.NotificationTarget, enable: boolean): Promise<m.Envelope<m.Core.Services.Notifications.Dtos.AgencyNotificationSettingDto, m.SimpleError>> {
				return Client.post(`/${partnerId}/BackOffice/Notification/UpdateNotificationSetting`, { area, areaType, target, enable });
			}
		}
	}
	export namespace PartnerCompanyApplicationController {
		export namespace CreateApplication {
			export function Post(org: string, userInformation: m.Model.Commands.Partners.PartnerCompanyApplicationCommands.PartnerCompanyApplicationCommandInfo, agency: m.Model.Commands.Partners.PartnerCompanyApplicationCommands.Agency): Promise<m.Envelope<string, m.Bokio.BackOffice.Models.CreatePartnerQuoteRequestError>> {
				return Client.post(`/${org}/PartnerCompanyApplication/CreateApplication`, { userInformation, agency });
			}
		}
		export namespace GetAgencyDescription {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.BackOffice.PartnerCompanyInfo[], m.SimpleError>> {
				return Client.get(`/${org}/PartnerCompanyApplication/GetAgencyDescription`);
			}
		}
		export namespace GetApplication {
			export function Get(org: string, agency: m.Model.Commands.Partners.PartnerCompanyApplicationCommands.Agency): Promise<m.Envelope<m.Bokio.BackOffice.PartnerCompanyGetApplicationDto, m.SimpleError>> {
				return Client.get(`/${org}/PartnerCompanyApplication/GetApplication`, { agency })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.Application.PartnerStartDate"}));
			}
		}
		export namespace GetCompanyInfo {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.BackOffice.Models.PartnerCompanyApplicationCompanyInfoDto, m.SimpleError>> {
				return Client.get(`/${org}/PartnerCompanyApplication/GetCompanyInfo`)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.StartedAt"}));
			}
		}
	}
	export namespace PartnerViewerController {
		export namespace AgencyStatus {
			export function Get(partnerId: string): Promise<m.Envelope<m.Bokio.BackOffice.PartnerStatusDto, m.SimpleError>> {
				return Client.get(`/${partnerId}/BackOffice/PartnerViewer/AgencyStatus`)
				             .then(data => convertByKeys(data, {"type":"CountryCode","key":"Data.Country"}));
			}
		}
		export namespace GetCount {
			export function Get(partnerId: string): Promise<m.Envelope<m.Bokio.BackOffice.AgencyCountViewModel, m.SimpleError>> {
				return Client.get(`/${partnerId}/BackOffice/PartnerViewer/GetCount`);
			}
		}
	}
	export namespace RootAccountingFirmController {
		export namespace AddFullAccessUserToPartner {
			export function Post(partnerId: string, request: m.Bokio.BackOffice.Requests.AddFullAccessUserRequest): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${partnerId}/BackOffice/RootAccountingFirm/AddFullAccessUserToPartner`, request);
			}
		}
		export namespace CreateAgency {
			export function Post(partnerId: string, request: m.Bokio.BackOffice.Requests.RootFirmCreateAgencyRequest): Promise<m.Envelope<string, m.SimpleError>> {
				return Client.post(`/${partnerId}/BackOffice/RootAccountingFirm/CreateAgency`, request);
			}
		}
		export namespace GetCompaniesUserIsMemberOf {
			export function Get(partnerId: string, userEmail: string): Promise<m.Envelope<m.Bokio.BackOffice.CompaniesUserIsMemberOfDto, m.SimpleError>> {
				return Client.get(`/${partnerId}/BackOffice/RootAccountingFirm/GetCompaniesUserIsMemberOf`, { userEmail })
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.Companies.LastActivity"}));
			}
		}
		export namespace GetTiersInfo {
			export function Get(partnerId: string, agencyId: string): Promise<m.Envelope<number, m.SimpleError>> {
				return Client.get(`/${partnerId}/BackOffice/RootAccountingFirm/GetTiersInfo`, { agencyId });
			}
		}
		export namespace ListAllAgencies {
			export function Get(partnerId: string, isForMigraton: boolean): Promise<m.Envelope<m.Bokio.BackOffice.PartnerAgencyDto[], m.SimpleError>> {
				return Client.get(`/${partnerId}/BackOffice/RootAccountingFirm/ListAllAgencies`, { isForMigraton })
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.AuditTime"}, {"type":"CountryCode","key":"Data.Country"}));
			}
		}
		export namespace ListAllClients {
			export function Get(partnerId: string): Promise<m.Envelope<m.Bokio.BackOffice.PartnerCompanyDetailsDto[], m.SimpleError>> {
				return Client.get(`/${partnerId}/BackOffice/RootAccountingFirm/ListAllClients`)
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.StartedAt"}, {"type":"CountrySubdivision","key":"Data.SenderData.CountrySubdivision"}, {"type":"Day","key":"Data.FiscalYear.EndDate"}, {"type":"Day","key":"Data.FiscalYear.StartDate"}, {"type":"Day","key":"Data.Contracts.StartDate"}, {"type":"Day","key":"Data.Contracts.EndDate"}, {"type":"CountryCode","key":"Data.Country"}, {"type":"CountryCode","key":"Data.Partner.Country"}, {"type":"Day","key":"Data.BokioPlan.PlannedChange.Date"}, {"type":"Day","key":"Data.BokioPlan.TrialPlanInfo.Start"}, {"type":"Day","key":"Data.BokioPlan.TrialPlanInfo.End"}));
			}
		}
		export namespace RemoveAgencyClientConnection {
			export function Post(partnerId: string, request: m.Bokio.BackOffice.Web.Controllers.RemoveAgencyClientRequest): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${partnerId}/BackOffice/RootAccountingFirm/RemoveAgencyClientConnection`, request);
			}
		}
		export namespace TransferClient {
			export function Post(partnerId: string, request: m.Bokio.BackOffice.Requests.TransferClientRequest): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${partnerId}/BackOffice/RootAccountingFirm/TransferClient`, request);
			}
		}
	}
	export namespace SupportTicketController {
		export namespace AssignableUsers {
			export function Get(partnerId: string): Promise<m.Envelope<m.Bokio.BackOffice.PartnerUserDto[], m.SimpleError>> {
				return Client.get(`/${partnerId}/BackOffice/SupportTicket/AssignableUsers`);
			}
		}
		export namespace AssignedSupportTickets {
			export function Get(partnerId: string, userId: string, includeUnreadOnly: boolean): Promise<m.Envelope<m.Bokio.Accounting.Contract.Support.SupportTicketForList[], m.SimpleError>> {
				return Client.get(`/${partnerId}/BackOffice/SupportTicket/AssignedSupportTickets`, { userId, includeUnreadOnly })
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.CreatedUtc"}, {"type":"Date","key":"Data.UpdatedUtc"}));
			}
		}
		export namespace AssignSupportTicket {
			export function Post(partnerId: string, request: m.Bokio.BackOffice.Web.Controllers.AssignSupportTicketRequest, companyId: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(Client.getPathWithQueryString(`/${partnerId}/BackOffice/SupportTicket/AssignSupportTicket`, { companyId }), request);
			}
		}
		export namespace GetReceiptForView {
			export function Get(partnerId: string, companyId: string, receiptId: string): Promise<m.Accounting.Viewmodels.ReceiptForView> {
				return Client.get(`/${partnerId}/BackOffice/SupportTicket/GetReceiptForView`, { companyId, receiptId })
				             .then(data => convertByKeys(data, {"type":"Date","key":"UploadedDate"}));
			}
		}
		export namespace GetSupportTicket {
			export function Get(partnerId: string, ticketId: string): Promise<m.Envelope<m.Bokio.Accounting.Contract.Support.SupportTicketViewModel, m.SimpleError>> {
				return Client.get(`/${partnerId}/BackOffice/SupportTicket/GetSupportTicket`, { ticketId })
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.CreatedUtc"}, {"type":"Date","key":"Data.UpdatedUtc"}, {"type":"Date","key":"Data.Revisions.CreatedUtc"}, {"type":"Day","key":"Data.Verification.Date"}, {"type":"Day","key":"Data.Verification.ExpectPaymentAt"}, {"type":"Date","key":"Data.Verification.CreatedUtc"}));
			}
		}
		export namespace GetSupportTicketsByCompany {
			export function Get(partnerId: string, searchValue: string): Promise<m.Envelope<m.Bokio.Accounting.Contract.Support.SupportTicketForList[], m.SimpleError>> {
				return Client.get(`/${partnerId}/BackOffice/SupportTicket/GetSupportTicketsByCompany`, { searchValue })
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.CreatedUtc"}, {"type":"Date","key":"Data.UpdatedUtc"}));
			}
		}
		export namespace ListBy {
			export function Get(partnerId: string, status: m.Entities.Support.SupportTicketStatus, start: Day, end: Day, includePreviousStatus: boolean): Promise<m.Envelope<m.Bokio.Accounting.Contract.Support.SupportTicketForList[], m.SimpleError>> {
				return Client.get(`/${partnerId}/BackOffice/SupportTicket/ListBy`, { status, start, end, includePreviousStatus })
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.CreatedUtc"}, {"type":"Date","key":"Data.UpdatedUtc"}));
			}
		}
		export namespace MarkForBilling {
			export function Post(partnerId: string, request: m.Bokio.BackOffice.Web.Controllers.MarkForBillingRequest): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${partnerId}/BackOffice/SupportTicket/MarkForBilling`, request);
			}
		}
		export namespace PendingSupportTickets {
			export function Get(partnerId: string): Promise<m.Envelope<m.Bokio.Accounting.Contract.Support.SupportTicketForList[], m.SimpleError>> {
				return Client.get(`/${partnerId}/BackOffice/SupportTicket/PendingSupportTickets`)
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.CreatedUtc"}, {"type":"Date","key":"Data.UpdatedUtc"}));
			}
		}
		export namespace UpdateSupportTicket {
			export function Post(partnerId: string, command: m.Model.Commands.Support.UpdateSupportTicket, companyId: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(Client.getPathWithQueryString(`/${partnerId}/BackOffice/SupportTicket/UpdateSupportTicket`, { companyId }), command);
			}
		}
	}
	export namespace UsersController {
		export namespace CancelInvite {
			export function Post(partnerId: string, inviteId: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${partnerId}/BackOffice/Users/CancelInvite`, { inviteId });
			}
		}
		export namespace ChangeOwner {
			export function Post(partnerId: string, newOwner: m.Bokio.BackOffice.Models.ChangeOwnerDto): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${partnerId}/BackOffice/Users/ChangeOwner`, newOwner);
			}
		}
		export namespace EditPartnerUserMembershipType {
			export function Post(partnerId: string, userId: string, type: m.Entities.PartnerMembershipType): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${partnerId}/BackOffice/Users/EditPartnerUserMembershipType`, { userId, type });
			}
		}
		export namespace Invite {
			export function Post(partnerId: string, email: string, membershipType: m.Entities.PartnerMembershipType): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${partnerId}/BackOffice/Users/Invite`, { email, membershipType });
			}
		}
		export namespace MentionableAccountants {
			export function Get(partnerId: string, filterMembership: m.Entities.PartnerMembershipType): Promise<m.Envelope<m.Bokio.BackOffice.Models.MentionableAccountantsDto, m.SimpleError>> {
				return Client.get(`/${partnerId}/BackOffice/Users/MentionableAccountants`, { filterMembership });
			}
		}
		export namespace RemoveUserFromPartner {
			export function Post(partnerId: string, membershipId: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${partnerId}/BackOffice/Users/RemoveUserFromPartner`, { membershipId });
			}
		}
		export namespace UsersPageViewModel {
			export function Get(partnerId: string): Promise<m.Envelope<m.Bokio.BackOffice.UsersPageViewDto, m.SimpleError>> {
				return Client.get(`/${partnerId}/BackOffice/Users/UsersPageViewModel`);
			}
		}
	}
}
export namespace Bank {
	export namespace AutoVerificationController {
		export namespace AllBankTransactionsRecorded {
			export function Get(org: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.get(`/${org}/BankApi/AutoVerification/AllBankTransactionsRecorded`);
			}
		}
		export namespace BankTransactionAccountOptions {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Accounting.Contract.AutoVerification.DTOs.AutoVerificationFilterAccountOptionDto[], m.SimpleError>> {
				return Client.get(`/${org}/BankApi/AutoVerification/BankTransactionAccountOptions`);
			}
		}
		export namespace ConnectToReceipt {
			export function Post(org: string, request: m.Bokio.Bank.Contract.AutoVerificationRows.ConnectToRecieptRequest): Promise<m.Envelope<string, m.SimpleError>> {
				return Client.post(`/${org}/BankApi/AutoVerification/ConnectToReceipt`, request);
			}
		}
		export namespace ConnectToSupplierInvoiePayment {
			export function Post(org: string, request: m.Bokio.Bank.Contract.AutoVerificationRows.Requests.ConnectAutoVerificationRowToSupplierInvoicePaymentRequest): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/BankApi/AutoVerification/ConnectToSupplierInvoiePayment`, request);
			}
		}
		export namespace ConnectToVerification {
			export function Post(org: string, request: m.Bokio.Bank.Contract.AutoVerificationRows.Requests.ConnectAutoVerificationRowToVerificationRequest): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/BankApi/AutoVerification/ConnectToVerification`, request);
			}
		}
		export namespace DisableMatching {
			export function Post(org: string, request: m.Bokio.Bank.Contract.AutoVerificationRows.Requests.DisableAutoVerificationRowMatchingRequest): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/BankApi/AutoVerification/DisableMatching`, request);
			}
		}
		export namespace DisconnectFromVerification {
			export function Post(org: string, request: m.Bokio.Bank.Contract.AutoVerificationRows.Requests.DisconnectAutoVerificationRowsFromVerificationRequest): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/BankApi/AutoVerification/DisconnectFromVerification`, request);
			}
		}
		export namespace EnableMatching {
			export function Post(org: string, request: m.Bokio.Bank.Contract.AutoVerificationRows.Requests.EnableAutoVerificationRowMatchingRequest): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/BankApi/AutoVerification/EnableMatching`, request);
			}
		}
		export namespace Get {
			export function Get(org: string, id: string): Promise<m.Envelope<m.Bokio.Bank.Contract.AutoVerificationRows.AutoVerificationRowViewModel, m.SimpleError>> {
				return Client.get(`/${org}/BankApi/AutoVerification/Get/${id}`)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.EffectiveDate"}, {"type":"Day","key":"Data.TransactionDate"}, {"type":"Day","key":"Data.OriginalTransactionDate"}, {"type":"Day","key":"Data.Matches.Data.Date"}, {"type":"Day","key":"Data.Matches.RowData.Date"}));
			}
		}
		export namespace GetAsTransactionDetails {
			export function Get(org: string, id: string): Promise<m.Envelope<m.Bokio.Bank.Contract.Dtos.TransactionDetailsDto, m.SimpleError>> {
				return Client.get(`/${org}/BankApi/AutoVerification/GetAsTransactionDetails/${id}`)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.TransactionDate"}, {"type":"Day","key":"Data.RenderedDetailRows.Value.Date"}));
			}
		}
		export namespace ListByAccount {
			export function Get(org: string, account: number): Promise<m.Bokio.Bank.Contract.AutoVerificationRows.AutoVerificationRowViewModel[]> {
				return Client.get(`/${org}/BankApi/AutoVerification/ListByAccount`, { account })
				             .then(data => convertByKeys(data, {"type":"Day","key":"EffectiveDate"}, {"type":"Day","key":"TransactionDate"}, {"type":"Day","key":"OriginalTransactionDate"}, {"type":"Day","key":"Matches.Data.Date"}, {"type":"Day","key":"Matches.RowData.Date"}));
			}
		}
		export namespace ListByAccountPaginated {
			export function Get(org: string, account: number, filter: m.Bokio.Bank.Contract.Utils.TransactionsFilter): Promise<m.Envelope<m.Bokio.Bank.Contract.AutoVerificationRows.PaginatedAutoVerificationRowList, m.SimpleError>> {
				return Client.get(`/${org}/BankApi/AutoVerification/ListByAccountPaginated`, { account, filter })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.Rows.EffectiveDate"}, {"type":"Day","key":"Data.Rows.TransactionDate"}, {"type":"Day","key":"Data.Rows.OriginalTransactionDate"}, {"type":"Day","key":"Data.Rows.Matches.Data.Date"}, {"type":"Day","key":"Data.Rows.Matches.RowData.Date"}, {"type":"Day","key":"Data.Filter.Filter.FromDate"}, {"type":"Day","key":"Data.Filter.Filter.ToDate"}));
			}
		}
		export namespace ListImportsByDate {
			export function Get(org: string, account: number): Promise<m.Bokio.Bank.Contract.AutoVerificationRows.ImportGroupedAutoVerificationViewModel> {
				return Client.get(`/${org}/BankApi/AutoVerification/ListImportsByDate`, { account })
				             .then(data => convertByKeys(data, {"type":"Date","key":"Items.ImportDate"}, {"type":"Day","key":"Items.AutoVerifications.EffectiveDate"}, {"type":"Day","key":"Items.AutoVerifications.TransactionDate"}, {"type":"Day","key":"Items.AutoVerifications.OriginalTransactionDate"}, {"type":"Day","key":"Items.AutoVerifications.Matches.Data.Date"}, {"type":"Day","key":"Items.AutoVerifications.Matches.RowData.Date"}));
			}
		}
		export namespace ListMergingAutoVerificationRows {
			export function Get(org: string, parentAvrId: string): Promise<m.Envelope<m.Bokio.Bank.Contract.AutoVerificationRows.AutoVerificationRowViewModel[], m.SimpleError>> {
				return Client.get(`/${org}/BankApi/AutoVerification/ListMergingAutoVerificationRows`, { parentAvrId })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.EffectiveDate"}, {"type":"Day","key":"Data.TransactionDate"}, {"type":"Day","key":"Data.OriginalTransactionDate"}, {"type":"Day","key":"Data.Matches.Data.Date"}, {"type":"Day","key":"Data.Matches.RowData.Date"}));
			}
		}
		export namespace Merge {
			export function Post(org: string, request: m.Bokio.Bank.Contract.AutoVerificationRows.Requests.MergeAutoVerificationRowRequest): Promise<m.Envelope<string, m.SimpleError>> {
				return Client.post(`/${org}/BankApi/AutoVerification/Merge`, request);
			}
		}
		export namespace Preview {
			export function Post(org: string, request: m.Bokio.Bank.Contract.AutoVerificationRows.SaveAllAutoVerificationRowsRequest): Promise<m.Bokio.Bank.Contract.AutoVerificationRows.AutoVerificationRowPreviewResult> {
				return Client.post(`/${org}/BankApi/AutoVerification/Preview`, request)
				             .then(data => convertByKeys(data, {"type":"Day","key":"AutoVerifications.EffectiveDate"}, {"type":"Day","key":"AutoVerifications.TransactionDate"}));
			}
		}
		export namespace RemoveRow {
			export function Post(org: string, id: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/BankApi/AutoVerification/RemoveRow/${id}`, {  });
			}
		}
		export namespace RemoveRows {
			export function Post(org: string, request: m.Bokio.Bank.Contract.AutoVerificationRows.Commands.RemoveAutoVerificationRows): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/BankApi/AutoVerification/RemoveRows`, request);
			}
		}
		export namespace SaveAll {
			export function Post(org: string, request: m.Bokio.Bank.Contract.AutoVerificationRows.SaveAllAutoVerificationRowsRequest): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/BankApi/AutoVerification/SaveAll`, request);
			}
		}
		export namespace SaveParseFailure {
			export function Post(org: string, request: m.Bokio.Bank.Contract.AutoVerificationRows.SaveParseFailureRequest): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/BankApi/AutoVerification/SaveParseFailure`, request);
			}
		}
		export namespace Split {
			export function Post(org: string, request: m.Bokio.Bank.Contract.AutoVerificationRows.Requests.SplitBankRowRequest): Promise<m.Envelope<string[], m.SimpleError>> {
				return Client.post(`/${org}/BankApi/AutoVerification/Split`, request);
			}
		}
		export namespace UndoRemoveRow {
			export function Post(org: string, id: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/BankApi/AutoVerification/UndoRemoveRow/${id}`, {  });
			}
		}
		export namespace UploadNewReceiptForRow {
			export function Post(org: string, files: (File | Blob | string)[], autoVerificationRowId: string, verificationId?: string, startReceiptPrediction?: boolean): Promise<m.Envelope<string, m.SimpleError>> {
				const form = new FormData();
				files.forEach(item => form.append("files", item));
				form.append("autoVerificationRowId", autoVerificationRowId);
				verificationId && form.append("verificationId", verificationId);
				return Client.post(`/${org}/BankApi/AutoVerification/UploadNewReceiptForRow`, form, true);
			}
		}
	}
	export namespace BankAccountController {
		export namespace Get {
			export function Get(org: string, bookkeepingAccount: number): Promise<m.Envelope<m.Bokio.Bank.Contract.Dtos.MoneyAccountWithInfo, m.SimpleError>> {
				return Client.get(`/${org}/BankApi/BankAccount/Get`, { bookkeepingAccount })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.LastRowDate"}, {"type":"Date","key":"Data.Connection.LastSyncDate"}, {"type":"Day","key":"Data.Connection.SyncFromDate"}, {"type":"Date","key":"Data.Connection.Bank.Accounts.LastSync"}, {"type":"Day","key":"Data.Connection.Bank.Accounts.SyncFromDate"}));
			}
		}
		export namespace GetBankAccountDetails {
			export function Get(org: string, bankAccountId: string): Promise<m.Envelope<m.Bokio.Bank.Contract.Dtos.BankAccountDetailsResponse, m.SimpleError>> {
				return Client.get(`/${org}/BankApi/BankAccount/GetBankAccountDetails`, { bankAccountId });
			}
		}
		export namespace ListBankAccounts {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Bank.Contract.Dtos.ListBankAccountsResponse, m.SimpleError>> {
				return Client.get(`/${org}/BankApi/BankAccount/ListBankAccounts`)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.MoneyAccounts.LastRowDate"}, {"type":"Date","key":"Data.MoneyAccounts.Connection.LastSyncDate"}, {"type":"Day","key":"Data.MoneyAccounts.Connection.SyncFromDate"}, {"type":"Date","key":"Data.MoneyAccounts.Connection.Bank.Accounts.LastSync"}, {"type":"Day","key":"Data.MoneyAccounts.Connection.Bank.Accounts.SyncFromDate"}));
			}
		}
		export namespace SetBookkeepingAccountAndCreateIfNeeded {
			export function Post(org: string, account: m.Bokio.Bank.Contract.Dtos.SetBookkeepingAccountDto): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/BankApi/BankAccount/SetBookkeepingAccountAndCreateIfNeeded`, account);
			}
		}
	}
	export namespace BankDemoController {
		export namespace GetData {
			export function Get(org: string, country: string): Promise<m.Envelope<m.Bokio.Bank.Web.Controllers.DemoBankViewModel, m.SimpleError>> {
				return Client.get(`/${org}/BankApi/BankDemo/GetData`, { country });
			}
		}
		export namespace GetDemoTransactions {
			export function Get(org: string, type?: m.Bokio.Bank.Web.Controllers.DemoDataType): Promise<m.Envelope<m.Bokio.Bank.Web.Controllers.DemoBankDto[], m.SimpleError>> {
				return Client.get(`/${org}/BankApi/BankDemo/GetDemoTransactions`, { type })
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.TransactionDate"}, {"type":"Date","key":"Data.BookkeepingDate"}));
			}
		}
		export namespace HasAnyBankrows {
			export function Get(org: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.get(`/${org}/BankApi/BankDemo/HasAnyBankrows`);
			}
		}
		export namespace SetupDemoData {
			export function Post(org: string, request: m.Bokio.Bank.Web.Controllers.DemoBankRequest): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/BankApi/BankDemo/SetupDemoData`, request);
			}
		}
	}
	export namespace BankFeedMoneyAccountsController {
		export namespace GetBokioBusinessAccountMoneyAccountSuggestion {
			export function Get(org: string, externalSystem: m.Entities.Bank.ExternalSystem, bankAccountType: m.Entities.Bank.BankAccountType): Promise<m.Envelope<m.Bokio.Bank.Contract.MoneyAccount.BankFeedMoneyAccountSuggestionDto, m.SimpleError>> {
				return Client.get(`/${org}/BankApi/BankFeedMoneyAccounts/GetBokioBusinessAccountMoneyAccountSuggestion`, { externalSystem, bankAccountType })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.ConnectableAccounts.EarliestSyncFromDate"}));
			}
		}
		export namespace ListBankFeedConnectableMoneyAccountsWithSyncDateInfo {
			export function Get(org: string, externalSystem: m.Entities.Bank.ExternalSystem): Promise<m.Envelope<m.Bokio.Bank.Contract.MoneyAccount.ConnectableAccountDto[], m.SimpleError>> {
				return Client.get(`/${org}/BankApi/BankFeedMoneyAccounts/ListBankFeedConnectableMoneyAccountsWithSyncDateInfo`, { externalSystem })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.EarliestSyncFromDate"}));
			}
		}
		export namespace MoneyAccount {
			export function Get(org: string, accountNumber: number): Promise<m.Envelope<m.Bokio.Bank.Contract.MoneyAccount.MoneyAccountDto, m.SimpleError>> {
				return Client.get(`/${org}/BankApi/BankFeedMoneyAccounts/MoneyAccount`, { accountNumber })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.BankAccount.LastRowDate"}, {"type":"Date","key":"Data.BankAccount.LastSyncDate"}));
			}
		}
	}
	export namespace BankIntegrationTestController {
		export namespace AddEnableBankingMockTransaction {
			export function Post(org: string, dto: m.Bokio.Bank.Contract.Requests.IntegrationTests.CreateEnableBankingMockTransactionDto): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/BankApi/BankIntegrationTest/AddEnableBankingMockTransaction`, dto);
			}
		}
		export namespace ApprovePreregisterApplication {
			export function Post(org: string, request: m.Bokio.Bank.Web.Controllers.ApprovePreregisterApplicationRequest): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/BankApi/BankIntegrationTest/ApprovePreregisterApplication`, request);
			}
		}
		export namespace CancelKycApplication {
			export function Delete(org: string): Promise<m.Envelope<boolean, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client._delete(`/${org}/BankApi/BankIntegrationTest/CancelKycApplication`, {  });
			}
		}
		export namespace CancelSveaPayment {
			export function Post(org: string, dto: m.Bokio.Bank.Contract.Dtos.IntegrationTests.RejectPaymentDto): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/BankApi/BankIntegrationTest/CancelSveaPayment`, dto);
			}
		}
		export namespace ChangeBankIdBehavior {
			export function Post(org: string, request: m.Bokio.Bank.Integration.Svea.BankIdChangeBehaviorRequest): Promise<m.Envelope<boolean, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.post(`/${org}/BankApi/BankIntegrationTest/ChangeBankIdBehavior`, request);
			}
		}
		export namespace CompleteEnableBankingAuthenticationForTest {
			export function Post(code: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(Client.getPathWithQueryString("/BankApi/BankIntegrationTest/CompleteEnableBankingAuthenticationForTest", { code }), {  });
			}
		}
		export namespace CompleteMirPayment {
			export function Post(org: string, dto: m.Bokio.Bank.Contract.Dtos.IntegrationTests.CompletePaymentDto): Promise<m.Envelope<string, m.SimpleError>> {
				return Client.post(`/${org}/BankApi/BankIntegrationTest/CompleteMirPayment`, dto);
			}
		}
		export namespace CompletePendingTransaction {
			export function Post(org: string, transactionId: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/BankApi/BankIntegrationTest/CompletePendingTransaction`, { transactionId });
			}
		}
		export namespace CompleteSveaPayment {
			export function Post(org: string, dto: m.Bokio.Bank.Contract.Dtos.IntegrationTests.CompletePaymentDto): Promise<m.Envelope<string, m.SimpleError>> {
				return Client.post(`/${org}/BankApi/BankIntegrationTest/CompleteSveaPayment`, dto);
			}
		}
		export namespace CreateCardTransaction {
			export function Post(org: string, dto: m.Bokio.Bank.Contract.Dtos.IntegrationTests.CreateMockCardTransactionDto): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/BankApi/BankIntegrationTest/CreateCardTransaction`, dto);
			}
		}
		export namespace CreateElinTransaction {
			export function Post(org: string, dto: m.Bokio.Bank.Contract.Dtos.IntegrationTests.SveaAsyncApiElinTransactionRequest): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/BankApi/BankIntegrationTest/CreateElinTransaction`, dto);
			}
		}
		export namespace CreateFakeSveaSavingsAccount {
			export function Post(org: string, bookkeepingAccount: number): Promise<m.Envelope<string, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.post(Client.getPathWithQueryString(`/${org}/BankApi/BankIntegrationTest/CreateFakeSveaSavingsAccount`, { bookkeepingAccount }), {  });
			}
		}
		export namespace CreateSveaCard {
			export function Post(org: string, request: m.Bokio.Bank.Integration.Svea.CreateMockCardDto): Promise<m.Envelope<string, m.SimpleError>> {
				return Client.post(`/${org}/BankApi/BankIntegrationTest/CreateSveaCard`, request);
			}
		}
		export namespace CreateSveaInboxMessage {
			export function Post(org: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/BankApi/BankIntegrationTest/CreateSveaInboxMessage`, {  });
			}
		}
		export namespace CreateTransaction {
			export function Post(org: string, dto: m.Bokio.Bank.Contract.Dtos.IntegrationTests.CreateMockTransactionDto): Promise<m.Envelope<string, m.SimpleError>> {
				return Client.post(`/${org}/BankApi/BankIntegrationTest/CreateTransaction`, dto);
			}
		}
		export namespace DeletePreregisterApplication {
			export function Post(org: string, request: m.Bokio.Bank.Web.Controllers.DeletePreregisterApplicationRequest): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/BankApi/BankIntegrationTest/DeletePreregisterApplication`, request);
			}
		}
		export namespace ForceOffboardFromSvea {
			export function Delete(org: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client._delete(`/${org}/BankApi/BankIntegrationTest/ForceOffboardFromSvea`, {  });
			}
		}
		export namespace GetPreregisterApplications {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Bank.Integration.Svea.GetInternationalPaymentApplicationDto[], m.SimpleError>> {
				return Client.get(`/${org}/BankApi/BankIntegrationTest/GetPreregisterApplications`)
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.Created"}));
			}
		}
		export namespace ListPayments {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Bank.Contract.Dtos.PaymentsForListDto, m.SimpleError>> {
				return Client.get(`/${org}/BankApi/BankIntegrationTest/ListPayments`)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.Filter.Filter.FromDate"}, {"type":"Day","key":"Data.Filter.Filter.ToDate"}, {"type":"Day","key":"Data.PaymentGroups.Date"}, {"type":"Day","key":"Data.PaymentGroups.Payments.Date"}));
			}
		}
		export namespace ListSveaCards {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Bank.Integration.Svea.SveaMockCardDto[], m.SimpleError>> {
				return Client.get(`/${org}/BankApi/BankIntegrationTest/ListSveaCards`);
			}
		}
		export namespace RejectMirPayment {
			export function Post(org: string, dto: m.Bokio.Bank.Contract.Dtos.IntegrationTests.RejectPaymentDto): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/BankApi/BankIntegrationTest/RejectMirPayment`, dto);
			}
		}
		export namespace RejectSveaPayment {
			export function Post(org: string, dto: m.Bokio.Bank.Contract.Dtos.IntegrationTests.RejectPaymentDto): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/BankApi/BankIntegrationTest/RejectSveaPayment`, dto);
			}
		}
		export namespace RemoveCard {
			export function Post(org: string, request: m.Bokio.Bank.Integration.Svea.SveaMockCardDto): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/BankApi/BankIntegrationTest/RemoveCard`, request);
			}
		}
		export namespace RemovePendingTransaction {
			export function Post(org: string, transactionId: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/BankApi/BankIntegrationTest/RemovePendingTransaction`, { transactionId });
			}
		}
		export namespace RenewCard {
			export function Post(org: string, cardId: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/BankApi/BankIntegrationTest/RenewCard`, { cardId });
			}
		}
		export namespace SetSveaPollingNeededAttempts {
			export function Post(org: string, neededAttempts: number): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(Client.getPathWithQueryString(`/${org}/BankApi/BankIntegrationTest/SetSveaPollingNeededAttempts`, { neededAttempts }), {  });
			}
		}
		export namespace SetupEnableBankingForTest {
			export function Post(): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post("/BankApi/BankIntegrationTest/SetupEnableBankingForTest", {  });
			}
		}
		export namespace SetupSveaMockForIntegrationTests {
			export function Post(org: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/BankApi/BankIntegrationTest/SetupSveaMockForIntegrationTests`, {  });
			}
		}
		export namespace SpeedrunSveaOnboarding {
			export function Post(org: string, request: m.Bokio.Bank.Contract.Requests.IntegrationTests.SveaBypassOnboardingRequest): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/BankApi/BankIntegrationTest/SpeedrunSveaOnboarding`, request);
			}
		}
		export namespace ToggleEnableBankingForceExpiredSession {
			export function Post(): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post("/BankApi/BankIntegrationTest/ToggleEnableBankingForceExpiredSession", {  });
			}
		}
		export namespace TriggerKycDueDateUpdateAsyncEvent {
			export function Post(org: string, dueDate: string): Promise<m.Envelope<boolean, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.post(Client.getPathWithQueryString(`/${org}/BankApi/BankIntegrationTest/TriggerKycDueDateUpdateAsyncEvent`, { dueDate }), {  });
			}
		}
	}
	export namespace CardController {
		export namespace Activate {
			export function Post(org: string, cardId: string): Promise<m.Envelope<boolean, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.post(`/${org}/BankApi/Card/Activate`, { cardId });
			}
		}
		export namespace CancelGetSetPinWidgetLink {
			export function Post(org: string, bankIdToken: string): Promise<m.Envelope<boolean, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.post(`/${org}/BankApi/Card/CancelGetSetPinWidgetLink`, { bankIdToken });
			}
		}
		export namespace ConfirmActivateCard {
			export function Get(org: string, cardId: string, confirmationId: string): Promise<m.Envelope<m.Bokio.Bank.Contract.Teller.Dtos.BankIdStatusDtoEmpty, m.SimpleError>> {
				return Client.get(`/${org}/BankApi/Card/ConfirmActivateCard`, { cardId, confirmationId });
			}
		}
		export namespace ConfirmCardLimitChange {
			export function Get(org: string, cardId: string, confirmationId: string): Promise<m.Envelope<m.Bokio.Bank.Contract.Teller.Dtos.BankIdStatusDtoEmpty, m.SimpleError>> {
				return Client.get(`/${org}/BankApi/Card/ConfirmCardLimitChange`, { cardId, confirmationId });
			}
		}
		export namespace ConfirmGetSetPinWidgetLink {
			export function Post(org: string, request: m.Bokio.Bank.Contract.Requests.ConfirmGetSetPinWidgetLinkRequest): Promise<m.Envelope<m.Bokio.Bank.Contract.Teller.Dtos.BankIdStatusDto<string>, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.post(`/${org}/BankApi/Card/ConfirmGetSetPinWidgetLink`, request);
			}
		}
		export namespace Destroy {
			export function Post(org: string, cardId: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/BankApi/Card/Destroy`, { cardId });
			}
		}
		export namespace DismissOrderCardTodoItem {
			export function Post(org: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/BankApi/Card/DismissOrderCardTodoItem`, {  });
			}
		}
		export namespace GetCard {
			export function Get(org: string, cardId: string): Promise<m.Envelope<m.Bokio.Bank.Contract.Dtos.CardDetailsDto, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.get(`/${org}/BankApi/Card/GetCard`, { cardId })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.ActivatedDate"}, {"type":"Day","key":"Data.CreatedDate"}, {"type":"Day","key":"Data.ExpiryDate"}, {"type":"Date","key":"Data.CardRenewals.Time"}, {"type":"Date","key":"Data.CardRenewals.ActivatedDate"}));
			}
		}
		export namespace GetCardStatus {
			export function Get(org: string, cardId: string): Promise<m.Envelope<m.Bokio.Bank.Contract.Dtos.CardStatus, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.get(`/${org}/BankApi/Card/GetCardStatus`, { cardId });
			}
		}
		export namespace GetCardUserInformation {
			export function Get(org: string, accountId: string, userId: string): Promise<m.Envelope<m.Bokio.Bank.Contract.Dtos.UserInformationDto, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.get(`/${org}/BankApi/Card/GetCardUserInformation`, { accountId, userId });
			}
		}
		export namespace GetCurrentUsersCard {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Bank.Contract.Dtos.CurrentUserCardsDto, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.get(`/${org}/BankApi/Card/GetCurrentUsersCard`)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.Cards.CreatedDate"}, {"type":"Day","key":"Data.Cards.ExpiryDate"}));
			}
		}
		export namespace HasAnyActiveCardForUser {
			export function Get(org: string, bankAccountId?: string): Promise<m.Envelope<boolean, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.get(`/${org}/BankApi/Card/HasAnyActiveCardForUser`, { bankAccountId });
			}
		}
		export namespace ListCards {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Bank.Contract.Dtos.CardListDto, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.get(`/${org}/BankApi/Card/ListCards`)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.Users.Cards.CreatedDate"}, {"type":"Day","key":"Data.Users.Cards.ExpiryDate"}));
			}
		}
		export namespace OrderCard {
			export function Post(org: string, request: m.Bokio.Bank.Contract.Requests.OrderCardFrontendRequest): Promise<m.Envelope<string, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.post(`/${org}/BankApi/Card/OrderCard`, request);
			}
		}
		export namespace Replace {
			export function Post(org: string, cardId: string, reason: string): Promise<m.Envelope<boolean, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.post(`/${org}/BankApi/Card/Replace`, { cardId, reason });
			}
		}
		export namespace ResendPin {
			export function Post(org: string, cardId: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/BankApi/Card/ResendPin`, { cardId });
			}
		}
		export namespace SetBlocked {
			export function Put(org: string, cardId: string, blocked: boolean): Promise<m.Envelope<boolean, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.put(`/${org}/BankApi/Card/SetBlocked`, { cardId, blocked });
			}
		}
		export namespace SetPermissionForAtmWithdrawal {
			export function Put(org: string, cardId: string, allowed: boolean): Promise<m.Envelope<boolean, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.put(`/${org}/BankApi/Card/SetPermissionForAtmWithdrawal`, { cardId, allowed });
			}
		}
		export namespace SetPermissionForContactless {
			export function Put(org: string, cardId: string, allowed: boolean): Promise<m.Envelope<boolean, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.put(`/${org}/BankApi/Card/SetPermissionForContactless`, { cardId, allowed });
			}
		}
		export namespace SetPermissionForInternationalPurchase {
			export function Put(org: string, cardId: string, allowed: boolean): Promise<m.Envelope<boolean, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.put(`/${org}/BankApi/Card/SetPermissionForInternationalPurchase`, { cardId, allowed });
			}
		}
		export namespace SetPermissionForOnlinePurchase {
			export function Put(org: string, cardId: string, allowed: boolean): Promise<m.Envelope<boolean, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.put(`/${org}/BankApi/Card/SetPermissionForOnlinePurchase`, { cardId, allowed });
			}
		}
		export namespace StartActivateCard {
			export function Post(org: string, request: m.Bokio.Bank.Contract.Mir.Card.StartActivateCardRequest): Promise<m.Envelope<m.Bokio.Bank.Contract.Mir.Onboarding.ConfirmationIdDto, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.post(`/${org}/BankApi/Card/StartActivateCard`, request);
			}
		}
		export namespace StartCardLimitChange {
			export function Post(org: string, cardId: string, amount: m.Bokio.Bank.Contract.Utils.TellerTransactionAmount): Promise<m.Envelope<m.Bokio.Bank.Contract.Mir.Onboarding.ConfirmationIdDto, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.post(`/${org}/BankApi/Card/StartCardLimitChange`, { cardId, amount });
			}
		}
		export namespace StartGetSetPinWidgetLink {
			export function Post(org: string, cardId: string): Promise<m.Envelope<m.Bokio.Bank.Contract.Teller.Interfaces.TellerBankIdSignStartResponseDto, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.post(`/${org}/BankApi/Card/StartGetSetPinWidgetLink`, { cardId });
			}
		}
		export namespace UpdatePhoneNumber {
			export function Put(org: string, cardId: string, phoneNumber: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.put(`/${org}/BankApi/Card/UpdatePhoneNumber`, { cardId, phoneNumber });
			}
		}
	}
	export namespace CodeExampleFeatureController {
		export namespace CreateItem {
			export function Post(org: string, request: m.Bokio.Bank.Contract.CodeExampleFeature.CreateCodeExampleFeatureItemRequestDto): Promise<m.Envelope<string, m.SimpleError>> {
				return Client.post(`/${org}/BankApi/CodeExampleFeature/CreateItem`, request);
			}
		}
		export namespace DeleteItem {
			export function Delete(org: string, id: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client._delete(`/${org}/BankApi/CodeExampleFeature/DeleteItem/${id}`, {  });
			}
		}
		export namespace GetItem {
			export function Get(org: string, id: string): Promise<m.Envelope<m.Bokio.Bank.Contract.CodeExampleFeature.CodeExampleFeatureItemDto, m.SimpleError>> {
				return Client.get(`/${org}/BankApi/CodeExampleFeature/GetItem/${id}`)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.LaunchDate"}, {"type":"Date","key":"Data.CreatedAt"}, {"type":"Date","key":"Data.UpdatedAt"}));
			}
		}
		export namespace ListItems {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Bank.Contract.CodeExampleFeature.CodeExampleFeatureItemDto[], m.SimpleError>> {
				return Client.get(`/${org}/BankApi/CodeExampleFeature/ListItems`)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.LaunchDate"}, {"type":"Date","key":"Data.CreatedAt"}, {"type":"Date","key":"Data.UpdatedAt"}));
			}
		}
		export namespace UpdateItem {
			export function Put(org: string, id: string, request: m.Bokio.Bank.Contract.CodeExampleFeature.UpdateCodeExampleFeatureItemRequestDto): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.put(`/${org}/BankApi/CodeExampleFeature/UpdateItem/${id}`, request);
			}
		}
	}
	export namespace EnableBankingController {
		export namespace AuthEnableBanking {
			export function Post(org: string, request: m.Bokio.Bank.Contract.EnableBanking.StartAuthorizationRequestDto): Promise<m.Envelope<m.Bokio.Bank.Contract.EnableBanking.StartAuthorizationResponseDto, m.SimpleError>> {
				return Client.post(`/${org}/BankApi/EnableBanking/AuthEnableBanking`, request);
			}
		}
		export namespace ConnectBankAccount {
			export function Post(org: string, request: m.Bokio.Bank.Contract.EnableBanking.SelectedExternalBankAccountsDto): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/BankApi/EnableBanking/ConnectBankAccount`, request);
			}
		}
		export namespace GetAspspList {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Bank.Contract.EnableBanking.AspspDataDto[], m.SimpleError>> {
				return Client.get(`/${org}/BankApi/EnableBanking/GetAspspList`);
			}
		}
		export namespace GetSessionAccounts {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Bank.Contract.EnableBanking.SessionAccountResponseDto, m.SimpleError>> {
				return Client.get(`/${org}/BankApi/EnableBanking/GetSessionAccounts`)
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.Accounts.ExistingMatchingBankAccount.MatchedBankAccountLastSyncDate"}));
			}
		}
		export namespace SyncAccount {
			export function Post(org: string, accountId: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/BankApi/EnableBanking/SyncAccount`, { accountId });
			}
		}
		export namespace SyncAllAccountsOnCompany {
			export function Post(org: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/BankApi/EnableBanking/SyncAllAccountsOnCompany`, {  });
			}
		}
	}
	export namespace KlarnaController {
		export namespace FinishTransactionSession {
			export function Post(org: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/BankApi/Klarna/FinishTransactionSession`, {  });
			}
		}
		export namespace StartTransactionSession {
			export function Post(org: string): Promise<m.Envelope<m.Bokio.Bank.Contract.Klarna.Dtos.KlarnaStartSessionDto, m.SimpleError>> {
				return Client.post(`/${org}/BankApi/Klarna/StartTransactionSession`, {  });
			}
		}
		export namespace SyncAccount {
			export function Post(org: string, accountId: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/BankApi/Klarna/SyncAccount`, { accountId });
			}
		}
		export namespace SyncAllAccountsOnCompany {
			export function Post(org: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/BankApi/Klarna/SyncAllAccountsOnCompany`, {  });
			}
		}
	}
	export namespace LocaleInfoController {
		export namespace GetCountryList {
			export function Get(org: string, filter?: m.Bokio.Bank.Contract.Utils.CountryFilter): Promise<m.Envelope<m.Bokio.Bank.Contract.Dtos.CountryInfoDto[], m.SimpleError>> {
				return Client.get(`/${org}/BankApi/LocaleInfo/GetCountryList`, { filter });
			}
		}
		export namespace GetCurrencyList {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Bank.Contract.Dtos.CurrencyInfoDto[], m.SimpleError>> {
				return Client.get(`/${org}/BankApi/LocaleInfo/GetCurrencyList`);
			}
		}
	}
	export namespace PaymentController {
		export namespace Cancel {
			export function Post(org: string, paymentGroupId: string): Promise<m.Envelope<boolean, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.post(`/${org}/BankApi/Payment/Cancel`, { paymentGroupId });
			}
		}
		export namespace CancelConfirmPayment {
			export function Post(org: string, externalSystem: m.Entities.Bank.ExternalSystem, bankIdToken: string): Promise<m.Envelope<boolean, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.post(Client.getPathWithQueryString(`/${org}/BankApi/Payment/CancelConfirmPayment`, { externalSystem, bankIdToken }), {  });
			}
		}
		export namespace CheckDuplicate {
			export function Post(org: string, paymentInfo: m.Bokio.Bank.Contract.Teller.Dtos.TellerPaymentInfoDto): Promise<m.Envelope<m.Bokio.Bank.Contract.Dtos.CheckDuplicatePaymentResult, m.SimpleError>> {
				return Client.post(`/${org}/BankApi/Payment/CheckDuplicate`, paymentInfo);
			}
		}
		export namespace ConfirmPayment {
			export function Post(org: string, confirmationId: string, paymentIds: string[]): Promise<m.Envelope<m.Bokio.Bank.Contract.Teller.Dtos.BankIdStatusDtoEmpty, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.post(`/${org}/BankApi/Payment/ConfirmPayment`, { confirmationId, paymentIds });
			}
		}
		export namespace ConnectManualPaymentToReceipt {
			export function Post(org: string, request: m.Bokio.Bank.Contract.Requests.ConnectManualPaymentToReceiptRequest): Promise<m.Envelope<string, m.SimpleError>> {
				return Client.post(`/${org}/BankApi/Payment/ConnectManualPaymentToReceipt`, request);
			}
		}
		export namespace ConvertRecipientToSupplierAndAddSupplierInvoicePayment {
			export function Post(org: string, request: m.Bokio.Bank.Contract.Requests.ConvertRecipientToSupplierAndCreateSupplierInvoicePaymentRequest): Promise<m.Envelope<m.Bokio.Accounting.Contract.SupplierInvoices.Dtos.AddSupplierInvoicePaymentDto, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.post(`/${org}/BankApi/Payment/ConvertRecipientToSupplierAndAddSupplierInvoicePayment`, request);
			}
		}
		export namespace Create {
			export function Post(org: string, paymentInfo: m.Bokio.Bank.Contract.Teller.Dtos.TellerPaymentInfoDto, saveRecipient?: boolean, receiptId?: string, recurringPaymentSeriesId?: string): Promise<m.Envelope<m.Bokio.Bank.Contract.Dtos.CreatePaymentResponseDto, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.post(`/${org}/BankApi/Payment/Create`, { paymentInfo, saveRecipient, receiptId, recurringPaymentSeriesId });
			}
		}
		export namespace CreateRecurringPaymentBatch {
			export function Post(org: string, batchInfo: m.Bokio.Bank.Contract.Teller.Dtos.CreateRecurringPaymentBatchDto): Promise<m.Envelope<m.Bokio.Bank.Contract.Teller.Dtos.CreateRecurringPaymentBatchResponseDto, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.post(`/${org}/BankApi/Payment/CreateRecurringPaymentBatch`, batchInfo);
			}
		}
		export namespace DeleteManualPaymentRecipient {
			export function Post(org: string, recipientId: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/BankApi/Payment/DeleteManualPaymentRecipient`, { recipientId });
			}
		}
		export namespace EditRecipient {
			export function Post(org: string, recipientId: string, recipientInfo: m.Bokio.Bank.Contract.Teller.Dtos.PaymentTypeDto, currency: string): Promise<m.Envelope<m.Bokio.Bank.Contract.Dtos.PaymentRecipientDto, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.post(`/${org}/BankApi/Payment/EditRecipient`, { recipientId, recipientInfo, currency });
			}
		}
		export namespace FetchGiroNumberRecipientInfo {
			export function Get(org: string, userInputGiroNumber: string): Promise<m.Envelope<m.Bokio.Bank.Contract.Dtos.GiroRecipientDto[], m.SimpleError>> {
				return Client.get(`/${org}/BankApi/Payment/FetchGiroNumberRecipientInfo`, { userInputGiroNumber });
			}
		}
		export namespace Get {
			export function Get(org: string, paymentId: string): Promise<m.Envelope<m.Bokio.Bank.Contract.Dtos.PaymentDetailsViewModel, m.SimpleError>> {
				return Client.get(`/${org}/BankApi/Payment/Get`, { paymentId })
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.Date"}));
			}
		}
		export namespace GetGroup {
			export function Get(org: string, paymentGroupId: string): Promise<m.Envelope<m.Bokio.Bank.Contract.Dtos.PaymentGroupForListDto, m.SimpleError>> {
				return Client.get(`/${org}/BankApi/Payment/GetGroup`, { paymentGroupId })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.Date"}, {"type":"Day","key":"Data.Payments.Date"}));
			}
		}
		export namespace GetPaymentCentralSummary {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Bank.Contract.Dtos.PaymentCentralPageSummaryDto, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.get(`/${org}/BankApi/Payment/GetPaymentCentralSummary`);
			}
		}
		export namespace GetPaymentValidationRules {
			export function Get(org: string, bankAccountId: string): Promise<m.Envelope<m.Bokio.Bank.Contract.Dtos.PaymentValidationRulesDto, m.SimpleError>> {
				return Client.get(`/${org}/BankApi/Payment/GetPaymentValidationRules`, { bankAccountId })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.NonBankingDays.Date"}, {"type":"Day","key":"Data.PaymentDateMaxValue"}, {"type":"Day","key":"Data.NextPossiblePaymentDateIncludingToday"}));
			}
		}
		export namespace GetPermissionOfCurrentUser {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Bank.Contract.Dtos.UserPaymentPermissionDto, m.SimpleError>> {
				return Client.get(`/${org}/BankApi/Payment/GetPermissionOfCurrentUser`);
			}
		}
		export namespace GetRecipient {
			export function Get(org: string, recipientId: string, consumer: m.Entities.Teller.TellerConsumer): Promise<m.Envelope<m.Bokio.Bank.Contract.Dtos.PaymentRecipientDto, m.SimpleError>> {
				return Client.get(`/${org}/BankApi/Payment/GetRecipient`, { recipientId, consumer });
			}
		}
		export namespace GetSenderBankAccounts {
			export function Get(org: string, externalSystem: m.Entities.Bank.ExternalSystem): Promise<m.Envelope<m.Bokio.Bank.Contract.Dtos.SenderBankAccountResponseDto, m.SimpleError>> {
				return Client.get(`/${org}/BankApi/Payment/GetSenderBankAccounts`, { externalSystem });
			}
		}
		export namespace GetSignablePaymentCount {
			export function Get(org: string): Promise<m.Envelope<number, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.get(`/${org}/BankApi/Payment/GetSignablePaymentCount`);
			}
		}
		export namespace GetSkatteverketPaymentReasonCodes {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Bank.Contract.Dtos.PaymentReasonCodeCategory[], m.SimpleError>> {
				return Client.get(`/${org}/BankApi/Payment/GetSkatteverketPaymentReasonCodes`);
			}
		}
		export namespace HasValidSession {
			export function Get(org: string, externalSystem: m.Entities.Bank.ExternalSystem): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.get(`/${org}/BankApi/Payment/HasValidSession`, { externalSystem });
			}
		}
		export namespace List {
			export function Get(org: string, filter: m.Bokio.Bank.Contract.Utils.PaymentsFilter): Promise<m.Envelope<m.Bokio.Bank.Contract.Dtos.PaymentsForListDto, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.get(`/${org}/BankApi/Payment/List`, { filter })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.Filter.Filter.FromDate"}, {"type":"Day","key":"Data.Filter.Filter.ToDate"}, {"type":"Day","key":"Data.PaymentGroups.Date"}, {"type":"Day","key":"Data.PaymentGroups.Payments.Date"}));
			}
		}
		export namespace ListSignablePayments {
			export function Get(org: string, bankAccountIds?: string[]): Promise<m.Envelope<m.Bokio.Bank.Contract.Dtos.PaymentsForListDto, m.SimpleError>> {
				return Client.get(`/${org}/BankApi/Payment/ListSignablePayments`, { bankAccountIds })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.Filter.Filter.FromDate"}, {"type":"Day","key":"Data.Filter.Filter.ToDate"}, {"type":"Day","key":"Data.PaymentGroups.Date"}, {"type":"Day","key":"Data.PaymentGroups.Payments.Date"}));
			}
		}
		export namespace PreviewCanPayToReceiver {
			export function Post(org: string, paymentInfo: m.Bokio.Bank.Contract.Teller.Dtos.TellerPaymentInfoDto, saveRecipient?: boolean, receiptId?: string, recurringPaymentSeriesId?: string): Promise<m.Envelope<m.Bokio.Bank.Contract.Teller.Dtos.ReceiverPayableStatus, m.SimpleError>> {
				return Client.post(`/${org}/BankApi/Payment/PreviewCanPayToReceiver`, { paymentInfo, saveRecipient, receiptId, recurringPaymentSeriesId });
			}
		}
		export namespace SaveRecipient {
			export function Post(org: string, recipientInfo: m.Bokio.Bank.Contract.Teller.Dtos.PaymentTypeDto, currency: string): Promise<m.Envelope<m.Bokio.Bank.Contract.Dtos.PaymentRecipientDto, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.post(`/${org}/BankApi/Payment/SaveRecipient`, { recipientInfo, currency });
			}
		}
		export namespace SearchGiroNumber {
			export function Get(org: string, giroNumber: string): Promise<m.Envelope<m.Bokio.Bank.Contract.Dtos.GiroNumberSearchResultDto[], m.SimpleError>> {
				return Client.get(`/${org}/BankApi/Payment/SearchGiroNumber`, { giroNumber });
			}
		}
		export namespace SearchRecipient {
			export function Get(org: string, searchInput: string): Promise<m.Envelope<m.Bokio.Bank.Contract.Dtos.PaymentRecipientDto[], m.SimpleError>> {
				return Client.get(`/${org}/BankApi/Payment/SearchRecipient`, { searchInput });
			}
		}
		export namespace SearchRecipient2 {
			export function Get(org: string, request: m.Bokio.Bank.Contract.Dtos.SearchRecipientDto): Promise<m.Envelope<m.Bokio.Bank.Contract.Dtos.SearchRecipientResponseDto, m.SimpleError>> {
				return Client.get(`/${org}/BankApi/Payment/SearchRecipient2`, { request });
			}
		}
		export namespace SendAndAuthorizePayments {
			export function Post(org: string, paymentGroups: m.Bokio.Bank.Contract.Dtos.PaymentGroupForAuthorization[]): Promise<m.Envelope<m.Bokio.Bank.Contract.Dtos.SendAndAuthorizePaymentsResultDto, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.post(`/${org}/BankApi/Payment/SendAndAuthorizePayments`, paymentGroups);
			}
		}
		export namespace SetHidden {
			export function Post(org: string, paymentGroupId: string, hidden: boolean): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/BankApi/Payment/SetHidden`, { paymentGroupId, hidden });
			}
		}
		export namespace ShouldAskForPaymentReasonCode {
			export function Get(org: string, amount: m.Bokio.Bank.Contract.Utils.TellerTransactionAmount, paymentType: m.Entities.Teller.TellerPaymentType): Promise<m.Envelope<m.Bokio.Bank.Contract.Dtos.PaymentReasonRequirementsDto, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.get(`/${org}/BankApi/Payment/ShouldAskForPaymentReasonCode`, { amount, paymentType });
			}
		}
		export namespace UploadNewReceiptForManualPayment {
			export function Post(org: string, manualPaymentId: string, files: (File | Blob | string)[], startReceiptPrediction?: boolean): Promise<m.Envelope<string, m.SimpleError>> {
				const form = new FormData();
				form.append("manualPaymentId", manualPaymentId);
				files.forEach(item => form.append("files", item));
				return Client.post(`/${org}/BankApi/Payment/UploadNewReceiptForManualPayment`, form, true);
			}
		}
	}
	export namespace SkatteverketTaxAccountFeedController {
		export namespace FetchTransactions {
			export function Post(org: string): Promise<m.Envelope<m.Bokio.Bank.Web.Controllers.SkatteverketFetchResult, m.SimpleError>> {
				return Client.post(`/${org}/BankApi/SkatteverketTaxAccountFeed/FetchTransactions`, {  });
			}
		}
		export namespace GetShouldSyncStatus {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Bank.Web.Controllers.SkatteverketShouldSyncResult, m.SimpleError>> {
				return Client.get(`/${org}/BankApi/SkatteverketTaxAccountFeed/GetShouldSyncStatus`)
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.LastSync"}));
			}
		}
		export namespace List {
			export function Get(org: string, fromDate: Day, toDate: Day): Promise<m.Envelope<m.Bokio.Bank.Web.Controllers.TaxAccountTransactionDto[], m.SimpleError>> {
				return Client.get(`/${org}/BankApi/SkatteverketTaxAccountFeed/List`, { fromDate, toDate })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.TransactionDate"}));
			}
		}
		export namespace SetupSkatteverketAccount {
			export function Post(org: string, dto: m.Bokio.Bank.Web.Controllers.SetupSkatteverketAccountDto): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/BankApi/SkatteverketTaxAccountFeed/SetupSkatteverketAccount`, dto);
			}
		}
		export namespace SetupSkatteverketAccountPreview {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Bank.Contract.TaxAccounts.SetupSkatteverketAccountPreviewDto, m.SimpleError>> {
				return Client.get(`/${org}/BankApi/SkatteverketTaxAccountFeed/SetupSkatteverketAccountPreview`)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.SuggestedStartDate"}));
			}
		}
		export namespace StartFetchSession {
			export function Post(org: string, source: m.Bokio.Bank.Web.Controllers.StartSkatteverketAuthSessionSource): Promise<m.Envelope<m.Bokio.Bank.Web.Controllers.SkatteverketStartFetchSessionResult, m.SimpleError>> {
				return Client.post(Client.getPathWithQueryString(`/${org}/BankApi/SkatteverketTaxAccountFeed/StartFetchSession`, { source }), {  });
			}
		}
	}
	export namespace SveaAddProductController {
		export namespace AssignGuarantor {
			export function Post(org: string, request: m.Bokio.Bank.Contract.Svea.Requests.AssignGuarantorRequest): Promise<m.Envelope<boolean, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.post(`/${org}/BankApi/SveaAddProduct/AssignGuarantor`, request);
			}
		}
		export namespace CancelApplication {
			export function Delete(org: string, request: m.Bokio.Bank.Contract.Svea.Requests.CancelApplicationRequest): Promise<m.Envelope<boolean, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client._delete(`/${org}/BankApi/SveaAddProduct/CancelApplication`, { request });
			}
		}
		export namespace CancelCardApplication {
			export function Delete(org: string): Promise<m.Envelope<boolean, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client._delete(`/${org}/BankApi/SveaAddProduct/CancelCardApplication`, {  });
			}
		}
		export namespace CancelSavingsAccountApplicationInBokio {
			export function Post(org: string): Promise<m.Envelope<boolean, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.post(`/${org}/BankApi/SveaAddProduct/CancelSavingsAccountApplicationInBokio`, {  });
			}
		}
		export namespace CancelSigning {
			export function Post(org: string, revision?: string): Promise<m.Envelope<boolean, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.post(Client.getPathWithQueryString(`/${org}/BankApi/SveaAddProduct/CancelSigning`, { revision }), {  });
			}
		}
		export namespace CheckApplicationStatus {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Bank.Contract.Svea.Dtos.SveaApplicationStatus, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.get(`/${org}/BankApi/SveaAddProduct/CheckApplicationStatus`);
			}
		}
		export namespace CheckApplicationStatusAndCompleteInternationalPaymentSetup {
			export function Post(org: string): Promise<m.Envelope<m.Bokio.Bank.Contract.Svea.Dtos.SveaApplicationStatus, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.post(`/${org}/BankApi/SveaAddProduct/CheckApplicationStatusAndCompleteInternationalPaymentSetup`, {  });
			}
		}
		export namespace CheckCardApplicationStatusAndCompleteCardOrder {
			export function Post(org: string, request: m.Bokio.Bank.Contract.Svea.Dtos.SveaCardOrderStatusRequest): Promise<m.Envelope<m.Bokio.Bank.Contract.Svea.Dtos.SveaCardApplicationStatus, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.post(`/${org}/BankApi/SveaAddProduct/CheckCardApplicationStatusAndCompleteCardOrder`, request);
			}
		}
		export namespace CheckCheckCreditApplicationStatus {
			export function Post(org: string): Promise<m.Envelope<m.Bokio.Bank.Contract.Svea.Dtos.SveaApplicationStatus, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.post(`/${org}/BankApi/SveaAddProduct/CheckCheckCreditApplicationStatus`, {  });
			}
		}
		export namespace CheckCreditScoreForCheckCredit {
			export function Post(org: string, request: m.Bokio.Bank.Contract.Svea.Requests.CheckCreditScoreRequest): Promise<m.Envelope<boolean, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.post(`/${org}/BankApi/SveaAddProduct/CheckCreditScoreForCheckCredit`, request);
			}
		}
		export namespace CheckCreditStatus {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Bank.Contract.Svea.Dtos.SveaAddProductStatusDto, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.get(`/${org}/BankApi/SveaAddProduct/CheckCreditStatus`);
			}
		}
		export namespace CheckSavingsAccountOnboardingStatus {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Bank.Contract.Svea.Dtos.SveaApplicationAndBankAccountStatus, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.get(`/${org}/BankApi/SveaAddProduct/CheckSavingsAccountOnboardingStatus`);
			}
		}
		export namespace CollectPackageAgreementSigning {
			export function Get(org: string, revision: string): Promise<m.Envelope<m.Bokio.Bank.Contract.Svea.Dtos.BankIdSigningDto, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.get(`/${org}/BankApi/SveaAddProduct/CollectPackageAgreementSigning`, { revision });
			}
		}
		export namespace ConfigureCheckCreditAccount {
			export function Post(org: string, request: m.Bokio.Bank.Contract.Svea.Requests.ConfigureCheckCreditAccountRequest): Promise<m.Envelope<boolean, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.post(`/${org}/BankApi/SveaAddProduct/ConfigureCheckCreditAccount`, request);
			}
		}
		export namespace ConfigureCheckCreditProduct {
			export function Post(org: string, request: m.Bokio.Bank.Contract.Svea.Requests.ConfigureCreditProductRequest): Promise<m.Envelope<boolean, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.post(`/${org}/BankApi/SveaAddProduct/ConfigureCheckCreditProduct`, request);
			}
		}
		export namespace ConfigureSwish {
			export function Post(org: string, request: m.Bokio.Bank.Contract.Svea.Requests.SveaConfigureSwishRequest): Promise<m.Envelope<boolean, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.post(`/${org}/BankApi/SveaAddProduct/ConfigureSwish`, request);
			}
		}
		export namespace FinalizeProductOrder {
			export function Post(org: string): Promise<m.Envelope<boolean, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.post(`/${org}/BankApi/SveaAddProduct/FinalizeProductOrder`, {  });
			}
		}
		export namespace GetAmlQuestions {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Bank.Contract.Svea.Dtos.KycAmlQuestionsForProduct, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.get(`/${org}/BankApi/SveaAddProduct/GetAmlQuestions`)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.Questions.AnswerChoices.Value.PepQuestionDataValue.BirthDate"}));
			}
		}
		export namespace GetApplicationDetails {
			export function Get(org: string, applicationId: string): Promise<m.Envelope<m.Bokio.Bank.Contract.Svea.Dtos.SveaApplicationDetails, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.get(`/${org}/BankApi/SveaAddProduct/GetApplicationDetails`, { applicationId });
			}
		}
		export namespace GetCardOrderInformation {
			export function Get(org: string, accountId: string, userId: string): Promise<m.Envelope<m.Bokio.Bank.Contract.Svea.Dtos.SveaCardOrderInformationResponse, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.get(`/${org}/BankApi/SveaAddProduct/GetCardOrderInformation`, { accountId, userId });
			}
		}
		export namespace GetCheckCreditOnboardingSteps {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Bank.Contract.Svea.Dtos.SveaAddProductStepsUnion, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.get(`/${org}/BankApi/SveaAddProduct/GetCheckCreditOnboardingSteps`);
			}
		}
		export namespace GetSavingsAccountOnboardingStatus {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Bank.Contract.Svea.Dtos.SveaSavingsAccountStatusDto, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.get(`/${org}/BankApi/SveaAddProduct/GetSavingsAccountOnboardingStatus`);
			}
		}
		export namespace GetSavingsAccountOnboardingSteps {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Bank.Contract.Svea.Dtos.SveaAddProductStepsUnion, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.get(`/${org}/BankApi/SveaAddProduct/GetSavingsAccountOnboardingSteps`);
			}
		}
		export namespace GetSwishOnboardingStatus {
			export function Get(org: string, applicationId?: string): Promise<m.Envelope<m.Bokio.Bank.Contract.Svea.Dtos.SveaApplicationStatus, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.get(`/${org}/BankApi/SveaAddProduct/GetSwishOnboardingStatus`, { applicationId });
			}
		}
		export namespace GetSwishOnboardingSteps {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Bank.Contract.Svea.Dtos.SveaAddProductStepsUnion, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.get(`/${org}/BankApi/SveaAddProduct/GetSwishOnboardingSteps`);
			}
		}
		export namespace RegisterAmlAnswers {
			export function Post(org: string, request: m.Bokio.Bank.Contract.Svea.Requests.RegisterAmlAnswersRequest): Promise<m.Envelope<boolean, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.post(`/${org}/BankApi/SveaAddProduct/RegisterAmlAnswers`, request);
			}
		}
		export namespace RegisterInternationalPaymentsAmlAnswers {
			export function Post(org: string, request: m.Bokio.Bank.Contract.Svea.Requests.RegisterAmlAnswersRequest): Promise<m.Envelope<boolean, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.post(`/${org}/BankApi/SveaAddProduct/RegisterInternationalPaymentsAmlAnswers`, request);
			}
		}
		export namespace SetBookkeepingAccountForSavingsAccount {
			export function Post(org: string, request: m.Bokio.Bank.Contract.Dtos.SetBookkeepingAccountDto): Promise<m.Envelope<boolean, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.post(`/${org}/BankApi/SveaAddProduct/SetBookkeepingAccountForSavingsAccount`, request);
			}
		}
		export namespace SetupCardOrderingAndStartSigningWithQr {
			export function Post(org: string, request: m.Bokio.Bank.Contract.Svea.Requests.SveaConfigureCardRequest): Promise<m.Envelope<m.Bokio.Bank.Contract.Svea.Dtos.BankIdSigningDto, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.post(`/${org}/BankApi/SveaAddProduct/SetupCardOrderingAndStartSigningWithQr`, request);
			}
		}
		export namespace SetupGuarantorAgreement {
			export function Post(org: string, request: m.Bokio.Bank.Contract.Svea.Requests.SetupGuarantorAgreementRequest): Promise<m.Envelope<boolean, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.post(`/${org}/BankApi/SveaAddProduct/SetupGuarantorAgreement`, request);
			}
		}
		export namespace StartAddInternationalPaymentsAndGetSteps {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Bank.Contract.Svea.Dtos.SveaAddProductStepsUnion, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.get(`/${org}/BankApi/SveaAddProduct/StartAddInternationalPaymentsAndGetSteps`);
			}
		}
		export namespace StartSigningGuarantorAgreementWithQrCode {
			export function Post(org: string): Promise<m.Envelope<m.Bokio.Bank.Contract.Svea.Dtos.BankIdSigningDto, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.post(`/${org}/BankApi/SveaAddProduct/StartSigningGuarantorAgreementWithQrCode`, {  });
			}
		}
		export namespace StartSigningProductAgreementWithQrCode {
			export function Post(org: string): Promise<m.Envelope<m.Bokio.Bank.Contract.Svea.Dtos.BankIdSigningDto, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.post(`/${org}/BankApi/SveaAddProduct/StartSigningProductAgreementWithQrCode`, {  });
			}
		}
	}
	export namespace SveaAuth2Controller {
		export namespace Cancel {
			export function Post(request: m.Bokio.Bank.Web.Controllers.OngoingAuthenticationRequestBody): Promise<m.Envelope<m.Bokio.Bank.Web.Controllers.CancelResponseBody, m.Bokio.Bank.Web.Controllers.AuthenticationError>> {
				return Client.post("/BankApi/SveaAuth2/Cancel", request);
			}
		}
		export namespace CancelSign {
			export function Post(request: m.Bokio.Bank.Web.Controllers.OngoingSigninRequestBody): Promise<m.Envelope<m.Bokio.Bank.Web.Controllers.CancelSignResponseBody, m.Bokio.Bank.Web.Controllers.AuthenticationError>> {
				return Client.post("/BankApi/SveaAuth2/CancelSign", request);
			}
		}
		export namespace Complete {
			export function Post(request: m.Bokio.Bank.Web.Controllers.OngoingAuthenticationRequestBody): Promise<m.Envelope<m.Bokio.Bank.Web.Controllers.CompleteResponseBody, m.Bokio.Bank.Web.Controllers.AuthenticationError>> {
				return Client.post("/BankApi/SveaAuth2/Complete", request);
			}
		}
		export namespace CompleteSign {
			export function Post(request: m.Bokio.Bank.Web.Controllers.OngoingSigninRequestBody): Promise<m.Envelope<m.Bokio.Bank.Web.Controllers.CompleteSignResponseBody, m.Bokio.Bank.Web.Controllers.AuthenticationError>> {
				return Client.post("/BankApi/SveaAuth2/CompleteSign", request);
			}
		}
		export namespace Logout {
			export function Post(): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post("/BankApi/SveaAuth2/Logout", {  });
			}
		}
		export namespace RefreshToken {
			export function Post(): Promise<m.Envelope<m.Bokio.Bank.Web.Controllers.RefreshTokenResponseBody, m.Bokio.Bank.Web.Controllers.AuthenticationError>> {
				return Client.post("/BankApi/SveaAuth2/RefreshToken", {  });
			}
		}
		export namespace RequestSign {
			export function Post(request: m.Bokio.Bank.Web.Controllers.RequestSignBody): Promise<m.Envelope<m.Bokio.Bank.Web.Controllers.RequestSignResponseBody, m.Bokio.Bank.Web.Controllers.SignError>> {
				return Client.post("/BankApi/SveaAuth2/RequestSign", request);
			}
		}
		export namespace Start {
			export function Post(): Promise<m.Envelope<m.Bokio.Bank.Web.Controllers.AuthStatusResult, m.Bokio.Bank.Web.Controllers.AuthenticationError>> {
				return Client.post("/BankApi/SveaAuth2/Start", {  });
			}
		}
		export namespace StartSign {
			export function Post(request: m.Bokio.Bank.Web.Controllers.StartSignRequestBody): Promise<m.Envelope<m.Bokio.Bank.Web.Controllers.SignStatusResult, m.Bokio.Bank.Web.Controllers.AuthenticationError>> {
				return Client.post("/BankApi/SveaAuth2/StartSign", request);
			}
		}
		export namespace Status {
			export function Get(bankIdToken: string): Promise<m.Envelope<m.Bokio.Bank.Web.Controllers.AuthStatusResult, m.Bokio.Bank.Web.Controllers.AuthenticationError>> {
				return Client.get("/BankApi/SveaAuth2/Status", { bankIdToken });
			}
		}
		export namespace StatusSign {
			export function Get(bankIdToken: string): Promise<m.Envelope<m.Bokio.Bank.Web.Controllers.SignStatusResult, m.Bokio.Bank.Web.Controllers.AuthenticationError>> {
				return Client.get("/BankApi/SveaAuth2/StatusSign", { bankIdToken });
			}
		}
	}
	export namespace SveaAuthController {
		export namespace CancelBankIdAuth {
			export function Post(org: string, request: m.Bokio.Bank.Contract.Requests.BankIdTokenOperationRequest): Promise<m.Envelope<boolean, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.post(`/${org}/BankApi/SveaAuth/CancelBankIdAuth`, request);
			}
		}
		export namespace GetBankIdAuthStatusAndVerifyAuth {
			export function Post(org: string, request: m.Bokio.Bank.Contract.Requests.SveaAuthStatusRequest): Promise<m.Envelope<m.Bokio.Bank.Contract.Requests.SveaAuthStatusResponse, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.post(`/${org}/BankApi/SveaAuth/GetBankIdAuthStatusAndVerifyAuth`, request);
			}
		}
		export namespace GetUserInfo {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Bank.Contract.Svea.Dtos.SveaUserInfo, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.get(`/${org}/BankApi/SveaAuth/GetUserInfo`);
			}
		}
		export namespace Logout {
			export function Post(): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post("/BankApi/SveaAuth/Logout", {  });
			}
		}
		export namespace StartBankIdAuthentication {
			export function Post(org: string): Promise<m.Envelope<m.Bokio.Bank.Contract.Requests.SveaBankIdAuthStartResponse, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.post(`/${org}/BankApi/SveaAuth/StartBankIdAuthentication`, {  });
			}
		}
		export namespace StartBankIdAuthWithQrCode {
			export function Post(org: string, request: m.Bokio.Bank.Contract.Requests.SveaBankIdAuthStartRequest): Promise<m.Envelope<m.Bokio.Bank.Contract.Requests.SveaBankIdAuthStartResponse, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.post(`/${org}/BankApi/SveaAuth/StartBankIdAuthWithQrCode`, request);
			}
		}
	}
	export namespace SveaAutogiroController {
		export namespace GetAutogiroConsents {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Bank.Contract.Svea.Dtos.SveaAutogiroConsentDto, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.get(`/${org}/BankApi/SveaAutogiro/GetAutogiroConsents`);
			}
		}
		export namespace IsRecipientAutogiroEligible {
			export function Get(org: string, bankGiroNumber: string): Promise<m.Envelope<m.Bokio.Bank.Contract.Svea.Dtos.AutogiroRecipientEligibilityStatus, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.get(`/${org}/BankApi/SveaAutogiro/IsRecipientAutogiroEligible`, { bankGiroNumber });
			}
		}
	}
	export namespace SveaConsentController {
		export namespace ChangeConsent {
			export function Post(org: string, request: m.Bokio.Bank.Contract.Svea.Requests.SveaChangeConsent): Promise<m.Envelope<boolean, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.post(`/${org}/BankApi/SveaConsent/ChangeConsent`, request);
			}
		}
		export namespace CheckConsentAndTransactionsInSveaIfNonConsent {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Bank.Contract.Svea.Dtos.SveaCheckConsentAndHasTransactionsInSvea, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.get(`/${org}/BankApi/SveaConsent/CheckConsentAndTransactionsInSveaIfNonConsent`);
			}
		}
	}
	export namespace SveaDelegatesManagementController {
		export namespace ChangeDelegateAccessLevel {
			export function Post(org: string, delegateId: string, request: m.Bokio.Bank.Web.Controllers.ChangeDelegateAccessLevelRequest): Promise<m.Envelope<boolean, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.post(Client.getPathWithQueryString(`/${org}/BankApi/SveaDelegatesManagement/ChangeDelegateAccessLevel`, { delegateId }), request);
			}
		}
		export namespace CreateNewDelegate {
			export function Post(org: string, request: m.Bokio.Bank.Web.Controllers.CreateNewDelegateRequest): Promise<m.Envelope<m.Bokio.Bank.Web.Controllers.CreateNewDelegateResult, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.post(`/${org}/BankApi/SveaDelegatesManagement/CreateNewDelegate`, request);
			}
		}
		export namespace DeleteDelegate {
			export function Post(org: string, request: m.Bokio.Bank.Web.Controllers.DeleteDelegateRequest): Promise<m.Envelope<boolean, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.post(`/${org}/BankApi/SveaDelegatesManagement/DeleteDelegate`, request);
			}
		}
		export namespace GetDelegate {
			export function Get(org: string, delegateId: string): Promise<m.Envelope<m.Bokio.Bank.Web.Controllers.GetDelegateResult, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.get(`/${org}/BankApi/SveaDelegatesManagement/GetDelegate`, { delegateId });
			}
		}
		export namespace GetDelegates {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Bank.Web.Controllers.GetDelegatesResultListEntry[], m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.get(`/${org}/BankApi/SveaDelegatesManagement/GetDelegates`);
			}
		}
		export namespace LookupPersonName {
			export function Post(org: string, request: m.Bokio.Bank.Web.Controllers.LookupPersonNameRequest): Promise<m.Envelope<m.Bokio.Bank.Web.Controllers.LookupPersonNameResult, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.post(`/${org}/BankApi/SveaDelegatesManagement/LookupPersonName`, request);
			}
		}
	}
	export namespace SveaInboxController {
		export namespace DeleteMessage {
			export function Delete(org: string, messageId: string): Promise<m.Envelope<boolean, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client._delete(`/${org}/BankApi/SveaInbox/DeleteMessage`, { messageId });
			}
		}
		export namespace GetSingleMessage {
			export function Get(org: string, messageId: string): Promise<m.Envelope<m.Bokio.Bank.Contract.Svea.Dtos.SveaInboxMessage, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.get(`/${org}/BankApi/SveaInbox/GetSingleMessage`, { messageId })
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.Attachments.AvailableUntil"}, {"type":"Date","key":"Data.TimeRead"}, {"type":"Date","key":"Data.TimeSent"}));
			}
		}
		export namespace ListMessages {
			export function Get(org: string, fromDate?: Date, toDate?: Date): Promise<m.Envelope<m.Bokio.Bank.Contract.Svea.Dtos.SveaInboxMessage[], m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.get(`/${org}/BankApi/SveaInbox/ListMessages`, { fromDate, toDate })
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.Attachments.AvailableUntil"}, {"type":"Date","key":"Data.TimeRead"}, {"type":"Date","key":"Data.TimeSent"}));
			}
		}
		export namespace MarkMessageAsRead {
			export function Post(org: string, messageId: string): Promise<m.Envelope<boolean, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.post(Client.getPathWithQueryString(`/${org}/BankApi/SveaInbox/MarkMessageAsRead`, { messageId }), {  });
			}
		}
	}
	export namespace SveaInternationalPaymentsController {
		export namespace CancelApplication {
			export function Post(org: string, id: string, revision: string): Promise<m.Envelope<boolean, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.post(Client.getPathWithQueryString(`/${org}/BankApi/SveaInternationalPayments/CancelApplication/${id}`, { revision }), {  });
			}
		}
		export namespace Create {
			export function Post(org: string, request: m.Bokio.Bank.Contract.Svea.Dtos.InternationalPayments.SveaInternationalPaymentsCreatePreregistrationApplicationRequest): Promise<m.Envelope<m.Bokio.Bank.Web.Controllers.SveaInternationalPaymentsCreateApplicationResponseDto, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.post(`/${org}/BankApi/SveaInternationalPayments/Create`, request);
			}
		}
		export namespace DeletePreregistrationCreditor {
			export function Post(org: string, id: string): Promise<m.Envelope<boolean, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.post(`/${org}/BankApi/SveaInternationalPayments/DeletePreregistrationCreditor/${id}`, {  });
			}
		}
		export namespace DeletePreregistrationDebtor {
			export function Post(org: string, id: string): Promise<m.Envelope<boolean, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.post(`/${org}/BankApi/SveaInternationalPayments/DeletePreregistrationDebtor/${id}`, {  });
			}
		}
		export namespace GetAmlQuestions {
			export function Get(org: string, id: string): Promise<m.Envelope<m.Bokio.Bank.Contract.Svea.Dtos.KycAmlQuestionsForProduct[], m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.get(`/${org}/BankApi/SveaInternationalPayments/GetAmlQuestions/${id}`)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.Questions.AnswerChoices.Value.PepQuestionDataValue.BirthDate"}));
			}
		}
		export namespace GetApplication {
			export function Get(org: string, id: string): Promise<m.Envelope<m.Bokio.Bank.Contract.Svea.Dtos.InternationalPayments.SveaInternationalPaymentsPreregistrationApplicationDetailsDto, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.get(`/${org}/BankApi/SveaInternationalPayments/GetApplication/${id}`)
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.LastSynchronized"}, {"type":"Date","key":"Data.Created"}));
			}
		}
		export namespace GetCreditorSupplierMatchInfo {
			export function Get(org: string, request: m.Bokio.Bank.Contract.Teller.Dtos.CreditorMatchInfoDto): Promise<m.Envelope<m.Bokio.Bank.Contract.Teller.Dtos.SupplierMatchInfoDto[], m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.get(`/${org}/BankApi/SveaInternationalPayments/GetCreditorSupplierMatchInfo`, { request });
			}
		}
		export namespace GetPreregistration {
			export function Get(org: string, id: string): Promise<m.Envelope<m.Bokio.Bank.Contract.Svea.Dtos.InternationalPayments.SveaInternationalPaymentPreregistrationDetailsDto, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.get(`/${org}/BankApi/SveaInternationalPayments/GetPreregistration/${id}`)
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.LastSynchronized"}));
			}
		}
		export namespace GetSettingsContent {
			export function Post(org: string, getFilter: m.Bokio.Bank.Contract.Svea.Dtos.InternationalPayments.SveaInternationalPaymentsPreregistrationSettingsContentFilter): Promise<m.Envelope<m.Bokio.Bank.Contract.Svea.Dtos.InternationalPayments.SettingsContentDto, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.post(`/${org}/BankApi/SveaInternationalPayments/GetSettingsContent`, getFilter)
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.LastSynchronized"}, {"type":"Date","key":"Data.Applications.LastSynchronized"}, {"type":"Date","key":"Data.Applications.Created"}, {"type":"Date","key":"Data.Preregistrations.LastSynchronized"}));
			}
		}
		export namespace SaveAmlQuestionsAndFinalize {
			export function Post(org: string, id: string, revision: string, request: m.Bokio.Bank.Contract.Svea.Requests.RegisterPreregistrationAmlAnswersRequest): Promise<m.Envelope<string, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.post(Client.getPathWithQueryString(`/${org}/BankApi/SveaInternationalPayments/SaveAmlQuestionsAndFinalize/${id}`, { revision }), request);
			}
		}
		export namespace Status {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Bank.Contract.Svea.Dtos.SveaAddProductStatusDto, m.SimpleError>> {
				return Client.get(`/${org}/BankApi/SveaInternationalPayments/Status`);
			}
		}
		export namespace SynchronizeIfInternationalPaymentsIsActive {
			export function Post(org: string): Promise<m.Envelope<boolean, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.post(`/${org}/BankApi/SveaInternationalPayments/SynchronizeIfInternationalPaymentsIsActive`, {  });
			}
		}
	}
	export namespace SveaKycApplicationController {
		export namespace ConfirmBeneficialOwnership {
			export function Post(org: string, request: m.Bokio.Bank.Contract.Svea.Requests.ConfirmBeneficialOwnershipRequest): Promise<m.Envelope<boolean, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.post(`/${org}/BankApi/SveaKycApplication/ConfirmBeneficialOwnership`, request);
			}
		}
		export namespace FinalizeApplication {
			export function Post(org: string, request: m.Bokio.Bank.Contract.Svea.Requests.FinalizeApplicationRequest): Promise<m.Envelope<boolean, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.post(`/${org}/BankApi/SveaKycApplication/FinalizeApplication`, request);
			}
		}
		export namespace GetApplicationStatus {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Bank.Contract.Svea.Dtos.SveaKycApplicationStatus, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.get(`/${org}/BankApi/SveaKycApplication/GetApplicationStatus`);
			}
		}
		export namespace GetBeneficialOwnerQuestions {
			export function Get(org: string, personKey: string): Promise<m.Envelope<m.Bokio.Bank.Contract.Svea.Dtos.KycQuestion[], m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.get(`/${org}/BankApi/SveaKycApplication/GetBeneficialOwnerQuestions`, { personKey })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.AnswerChoices.Value.PepQuestionDataValue.BirthDate"}, {"type":"Day","key":"Data.Answers.AnswerValue.AnswerValue.PepQuestionDataValue.BirthDate"}));
			}
		}
		export namespace GetBeneficialOwners {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Bank.Contract.Svea.Dtos.ApplicationIdBeneficialOwnership, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.get(`/${org}/BankApi/SveaKycApplication/GetBeneficialOwners`);
			}
		}
		export namespace GetKycAmlQuestions {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Bank.Contract.Svea.Dtos.KycAmlQuestionsForProduct[], m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.get(`/${org}/BankApi/SveaKycApplication/GetKycAmlQuestions`)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.Questions.AnswerChoices.Value.PepQuestionDataValue.BirthDate"}));
			}
		}
		export namespace GetKycAmlQuestionsForProductId {
			export function Get(org: string, productId: string): Promise<m.Envelope<m.Bokio.Bank.Contract.Svea.Dtos.KycAmlQuestionsForProduct, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.get(`/${org}/BankApi/SveaKycApplication/GetKycAmlQuestionsForProductId`, { productId })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.Questions.AnswerChoices.Value.PepQuestionDataValue.BirthDate"}));
			}
		}
		export namespace GetKycApplicationQuestions {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Bank.Contract.Svea.Dtos.KycQuestion[], m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.get(`/${org}/BankApi/SveaKycApplication/GetKycApplicationQuestions`)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.AnswerChoices.Value.PepQuestionDataValue.BirthDate"}, {"type":"Day","key":"Data.Answers.AnswerValue.AnswerValue.PepQuestionDataValue.BirthDate"}));
			}
		}
		export namespace GetSniCodes {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Bank.Contract.Svea.Dtos.SveaSniCodeItem[], m.SimpleError>> {
				return Client.get(`/${org}/BankApi/SveaKycApplication/GetSniCodes`);
			}
		}
		export namespace GetSteps {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Bank.Contract.Svea.Dtos.SveaKycApplicationStepDto, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.get(`/${org}/BankApi/SveaKycApplication/GetSteps`);
			}
		}
		export namespace InitiateApplication {
			export function Post(org: string): Promise<m.Envelope<m.Bokio.Bank.Contract.Svea.Dtos.SveaKycApplicationStatus, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.post(`/${org}/BankApi/SveaKycApplication/InitiateApplication`, {  });
			}
		}
		export namespace RegisterBeneficialOwnerAnswers {
			export function Post(org: string, request: m.Bokio.Bank.Contract.Svea.Requests.RegisterKycBeneficialOwnerAnswersRequest): Promise<m.Envelope<boolean, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.post(`/${org}/BankApi/SveaKycApplication/RegisterBeneficialOwnerAnswers`, request);
			}
		}
		export namespace RegisterKycAmlAnswers {
			export function Post(org: string, request: m.Bokio.Bank.Contract.Svea.Requests.RegisterKycAmlAnswersRequest): Promise<m.Envelope<boolean, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.post(`/${org}/BankApi/SveaKycApplication/RegisterKycAmlAnswers`, request);
			}
		}
		export namespace RegisterKycApplicationAnswers {
			export function Post(org: string, request: m.Bokio.Bank.Contract.Svea.Requests.RegisterKycApplicationAnswersRequest): Promise<m.Envelope<boolean, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.post(`/${org}/BankApi/SveaKycApplication/RegisterKycApplicationAnswers`, request);
			}
		}
		export namespace RegisterSniCodes {
			export function Post(org: string, request: m.Bokio.Bank.Contract.Svea.Requests.RegisterSniCodesRequest): Promise<m.Envelope<boolean, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.post(`/${org}/BankApi/SveaKycApplication/RegisterSniCodes`, request);
			}
		}
	}
	export namespace SveaOnboardingController {
		export namespace AssignSignatories {
			export function Post(org: string, request: m.Bokio.Bank.Contract.Svea.Requests.AssignSignatoriesRequest): Promise<m.Envelope<boolean, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.post(`/${org}/BankApi/SveaOnboarding/AssignSignatories`, request);
			}
		}
		export namespace CancelApplication {
			export function Delete(org: string, request: m.Bokio.Bank.Contract.Svea.Requests.CancelApplicationRequest): Promise<m.Envelope<boolean, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client._delete(`/${org}/BankApi/SveaOnboarding/CancelApplication`, { request });
			}
		}
		export namespace CancelSigning {
			export function Post(org: string, request: m.Bokio.Bank.Contract.Svea.Requests.CancelSigningRequest): Promise<m.Envelope<boolean, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.post(`/${org}/BankApi/SveaOnboarding/CancelSigning`, request);
			}
		}
		export namespace CheckApplicationStatusAndCreateBankAccounts {
			export function Post(org: string): Promise<m.Envelope<m.Bokio.Bank.Contract.Svea.Dtos.SveaApplicationAndCreatedBankStatus, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.post(`/${org}/BankApi/SveaOnboarding/CheckApplicationStatusAndCreateBankAccounts`, {  });
			}
		}
		export namespace CheckCreditScoreIfNotCompleted {
			export function Post(org: string): Promise<m.Envelope<boolean, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.post(`/${org}/BankApi/SveaOnboarding/CheckCreditScoreIfNotCompleted`, {  });
			}
		}
		export namespace CollectPackageAgreementSigning {
			export function Get(org: string, revision: string): Promise<m.Envelope<m.Bokio.Bank.Contract.Svea.Dtos.BankIdSigningDto, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.get(`/${org}/BankApi/SveaOnboarding/CollectPackageAgreementSigning`, { revision });
			}
		}
		export namespace ConfigureConsentAndSetupPackageAgreement {
			export function Post(org: string, request: m.Bokio.Bank.Contract.Svea.Requests.ConfigureConsentRequest): Promise<m.Envelope<boolean, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.post(`/${org}/BankApi/SveaOnboarding/ConfigureConsentAndSetupPackageAgreement`, request);
			}
		}
		export namespace ConfigureOptionalFeatures {
			export function Post(org: string, request: m.Bokio.Bank.Contract.Svea.Requests.OptionalFeaturesRequest): Promise<m.Envelope<boolean, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.post(`/${org}/BankApi/SveaOnboarding/ConfigureOptionalFeatures`, request);
			}
		}
		export namespace ConfirmBeneficialOwnership {
			export function Post(org: string, request: m.Bokio.Bank.Contract.Svea.Requests.ConfirmBeneficialOwnershipRequest): Promise<m.Envelope<m.Bokio.Bank.Contract.Svea.Dtos.ConfirmBeneficiaryOwnershipResponse, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.post(`/${org}/BankApi/SveaOnboarding/ConfirmBeneficialOwnership`, request);
			}
		}
		export namespace FinalizeApplication {
			export function Post(org: string, request: m.Bokio.Bank.Contract.Svea.Requests.FinalizeApplicationRequest): Promise<m.Envelope<boolean, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.post(`/${org}/BankApi/SveaOnboarding/FinalizeApplication`, request);
			}
		}
		export namespace GetApplicationDetails {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Bank.Contract.Svea.Dtos.SveaApplicationsDetails, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.get(`/${org}/BankApi/SveaOnboarding/GetApplicationDetails`);
			}
		}
		export namespace GetBeneficialOwners {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Bank.Contract.Svea.Dtos.ApplicationIdBeneficialOwnership, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.get(`/${org}/BankApi/SveaOnboarding/GetBeneficialOwners`);
			}
		}
		export namespace GetCardDisplayNames {
			export function Get(org: string): Promise<m.Envelope<string[], m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.get(`/${org}/BankApi/SveaOnboarding/GetCardDisplayNames`);
			}
		}
		export namespace GetKycAmlQuestions {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Bank.Contract.Svea.Dtos.KycAmlQuestionsForProduct[], m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.get(`/${org}/BankApi/SveaOnboarding/GetKycAmlQuestions`)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.Questions.AnswerChoices.Value.PepQuestionDataValue.BirthDate"}));
			}
		}
		export namespace GetKycQuestions {
			export function Get(org: string, questionIds: string[]): Promise<m.Envelope<m.Bokio.Bank.Contract.Svea.Dtos.KycQuestion[], m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.get(`/${org}/BankApi/SveaOnboarding/GetKycQuestions`, { questionIds })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.AnswerChoices.Value.PepQuestionDataValue.BirthDate"}, {"type":"Day","key":"Data.Answers.AnswerValue.AnswerValue.PepQuestionDataValue.BirthDate"}));
			}
		}
		export namespace GetNotConnectedBankAccounts {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Bank.Contract.Svea.Dtos.GetNotConnectedBankAccountsResponse, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.get(`/${org}/BankApi/SveaOnboarding/GetNotConnectedBankAccounts`);
			}
		}
		export namespace GetSteps {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Bank.Contract.Svea.Dtos.SveaOnboardingStepsUnion, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.get(`/${org}/BankApi/SveaOnboarding/GetSteps`);
			}
		}
		export namespace GetSveaCountriesList {
			export function Get(org: string, request: m.Bokio.Bank.Contract.Svea.Requests.SveaCountriesFilter): Promise<m.Envelope<m.Bokio.Bank.Contract.Svea.Dtos.SveaCountry[], m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.get(`/${org}/BankApi/SveaOnboarding/GetSveaCountriesList`, { request });
			}
		}
		export namespace HasConsent {
			export function Get(org: string): Promise<m.Envelope<boolean, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.get(`/${org}/BankApi/SveaOnboarding/HasConsent`);
			}
		}
		export namespace InitApplication {
			export function Post(org: string): Promise<m.Envelope<boolean, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.post(`/${org}/BankApi/SveaOnboarding/InitApplication`, {  });
			}
		}
		export namespace ListSignatories {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Bank.Contract.Svea.Dtos.SveaAssignSignatoryItem[], m.SimpleError>> {
				return Client.get(`/${org}/BankApi/SveaOnboarding/ListSignatories`);
			}
		}
		export namespace ListSniCodes {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Bank.Contract.Svea.Dtos.SveaSniCodeItem[], m.SimpleError>> {
				return Client.get(`/${org}/BankApi/SveaOnboarding/ListSniCodes`);
			}
		}
		export namespace RegisterBeneficialOwnerAnswers {
			export function Post(org: string, request: m.Bokio.Bank.Contract.Svea.Requests.RegisterKycBeneficialOwnerAnswersRequest): Promise<m.Envelope<boolean, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.post(`/${org}/BankApi/SveaOnboarding/RegisterBeneficialOwnerAnswers`, request);
			}
		}
		export namespace RegisterContactInformation {
			export function Post(org: string, request: m.Bokio.Bank.Contract.Svea.Requests.RegisterContactInformationRequest): Promise<m.Envelope<boolean, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.post(`/${org}/BankApi/SveaOnboarding/RegisterContactInformation`, request);
			}
		}
		export namespace RegisterKycAmlAnswers {
			export function Post(org: string, request: m.Bokio.Bank.Contract.Svea.Requests.RegisterKycAmlAnswersRequest): Promise<m.Envelope<boolean, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.post(`/${org}/BankApi/SveaOnboarding/RegisterKycAmlAnswers`, request);
			}
		}
		export namespace RegisterKycApplicationAnswers {
			export function Post(org: string, request: m.Bokio.Bank.Contract.Svea.Requests.RegisterKycApplicationAnswersRequest): Promise<m.Envelope<boolean, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.post(`/${org}/BankApi/SveaOnboarding/RegisterKycApplicationAnswers`, request);
			}
		}
		export namespace RegisterOrganizationContactInformation {
			export function Post(org: string, request: m.Bokio.Bank.Contract.Svea.Requests.RegisterOrganizationContactInformationRequest): Promise<m.Envelope<boolean, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.post(`/${org}/BankApi/SveaOnboarding/RegisterOrganizationContactInformation`, request);
			}
		}
		export namespace RegisterSniCodes {
			export function Post(org: string, request: m.Bokio.Bank.Contract.Svea.Requests.RegisterSniCodesRequest): Promise<m.Envelope<boolean, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.post(`/${org}/BankApi/SveaOnboarding/RegisterSniCodes`, request);
			}
		}
		export namespace SelectPackageAndAddons {
			export function Post(org: string, request: m.Bokio.Bank.Contract.Svea.Requests.SelectAddonRequest): Promise<m.Envelope<boolean, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.post(`/${org}/BankApi/SveaOnboarding/SelectPackageAndAddons`, request);
			}
		}
		export namespace SetBookkeepingAccount {
			export function Post(org: string, request: m.Bokio.Bank.Contract.Dtos.SetBookkeepingAccountDto): Promise<m.Envelope<boolean, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.post(`/${org}/BankApi/SveaOnboarding/SetBookkeepingAccount`, request);
			}
		}
		export namespace StartSigningPackageAgreementWithQrCode {
			export function Post(org: string, request: m.Bokio.Bank.Contract.Svea.Requests.SignPackageAgreementRequest): Promise<m.Envelope<m.Bokio.Bank.Contract.Svea.Dtos.BankIdSigningDto, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.post(`/${org}/BankApi/SveaOnboarding/StartSigningPackageAgreementWithQrCode`, request);
			}
		}
		export namespace Status {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Bank.Services.SveaOnboardingStatus, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.get(`/${org}/BankApi/SveaOnboarding/Status`);
			}
		}
		export namespace TryFinalizePackageAgreementSigning {
			export function Post(org: string): Promise<m.Envelope<boolean, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.post(`/${org}/BankApi/SveaOnboarding/TryFinalizePackageAgreementSigning`, {  });
			}
		}
	}
	export namespace SveaPaymentMatchingController {
		export namespace HasPaymentsToMatch {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Bank.Web.Controllers.NeedsMatchingResult, m.SimpleError>> {
				return Client.get(`/${org}/BankApi/SveaPaymentMatching/HasPaymentsToMatch`);
			}
		}
		export namespace List {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Bank.Web.Controllers.MatchingItem[], m.SimpleError>> {
				return Client.get(`/${org}/BankApi/SveaPaymentMatching/List`)
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.Transaction.TransactionDate"}, {"type":"Date","key":"Data.Transaction.EffectiveDate"}, {"type":"Date","key":"Data.Payments.Payment.Date"}));
			}
		}
		export namespace MatchPaymentAndTransaction {
			export function Post(org: string, request: m.Bokio.Bank.Web.Controllers.MatchPaymentAndTransactionDto): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/BankApi/SveaPaymentMatching/MatchPaymentAndTransaction`, request);
			}
		}
	}
	export namespace SveaStatusController {
		export namespace Status {
			export function Get(org: string): Promise<m.Envelope<boolean, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.get(`/${org}/BankApi/SveaStatus/Status`);
			}
		}
	}
	export namespace SveaSwishController {
		export namespace CancelOffBoardSwishEnrollment {
			export function Post(org: string, bankIdToken: string): Promise<m.Envelope<boolean, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.post(`/${org}/BankApi/SveaSwish/CancelOffBoardSwishEnrollment`, { bankIdToken });
			}
		}
		export namespace ConfirmOffBoardSwishEnrollment {
			export function Post(org: string, bankIdToken: string): Promise<m.Envelope<m.Bokio.Bank.Contract.Teller.Dtos.BankIdStatusDto<m.Bokio.Bank.Contract.Teller.Dtos.SignEmptyData>, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.post(`/${org}/BankApi/SveaSwish/ConfirmOffBoardSwishEnrollment`, { bankIdToken });
			}
		}
		export namespace HasSwishEnrollmentOffboarded {
			export function Get(org: string, request: m.Bokio.Bank.Contract.Svea.Requests.OffboardSveaSwishRequest): Promise<m.Envelope<boolean, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.get(`/${org}/BankApi/SveaSwish/HasSwishEnrollmentOffboarded`, { request });
			}
		}
		export namespace StartOffBoardSwishEnrollment {
			export function Post(org: string, request: m.Bokio.Bank.Contract.Svea.Requests.OffboardSveaSwishRequest): Promise<m.Envelope<m.Bokio.Bank.Contract.Teller.Interfaces.TellerBankIdSignStartResponseDto, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.post(Client.getPathWithQueryString(`/${org}/BankApi/SveaSwish/StartOffBoardSwishEnrollment`, { request }), {  });
			}
		}
		export namespace Status {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Bank.Contract.Svea.Dtos.SveaSwishStatusResponse, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.get(`/${org}/BankApi/SveaSwish/Status`);
			}
		}
	}
	export namespace TransactionController {
		export namespace Get {
			export function Get(org: string, account: number, transactionId: string): Promise<m.Envelope<m.Bokio.Bank.Contract.Dtos.TransactionDetailsDto, m.SimpleError>> {
				return Client.get(`/${org}/BankApi/Transaction/Get`, { account, transactionId })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.TransactionDate"}, {"type":"Day","key":"Data.RenderedDetailRows.Value.Date"}));
			}
		}
		export namespace GetReservedTransactions {
			export function Get(org: string, bankAccountId: string): Promise<m.Envelope<m.Bokio.Bank.Contract.Dtos.TransactionsForListDto, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.get(`/${org}/BankApi/Transaction/GetReservedTransactions`, { bankAccountId })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.PendingTransactions.TransactionDate"}, {"type":"Day","key":"Data.PendingTransactions.EffectiveDate"}, {"type":"Day","key":"Data.PendingTransactions.OriginalTransactionDate"}, {"type":"Day","key":"Data.CompletedTransactions.TransactionDate"}, {"type":"Day","key":"Data.CompletedTransactions.EffectiveDate"}, {"type":"Day","key":"Data.CompletedTransactions.OriginalTransactionDate"}));
			}
		}
		export namespace GetTransactionListPageSumary {
			export function Get(org: string, bankAccountId: string): Promise<m.Envelope<m.Bokio.Bank.Contract.Dtos.TransactionListPageSumaryDto, m.SimpleError>> {
				return Client.get(`/${org}/BankApi/Transaction/GetTransactionListPageSumary`, { bankAccountId });
			}
		}
		export namespace GetTransactionListPageSummary {
			export function Get(org: string, bankAccountId: string): Promise<m.Envelope<m.Bokio.Bank.Contract.Dtos.TransactionListPageSumaryDto, m.SimpleError>> {
				return Client.get(`/${org}/BankApi/Transaction/GetTransactionListPageSummary`, { bankAccountId });
			}
		}
		export namespace List {
			export function Get(org: string, account: number, filter: m.Bokio.Bank.Contract.Utils.TransactionsFilter): Promise<m.Envelope<m.Bokio.Bank.Contract.Dtos.TransactionsForListDto, m.SimpleError>> {
				return Client.get(`/${org}/BankApi/Transaction/List`, { account, filter })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.PendingTransactions.TransactionDate"}, {"type":"Day","key":"Data.PendingTransactions.EffectiveDate"}, {"type":"Day","key":"Data.PendingTransactions.OriginalTransactionDate"}, {"type":"Day","key":"Data.CompletedTransactions.TransactionDate"}, {"type":"Day","key":"Data.CompletedTransactions.EffectiveDate"}, {"type":"Day","key":"Data.CompletedTransactions.OriginalTransactionDate"}));
			}
		}
	}
	export namespace UploadRequestController {
		export namespace ClearReceiptRequest {
			export function Post(org: string, request: m.Bokio.Bank.Contract.AutoVerificationRows.Requests.ClearReceiptRequest): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/UploadRequest/ClearReceiptRequest`, request);
			}
		}
		export namespace GetLastReceiptRequestNotifications {
			export function Get(org: string): Promise<m.Envelope<{ [key: string]: Date; }, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/UploadRequest/GetLastReceiptRequestNotifications`);
			}
		}
		export namespace GetUsersToNotify {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Bank.Contract.UploadRequests.NotifyUsersModel, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/UploadRequest/GetUsersToNotify`);
			}
		}
		export namespace RequestReceipt {
			export function Post(org: string, request: m.Bokio.Bank.Contract.AutoVerificationRows.Requests.ReceiptRequest): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/UploadRequest/RequestReceipt`, request);
			}
		}
	}
}
export namespace BankFeed {
	export namespace BankFeedController {
		export namespace AddConnection {
			export function Post(org: string, request: m.Bokio.Integration.Plaid.AddBankFeedConection): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/BankFeed/BankFeed/AddConnection`, request);
			}
		}
		export namespace CreateLinkToken {
			export function Post(org: string): Promise<m.Envelope<string, m.SimpleError>> {
				return Client.post(`/${org}/BankFeed/BankFeed/CreateLinkToken`, {  });
			}
		}
		export namespace CreateUpdateToken {
			export function Post(org: string, bankId: string): Promise<m.Envelope<string, m.SimpleError>> {
				return Client.post(`/${org}/BankFeed/BankFeed/CreateUpdateToken`, { bankId });
			}
		}
		export namespace FindBanksNeedReAuthentication {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Bank.Contract.Dtos.BankNeedReAuthenticationDto[], m.SimpleError>> {
				return Client.get(`/${org}/BankFeed/BankFeed/FindBanksNeedReAuthentication`);
			}
		}
		export namespace GetBankNeedsReAuthentication {
			export function Get(org: string, bankId: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.get(`/${org}/BankFeed/BankFeed/GetBankNeedsReAuthentication`, { bankId });
			}
		}
		export namespace GetConnectedBanks {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Bank.Contract.Dtos.BanksDto, m.SimpleError>> {
				return Client.get(`/${org}/BankFeed/BankFeed/GetConnectedBanks`)
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.Banks.Accounts.LastSync"}, {"type":"Day","key":"Data.Banks.Accounts.SyncFromDate"}));
			}
		}
		export namespace GetItemNeedsReAuthentication {
			export function Get(org: string, bankId: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.get(`/${org}/BankFeed/BankFeed/GetItemNeedsReAuthentication`, { bankId });
			}
		}
		export namespace RemoveConnection {
			export function Post(org: string, request: m.Bokio.Integration.Plaid.RemoveBankFeedConection): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/BankFeed/BankFeed/RemoveConnection`, request);
			}
		}
		export namespace ResetConnectionNeedsUpdate {
			export function Post(org: string, bankId: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/BankFeed/BankFeed/ResetConnectionNeedsUpdate`, { bankId });
			}
		}
		export namespace SetMultipleBookkeepingAccounts {
			export function Post(org: string, accounts: m.Bokio.Bank.Contract.Dtos.SetBookkeepingAccountDto[]): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/BankFeed/BankFeed/SetMultipleBookkeepingAccounts`, accounts);
			}
		}
	}
	export namespace PlaidIncomingWebjobController {
		export namespace JobWasExecuted {
			export function Post(job: m.Bokio.Integration.Plaid.PlaidQueueItemDto): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post("/BankFeed/PlaidIncomingWebjob/JobWasExecuted", job);
			}
		}
	}
	export namespace PlaidOptionsController {
		export namespace GetEnvironment {
			export function Get(org: string, bankId?: string): Promise<m.Envelope<string, m.SimpleError>> {
				return Client.get(`/${org}/BankFeed/PlaidOptions/GetEnvironment`, { bankId });
			}
		}
		export namespace GetOptions {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Bank.Contract.Plaid.PlaidOptionsDto, m.SimpleError>> {
				return Client.get(`/${org}/BankFeed/PlaidOptions/GetOptions`);
			}
		}
	}
}
export namespace Bokio {
	export namespace AccountController {
		export namespace CanDeleteUserAccount {
			export function Get(): Promise<m.Envelope<m.Bokio.Backbone.Web.Controllers.Accounts.CanDeleteResponse, m.SimpleError>> {
				return Client.get("/Account/CanDeleteUserAccount");
			}
		}
		export namespace ChangePassword {
			export function Post(currentPassword: string, newPassword: string, confirmNewPassword: string): Promise<m.Envelope<boolean, m.Bokio.Services.Account.ChangePasswordError>> {
				return Client.post("/Account/ChangePassword", { currentPassword, newPassword, confirmNewPassword });
			}
		}
		export namespace CompanyOwnerInvitationDetails {
			export function Get(invitationId: string): Promise<m.Envelope<m.Bokio.Services.Account.InvitationDetails, m.SimpleError>> {
				return Client.get("/Account/CompanyOwnerInvitationDetails", { invitationId });
			}
		}
		export namespace ConfirmBankIdLogin {
			export function Post(username: string): Promise<m.Envelope<m.Bokio.Backbone.Web.Controllers.Accounts.ConfirmBankIdLoginResponse, m.Bokio.Common.Contract.BankId.BankIdError>> {
				return Client.post("/Account/ConfirmBankIdLogin", { username });
			}
		}
		export namespace ConfirmBankIdLoginOrCreate {
			export function Post(returnUrl?: string, referralSource?: m.Entities.UserReferralSource, acquisitionCampaign?: m.Entities.AcquisitionCampaignData, voucherCode?: string): Promise<m.Envelope<m.Bokio.Backbone.Web.Controllers.Accounts.ConfirmBankIdLoginOrCreateResponse, m.Bokio.Common.Contract.BankId.BankIdError>> {
				return Client.post("/Account/ConfirmBankIdLoginOrCreate", { returnUrl, referralSource, acquisitionCampaign, voucherCode });
			}
		}
		export namespace ConfirmEmail {
			export function Post(userId: string, confirmationCode: number, userType: m.Bokio.Common.Contract.Accounts.UserType): Promise<m.Envelope<string, m.Bokio.Services.Account.ConfirmEmailError>> {
				return Client.post("/Account/ConfirmEmail", { userId, confirmationCode, userType });
			}
		}
		export namespace CreateMagicLink {
			export function Post(): Promise<m.Envelope<m.Bokio.Common.Types.SecretString, m.SimpleError>> {
				return Client.post("/Account/CreateMagicLink", {  });
			}
		}
		export namespace CreateUser {
			export function Post(userEmail: string, userFirstName: string, userLastName: string, termsVersion: number, signupType: m.Entities.UserSignupType, userPersonalIdentifier?: string, returnUrl?: string, referralSource?: m.Entities.UserReferralSource, acquisitionCampaign?: m.Entities.AcquisitionCampaignData, voucherCode?: string): Promise<m.Envelope<m.Bokio.Services.Account.UserToBeConfirmedDto, m.Bokio.Services.Account.CreateUserToBeConfirmedError>> {
				return Client.post("/Account/CreateUser", { userEmail, userFirstName, userLastName, termsVersion, signupType, userPersonalIdentifier, returnUrl, referralSource, acquisitionCampaign, voucherCode });
			}
		}
		export namespace DeleteUserAccount {
			export function Post(): Promise<m.Envelope<m.Bokio.Utils.RecentLoginProtectedResult<boolean>, m.SimpleError>> {
				return Client.post("/Account/DeleteUserAccount", {  });
			}
		}
		export namespace ForgotPassword {
			export function Post(email: string, returnUrl: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post("/Account/ForgotPassword", { email, returnUrl });
			}
		}
		export namespace GetPasswordSafety {
			export function Post(request: m.Bokio.Backbone.Web.Controllers.Accounts.PasswordSafetyRequest): Promise<m.Envelope<m.Bokio.Backbone.Web.Controllers.Accounts.PasswordSafety, m.SimpleError>> {
				return Client.post("/Account/GetPasswordSafety", request);
			}
		}
		export namespace GetPossibleLoginMethods {
			export function Get(username: string): Promise<m.Envelope<m.Bokio.Common.Contract.LoginMethod[], m.SimpleError>> {
				return Client.get("/Account/GetPossibleLoginMethods", { username });
			}
		}
		export namespace GetPossibleLoginMethodsPost {
			export function Post(username: m.Bokio.Backbone.Web.Controllers.Accounts.GetPossibleLoginMethodsRequest): Promise<m.Envelope<m.Bokio.Common.Contract.LoginMethod[], m.SimpleError>> {
				return Client.post("/Account/GetPossibleLoginMethodsPost", username);
			}
		}
		export namespace GetPreUserABVariant {
			export function Get(): Promise<m.Envelope<m.Bokio.Services.Account.PreUserABVariantDto, m.SimpleError>> {
				return Client.get("/Account/GetPreUserABVariant");
			}
		}
		export namespace InvitationDetails {
			export function Get(inviteId: string): Promise<m.Envelope<m.Bokio.Services.Account.InvitationDetails, m.SimpleError>> {
				return Client.get("/Account/InvitationDetails", { inviteId });
			}
		}
		export namespace IsAuthenticated {
			export function Get(): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.get("/Account/IsAuthenticated");
			}
		}
		export namespace JoinByInvitation {
			export function Post(parameters: m.Bokio.Services.Account.JoinByInvitationParameters): Promise<m.Envelope<m.Bokio.Services.Account.AcceptInvitationResponse, m.SimpleError>> {
				return Client.post("/Account/JoinByInvitation", parameters);
			}
		}
		export namespace JoinCompanyOwnerInvitation {
			export function Post(parameters: m.Bokio.Services.Account.JoinByInvitationParameters): Promise<m.Envelope<m.Bokio.Services.Account.AcceptInvitationResponse, m.SimpleError>> {
				return Client.post("/Account/JoinCompanyOwnerInvitation", parameters);
			}
		}
		export namespace Login {
			export function Post(userName: string, password: string): Promise<m.Envelope<m.Bokio.Services.Account.LoginUserResult, m.Bokio.Services.Account.LoginError>> {
				return Client.post("/Account/Login", { userName, password });
			}
		}
		export namespace Login2FA {
			export function Post(code: string): Promise<m.Envelope<m.Bokio.Services.Account.LoginUserResult, m.Bokio.Services.Account.LoginError>> {
				return Client.post("/Account/Login2FA", { code });
			}
		}
		export namespace LogOffFromAllDevices {
			export function Post(): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post("/Account/LogOffFromAllDevices", {  });
			}
		}
		export namespace ResetPassword {
			export function Post(userId: string, resetToken: string, newPassword: string): Promise<m.Envelope<boolean, m.Bokio.Services.Account.ResetPasswordError>> {
				return Client.post("/Account/ResetPassword", { userId, resetToken, newPassword });
			}
		}
		export namespace SetPassword {
			export function Post(password: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post("/Account/SetPassword", { password });
			}
		}
		export namespace StartBankIdLogin {
			export function Post(userName: string): Promise<m.Envelope<m.Bokio.Backbone.Web.Controllers.Accounts.StartBankIdLoginResponse, m.Bokio.Common.Contract.BankId.BankIdError>> {
				return Client.post("/Account/StartBankIdLogin", { userName });
			}
		}
		export namespace StartBankIdLoginOrCreate {
			export function Post(): Promise<m.Envelope<m.Bokio.Backbone.Web.Controllers.Accounts.StartBankIdLoginOrCreateResponse, m.Bokio.Common.Contract.BankId.BankIdError>> {
				return Client.post("/Account/StartBankIdLoginOrCreate", {  });
			}
		}
		export namespace UpdateBankIdUserToBeConfirmed {
			export function Post(userToBeConfirmedId: string, clientSecret: string, userEmail: string, termsVersion: number): Promise<m.Envelope<m.Bokio.Services.Account.UserToBeConfirmedDto, m.Bokio.Common.Contract.BankId.BankIdError>> {
				return Client.post("/Account/UpdateBankIdUserToBeConfirmed", { userToBeConfirmedId, clientSecret, userEmail, termsVersion });
			}
		}
		export namespace UserInfo {
			export function Get(): Promise<m.Envelope<m.Bokio.Backbone.Web.Controllers.Accounts.UserInfoDto, m.SimpleError>> {
				return Client.get("/Account/UserInfo");
			}
		}
	}
	export namespace BankFeedTestSetupController {
		export namespace FirePlaidItemErrorWebhook {
			export function Post(org: string, bankId: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post("/BankFeedTestSetup/FirePlaidItemErrorWebhook", { org, bankId });
			}
		}
		export namespace FirePlaidTransactionsDefaultUpdateWebhook {
			export function Post(org: string, bankId: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post("/BankFeedTestSetup/FirePlaidTransactionsDefaultUpdateWebhook", { org, bankId });
			}
		}
	}
	export namespace BankIdController {
		export namespace Cancel {
			export function Post(): Promise<m.Envelope<boolean, m.Bokio.Common.Contract.BankId.BankIdError>> {
				return Client.post("/BankId/Cancel", {  });
			}
		}
		export namespace QrCode {
			export function Get(qrStartToken: string): Promise<m.Envelope<m.Bokio.Integration.BokioPay.Auth.BankIdQrCollectResponse, m.Bokio.Common.Contract.BankId.BankIdError>> {
				return Client.get("/BankId/QrCode", { qrStartToken });
			}
		}
	}
	export namespace CompanySearchingController {
		export namespace FetchInfo {
			export function Get(request: m.Bokio.Services.CompanySearch.FetchInfoRequest): Promise<m.Envelope<m.Bokio.Services.CompanySearch.CompanySearchFetchResult, m.SimpleError>> {
				return Client.get("/CompanySearching/FetchInfo", { request })
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.StartedAt"}, {"type":"Day","key":"Data.ActiveFiscal.StartDate"}, {"type":"Day","key":"Data.ActiveFiscal.EndDate"}));
			}
		}
		export namespace GetUserAssociatedCompanies {
			export function Get(): Promise<m.Envelope<m.Bokio.Services.CompanySearch.SearchResult[], m.SimpleError>> {
				return Client.get("/CompanySearching/GetUserAssociatedCompanies");
			}
		}
		export namespace Search {
			export function Get(request: m.Bokio.Services.CompanySearch.SearchRequest): Promise<m.Envelope<m.Bokio.Services.CompanySearch.SearchResult[], m.Bokio.Common.Services.CompanySearch.UcBi.SearchError>> {
				return Client.get("/CompanySearching/Search", { request });
			}
		}
	}
	export namespace CountryMetadataController {
		export namespace Index {
			export function Get(country?: string): Promise<m.Envelope<m.Classes.CountryMetadata, m.SimpleError>> {
				return Client.get("/CountryMetadata", { country })
				             .then(data => convertByKeys(data, {"type":"CountryCode","key":"Data.CountryCode"}));
			}
		}
	}
	export namespace ExperimentController {
		export namespace AllActive {
			export function Get(): Promise<m.Envelope<m.Bokio.Services.Experiments.ExperimentDto[], m.SimpleError>> {
				return Client.get("/Experiment/AllActive");
			}
		}
		export namespace AnonymousExperiment {
			export function Get(experimentName: m.Bokio.Backbone.Web.Controllers.AnonymousExperimentNames): Promise<m.Bokio.Backbone.Web.Controllers.AnonymousExperimentResult> {
				return Client.get("/Experiment/AnonymousExperiment", { experimentName });
			}
		}
		export namespace ChooseVariant {
			export function Post(request: m.Bokio.Backbone.Web.Controllers.Requests.ChooseUserExperimentVariantRequestDto): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post("/Experiment/ChooseVariant", request);
			}
		}
		export namespace Index {
			export function Post(name: string): Promise<m.Envelope<m.Bokio.Services.Experiments.ExperimentDto, m.SimpleError>> {
				return Client.post("/Experiment", { name });
			}
		}
		export namespace Reset {
			export function Post(command: m.Model.Commands.Payment.ResetUserExperiment): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post("/Experiment/Reset", command);
			}
		}
	}
	export namespace IntegrationTestSetupController {
		export namespace AddBlockingSupportMessage {
			export function Post(org: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post("/IntegrationTestSetup/AddBlockingSupportMessage", { org });
			}
		}
		export namespace AddIncomingEInvoice {
			export function Post(org: string, request: m.Bokio.Backbone.Web.Controllers.IntegrationTestAddEInvoiceRequest): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post("/IntegrationTestSetup/AddIncomingEInvoice", { org, request });
			}
		}
		export namespace AddSigningSupportMessageToUser {
			export function Post(org: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post("/IntegrationTestSetup/AddSigningSupportMessageToUser", { org });
			}
		}
		export namespace AddSummerCampaignSupportMessage {
			export function Post(org: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post("/IntegrationTestSetup/AddSummerCampaignSupportMessage", { org });
			}
		}
		export namespace AddTrialOverSupportMessage {
			export function Post(org: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post("/IntegrationTestSetup/AddTrialOverSupportMessage", { org });
			}
		}
		export namespace AddUserToAgency {
			export function Post(request: m.Bokio.Backbone.Web.Controllers.IntegrationTestAddUserToAgencyRequest): Promise<m.Envelope<string, m.SimpleError>> {
				return Client.post("/IntegrationTestSetup/AddUserToAgency", request);
			}
		}
		export namespace AddUserToCompany {
			export function Post(request: m.Bokio.Backbone.Web.Controllers.IntegrationTestAddUserToCompanyRequest): Promise<m.Envelope<string, m.SimpleError>> {
				return Client.post("/IntegrationTestSetup/AddUserToCompany", request);
			}
		}
		export namespace AddUserToPartnerCompany {
			export function Post(request: m.Bokio.Backbone.Web.Controllers.IntegrationTestAddUserToPartnerCompanyRequest): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post("/IntegrationTestSetup/AddUserToPartnerCompany", request);
			}
		}
		export namespace AnEnvelope {
			export function Get(success: boolean): Promise<m.Envelope<string, m.SimpleError>> {
				return Client.get("/IntegrationTestSetup/AnEnvelope", { success });
			}
		}
		export namespace ChooseExperimentVariant {
			export function Post(request: m.Bokio.Backbone.Web.Controllers.IntegrationTestChooseUserExperimentVariantRequest): Promise<string> {
				return Client.post("/IntegrationTestSetup/ChooseExperimentVariant", request);
			}
		}
		export namespace ClearFactoringOnboarding {
			export function Post(org: string): Promise<m.Envelope<string, m.SimpleError>> {
				return Client.post("/IntegrationTestSetup/ClearFactoringOnboarding", { org });
			}
		}
		export namespace CompaniesByUser {
			export function Get(userEmail: string): Promise<m.Envelope<m.Bokio.Services.Companies.CompanyInfo[], m.SimpleError>> {
				return Client.get("/IntegrationTestSetup/CompaniesByUser", { userEmail })
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.StartedAt"}));
			}
		}
		export namespace CompleteFactoringOnboarding {
			export function Post(orgNumber: string): Promise<m.Envelope<string, m.SimpleError>> {
				return Client.post("/IntegrationTestSetup/CompleteFactoringOnboarding", { orgNumber });
			}
		}
		export namespace CreateCompany {
			export function Post(request: m.Bokio.Backbone.Web.Controllers.IntegrationTestCreateCompanyRequest): Promise<m.Envelope<string, m.SimpleError>> {
				return Client.post("/IntegrationTestSetup/CreateCompany", request);
			}
		}
		export namespace CreateCompanyWithLoginRestriction {
			export function Post(request: m.Bokio.Backbone.Web.Controllers.IntegrationTestCreateCompanyRequest): Promise<m.Envelope<string, m.SimpleError>> {
				return Client.post("/IntegrationTestSetup/CreateCompanyWithLoginRestriction", request);
			}
		}
		export namespace CreatePreviousFiscalYear {
			export function Post(org: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(Client.getPathWithQueryString("/IntegrationTestSetup/CreatePreviousFiscalYear", { org }), {  });
			}
		}
		export namespace CreateRootAccountingFirm {
			export function Post(name: string): Promise<m.Envelope<string, m.SimpleError>> {
				return Client.post("/IntegrationTestSetup/CreateRootAccountingFirm", { name });
			}
		}
		export namespace CreateUserAccount {
			export function Post(account: m.Bokio.Backbone.Web.Controllers.InitUserAccountDto): Promise<m.Envelope<string, m.SimpleError>> {
				return Client.post("/IntegrationTestSetup/CreateUserAccount", account);
			}
		}
		export namespace CreateUserAccountWithBokioPay {
			export function Post(request: m.Bokio.Backbone.Web.Controllers.AddBokioPayExternalLoginMethodRequest): Promise<m.Envelope<string, m.SimpleError>> {
				return Client.post("/IntegrationTestSetup/CreateUserAccountWithBokioPay", request);
			}
		}
		export namespace DisableAllBokioPayExternalLoginMethodsForPerson {
			export function Post(request: m.Bokio.Backbone.Web.Controllers.DisableAllBokioPayExternalLoginMethodsRequest): Promise<m.Envelope<number, m.SimpleError>> {
				return Client.post("/IntegrationTestSetup/DisableAllBokioPayExternalLoginMethodsForPerson", request);
			}
		}
		export namespace EditPartnerUserMembershipType {
			export function Post(request: m.Bokio.Backbone.Web.Controllers.IntegrationTestEditPartnerUserMembershipType): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post("/IntegrationTestSetup/EditPartnerUserMembershipType", request);
			}
		}
		export namespace FlagEnum2Integer {
			export function Get(enumValues: m.Bokio.Backbone.Web.Controllers.ExponentialOfTwo): Promise<number> {
				return Client.get("/IntegrationTestSetup/FlagEnum2Integer", { enumValues });
			}
		}
		export namespace ForceUnregisterEInvoices {
			export function Post(org: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post("/IntegrationTestSetup/ForceUnregisterEInvoices", { org });
			}
		}
		export namespace GetConstantDateTime {
			export function Get(): Promise<m.Envelope<m.Bokio.Backbone.Web.Controllers.SerializationTestDto, m.SimpleError>> {
				return Client.get("/IntegrationTestSetup/GetConstantDateTime")
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.DateTimeUtc"}, {"type":"Date","key":"Data.NullableDateTimeUtc"}, {"type":"Date","key":"Data.NullableDateTimeNull"}));
			}
		}
		export namespace GetLastConfirmCode {
			export function Get(email: string): Promise<number> {
				return Client.get("/IntegrationTestSetup/GetLastConfirmCode", { email });
			}
		}
		export namespace GetUserAcquisitionCampaignData {
			export function Get(email: string): Promise<m.Bokio.Backbone.Web.Controllers.UserAcquisitionCampaignDataDto> {
				return Client.get("/IntegrationTestSetup/GetUserAcquisitionCampaignData", { email });
			}
		}
		export namespace GetUserReferralData {
			export function Get(email: string): Promise<m.Bokio.Backbone.Web.Controllers.UserReferralDataDto> {
				return Client.get("/IntegrationTestSetup/GetUserReferralData", { email });
			}
		}
		export namespace Integer2FlagEnum {
			export function Get(n: number): Promise<m.Bokio.Backbone.Web.Controllers.ExponentialOfTwo> {
				return Client.get("/IntegrationTestSetup/Integer2FlagEnum", { n });
			}
		}
		export namespace MakeStripePayment {
			export function Post(org: string, publicLinkId: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post("/IntegrationTestSetup/MakeStripePayment", { org, publicLinkId });
			}
		}
		export namespace Ping {
			export function Get(msg: string): Promise<m.Envelope<string, m.SimpleError>> {
				return Client.get("/IntegrationTestSetup/Ping", { msg });
			}
		}
		export namespace ProxyPostmarkMock {
			export function Get(): Promise<{}> {
				return Client.get("/IntegrationTestSetup/ProxyPostmarkMock");
			}
		}
		export namespace QuickOnboardToSvea {
			export function Post(org: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(Client.getPathWithQueryString("/IntegrationTestSetup/QuickOnboardToSvea", { org }), {  });
			}
		}
		export namespace RefreshLogin {
			export function Get(): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.get("/IntegrationTestSetup/RefreshLogin");
			}
		}
		export namespace RegisterForSendingAndReceivingEInvoices {
			export function Post(org: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post("/IntegrationTestSetup/RegisterForSendingAndReceivingEInvoices", { org });
			}
		}
		export namespace RemoveStripeIntegration {
			export function Post(org: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post("/IntegrationTestSetup/RemoveStripeIntegration", { org });
			}
		}
		export namespace RemoveUserFromPartnerCompany {
			export function Post(request: m.Bokio.Backbone.Web.Controllers.IntegrationTestRemoveUserToPartnerCompanyRequest): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post("/IntegrationTestSetup/RemoveUserFromPartnerCompany", request);
			}
		}
		export namespace ResetCrediflowMockForIntegrationTest {
			export function Post(): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post("/IntegrationTestSetup/ResetCrediflowMockForIntegrationTest", {  });
			}
		}
		export namespace SendNotificationToSelf {
			export function Post(org: string, request: m.Bokio.Backbone.Web.Controllers.IntegrationTestNotificationRequest): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post("/IntegrationTestSetup/SendNotificationToSelf", { org, request });
			}
		}
		export namespace SetAllInProgressEInvoicesToStatus {
			export function Post(request: m.Bokio.Backbone.Web.Controllers.UpdateEInvoiceStatusRequest): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post("/IntegrationTestSetup/SetAllInProgressEInvoicesToStatus", request);
			}
		}
		export namespace SetBokioPayBankIdPersonalNumberInMock {
			export function Post(personalNumber: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(Client.getPathWithQueryString("/IntegrationTestSetup/SetBokioPayBankIdPersonalNumberInMock", { personalNumber }), {  });
			}
		}
		export namespace SetExperimentVariant {
			export function Post(request: m.Bokio.Backbone.Web.Controllers.Requests.ChooseUserExperimentVariantRequestDto): Promise<m.Envelope<string, m.SimpleError>> {
				return Client.post("/IntegrationTestSetup/SetExperimentVariant", request);
			}
		}
		export namespace SetupBillingCardExpiry {
			export function Post(org: string, state: m.Bokio.Integration.Billing.MockCardExpiryState): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post("/IntegrationTestSetup/SetupBillingCardExpiry", { org, state });
			}
		}
		export namespace SetupBillingReceiptsResponse {
			export function Post(org: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post("/IntegrationTestSetup/SetupBillingReceiptsResponse", { org });
			}
		}
		export namespace SetupBillingRetryPaymentsResponse_AllSucceeded {
			export function Post(org: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post("/IntegrationTestSetup/SetupBillingRetryPaymentsResponse_AllSucceeded", { org });
			}
		}
		export namespace SetupBillingRetryPaymentsResponse_DidNotRetry {
			export function Post(org: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post("/IntegrationTestSetup/SetupBillingRetryPaymentsResponse_DidNotRetry", { org });
			}
		}
		export namespace SetupBillingRetryPaymentsResponse_DidNotTryAll {
			export function Post(org: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post("/IntegrationTestSetup/SetupBillingRetryPaymentsResponse_DidNotTryAll", { org });
			}
		}
		export namespace SetupBillingRetryPaymentsResponse_OneFailed {
			export function Post(org: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post("/IntegrationTestSetup/SetupBillingRetryPaymentsResponse_OneFailed", { org });
			}
		}
		export namespace SetupCashback {
			export function Post(defaultCashback: m.Bokio.Common.Billing.Model.CashbackContract, availableCashbackOffer?: m.Bokio.Backbone.Web.Controllers.CashbackOfferDto): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post("/IntegrationTestSetup/SetupCashback", { defaultCashback, availableCashbackOffer });
			}
		}
		export namespace SetupOldPlan {
			export function Post(org: string, plan: m.Entities.BokioPlan, trial: boolean, interval: m.Bokio.Common.Billing.Model.SubscriptionInterval, paymentState: m.Entities.BillingSubscriptionPaymentState, addons: m.Bokio.Billing.Contract.Models.Subscriptions.AddonsDto[]): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post("/IntegrationTestSetup/SetupOldPlan", { org, plan, trial, interval, paymentState, addons });
			}
		}
		export namespace SetupPreliminaryTaxesImportantDates {
			export function Post(year: number): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post("/IntegrationTestSetup/SetupPreliminaryTaxesImportantDates", { year });
			}
		}
		export namespace SetupVerificationsForReconcilliationTest {
			export function Post(org: string, dto: m.Bokio.Backbone.Web.Controllers.ReconcilliationSetupDto): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post("/IntegrationTestSetup/SetupVerificationsForReconcilliationTest", { org, dto });
			}
		}
		export namespace StartCrediflowSyncWebJob {
			export function Post(): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post("/IntegrationTestSetup/StartCrediflowSyncWebJob", {  });
			}
		}
	}
	export namespace LinkClicksController {
		export namespace Send {
			export function Post(request: m.Bokio.Backbone.Web.Controllers.LinkClickTrackRequest): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post("/LinkClicks/Send", request);
			}
		}
		export namespace SendIfFirst {
			export function Post(request: m.Bokio.Backbone.Web.Controllers.LinkClickTrackRequest): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post("/LinkClicks/SendIfFirst", request);
			}
		}
	}
	export namespace LoginActivityController {
		export namespace GetRecentLogins {
			export function Get(): Promise<m.Envelope<m.Bokio.Backbone.Web.Controllers.Accounts.SuccessfulLoginActivity[], m.SimpleError>> {
				return Client.get("/LoginActivity/GetRecentLogins")
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.LoginUtc"}));
			}
		}
	}
	export namespace MailLinkerController {
		export namespace ListCompanies {
			export function Get(type: string, ids: string[]): Promise<m.Envelope<m.Bokio.Backbone.Web.Controllers.CompanySelectFromMailDto, m.SimpleError>> {
				return Client.get("/MailLinker/ListCompanies", { type, ids });
			}
		}
	}
	export namespace ManifestController {
		export namespace Index {
			export function Get(): Promise<m.Envelope<m.Core.Manifest.ServerManifest, m.SimpleError>> {
				return Client.get("/Manifest")
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.ReleaseDate"}));
			}
		}
	}
	export namespace OnboardingController {
		export namespace GetChecklist {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Backbone.Web.Controllers.OnboardingChecklistDto, m.SimpleError>> {
				return Client.get(`/${org}/CommonWeb/Onboarding/GetChecklist`);
			}
		}
		export namespace GetOrCreateOnboardingWizard {
			export function Post(orgOrDraftCompanyId: string): Promise<m.Envelope<m.Bokio.Backbone.Web.Controllers.OnboardingWizardDto, m.SimpleError>> {
				return Client.post(Client.getPathWithQueryString("/CommonWeb/Onboarding/GetOrCreateOnboardingWizard", { orgOrDraftCompanyId }), {  });
			}
		}
		export namespace SaveOnboardingWizard {
			export function Post(org: string, dto: m.Bokio.Backbone.Web.Controllers.OnboardingWizardDto): Promise<m.Envelope<m.Bokio.Backbone.Web.Controllers.OnboardingWizardResponseDto, m.Bokio.Backbone.Web.Controllers.SaveOnboardingWizardError>> {
				return Client.post(`/${org}/CommonWeb/Onboarding/SaveOnboardingWizard`, dto);
			}
		}
		export namespace ShowTestCompanyConvertModal {
			export function Get(org: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.get(`/${org}/CommonWeb/Onboarding/ShowTestCompanyConvertModal`);
			}
		}
		export namespace UpdateChecklistStep {
			export function Post(org: string, dto: m.Bokio.Backbone.Web.Controllers.UpdateChecklistItemDto): Promise<m.Envelope<m.Bokio.Backbone.Web.Controllers.OnboardingChecklistDto, m.SimpleError>> {
				return Client.post(`/${org}/CommonWeb/Onboarding/UpdateChecklistStep`, dto);
			}
		}
	}
	export namespace PageViewController {
		export namespace SavePageViewForCompany {
			export function Post(org: string, request: m.Bokio.Backbone.Web.Controllers.SavePageViewRequest): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/PageView/SavePageViewForCompany`, request);
			}
		}
		export namespace SavePageViewForUser {
			export function Post(request: m.Bokio.Backbone.Web.Controllers.SavePageViewRequest): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post("/PageView/SavePageViewForUser", request);
			}
		}
	}
	export namespace SalesIntegrationTestSetupController {
		export namespace PublishInvoice {
			export function Post(org: string, publishInvoiceDto: m.Bokio.Backbone.Web.Controllers.PublishInvoiceDto): Promise<m.Envelope<m.Bokio.Sales.Web.ViewModels.RecurringInvoiceForView, m.SimpleError>> {
				return Client.post("/SalesIntegrationTestSetup/PublishInvoice", { org, publishInvoiceDto })
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.Created"}, {"type":"Date","key":"Data.Updated"}, {"type":"Day","key":"Data.RecurringInvoiceScheduling.StartDate"}));
			}
		}
		export namespace RejectFactoringInvoice {
			export function Post(org: string, bokioInvoiceId: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/SalesIntegrationTestSetup/RejectFactoringInvoice`, { bokioInvoiceId });
			}
		}
		export namespace SettleFactoringInvoice {
			export function Post(org: string, bokioInvoiceId: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/SalesIntegrationTestSetup/SettleFactoringInvoice`, { bokioInvoiceId });
			}
		}
		export namespace SetupRotRutErrands {
			export function Post(org: string, request: m.Bokio.Backbone.Web.Controllers.SetupRotRutErrandsDto): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/SalesIntegrationTestSetup/SetupRotRutErrands`, request);
			}
		}
	}
	export namespace TermsController {
		export namespace GetBccTerms {
			export function Get(): Promise<m.Bokio.Web.Controllers.SingleTermViewModel> {
				return Client.get("/Terms/GetBccTerms");
			}
		}
		export namespace GetDpa {
			export function Get(): Promise<m.Bokio.Web.Controllers.SingleTermViewModel> {
				return Client.get("/Terms/GetDpa");
			}
		}
		export namespace GetEula {
			export function Get(): Promise<m.Bokio.Web.Controllers.SingleTermViewModel> {
				return Client.get("/Terms/GetEula");
			}
		}
		export namespace GetTermsInfo {
			export function Get(): Promise<m.Bokio.Web.Controllers.TermsInfo> {
				return Client.get("/Terms/GetTermsInfo");
			}
		}
		export namespace GetTermsToSign {
			export function Get(): Promise<m.Bokio.Web.Controllers.TermsViewModel> {
				return Client.get("/Terms/GetTermsToSign");
			}
		}
		export namespace GetUserApprovals {
			export function Get(): Promise<m.Envelope<m.Bokio.Web.Controllers.UserApprovalsViewModel, m.SimpleError>> {
				return Client.get("/Terms/GetUserApprovals");
			}
		}
		export namespace SetAllowMarketing {
			export function Post(request: m.Bokio.Web.Controllers.SetMarketingSettingRequest): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post("/Terms/SetAllowMarketing", request);
			}
		}
		export namespace Sign {
			export function Post(returnUrl: string, request: m.Bokio.Web.Controllers.SignTermsRequest): Promise<m.Envelope<m.Bokio.Web.Controllers.SignedTermsResponse, m.SimpleError>> {
				return Client.post(Client.getPathWithQueryString("/Terms/Sign", { returnUrl }), request);
			}
		}
	}
	export namespace UmbracoEngageController {
		export namespace PostEngageEvent {
			export function Post(request: m.Bokio.Web.Controllers.PageEventRequest): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post("/UmbracoEngage/PostEngageEvent", request);
			}
		}
	}
}
export namespace Bokio.Accounting.Web.Accounting {
	export namespace AccountingIntegrationTestSetupController {
		export namespace EnsureFiscalYearCoversDate {
			export function Post(org: string, date: Date): Promise<boolean> {
				return Client.post(`/${org}/AccountingIntegrationTestSetup/EnsureFiscalYearCoversDate`, { date });
			}
		}
		export namespace SetupEventsToRecordForTestingAllCases {
			export function Post(org: string): Promise<boolean> {
				return Client.post(`/${org}/AccountingIntegrationTestSetup/SetupEventsToRecordForTestingAllCases`, {  });
			}
		}
		export namespace SetupEventsToRecordForTestingBulkRecording {
			export function Post(org: string): Promise<boolean> {
				return Client.post(`/${org}/AccountingIntegrationTestSetup/SetupEventsToRecordForTestingBulkRecording`, {  });
			}
		}
		export namespace SetupEventsToRecordForTestingBulkRecordingWithAutomationRules {
			export function Post(org: string): Promise<boolean> {
				return Client.post(`/${org}/AccountingIntegrationTestSetup/SetupEventsToRecordForTestingBulkRecordingWithAutomationRules`, {  });
			}
		}
		export namespace SetupEventsToRecordForTestingBulkRecordingWithVatVsVatExempt {
			export function Post(org: string): Promise<m.Bokio.Accounting.Web.Accounting.Controllers.SetupEventsToRecordForTestingBulkRecordingResponse> {
				return Client.post(`/${org}/AccountingIntegrationTestSetup/SetupEventsToRecordForTestingBulkRecordingWithVatVsVatExempt`, {  })
				             .then(data => convertByKeys(data, {"type":"Day","key":"MinDate"}));
			}
		}
		export namespace SetupEventsToRecordForTestingExpenses {
			export function Post(org: string): Promise<boolean> {
				return Client.post(`/${org}/AccountingIntegrationTestSetup/SetupEventsToRecordForTestingExpenses`, {  });
			}
		}
		export namespace SetupEventsToRecordForTestingSupplierInvoiceCashVat_UK {
			export function Post(org: string): Promise<boolean> {
				return Client.post(`/${org}/AccountingIntegrationTestSetup/SetupEventsToRecordForTestingSupplierInvoiceCashVat_UK`, {  });
			}
		}
		export namespace SetupEventsToRecordForTestingSupplierInvoices {
			export function Post(org: string): Promise<boolean> {
				return Client.post(`/${org}/AccountingIntegrationTestSetup/SetupEventsToRecordForTestingSupplierInvoices`, {  });
			}
		}
		export namespace SetupEventsToRecordForTestingTaxMatches {
			export function Post(org: string): Promise<boolean> {
				return Client.post(`/${org}/AccountingIntegrationTestSetup/SetupEventsToRecordForTestingTaxMatches`, {  });
			}
		}
		export namespace SetupPowerFunctionsForTesting {
			export function Post(org: string): Promise<boolean> {
				return Client.post(`/${org}/AccountingIntegrationTestSetup/SetupPowerFunctionsForTesting`, {  });
			}
		}
		export namespace SetupVerificationsAndTransactionsForBbaReconciliationTest {
			export function Post(org: string, request: m.Bokio.Accounting.Web.Accounting.Controllers.SetupVerificationsAndTransactionsForBbaReconciliationRequest): Promise<boolean> {
				return Client.post(`/${org}/AccountingIntegrationTestSetup/SetupVerificationsAndTransactionsForBbaReconciliationTest`, request);
			}
		}
	}
	export namespace AiTemplateSearchController {
		export namespace AiTemplateSearch {
			export function Post(org: string, request: m.Bokio.Accounting.Contract.Recipes.Requests.AiTemplateSearchRequest): Promise<m.Envelope<m.Bokio.Accounting.Contract.Recipes.Dtos.AiTemplateSearchResponse, m.Bokio.Common.Contract.Services.AiProxy.AiServiceError>> {
				return Client.post(`/${org}/Accounting/AiTemplateSearch/AiTemplateSearch`, request);
			}
		}
		export namespace PromptRebuildContext {
			export function Get(org: string, category: m.Bokio.Accounting.Contract.Verifications.ReceiptCategory, isVatFree: boolean): Promise<m.Envelope<m.Bokio.Accounting.Contract.Recipes.Dtos.AiTemplateSearchPromptRebuildContext, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/AiTemplateSearch/PromptRebuildContext`, { category, isVatFree });
			}
		}
	}
	export namespace AiVerificationExplanationController {
		export namespace Explain {
			export function Post(org: string, request: m.Bokio.Accounting.Contract.Verifications.Requests.AiVerificationExplanationRequest): Promise<m.Envelope<m.Bokio.Accounting.Contract.Verifications.DTOs.AiVerificationExplanationResponse, m.Bokio.Common.Contract.Services.AiProxy.AiServiceError>> {
				return Client.post(`/${org}/Accounting/AiVerificationExplanation/Explain`, request);
			}
		}
	}
	export namespace AssetController {
		export namespace AddAllPendingDepreciations {
			export function Post(org: string, request: m.Bokio.Accounting.Contract.Assets.Requests.AddAllPendingDepreciationsRequest): Promise<m.Envelope<m.Bokio.Accounting.Contract.Assets.DTOs.AssetDepreciationDto, m.Core.Recipes.FailReason>> {
				return Client.post(`/${org}/Accounting/Asset/AddAllPendingDepreciations`, request);
			}
		}
		export namespace AddDepreciation {
			export function Post(org: string, request: m.Bokio.Accounting.Contract.Assets.Requests.AddDepreciationRequest): Promise<m.Envelope<m.Bokio.Accounting.Contract.Assets.DTOs.AssetDepreciationDto, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/Asset/AddDepreciation`, request);
			}
		}
		export namespace ArchiveAsset {
			export function Post(org: string, assetId: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/Asset/ArchiveAsset`, { assetId });
			}
		}
		export namespace CheckVerificationAssetStatus {
			export function Get(org: string, verificationId: string): Promise<m.Envelope<m.Bokio.Accounting.Contract.Assets.DTOs.VerificationAssetStatus, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/Asset/CheckVerificationAssetStatus`, { verificationId });
			}
		}
		export namespace DeleteAsset {
			export function Post(org: string, request: m.Accounting.Viewmodels.Files.DeleteAssetRequest): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/Asset/DeleteAsset`, request);
			}
		}
		export namespace GetAsset {
			export function Get(org: string, assetId: string): Promise<m.Envelope<m.Bokio.Accounting.Contract.Assets.DTOs.AssetForListDto, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/Asset/GetAsset`, { assetId })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.PurchaseDate"}, {"type":"Day","key":"Data.DepreciatedUntil"}, {"type":"Day","key":"Data.AssetDepreciateFromDate"}));
			}
		}
		export namespace GetAssetDepreciationPerPeriod {
			export function Get(org: string, request: m.Bokio.Accounting.Contract.Assets.Requests.GetAssetDepreciationPerPeriodRequest): Promise<m.Envelope<m.Bokio.Accounting.Contract.Assets.DTOs.AssetDepreciationPreviewDto[], m.SimpleError>> {
				return Client.get(`/${org}/Accounting/Asset/GetAssetDepreciationPerPeriod`, { request });
			}
		}
		export namespace GetAssets {
			export function Get(org: string, request: m.Bokio.Accounting.Contract.Assets.Requests.GetAssetsRequest): Promise<m.Envelope<m.Bokio.Accounting.Contract.Assets.DTOs.AssetListDto, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/Asset/GetAssets`, { request })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.Assets.PurchaseDate"}, {"type":"Day","key":"Data.Assets.DepreciatedUntil"}, {"type":"Day","key":"Data.Assets.AssetDepreciateFromDate"}));
			}
		}
		export namespace GetDepreciatableAssetCategories {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Accounting.Contract.Assets.DTOs.DepreciatableAssetDto[], m.SimpleError>> {
				return Client.get(`/${org}/Accounting/Asset/GetDepreciatableAssetCategories`);
			}
		}
		export namespace GetPendingAssetDepreciationsCount {
			export function Get(org: string, untilDate: Date): Promise<m.Envelope<m.Bokio.Accounting.Web.Accounting.Viewmodels.LockPeriod.PendingAssetDepreciationsResult, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/Asset/GetPendingAssetDepreciationsCount`, { untilDate });
			}
		}
		export namespace GetPlannedDepreciationPeriods {
			export function Get(org: string, futureMonthsToInclude?: number): Promise<m.Envelope<m.Bokio.Accounting.Contract.Assets.DTOs.DepreciationPeriodDto[], m.SimpleError>> {
				return Client.get(`/${org}/Accounting/Asset/GetPlannedDepreciationPeriods`, { futureMonthsToInclude })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.RecordingDate"}));
			}
		}
		export namespace RegisterAsset {
			export function Post(org: string, createManualAssetRequest: m.Bokio.Accounting.Contract.Assets.DTOs.CreateManualAssetRequest): Promise<m.Envelope<string, m.Bokio.Accounting.Contract.Assets.Errors.RegisterAssetError>> {
				return Client.post(`/${org}/Accounting/Asset/RegisterAsset`, createManualAssetRequest);
			}
		}
		export namespace RegisterAssetForVerification {
			export function Post(org: string, createAssetRequest: m.Bokio.Accounting.Contract.Assets.DTOs.CreateAssetFromVerificationRequest): Promise<m.Envelope<string, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/Asset/RegisterAssetForVerification`, createAssetRequest);
			}
		}
		export namespace RemoveDepreciation {
			export function Post(org: string, request: m.Bokio.Accounting.Contract.Assets.Requests.RemoveDepreciationRequest): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/Asset/RemoveDepreciation`, request);
			}
		}
		export namespace SearchForAssetVerifications {
			export function Get(org: string, request: m.Bokio.Accounting.Contract.Assets.Requests.SearchForAssetVerificationRequest): Promise<m.Envelope<m.Bokio.Accounting.Contract.Verifications.DTOs.VerificationPreviewDto[], m.SimpleError>> {
				return Client.get(`/${org}/Accounting/Asset/SearchForAssetVerifications`, { request })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.Date"}));
			}
		}
		export namespace UnarchiveAsset {
			export function Post(org: string, assetId: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/Asset/UnarchiveAsset`, { assetId });
			}
		}
		export namespace UpdateAsset {
			export function Post(org: string, request: m.Bokio.Accounting.Contract.Assets.Requests.UpdateAssetRequest): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/Asset/UpdateAsset`, request);
			}
		}
	}
	export namespace AutoVerificationVerificationController {
		export namespace AllBankTransactions {
			export function Get(org: string, request: m.Bokio.Accounting.Contract.AutoVerification.DTOs.AutoVerificationFilterRequestDto): Promise<m.Envelope<m.Bokio.Accounting.Contract.AutoVerification.DTOs.AutoVerificationFilterResponseDto, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/AutoVerificationVerification/AllBankTransactions`, { request })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.Items.EffectiveDate"}, {"type":"Day","key":"Data.Items.TransactionDate"}, {"type":"Day","key":"Data.Items.OriginalTransactionDate"}, {"type":"Day","key":"Data.Items.Matches.Data.Date"}, {"type":"Day","key":"Data.Items.Matches.RowData.Date"}));
			}
		}
		export namespace GetAutoVerificationPreviews {
			export function Post(org: string, request: m.Bokio.Accounting.Contract.AutoVerification.DTOs.PreviewTransactionVerificationsRequest): Promise<m.Envelope<m.Bokio.Accounting.Contract.Verifications.DTOs.BankTransactionVerificationPreviewDto[], m.SimpleError>> {
				return Client.post(`/${org}/Accounting/AutoVerificationVerification/GetAutoVerificationPreviews`, request)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.Date"}));
			}
		}
		export namespace SaveAutoVerificationForms {
			export function Post(org: string, request: m.Bokio.Accounting.Web.AutoVerification.Controllers.SaveAutoVerificationRequest, files: (File | Blob | string)[]): Promise<m.Envelope<string, m.Bokio.Accounting.Web.AutoVerification.Controllers.SaveAutoVerificationError>> {
				const form = new FormData();
				form.append("request", JSON.stringify(request));
				files.forEach(item => form.append("files", item));
				return Client.post(`/${org}/Accounting/AutoVerificationVerification/SaveAutoVerificationForms`, form, true);
			}
		}
		export namespace SaveRowVerificationFromManual {
			export function Post(org: string, autoVerificationRowId: string, model: m.Core.ViewData.RegisterViewModel, files: (File | Blob | string)[], rowVersion: string): Promise<m.Core.ViewData.RegisteredVerificationResult> {
				const form = new FormData();
				form.append("autoVerificationRowId", autoVerificationRowId);
				form.append("model", JSON.stringify(model));
				files.forEach(item => form.append("files", item));
				form.append("rowVersion", JSON.stringify(rowVersion));
				return Client.post(`/${org}/Accounting/AutoVerificationVerification/SaveRowVerificationFromManual`, form, true)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Verification.Date"}, {"type":"Day","key":"Verification.ExpectPaymentAt"}, {"type":"Date","key":"Verification.CreatedUtc"}));
			}
		}
		export namespace SaveRowVerificationMultiRecipe {
			export function Post(org: string, command: m.Bokio.Accounting.Web.AutoVerification.Controllers.SaveAutoVerificationRequest): Promise<m.Core.Recipes.RegisteredRecipeResult> {
				return Client.post(`/${org}/Accounting/AutoVerificationVerification/SaveRowVerificationMultiRecipe`, command);
			}
		}
	}
	export namespace BankgiroSplittingController {
		export namespace GetBankgiroRows {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Accounting.Contract.EventsToRecord.Dtos.BankgiroRowForList[], m.SimpleError>> {
				return Client.get(`/${org}/Accounting/BankgiroSplitting/GetBankgiroRows`)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.Date"}));
			}
		}
		export namespace ParseBankgiroExcelFile {
			export function Post(org: string, file: (File | Blob | string)): Promise<m.Envelope<m.Bokio.Accounting.Contract.EventsToRecord.Dtos.ParsedBankgiroExcelData, m.SimpleError>> {
				const form = new FormData();
				form.append("file", file);
				return Client.post(`/${org}/Accounting/BankgiroSplitting/ParseBankgiroExcelFile`, form, true)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.DateGroups.Date"}));
			}
		}
		export namespace SplitBankgiroRow {
			export function Post(org: string, request: m.Bokio.Accounting.Contract.EventsToRecord.Requests.SplitBankgiroRowRequest): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/BankgiroSplitting/SplitBankgiroRow`, request);
			}
		}
	}
	export namespace DraftVerificationController {
		export namespace Create {
			export function Post(org: string, request: m.Bokio.Accounting.Web.Accounting.Controllers.CreateDraftVerificationRequest): Promise<m.Envelope<string, m.Bokio.Accounting.Web.Accounting.Controllers.DraftVerificationError>> {
				return Client.post(`/${org}/Accounting/DraftVerification/Create`, request);
			}
		}
		export namespace Delete {
			export function Post(org: string, draftId: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/DraftVerification/Delete`, { draftId });
			}
		}
		export namespace Edit {
			export function Post(org: string, request: m.Bokio.Accounting.Web.Accounting.Controllers.EditDraftVerificationRequest): Promise<m.Envelope<boolean, m.Bokio.Accounting.Web.Accounting.Controllers.DraftVerificationError>> {
				return Client.post(`/${org}/Accounting/DraftVerification/Edit`, request);
			}
		}
		export namespace GetPreview {
			export function Get(org: string, draftId: string): Promise<m.Envelope<m.Core.ViewData.VerificationForList, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/DraftVerification/GetPreview`, { draftId })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.Date"}, {"type":"Day","key":"Data.ExpectPaymentAt"}, {"type":"Date","key":"Data.CreatedUtc"}));
			}
		}
		export namespace Publish {
			export function Post(org: string, draftId: string): Promise<m.Envelope<string, m.Bokio.Accounting.Web.Accounting.Controllers.DraftVerificationError>> {
				return Client.post(`/${org}/Accounting/DraftVerification/Publish`, { draftId });
			}
		}
	}
	export namespace DrilldownReportController {
		export namespace GetFullReportComparisonData {
			export function Post(org: string, fromDate: Day, toDate: Day, comparisonType: m.Bokio.Accounting.Web.Accounting.Controllers.DrilldownReportComparisonType, periodOffset: number, reportConfig: m.Bokio.Accounting.Web.Accounting.Controllers.DrilldownReportConfig): Promise<m.Envelope<m.Bokio.Accounting.Web.Accounting.Controllers.DrilldownReportData, m.SimpleError>> {
				return Client.post(Client.getPathWithQueryString(`/${org}/Accounting/DrilldownReport/GetFullReportComparisonData`, { fromDate, toDate, comparisonType, periodOffset }), reportConfig);
			}
		}
		export namespace GetFullReportData {
			export function Post(org: string, fromDate: Day, toDate: Day, reportConfig: m.Bokio.Accounting.Web.Accounting.Controllers.DrilldownReportConfig): Promise<m.Envelope<m.Bokio.Accounting.Web.Accounting.Controllers.DrilldownReportData, m.SimpleError>> {
				return Client.post(Client.getPathWithQueryString(`/${org}/Accounting/DrilldownReport/GetFullReportData`, { fromDate, toDate }), reportConfig);
			}
		}
		export namespace GetPossibleComparisons {
			export function Get(org: string, fromDate: Day, toDate: Day): Promise<m.Envelope<m.Bokio.Accounting.Web.Accounting.Controllers.GetPossibleComparisonOption[], m.Bokio.Accounting.Web.Accounting.Controllers.GetPossibleComparisonsError>> {
				return Client.get(`/${org}/Accounting/DrilldownReport/GetPossibleComparisons`, { fromDate, toDate })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.From"}, {"type":"Day","key":"Data.To"}));
			}
		}
		export namespace GetReportStructure {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Accounting.Web.Accounting.Controllers.ReportStructureDto, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/DrilldownReport/GetReportStructure`);
			}
		}
	}
	export namespace EventsToRecordController {
		export namespace AdjustRecordingDate {
			export function Post(org: string, request: m.Bokio.Accounting.Contract.EventsToRecord.Requests.AdjustRecordingDateRequest): Promise<m.Envelope<m.Bokio.Accounting.Contract.EventsToRecord.Dtos.EventToRecordView, m.Bokio.Accounting.Contract.EventsToRecord.EventToRecordViewError>> {
				return Client.post(`/${org}/Accounting/EventsToRecord/AdjustRecordingDate`, request)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.Item.Date"}, {"type":"Day","key":"Data.Item.OriginalTransactionDate"}, {"type":"Day","key":"Data.Item.SupplierData.OriginalInvoice.Date"}, {"type":"Day","key":"Data.BankRowMatches.Data.Date"}, {"type":"Day","key":"Data.BankRowMatches.RowData.Date"}, {"type":"Day","key":"Data.BookkeepingSuggestions.VerificationPreview.Date"}));
			}
		}
		export namespace GetBulkAutomationRules {
			export function Post(org: string, eventsToMatch: m.Bokio.Accounting.Contract.AutomationRules.Dtos.EventToMatchDto[]): Promise<m.Envelope<m.Bokio.Accounting.Contract.AutomationRules.Dtos.AutomationRuleMatchDto[], m.SimpleError>> {
				return Client.post(`/${org}/Accounting/EventsToRecord/GetBulkAutomationRules`, eventsToMatch);
			}
		}
		export namespace GetBulkBankRowMatches {
			export function Post(org: string, eventsToMatch: m.Bokio.Accounting.Contract.AutomationRules.Dtos.EventToMatchDto[]): Promise<m.Envelope<m.Bokio.Bank.Contract.AutoVerificationRows.Matching.AutoVerificationMatches[], m.SimpleError>> {
				return Client.post(`/${org}/Accounting/EventsToRecord/GetBulkBankRowMatches`, eventsToMatch)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.Matches.Data.Date"}, {"type":"Day","key":"Data.Matches.RowData.Date"}));
			}
		}
		export namespace GetRecordingPeriodStatus {
			export function Get(org: string, itemId: string, type: m.Bokio.Accounting.Contract.EventsToRecord.Dtos.EventType): Promise<m.Envelope<m.Bokio.Accounting.Contract.EventsToRecord.Dtos.RecordingPeriodStatus, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/EventsToRecord/GetRecordingPeriodStatus`, { itemId, type })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.FirstOpenFiscalYearDate"}, {"type":"Day","key":"Data.FirstDateAfterLockPeriod"}, {"type":"Day","key":"Data.FirstDateAfterVatPeriod"}, {"type":"Day","key":"Data.NextRecordableDate"}));
			}
		}
		export namespace Item {
			export function Get(org: string, itemId: string, type: m.Bokio.Accounting.Contract.EventsToRecord.Dtos.EventType): Promise<m.Envelope<m.Bokio.Accounting.Contract.EventsToRecord.Dtos.EventToRecordView, m.Bokio.Accounting.Contract.EventsToRecord.EventToRecordViewError>> {
				return Client.get(`/${org}/Accounting/EventsToRecord/Item`, { itemId, type })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.Item.Date"}, {"type":"Day","key":"Data.Item.OriginalTransactionDate"}, {"type":"Day","key":"Data.Item.SupplierData.OriginalInvoice.Date"}, {"type":"Day","key":"Data.BankRowMatches.Data.Date"}, {"type":"Day","key":"Data.BankRowMatches.RowData.Date"}, {"type":"Day","key":"Data.BookkeepingSuggestions.VerificationPreview.Date"}));
			}
		}
		export namespace List {
			export function Get(org: string, includeOldRows?: boolean): Promise<m.Envelope<m.Bokio.Accounting.Contract.EventsToRecord.Dtos.EventsToRecordListView, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/EventsToRecord/List`, { includeOldRows })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.Items.Date"}, {"type":"Day","key":"Data.Items.OriginalTransactionDate"}, {"type":"Day","key":"Data.Items.SupplierData.OriginalInvoice.Date"}, {"type":"Day","key":"Data.BankAccountSyncStatuses.LastSync"}, {"type":"Day","key":"Data.SyncStatusSummary.UpToDateUntill"}));
			}
		}
		export namespace PreRecordingChecks {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Accounting.Contract.EventsToRecord.Dtos.PreRecordingChecksView, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/EventsToRecord/PreRecordingChecks`);
			}
		}
		export namespace ReceiptMatches {
			export function Get(org: string, itemId: string, type: m.Bokio.Accounting.Contract.EventsToRecord.Dtos.EventType, shouldScanAll?: boolean): Promise<m.Envelope<m.Bokio.Accounting.Contract.EventsToRecord.Dtos.EventToRecordReceiptMatchingView, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/EventsToRecord/ReceiptMatches`, { itemId, type, shouldScanAll })
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.Matches.Date"}));
			}
		}
		export namespace Record {
			export function Post(org: string, itemId: string, type: m.Bokio.Accounting.Contract.EventsToRecord.Dtos.EventType, request: m.Bokio.Accounting.Contract.EventsToRecord.Requests.RecordEvent): Promise<m.Core.Recipes.RegisteredRecipeResult> {
				return Client.post(Client.getPathWithQueryString(`/${org}/Accounting/EventsToRecord/Record`, { itemId, type }), request);
			}
		}
		export namespace RevertRecordingDate {
			export function Post(org: string, request: m.Bokio.Accounting.Contract.EventsToRecord.Requests.RevertRecordingDateRequest): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/EventsToRecord/RevertRecordingDate`, request);
			}
		}
	}
	export namespace ImportSiController {
		export namespace Import {
			export function Post(org: string, fileGroupId: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/ImportSi/Import`, { fileGroupId });
			}
		}
		export namespace UploadAndValidate {
			export function Post(org: string, files: (File | Blob | string)[]): Promise<m.Envelope<m.Bokio.Accounting.Contract.ImportSi.DTOs.ValidationDto, m.SimpleError>> {
				const form = new FormData();
				files.forEach(item => form.append("files", item));
				return Client.post(`/${org}/Accounting/ImportSi/UploadAndValidate`, form, true)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.FilesValidation.VerificationValidationList.Verification.Date"}, {"type":"Day","key":"Data.FilesValidation.VerificationValidationList.Verification.ExpectPaymentAt"}, {"type":"Date","key":"Data.FilesValidation.VerificationValidationList.Verification.CreatedUtc"}));
			}
		}
	}
	export namespace LockPeriodController {
		export namespace CreateLockPeriod {
			export function Post(org: string, request: m.Bokio.Accounting.Web.Accounting.Viewmodels.LockPeriod.LockPeriodRequest): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/LockPeriod/CreateLockPeriod`, request);
			}
		}
		export namespace CurrentLockPeriod {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Accounting.Web.Accounting.Viewmodels.LockPeriod.LockPeriodViewModel, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/LockPeriod/CurrentLockPeriod`)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.LatestAllowedLockDate"}, {"type":"Day","key":"Data.LockedUntil"}));
			}
		}
		export namespace RemoveLockPeriod {
			export function Post(org: string, request: m.Bokio.Accounting.Web.Accounting.Viewmodels.LockPeriod.RemoveLockPeriodRequest): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/LockPeriod/RemoveLockPeriod`, request);
			}
		}
		export namespace UpdateLockPeriod {
			export function Post(org: string, request: m.Bokio.Accounting.Web.Accounting.Viewmodels.LockPeriod.UpdateLockPeriodRequest): Promise<m.Envelope<m.Bokio.Accounting.Web.Accounting.Viewmodels.LockPeriod.UpdateLockPeriodResult, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/LockPeriod/UpdateLockPeriod`, request)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.UpdatedDate"}));
			}
		}
	}
	export namespace PowerFunctionsController {
		export namespace GetAutomationRules {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Accounting.Contract.AutomationRules.Dtos.AutomationRuleEventsMatchDto[], m.SimpleError>> {
				return Client.get(`/${org}/Accounting/PowerFunctions/GetAutomationRules`)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.Events.Date"}, {"type":"Day","key":"Data.Events.OriginalTransactionDate"}, {"type":"Day","key":"Data.Events.SupplierData.OriginalInvoice.Date"}));
			}
		}
		export namespace GetBankRowMatches {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Accounting.Contract.PowerFunctions.Dtos.BankRowMatchView, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/PowerFunctions/GetBankRowMatches`)
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.PerfectMatches.BankRow.Date"}, {"type":"Day","key":"Data.PerfectMatches.Match.Data.Date"}, {"type":"Day","key":"Data.PerfectMatches.Match.RowData.Date"}, {"type":"Date","key":"Data.PotentialMatches.BankRow.Date"}, {"type":"Day","key":"Data.PotentialMatches.Match.Data.Date"}, {"type":"Day","key":"Data.PotentialMatches.Match.RowData.Date"}));
			}
		}
		export namespace GetReceiptMatches {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Accounting.Contract.PowerFunctions.Dtos.ReceiptMatchView, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/PowerFunctions/GetReceiptMatches`)
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.PerfectMatches.Receipt.Date"}, {"type":"Date","key":"Data.PerfectMatches.Match.Date"}, {"type":"Date","key":"Data.PotentialMatches.Receipt.Date"}, {"type":"Date","key":"Data.PotentialMatches.Match.Date"}));
			}
		}
	}
	export namespace PredictionController {
		export namespace Predict {
			export function Get(org: string, autoverificationRowId: string): Promise<m.Envelope<m.Bokio.Accounting.Contract.Recipes.Dtos.PredictionResult, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/Prediction/Predict`, { autoverificationRowId });
			}
		}
		export namespace PredictForExpense {
			export function Get(org: string, expenseId: string): Promise<m.Envelope<m.Bokio.Accounting.Contract.Recipes.Dtos.PredictionResult, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/Prediction/PredictForExpense`, { expenseId });
			}
		}
	}
	export namespace PredictionTestSetupController {
		export namespace SetupPredictionRulesAndAutoVerificationsForTestingBookkeepingSuggestions {
			export function Post(org: string): Promise<boolean> {
				return Client.post(`/${org}/PredictionTestSetup/SetupPredictionRulesAndAutoVerificationsForTestingBookkeepingSuggestions`, {  });
			}
		}
	}
	export namespace RegisterRecipeController {
		export namespace GetInitialRecipes {
			export function Get(org: string, request: m.Bokio.Accounting.Contract.Recipes.Requests.GetInitialRecipesRequest): Promise<m.Envelope<m.Accounting.Viewmodels.Recipes.InitialRecipesViewModel, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/RegisterRecipe/GetInitialRecipes`, { request });
			}
		}
		export namespace GetRecipeDefs {
			export function Post(org: string, request: m.Model.Commands.Accounting.Verifications.GetRecipeDefsRequest): Promise<m.Core.Recipes.RecipeInputDefinition[]> {
				return Client.post(`/${org}/Accounting/RegisterRecipe/GetRecipeDefs`, request);
			}
		}
		export namespace GetRecipeForms {
			export function Get(org: string, request: m.Bokio.Accounting.Contract.Recipes.Requests.GetRecipeFormsRequest): Promise<m.Envelope<m.Core.Recipes.Dtos.BookkeepingForms, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/RegisterRecipe/GetRecipeForms`, { request });
			}
		}
		export namespace MultiplePreviews {
			export function Post(org: string, requests: { [key: string]: m.Bokio.Accounting.Contract.Recipes.Requests.PreviewRequest; }): Promise<m.Envelope<{ [key: string]: m.Accounting.Viewmodels.Verifications.PreviewDto; }, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/RegisterRecipe/MultiplePreviews`, requests);
			}
		}
		export namespace MultiRecipePreview {
			export function Post(org: string, request: m.Bokio.Accounting.Contract.Recipes.Requests.MultiRecipePreviewRequest): Promise<m.Envelope<m.Accounting.Viewmodels.Verifications.PreviewDto, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/RegisterRecipe/MultiRecipePreview`, request)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.Verification.Date"}, {"type":"Day","key":"Data.Verification.ExpectPaymentAt"}, {"type":"Date","key":"Data.Verification.CreatedUtc"}, {"type":"Day","key":"Data.PaymentVerification.Date"}, {"type":"Day","key":"Data.PaymentVerification.ExpectPaymentAt"}, {"type":"Date","key":"Data.PaymentVerification.CreatedUtc"}));
			}
		}
		export namespace MultiRecipeSave {
			export function Post(org: string, command: m.Bokio.Accounting.Contract.Verifications.Requests.SaveVerificationFromMultipleRecipesRequest): Promise<m.Core.Recipes.RegisteredRecipeResult> {
				return Client.post(`/${org}/Accounting/RegisterRecipe/MultiRecipeSave`, command);
			}
		}
		export namespace MultiRecipeSaveSupplierInvoice {
			export function Post(org: string, request: m.Core.ViewData.SaveRecipesVerificationForSupplierInvoice): Promise<m.Core.Recipes.RegisteredRecipeResult> {
				return Client.post(`/${org}/Accounting/RegisterRecipe/MultiRecipeSaveSupplierInvoice`, request);
			}
		}
		export namespace Preview {
			export function Post(org: string, request: m.Bokio.Accounting.Contract.Recipes.Requests.PreviewRequest): Promise<m.Envelope<m.Accounting.Viewmodels.Verifications.PreviewDto, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/RegisterRecipe/Preview`, request)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.Verification.Date"}, {"type":"Day","key":"Data.Verification.ExpectPaymentAt"}, {"type":"Date","key":"Data.Verification.CreatedUtc"}, {"type":"Day","key":"Data.PaymentVerification.Date"}, {"type":"Day","key":"Data.PaymentVerification.ExpectPaymentAt"}, {"type":"Date","key":"Data.PaymentVerification.CreatedUtc"}));
			}
		}
		export namespace Search {
			export function Get(org: string, request: m.Bokio.Accounting.Contract.Recipes.Requests.SearchRecipesRequest): Promise<m.Envelope<m.Accounting.Viewmodels.Recipes.SearchResult, m.Accounting.Viewmodels.Recipes.SearchError>> {
				return Client.get(`/${org}/Accounting/RegisterRecipe/Search`, { request });
			}
		}
		export namespace ShowAll {
			export function Get(org: string, request: m.Bokio.Accounting.Contract.Recipes.Requests.ShowAllRecipesRequest): Promise<m.Envelope<m.Accounting.Viewmodels.Recipes.SearchResult, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/RegisterRecipe/ShowAll`, { request });
			}
		}
	}
	export namespace VerificationAndBankTransactionMatchingController {
		export namespace DiagnoseNoMatch {
			export function Get(org: string, request: m.Bokio.Accounting.Web.Accounting.Controllers.DiagnoseNoMatchRequest): Promise<m.Envelope<m.Bokio.Accounting.Web.Accounting.Controllers.DiagnoseNoMatchResponse, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/VerificationAndBankTransactionMatching/DiagnoseNoMatch`, { request });
			}
		}
		export namespace GetVerificationsToMatchCount {
			export function Get(org: string, request: m.Bokio.Accounting.Web.Accounting.Controllers.GetVerificationsToMatchCountRequest): Promise<m.Envelope<m.Bokio.Accounting.Web.Accounting.Controllers.GetVerificationsToMatchCountResponse, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/VerificationAndBankTransactionMatching/GetVerificationsToMatchCount`, { request })
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.AccountCounts.FromDate"}));
			}
		}
		export namespace ListOptions {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Accounting.Web.Accounting.Controllers.ListVerificationsThatNeedMatchingOptionsResponse, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/VerificationAndBankTransactionMatching/ListOptions`)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.Periods.StartDate"}, {"type":"Day","key":"Data.Periods.EndDate"}));
			}
		}
		export namespace ListVerificationsThatNeedMatching {
			export function Get(org: string, request: m.Bokio.Accounting.Web.Accounting.Controllers.ListVerificationsThatNeedMatchingRequest): Promise<m.Envelope<m.Bokio.Accounting.Web.Accounting.Controllers.ListVerificationsThatNeedMatchingResponse, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/VerificationAndBankTransactionMatching/ListVerificationsThatNeedMatching`, { request })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.Verifications.Verification.Date"}, {"type":"Day","key":"Data.Verifications.Verification.ExpectPaymentAt"}, {"type":"Date","key":"Data.Verifications.Verification.CreatedUtc"}, {"type":"Day","key":"Data.Transactions.Transaction.EffectiveDate"}, {"type":"Day","key":"Data.Transactions.Transaction.TransactionDate"}, {"type":"Day","key":"Data.Transactions.Transaction.OriginalTransactionDate"}, {"type":"Day","key":"Data.Transactions.Transaction.Matches.Data.Date"}, {"type":"Day","key":"Data.Transactions.Transaction.Matches.RowData.Date"}));
			}
		}
	}
	export namespace VerificationAttributeController {
		export namespace AddAttribute {
			export function Post(org: string, dto: m.Bokio.Accounting.Contract.EventsToRecord.Dtos.AddVerificationAttributeDto): Promise<m.Envelope<boolean, m.Bokio.Accounting.Web.Accounting.Controllers.VerificationAttributeError>> {
				return Client.post(`/${org}/Accounting/VerificationAttribute/AddAttribute`, dto);
			}
		}
		export namespace AttributesForVerification {
			export function Get(org: string, verificationId: string): Promise<m.Envelope<m.Bokio.Accounting.Contract.EventsToRecord.Dtos.AttributesForVerificationDto, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/VerificationAttribute/AttributesForVerification`, { verificationId })
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.Attributes.CreatedUtc"}));
			}
		}
		export namespace RemoveAttribute {
			export function Post(org: string, dto: m.Bokio.Accounting.Contract.EventsToRecord.Dtos.VerificationAttributeDto): Promise<m.Envelope<boolean, m.Bokio.Accounting.Web.Accounting.Controllers.VerificationAttributeError>> {
				return Client.post(`/${org}/Accounting/VerificationAttribute/RemoveAttribute`, dto);
			}
		}
	}
	export namespace VerificationTagController {
		export namespace DeleteTag {
			export function Post(org: string, dto: m.Bokio.Accounting.Web.Accounting.Controllers.DeleteTagDto): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/VerificationTag/DeleteTag`, dto);
			}
		}
		export namespace DeleteTransactionTag {
			export function Post(org: string, dto: m.Bokio.Accounting.Web.Accounting.Controllers.DeleteTagDto): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/VerificationTag/DeleteTransactionTag`, dto);
			}
		}
		export namespace Tag {
			export function Post(org: string, dto: m.Bokio.Accounting.Web.Accounting.Controllers.TagDto): Promise<m.Envelope<boolean, m.Bokio.Accounting.Web.Accounting.Controllers.TagVerificationError>> {
				return Client.post(`/${org}/Accounting/VerificationTag/Tag`, dto);
			}
		}
		export namespace TagsAutoCompleteData {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Accounting.Web.Accounting.Controllers.TagTypeGroupAutocompleteDto[], m.SimpleError>> {
				return Client.get(`/${org}/Accounting/VerificationTag/TagsAutoCompleteData`);
			}
		}
		export namespace TagsFormData2 {
			export function Post(org: string, verificationIds: string[]): Promise<m.Envelope<m.Bokio.Accounting.Web.Accounting.Controllers.TagVerificationsFormData, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/VerificationTag/TagsFormData2`, verificationIds)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.VerificationData.Date"}));
			}
		}
		export namespace TagsForVerification {
			export function Get(org: string, verificationId: string): Promise<m.Envelope<m.Bokio.Accounting.Web.Accounting.Controllers.TagsForVerificationDto, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/VerificationTag/TagsForVerification`, { verificationId });
			}
		}
	}
}
export namespace Bokio.Accounting.Web.AdditionalFiles {
	export namespace AdditionalFilesController {
		export namespace DeleteAdditionalFiles {
			export function Post(org: string, additionalFileIds: string[]): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/AdditionalFiles/DeleteAdditionalFiles`, additionalFileIds);
			}
		}
		export namespace ListAdditionalFiles {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Accounting.Contract.Services.AdditionalFiles.AdditionalFilesListDto, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/AdditionalFiles/ListAdditionalFiles`)
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.Files.UploadedDateTime"}));
			}
		}
		export namespace UploadAdditionalFile {
			export function Post(org: string, file: (File | Blob | string)): Promise<m.Envelope<boolean, m.SimpleError>> {
				const form = new FormData();
				form.append("file", file);
				return Client.post(`/${org}/Accounting/AdditionalFiles/UploadAdditionalFile`, form, true);
			}
		}
	}
}
export namespace Bokio.Accounting.Web.AnnualReport {
	export namespace AnnualReportController {
		export namespace CompleteAnnualReportSubmissionItem {
			export function Post(org: string, todoItemId: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/AnnualReport/CompleteAnnualReportSubmissionItem`, { todoItemId });
			}
		}
		export namespace CreateReport {
			export function Post(org: string, settingId: string): Promise<m.Envelope<m.Bokio.Accounting.Contract.AnnualReport.Dtos.AnnualReportViewModel, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/AnnualReport/CreateReport`, { settingId });
			}
		}
		export namespace Get {
			export function Get(org: string, id: string): Promise<m.Envelope<m.Bokio.Accounting.Contract.AnnualReport.Dtos.AnnualReportViewModel, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/AnnualReport/Get/${id}`);
			}
		}
		export namespace GetEquityAccountResult {
			export function Get(org: string, settingId: string, isPostClosure: boolean): Promise<m.Envelope<m.Bokio.Accounting.Contract.AnnualReport.Dtos.ClosureAccountResultDto, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/AnnualReport/GetEquityAccountResult`, { settingId, isPostClosure })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.ResultVerificationPreview.Date"}));
			}
		}
		export namespace GetStatus {
			export function Get(org: string, closureId: string): Promise<m.Envelope<m.Bokio.Accounting.Contract.AnnualReport.Dtos.AnnualReportStatusViewModel, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/AnnualReport/GetStatus`, { closureId });
			}
		}
		export namespace SaveEntries {
			export function Post(org: string, request: m.Bokio.Accounting.Contract.AnnualReport.Requests.AnnualReportSaveEntriesRequest): Promise<m.Envelope<boolean, m.Bokio.Accounting.Contract.AnnualReport.Errors.AnnualReportSaveEntriesErrors>> {
				return Client.post(`/${org}/Accounting/AnnualReport/SaveEntries`, request);
			}
		}
		export namespace ShouldShowDepreciationsInGeneralInfoNotes {
			export function Get(org: string, settingId: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/AnnualReport/ShouldShowDepreciationsInGeneralInfoNotes`, { settingId });
			}
		}
	}
}
export namespace Bokio.Accounting.Web.AutomationRules {
	export namespace AutomationRulesController {
		export namespace ChangePriorities {
			export function Post(org: string, request: m.Bokio.Accounting.Contract.AutomationRules.Requests.ChangeAutomationRulesPriorityRequest): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/AutomationRules/ChangePriorities`, request);
			}
		}
		export namespace CreateRule {
			export function Post(org: string, createAutomationRule: m.Bokio.Accounting.Contract.AutomationRules.Requests.CreateAutomationRuleRequest): Promise<m.Envelope<string, m.Bokio.Accounting.Contract.AutomationRules.Errors.AutomationRuleError>> {
				return Client.post(`/${org}/Accounting/AutomationRules/CreateRule`, createAutomationRule);
			}
		}
		export namespace DebugRule {
			export function Post(org: string, request: m.Bokio.Accounting.Contract.AutomationRules.Requests.DebugAutomationRuleRequest): Promise<m.Envelope<m.Bokio.Accounting.Contract.AutomationRules.Requests.DebugAutomationRuleResponse, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/AutomationRules/DebugRule`, request);
			}
		}
		export namespace EditRule {
			export function Post(org: string, editRuleRequest: m.Bokio.Accounting.Contract.AutomationRules.Requests.EditAutomationRuleRequest): Promise<m.Envelope<string, m.Bokio.Accounting.Contract.AutomationRules.Errors.AutomationRuleError>> {
				return Client.post(`/${org}/Accounting/AutomationRules/EditRule`, editRuleRequest);
			}
		}
		export namespace GetConstraintCombinations {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Accounting.Contract.AutomationRules.Dtos.AutomationRuleConstraintCombinationDto[], m.SimpleError>> {
				return Client.get(`/${org}/Accounting/AutomationRules/GetConstraintCombinations`);
			}
		}
		export namespace GetRule {
			export function Get(org: string, ruleId: string): Promise<m.Envelope<m.Bokio.Accounting.Contract.AutomationRules.Dtos.AutomationRuleDto, m.Bokio.Accounting.Contract.AutomationRules.Errors.AutomationRuleError>> {
				return Client.get(`/${org}/Accounting/AutomationRules/GetRule`, { ruleId })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.CreationDate"}));
			}
		}
		export namespace List {
			export function Get(org: string, includeDeleted?: boolean): Promise<m.Envelope<m.Bokio.Accounting.Contract.AutomationRules.Dtos.AutomationRuleDto[], m.SimpleError>> {
				return Client.get(`/${org}/Accounting/AutomationRules/List`, { includeDeleted })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.CreationDate"}));
			}
		}
		export namespace PreviewRule {
			export function Post(org: string, request: m.Bokio.Accounting.Contract.AutomationRules.Requests.EditAutomationRuleRequest): Promise<m.Envelope<m.Bokio.Accounting.Contract.AutoVerification.DTOs.BankRowRuleMatch[], m.SimpleError>> {
				return Client.post(`/${org}/Accounting/AutomationRules/PreviewRule`, request)
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.Row.TransactionDate"}));
			}
		}
		export namespace SetStatus {
			export function Post(org: string, statusRequest: m.Bokio.Accounting.Contract.AutomationRules.Requests.ChangeAutomationRuleStatusRequest): Promise<m.Envelope<boolean, m.Bokio.Accounting.Contract.AutomationRules.Errors.AutomationRuleError>> {
				return Client.post(`/${org}/Accounting/AutomationRules/SetStatus`, statusRequest);
			}
		}
		export namespace SuggestRule {
			export function Post(org: string, request: m.Bokio.Accounting.Contract.AutomationRules.Dtos.AutomationRuleSuggestionRequest): Promise<m.Envelope<m.Bokio.Accounting.Contract.AutomationRules.Dtos.AutomationRuleSuggestionResponse, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/AutomationRules/SuggestRule`, request);
			}
		}
	}
}
export namespace Bokio.Accounting.Web.Dashboard {
	export namespace DashboardController {
		export namespace GetCustomerInvoiceData {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Accounting.Contract.Dashboard.Dtos.InvoiceOverviewDto, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/Dashboard/GetCustomerInvoiceData`);
			}
		}
		export namespace GetIncomeAndExpenseData {
			export function Get(org: string, fromDate: Day, toDate: Day): Promise<m.Envelope<m.Bokio.Accounting.Contract.Dashboard.Dtos.IncomeAndExpenseByMonthDto, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/Dashboard/GetIncomeAndExpenseData`, { fromDate, toDate });
			}
		}
		export namespace GetProprietorshipSettings {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Accounting.Contract.Dashboard.Dtos.ProprietorshipSettingsDto, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/Dashboard/GetProprietorshipSettings`);
			}
		}
		export namespace GetSummaryData {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Accounting.Contract.Dashboard.Dtos.FinancialSummaryDto, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/Dashboard/GetSummaryData`);
			}
		}
		export namespace GetSupplierInvoiceData {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Accounting.Contract.Dashboard.Dtos.InvoiceOverviewDto, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/Dashboard/GetSupplierInvoiceData`);
			}
		}
		export namespace GetTopFiveCustomersAndArticles {
			export function Get(org: string, fromDate: Day, toDate: Day): Promise<m.Envelope<m.Bokio.Accounting.Contract.Dashboard.Dtos.TopFiveCustomersAndArticlesDto, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/Dashboard/GetTopFiveCustomersAndArticles`, { fromDate, toDate });
			}
		}
		export namespace GetTopFiveExpenseData {
			export function Get(org: string, fromDate: Day, toDate: Day): Promise<m.Envelope<m.Bokio.Accounting.Contract.Dashboard.Dtos.TopFiveExpensesDto, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/Dashboard/GetTopFiveExpenseData`, { fromDate, toDate });
			}
		}
		export namespace Overview {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Accounting.Contract.Dashboard.Dtos.MoneyReportDto, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/Dashboard/Overview`)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.BankAccounts.MoneyAccounts.LastRowDate"}, {"type":"Date","key":"Data.BankAccounts.MoneyAccounts.Connection.LastSyncDate"}, {"type":"Day","key":"Data.BankAccounts.MoneyAccounts.Connection.SyncFromDate"}));
			}
		}
		export namespace SetProprietorshipSettings {
			export function Post(org: string, request: m.Model.Commands.Settings.SetProprietorshipSettings): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/Dashboard/SetProprietorshipSettings`, request);
			}
		}
	}
}
export namespace Bokio.Accounting.Web.Settings {
	export namespace CustomAccountsController {
		export namespace BaseAccountDetails {
			export function Get(org: string, account: number): Promise<m.Envelope<m.Bokio.Accounting.Contract.CustomAccounts.AccountDetailsDto, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/CustomAccounts/BaseAccountDetails`, { account });
			}
		}
		export namespace CreateCustomAccount {
			export function Post(org: string, dto: m.Bokio.Accounting.Contract.CustomAccounts.CreateCustomAccountDto): Promise<m.Envelope<m.Bokio.Accounting.Contract.CustomAccounts.AccountDetailsDto, m.Bokio.Accounting.Contract.CustomAccounts.CustomAccountError>> {
				return Client.post(`/${org}/Accounting/CustomAccounts/CreateCustomAccount`, dto);
			}
		}
		export namespace DeleteCustomAccount {
			export function Post(org: string, dto: m.Bokio.Accounting.Contract.CustomAccounts.DeleteCustomAccountDto): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/CustomAccounts/DeleteCustomAccount`, dto);
			}
		}
		export namespace Details {
			export function Get(org: string, account: number): Promise<m.Envelope<m.Bokio.Accounting.Contract.CustomAccounts.AccountDetailsDto, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/CustomAccounts/Details`, { account });
			}
		}
		export namespace EditCustomAccount {
			export function Post(org: string, dto: m.Bokio.Accounting.Contract.CustomAccounts.EditCustomAccountDto): Promise<m.Envelope<m.Bokio.Accounting.Contract.CustomAccounts.AccountDetailsDto, m.Bokio.Accounting.Contract.CustomAccounts.CustomAccountError>> {
				return Client.post(`/${org}/Accounting/CustomAccounts/EditCustomAccount`, dto);
			}
		}
		export namespace GetPossibleAccountNumbers {
			export function Get(org: string, connectedAccount: number): Promise<m.Envelope<number[], m.SimpleError>> {
				return Client.get(`/${org}/Accounting/CustomAccounts/GetPossibleAccountNumbers`, { connectedAccount });
			}
		}
		export namespace GetPossibleConnectedAccounts {
			export function Get(org: string, customAccount: number): Promise<m.Envelope<m.Classes.AccountBase[], m.SimpleError>> {
				return Client.get(`/${org}/Accounting/CustomAccounts/GetPossibleConnectedAccounts`, { customAccount });
			}
		}
		export namespace ListCustomAccounts {
			export function Get(org: string): Promise<m.Core.ViewData.CustomAccountForView[]> {
				return Client.get(`/${org}/Accounting/CustomAccounts/ListCustomAccounts`);
			}
		}
		export namespace SetCustomAccountName {
			export function Post(org: string, dto: m.Bokio.Accounting.Contract.CustomAccounts.SetCustomAccountNameDto): Promise<m.Envelope<m.Bokio.Accounting.Contract.CustomAccounts.AccountDetailsDto, m.Bokio.Accounting.Contract.CustomAccounts.CustomAccountError>> {
				return Client.post(`/${org}/Accounting/CustomAccounts/SetCustomAccountName`, dto);
			}
		}
		export namespace UpdateCustomAccounts {
			export function Post(org: string, request: m.Bokio.Accounting.Contract.CustomAccounts.UpdateCustomAccountsDto): Promise<m.Envelope<boolean, m.Bokio.Accounting.Contract.CustomAccounts.CustomAccountError>> {
				return Client.post(`/${org}/Accounting/CustomAccounts/UpdateCustomAccounts`, request);
			}
		}
	}
	export namespace FiscalYearsController {
		export namespace CanCloseYears {
			export function Get(org: string): Promise<m.Bokio.Services.FiscalYears.CanCloseFiscalYear[]> {
				return Client.get(`/${org}/Accounting/FiscalYears/CanCloseYears`);
			}
		}
		export namespace CheckOpenFiscalYear {
			export function Get(org: string, settingsId: string): Promise<m.Bokio.Accounting.Contract.FiscalYears.Errors.QuickActionYearErrorsWarnings> {
				return Client.get(`/${org}/Accounting/FiscalYears/CheckOpenFiscalYear`, { settingsId });
			}
		}
		export namespace Close {
			export function Post(org: string, settingsId: string, ignoreImbalanced: boolean, ignoreUserSetIncomingBalances: boolean): Promise<m.Envelope<boolean, m.Bokio.Accounting.Contract.FiscalYears.Errors.ClosureError>> {
				return Client.post(`/${org}/Accounting/FiscalYears/Close`, { settingsId, ignoreImbalanced, ignoreUserSetIncomingBalances });
			}
		}
		export namespace CreateFiscal {
			export function Get(org: string, mode: m.Bokio.Services.FiscalYears.CreateFiscalMode): Promise<m.Bokio.Services.FiscalYears.FiscalYearDto> {
				return Client.get(`/${org}/Accounting/FiscalYears/CreateFiscal`, { mode })
				             .then(data => convertByKeys(data, {"type":"Day","key":"EndDate"}, {"type":"Day","key":"StartDate"}));
			}
		}
		export namespace CreateNext {
			export function Post(org: string, request: m.Model.Commands.Accounting.FiscalYears.CreateNextYear): Promise<m.Envelope<m.Bokio.Services.FiscalYears.FiscalYearDto, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/FiscalYears/CreateNext`, request)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.EndDate"}, {"type":"Day","key":"Data.StartDate"}));
			}
		}
		export namespace CreatePrevious {
			export function Post(org: string, request: m.Model.Commands.Accounting.FiscalYears.CreatePreviousYear): Promise<m.Envelope<m.Bokio.Services.FiscalYears.FiscalYearDto, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/FiscalYears/CreatePrevious`, request)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.EndDate"}, {"type":"Day","key":"Data.StartDate"}));
			}
		}
		export namespace DeleteYear {
			export function Post(org: string, command: m.Model.Commands.Accounting.FiscalYears.DeleteYear): Promise<m.Envelope<boolean, m.Bokio.Accounting.Contract.FiscalYears.Errors.DeleteFiscalYearError>> {
				return Client.post(`/${org}/Accounting/FiscalYears/DeleteYear`, command);
			}
		}
		export namespace FirstFiscalYearDateRange {
			export function Get(org: string): Promise<m.Envelope<m.Classes.DateRange, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/FiscalYears/FirstFiscalYearDateRange`)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.Start"}, {"type":"Day","key":"Data.End"}));
			}
		}
		export namespace GetCurrentFiscalYear {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Services.FiscalYears.FiscalYearDto, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/FiscalYears/GetCurrentFiscalYear`)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.EndDate"}, {"type":"Day","key":"Data.StartDate"}));
			}
		}
		export namespace Index {
			export function Get(org: string): Promise<m.Bokio.Services.FiscalYears.FiscalYearsDto> {
				return Client.get(`/${org}/Accounting/FiscalYears`)
				             .then(data => convertByKeys(data, {"type":"Day","key":"NextYear.StartDate"}, {"type":"Day","key":"NextYear.EndDate"}, {"type":"Day","key":"PreviousYear.StartDate"}, {"type":"Day","key":"PreviousYear.EndDate"}, {"type":"Day","key":"Years.FiscalYear.StartDate"}, {"type":"Day","key":"Years.FiscalYear.EndDate"}));
			}
		}
		export namespace List {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Accounting.Contract.FiscalYears.Dtos.FiscalYearsViewModel, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/FiscalYears/List`)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.FiscalYears.StartDate"}, {"type":"Day","key":"Data.FiscalYears.EndDate"}));
			}
		}
		export namespace ListWithValidation {
			export function Get(org: string): Promise<m.Bokio.Services.FiscalYears.FiscalYearsDto> {
				return Client.get(`/${org}/Accounting/FiscalYears/ListWithValidation`)
				             .then(data => convertByKeys(data, {"type":"Day","key":"NextYear.StartDate"}, {"type":"Day","key":"NextYear.EndDate"}, {"type":"Day","key":"PreviousYear.StartDate"}, {"type":"Day","key":"PreviousYear.EndDate"}, {"type":"Day","key":"Years.FiscalYear.StartDate"}, {"type":"Day","key":"Years.FiscalYear.EndDate"}));
			}
		}
		export namespace MoveFirstFiscalYearStartDate {
			export function Post(org: string): Promise<m.Envelope<m.Bokio.Accounting.Contract.FiscalYears.Dtos.MoveFirstFiscalYearStartDateResult, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/FiscalYears/MoveFirstFiscalYearStartDate`, {  })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.NewStartDate"}, {"type":"Day","key":"Data.NewEndDate"}, {"type":"Day","key":"Data.MovedVerifications.Date"}, {"type":"Day","key":"Data.MovedVerifications.ExpectPaymentAt"}, {"type":"Date","key":"Data.MovedVerifications.CreatedUtc"}, {"type":"Day","key":"Data.OldEndDate"}, {"type":"Day","key":"Data.OldStartDate"}));
			}
		}
		export namespace MoveFirstFiscalYearStartDatePreview {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Accounting.Contract.FiscalYears.Dtos.MoveFirstFiscalYearStartDateResult, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/FiscalYears/MoveFirstFiscalYearStartDatePreview`)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.NewStartDate"}, {"type":"Day","key":"Data.NewEndDate"}, {"type":"Day","key":"Data.MovedVerifications.Date"}, {"type":"Day","key":"Data.MovedVerifications.ExpectPaymentAt"}, {"type":"Date","key":"Data.MovedVerifications.CreatedUtc"}, {"type":"Day","key":"Data.OldEndDate"}, {"type":"Day","key":"Data.OldStartDate"}));
			}
		}
		export namespace Open {
			export function Post(org: string, settingsId: string): Promise<m.Envelope<boolean, m.Bokio.Accounting.Contract.FiscalYears.Errors.ClosureError>> {
				return Client.post(`/${org}/Accounting/FiscalYears/Open`, { settingsId });
			}
		}
		export namespace Update {
			export function Post(org: string, request: m.Model.Commands.Accounting.FiscalYears.UpdateYear): Promise<m.Envelope<m.Bokio.Services.FiscalYears.FiscalYearDto, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/FiscalYears/Update`, request)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.EndDate"}, {"type":"Day","key":"Data.StartDate"}));
			}
		}
		export namespace Year {
			export function Get(org: string, id: string): Promise<m.Bokio.Services.FiscalYears.FiscalYearDto> {
				return Client.get(`/${org}/Accounting/FiscalYears/Year/${id}`)
				             .then(data => convertByKeys(data, {"type":"Day","key":"EndDate"}, {"type":"Day","key":"StartDate"}));
			}
		}
	}
	export namespace OpeningBalancesController {
		export namespace GetCalculatedOpeningBalances {
			export function Get(org: string, fiscalYearId: string): Promise<m.Envelope<m.Settings.Viewmodels.BalancesViewModel, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/OpeningBalances/GetCalculatedOpeningBalances`, { fiscalYearId });
			}
		}
		export namespace HasFirstYearOpeningBalances {
			export function Get(org: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/OpeningBalances/HasFirstYearOpeningBalances`);
			}
		}
		export namespace SetOpeningBalances {
			export function Post(org: string, data: m.Settings.Viewmodels.OpeningBalances): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/OpeningBalances/SetOpeningBalances`, data);
			}
		}
		export namespace Status {
			export function Get(org: string, fiscalId?: string): Promise<m.Envelope<m.Settings.Viewmodels.OpeningBalancesViewModel, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/OpeningBalances/Status`, { fiscalId })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.FiscalYearStartDate"}, {"type":"Day","key":"Data.FiscalYearEndDate"}));
			}
		}
		export namespace UndoOpeningBalances {
			export function Post(org: string, fiscalYearId: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/OpeningBalances/UndoOpeningBalances`, { fiscalYearId });
			}
		}
	}
}
export namespace Bokio.Accounting.Web.Tax {
	export namespace SkatteverketTaxAccountController {
		export namespace TrySetupTaxAccountRecipes {
			export function Post(org: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Accounting/SkatteverketTaxAccount/TrySetupTaxAccountRecipes`, {  });
			}
		}
	}
	export namespace TaxController {
		export namespace GetOtherTaxCostsCalculation {
			export function Get(org: string, settingId: string): Promise<m.Envelope<m.Bokio.Accounting.Contract.Tax.Dtos.OtherTaxCostsCalculationDto, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/Tax/GetOtherTaxCostsCalculation`, { settingId });
			}
		}
		export namespace GetSpecialPayrollTaxOnPensionCostsCalculation {
			export function Get(org: string, settingId: string): Promise<m.Envelope<m.Bokio.Accounting.Contract.Tax.Dtos.SpecialPayrollTaxOnPensionCostsCalculationDto, m.SimpleError>> {
				return Client.get(`/${org}/Accounting/Tax/GetSpecialPayrollTaxOnPensionCostsCalculation`, { settingId });
			}
		}
		export namespace GetTaxCalculation {
			export function Get(org: string, request: m.Bokio.Accounting.Contract.Tax.Requests.TaxCalculationRequest): Promise<m.Envelope<m.Bokio.Accounting.Contract.Tax.Dtos.TaxCalculationWithVerificationPreviewDto, m.Bokio.Accounting.Contract.Tax.Exceptions.FinalTaxCalculatorValidationError>> {
				return Client.get(`/${org}/Accounting/Tax/GetTaxCalculation`, { request })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.VerificationPreview.Date"}));
			}
		}
	}
}
export namespace Bokio.Bcc.Web {
	export namespace BccController {
		export namespace CreateOnboarding {
			export function Post(request: m.Bokio.Bcc.Web.Contract.Request.BccCreateOnboardingRequest): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post("/Bcc/Bcc/CreateOnboarding", request);
			}
		}
		export namespace GetOnboardings {
			export function Get(): Promise<m.Envelope<m.Bokio.Bcc.Web.Contract.Response.BccGetOnboardingsDto, m.SimpleError>> {
				return Client.get("/Bcc/Bcc/GetOnboardings");
			}
		}
	}
	export namespace BccRedflagController {
		export namespace GetCountries {
			export function Get(): Promise<m.Envelope<m.Bokio.Common.Contract.Internationalization.GetCountriesResult, m.SimpleError>> {
				return Client.get("/Bcc/BccRedflag/GetCountries")
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.Countries.CountrySubdivisions.EUMembershipHistory.Entry"}, {"type":"Date","key":"Data.Countries.CountrySubdivisions.EUMembershipHistory.Exit"}));
			}
		}
		export namespace SubmitBccKyc {
			export function Post(request: m.Bokio.Bcc.Web.Contract.Request.BccKycRequest): Promise<m.Envelope<m.Bokio.Bcc.Web.Controllers.BccKycForm, m.SimpleError>> {
				return Client.post("/Bcc/BccRedflag/SubmitBccKyc", request);
			}
		}
	}
}
export namespace Bokio.Common.Web.Billing {
	export namespace BillingController {
		export namespace ActivateVoucher {
			export function Post(org: string, code: string): Promise<m.Envelope<m.Bokio.Common.Contract.Billing.Model.ActivateVoucherResult, m.SimpleError>> {
				return Client.post(`/${org}/CommonWeb/Billing/ActivateVoucher`, { code })
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.DiscountDetails.ValidTo"}));
			}
		}
		export namespace GetBillingSettings {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Common.Billing.Model.BillingSettings, m.SimpleError>> {
				return Client.get(`/${org}/CommonWeb/Billing/GetBillingSettings`);
			}
		}
		export namespace GetBillWithCosts {
			export function Get(org: string, billId: string): Promise<m.Envelope<m.Bokio.Common.Billing.Model.Bill, m.SimpleError>> {
				return Client.get(`/${org}/CommonWeb/Billing/GetBillWithCosts`, { billId })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.FirstDay"}, {"type":"Day","key":"Data.LastDay"}, {"type":"Day","key":"Data.BillingDay"}, {"type":"Day","key":"Data.DueDate"}, {"type":"Day","key":"Data.Costs.Date"}));
			}
		}
		export namespace GetCashbackDetailsForIssuer {
			export function Get(org: string, lastDay: Day): Promise<m.Envelope<m.Bokio.Common.Billing.Model.CashbackDetails, m.SimpleError>> {
				return Client.get(`/${org}/CommonWeb/Billing/GetCashbackDetailsForIssuer`, { lastDay })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.Summary.LastDay"}, {"type":"Day","key":"Data.Payments.PaymentDate"}, {"type":"Day","key":"Data.Payments.PaymentCreatedUtc"}, {"type":"Day","key":"Data.Payments.PaymentCompletedUtc"}));
			}
		}
		export namespace GetCashbackSummaryForIssuer {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Common.Billing.Model.CashbackSummary[], m.SimpleError>> {
				return Client.get(`/${org}/CommonWeb/Billing/GetCashbackSummaryForIssuer`)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.LastDay"}));
			}
		}
		export namespace GetReceipts {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Common.Billing.Model.ReceiptsVM, m.SimpleError>> {
				return Client.get(`/${org}/CommonWeb/Billing/GetReceipts`)
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.Receipts.Date"}, {"type":"Day","key":"Data.Bills.FirstDay"}, {"type":"Day","key":"Data.Bills.LastDay"}, {"type":"Day","key":"Data.Bills.BillingDay"}, {"type":"Day","key":"Data.Bills.DueDate"}, {"type":"Day","key":"Data.Bills.Costs.Date"}));
			}
		}
		export namespace GetVouchers {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Common.Contract.Billing.Model.BillingVoucher[], m.SimpleError>> {
				return Client.get(`/${org}/CommonWeb/Billing/GetVouchers`)
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.ActiveFrom"}, {"type":"Date","key":"Data.ActiveTo"}, {"type":"Date","key":"Data.CreatedUtc"}));
			}
		}
		export namespace IsBillingCompany {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Common.Billing.Model.BillingCompany, m.SimpleError>> {
				return Client.get(`/${org}/CommonWeb/Billing/IsBillingCompany`);
			}
		}
		export namespace RemoveStripePaymentMethod {
			export function Post(org: string, req: m.Bokio.Billing.Contract.Models.RemoveStripePaymentMethodRequest): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(Client.getPathWithQueryString(`/${org}/CommonWeb/Billing/RemoveStripePaymentMethod`, { req }), {  });
			}
		}
		export namespace RetryFailedPayments {
			export function Post(org: string): Promise<m.Envelope<m.Bokio.Common.Contract.Billing.Model.RetryFailedPaymentsResult, m.SimpleError>> {
				return Client.post(`/${org}/CommonWeb/Billing/RetryFailedPayments`, {  })
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.PaymentResults.BillDate"}));
			}
		}
		export namespace SetStripePaymentMethodAsDefault {
			export function Post(org: string, req: m.Bokio.Billing.Contract.Models.SetStripePaymentMethodAsDefaultRequest): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(Client.getPathWithQueryString(`/${org}/CommonWeb/Billing/SetStripePaymentMethodAsDefault`, { req }), {  });
			}
		}
	}
	export namespace CampaignController {
		export namespace GetActiveCampaign {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Common.Contract.Billing.Model.CampaignDto[], m.SimpleError>> {
				return Client.get(`/${org}/CommonWeb/Campaign/GetActiveCampaign`)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.EndDate"}));
			}
		}
	}
}
export namespace Bokio.Common.Web.Comments {
	export namespace CommentsController {
		export namespace AddComment {
			export function Post(org: string, request: m.Bokio.Common.Contract.ViewData.AddCommentRequestDto): Promise<m.Envelope<string, m.Bokio.Backbone.Web.Controllers.Comments.CommentErrors>> {
				return Client.post(`/${org}/CommonWeb/Comments/AddComment`, request);
			}
		}
		export namespace DeleteComment {
			export function Post(org: string, commentId: string): Promise<m.Envelope<boolean, m.Bokio.Backbone.Web.Controllers.Comments.CommentErrors>> {
				return Client.post(`/${org}/CommonWeb/Comments/DeleteComment`, { commentId });
			}
		}
		export namespace EditComment {
			export function Post(org: string, request: m.Bokio.Common.Contract.ViewData.EditCommentRequestDto): Promise<m.Envelope<boolean, m.Bokio.Backbone.Web.Controllers.Comments.CommentErrors>> {
				return Client.post(`/${org}/CommonWeb/Comments/EditComment`, request);
			}
		}
		export namespace GetComments {
			export function Get(org: string, topicType: m.Entities.TopicType, topicId: string): Promise<m.Envelope<m.Bokio.Common.Contract.ViewData.CommentDto[], m.Bokio.Backbone.Web.Controllers.Comments.CommentErrors>> {
				return Client.get(`/${org}/CommonWeb/Comments/GetComments`, { topicType, topicId })
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.LastUpdated"}, {"type":"Date","key":"Data.CreatedAt"}));
			}
		}
		export namespace GetMentionableUsers {
			export function Get(org: string, topicType: m.Entities.TopicType, topicId: string): Promise<m.Envelope<m.Bokio.Common.Services.Comments.MentionableUserInfo[], m.Bokio.Backbone.Web.Controllers.Comments.CommentErrors>> {
				return Client.get(`/${org}/CommonWeb/Comments/GetMentionableUsers`, { topicType, topicId });
			}
		}
		export namespace GetNumberOfComments {
			export function Get(org: string, topicType: m.Entities.TopicType, topicId: string): Promise<number> {
				return Client.get(`/${org}/CommonWeb/Comments/GetNumberOfComments`, { topicType, topicId });
			}
		}
	}
}
export namespace Bokio.Common.Web.InAppSales {
	export namespace InAppSalesController {
		export namespace Send {
			export function Post(org: string, request: m.Bokio.Common.Contract.ViewData.InAppSalesTrackRequest): Promise<m.Bokio.Common.Contract.ViewData.InAppSalesTrackRequest> {
				return Client.post(`/${org}/CommonWeb/InAppSales/Send`, request);
			}
		}
	}
}
export namespace Bokio.Common.Web.Metrics {
	export namespace MetricsController {
		export namespace SaveAnalytics {
			export function Post(org: string, request: m.Bokio.Common.Contract.Metrics.Analytics.Requests.AnalyticsRequest): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/CommonWeb/Metrics/SaveAnalytics`, request);
			}
		}
		export namespace SaveAssetsFeedback {
			export function Post(org: string, request: m.Bokio.Common.Contract.Metrics.AssetsMetrics.Requests.SaveAssetsFeedbackRequest): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/CommonWeb/Metrics/SaveAssetsFeedback`, request);
			}
		}
		export namespace SaveDigitalAnnualReportFeedback {
			export function Post(org: string, request: m.Core.Metrics.DigitalAnnualReportMetrics.Requests.DigitalAnnualReportFeedbackRequest): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/CommonWeb/Metrics/SaveDigitalAnnualReportFeedback`, request);
			}
		}
		export namespace SaveFeatureInterest {
			export function Post(org: string, request: m.Bokio.Common.Contract.Metrics.FeatureInterest.Requests.FeatureInterestRequest): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/CommonWeb/Metrics/SaveFeatureInterest`, request);
			}
		}
		export namespace SaveGenericFeedback {
			export function Post(org: string, request: m.Core.Metrics.Feedback.GenericFeedbackRequest): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/CommonWeb/Metrics/SaveGenericFeedback`, request);
			}
		}
		export namespace SaveIntegrationsFeedback {
			export function Post(org: string, request: m.Bokio.Common.Contract.Metrics.Feedback.IntegrationsFeedbackRequest): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/CommonWeb/Metrics/SaveIntegrationsFeedback`, request);
			}
		}
		export namespace SaveVacationTrackingFeedback {
			export function Post(org: string, request: m.Bokio.Common.Contract.Metrics.VacationTrackingMetrics.Requests.VacationTrackingFeedbackRequest): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/CommonWeb/Metrics/SaveVacationTrackingFeedback`, request);
			}
		}
		export namespace SaveVerificationMetric {
			export function Post(org: string, request: m.Bokio.Common.Contract.Metrics.VerificationMetric.Requests.SaveVerificationMetricRequest): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/CommonWeb/Metrics/SaveVerificationMetric`, request);
			}
		}
		export namespace SaveYesNoFeedback {
			export function Post(org: string, request: m.Bokio.Common.Contract.Metrics.YesNoFeedback.Requests.YesNoFeedbackRequest): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/CommonWeb/Metrics/SaveYesNoFeedback`, request);
			}
		}
	}
}
export namespace Bokio.Common.Web.Plan {
	export namespace PricePlanFeatureController {
		export namespace GetAllFeaturesAvailableForCompany {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Common.Contract.ViewData.PricePlanFeatureInfo[], m.SimpleError>> {
				return Client.get(`/${org}/CommonWeb/PricePlanFeature/GetAllFeaturesAvailableForCompany`);
			}
		}
		export namespace GetFeatureAvailableForCompany {
			export function Get(org: string, feature: m.Entities.PricePlanFeature): Promise<m.Envelope<m.Bokio.Common.Contract.ViewData.PricePlanFeatureInfo, m.SimpleError>> {
				return Client.get(`/${org}/CommonWeb/PricePlanFeature/GetFeatureAvailableForCompany`, { feature });
			}
		}
	}
}
export namespace Bokio.Common.Web.Settings {
	export namespace SubscriptionController {
		export namespace AddSubscriptionAddons {
			export function Post(org: string, dto: m.Bokio.Backbone.Web.Controllers.Settings.AddSubscriptionAddonsDto): Promise<m.Envelope<m.Bokio.Billing.Contract.Models.Subscriptions.AddSubscriptionAddonsResponseDto, m.Bokio.Backbone.Web.Controllers.Settings.SubscriptionAddonErrorDto>> {
				return Client.post(`/${org}/CommonWeb/Subscription/AddSubscriptionAddons`, dto);
			}
		}
		export namespace BeginSetupNewSubscription {
			export function Post(org: string, dto: m.Bokio.Backbone.Web.Controllers.Settings.BeginSetUpNewSubscriptionDto): Promise<m.Envelope<m.Bokio.Backbone.Web.Controllers.Settings.SetupNewSubscriptionResponse, m.Bokio.Backbone.Web.Controllers.Settings.LoyalCustomerPurchaseError>> {
				return Client.post(`/${org}/CommonWeb/Subscription/BeginSetupNewSubscription`, dto);
			}
		}
		export namespace CancelScheduledSubscriptionChange {
			export function Post(org: string, source: m.Bokio.Billing.Contract.Models.Subscriptions.SubscriptionChangeSource): Promise<m.Envelope<boolean, m.Bokio.Backbone.Web.Controllers.Settings.PreviewBokioPlanChangeErrorDto>> {
				return Client.post(Client.getPathWithQueryString(`/${org}/CommonWeb/Subscription/CancelScheduledSubscriptionChange`, { source }), {  });
			}
		}
		export namespace CancelSubscriptionAddons {
			export function Post(org: string, dto: m.Bokio.Backbone.Web.Controllers.Settings.CancelSubscriptionAddonsDto): Promise<m.Envelope<m.Bokio.Billing.Contract.Models.Subscriptions.CancelSubscriptionAddonsResponseDto, m.Bokio.Backbone.Web.Controllers.Settings.CancelSubscriptionAddonErrorDto>> {
				return Client.post(`/${org}/CommonWeb/Subscription/CancelSubscriptionAddons`, dto)
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.RemovedAddons.EffectiveRemovalDate"}));
			}
		}
		export namespace ChangeBokioPricePlan {
			export function Post(org: string, dto: m.Bokio.Backbone.Web.Controllers.Settings.ChangePricePlanDto): Promise<m.Envelope<m.Bokio.Backbone.Web.Controllers.Settings.ChangePlanDto, m.Bokio.Backbone.Web.Controllers.Settings.ChangePricePlanError>> {
				return Client.post(`/${org}/CommonWeb/Subscription/ChangeBokioPricePlan`, dto);
			}
		}
		export namespace CompleteAddonPurchaseWith3DSecureChallenge {
			export function Post(org: string, dto: m.Bokio.Backbone.Web.Controllers.Settings.Authenticated3DSecureChallenge): Promise<m.Envelope<m.Bokio.Billing.Contract.Models.Subscriptions.AddSubscriptionAddonsResponseDto, m.Bokio.Backbone.Web.Controllers.Settings.SubscriptionAddonErrorDto>> {
				return Client.post(`/${org}/CommonWeb/Subscription/CompleteAddonPurchaseWith3DSecureChallenge`, dto);
			}
		}
		export namespace CompleteStripeCustomerSetupIntent {
			export function Post(org: string, dto: m.Bokio.Backbone.Web.Controllers.Settings.CompleteSetupIntentDto): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/CommonWeb/Subscription/CompleteStripeCustomerSetupIntent`, dto);
			}
		}
		export namespace CompleteUpgradeWith3DSecureChallenge {
			export function Post(org: string, dto: m.Bokio.Backbone.Web.Controllers.Settings.Authenticated3DSecureChallenge): Promise<m.Envelope<m.Bokio.Backbone.Web.Controllers.Settings.ChangePlanDto, m.Bokio.Backbone.Web.Controllers.Settings.ChangePricePlanError>> {
				return Client.post(`/${org}/CommonWeb/Subscription/CompleteUpgradeWith3DSecureChallenge`, dto);
			}
		}
		export namespace CostOverviewState {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Backbone.Web.Controllers.Settings.CostOverviewViewModel, m.SimpleError>> {
				return Client.get(`/${org}/CommonWeb/Subscription/CostOverviewState`)
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.Header.NextPaymentDate"}, {"type":"Date","key":"Data.PeriodCosts.NextPlanPaymentDate"}, {"type":"Date","key":"Data.PeriodCosts.Discount.ValidTo"}, {"type":"Date","key":"Data.MonthlyCosts.NextMonthlyPaymentDate"}));
			}
		}
		export namespace CurrentBokioPlan {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Common.Contract.ViewData.BokioPlanDto, m.SimpleError>> {
				return Client.get(`/${org}/CommonWeb/Subscription/CurrentBokioPlan`)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.PlannedChange.Date"}, {"type":"Day","key":"Data.TrialPlanInfo.Start"}, {"type":"Day","key":"Data.TrialPlanInfo.End"}));
			}
		}
		export namespace FetchAndUpdateCompanyInfo {
			export function Post(org: string, dto: m.Bokio.Backbone.Web.Controllers.Settings.FetchAndUpdateCompanyInfoDto): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/CommonWeb/Subscription/FetchAndUpdateCompanyInfo`, dto);
			}
		}
		export namespace GetCashbackContracts {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Backbone.Web.Controllers.Settings.CashbackContractsDto, m.SimpleError>> {
				return Client.get(`/${org}/CommonWeb/Subscription/GetCashbackContracts`)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.AvailableCashbackOffer.OfferValidTo"}));
			}
		}
		export namespace GetCashbackDefaultValue {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Backbone.Web.Controllers.Settings.CashbackValuesResponse, m.SimpleError>> {
				return Client.get(`/${org}/CommonWeb/Subscription/GetCashbackDefaultValue`);
			}
		}
		export namespace GetStripeCustomerSetupIntent {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Backbone.Web.Controllers.Settings.GetStripeCustomerSetupIntentDto, m.SimpleError>> {
				return Client.get(`/${org}/CommonWeb/Subscription/GetStripeCustomerSetupIntent`);
			}
		}
		export namespace List {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Services.Subscriptions.SubscriptionDto[], m.SimpleError>> {
				return Client.get(`/${org}/CommonWeb/Subscription/List`)
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.Item.Started"}));
			}
		}
		export namespace PreviewBokioPlanChange {
			export function Post(org: string, dto: m.Bokio.Backbone.Web.Controllers.Settings.ChangePricePlanDto): Promise<m.Envelope<m.Bokio.Backbone.Web.Controllers.Settings.PreviewPricePlanChangeResponse, m.Bokio.Backbone.Web.Controllers.Settings.PreviewBokioPlanChangeErrorDto>> {
				return Client.post(`/${org}/CommonWeb/Subscription/PreviewBokioPlanChange`, dto)
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.ConfirmPricePlanChangeData.ProrationEnds"}, {"type":"Date","key":"Data.ConfirmPricePlanChangeData.NewPeriodStart"}, {"type":"Date","key":"Data.ConfirmPricePlanChangeData.NewPeriodEnd"}, {"type":"Date","key":"Data.ConfirmPricePlanChangeData.DiscountEnd"}, {"type":"Date","key":"Data.ConfirmPricePlanChangeData.UpcomingDiscountedPayments.PaymentDate"}, {"type":"Date","key":"Data.ConfirmPricePlanChangeData.AddonProrationDetails.StartDate"}, {"type":"Date","key":"Data.ConfirmPricePlanChangeData.AddonProrationDetails.EndDate"}));
			}
		}
		export namespace PreviewSubscriptionAddons {
			export function Post(org: string, dto: m.Bokio.Backbone.Web.Controllers.Settings.PreviewSubscriptionAddonsDto): Promise<m.Envelope<m.Bokio.Backbone.Web.Controllers.Settings.PreviewSubscriptionAddonsResponseDto, m.Bokio.Backbone.Web.Controllers.Settings.SubscriptionAddonErrorDto>> {
				return Client.post(`/${org}/CommonWeb/Subscription/PreviewSubscriptionAddons`, dto)
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.NextPaymentDate"}));
			}
		}
		export namespace PriceplanState {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Backbone.Web.Controllers.Settings.PriceplansModel, m.SimpleError>> {
				return Client.get(`/${org}/CommonWeb/Subscription/PriceplanState`)
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.Plans.IntervalOptions.Monthly.Discount.OfferValidTo"}, {"type":"Day","key":"Data.Plans.IntervalOptions.Monthly.CashbackContractOffer.OfferValidTo"}, {"type":"Date","key":"Data.Plans.IntervalOptions.Quarterly.Discount.OfferValidTo"}, {"type":"Day","key":"Data.Plans.IntervalOptions.Quarterly.CashbackContractOffer.OfferValidTo"}, {"type":"Date","key":"Data.Plans.IntervalOptions.Yearly.Discount.OfferValidTo"}, {"type":"Day","key":"Data.Plans.IntervalOptions.Yearly.CashbackContractOffer.OfferValidTo"}, {"type":"Day","key":"Data.CurrentPlan.PaidUntil"}, {"type":"Day","key":"Data.CurrentPlan.ActiveCashbackCampaign.CampaignExpires"}, {"type":"Day","key":"Data.CurrentPlan.AppliedDiscount.StartDate"}, {"type":"Day","key":"Data.CurrentPlan.AppliedDiscount.EndDate"}, {"type":"Date","key":"Data.CurrentPlan.AppliedAddons.CloseDate"}, {"type":"Date","key":"Data.CurrentPlan.AppliedAddons.TrialEndDate"}, {"type":"Day","key":"Data.NextPlan.PaidUntil"}, {"type":"Day","key":"Data.NextPlan.ActiveCashbackCampaign.CampaignExpires"}, {"type":"Day","key":"Data.NextPlan.AppliedDiscount.StartDate"}, {"type":"Day","key":"Data.NextPlan.AppliedDiscount.EndDate"}, {"type":"Date","key":"Data.NextPlan.AppliedAddons.CloseDate"}, {"type":"Date","key":"Data.NextPlan.AppliedAddons.TrialEndDate"}, {"type":"Date","key":"Data.BokioStartCampaign.AvailableTo"}));
			}
		}
		export namespace RemoveStripePaymentMethod {
			export function Post(org: string, req: m.Bokio.Billing.Contract.Models.RemoveStripePaymentMethodRequest): Promise<m.Envelope<m.Bokio.Billing.Contract.Models.RemoveStripePaymentMethodResponse, m.SimpleError>> {
				return Client.post(`/${org}/CommonWeb/Subscription/RemoveStripePaymentMethod`, req);
			}
		}
		export namespace SetStripePaymentMethodAsDefault {
			export function Post(org: string, req: m.Bokio.Billing.Contract.Models.SetStripePaymentMethodAsDefaultRequest): Promise<m.Envelope<m.Bokio.Billing.Contract.Models.SetStripePaymentMethodAsDefaultResponse, m.SimpleError>> {
				return Client.post(`/${org}/CommonWeb/Subscription/SetStripePaymentMethodAsDefault`, req);
			}
		}
		export namespace SetupNewSubscription {
			export function Post(org: string, dto: m.Bokio.Backbone.Web.Controllers.Settings.SetUpNewSubscriptionDto): Promise<m.Envelope<m.Bokio.Backbone.Web.Controllers.Settings.BillingSetupSubscriptionViewModel, m.Bokio.Backbone.Web.Controllers.Settings.LoyalCustomerPurchaseError>> {
				return Client.post(`/${org}/CommonWeb/Subscription/SetupNewSubscription`, dto)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.TrialEnds"}));
			}
		}
		export namespace StartAddonTrial {
			export function Post(org: string, request: m.Bokio.Backbone.Web.Controllers.Settings.StartAddonTrialDto): Promise<m.Envelope<m.Bokio.Backbone.Web.Controllers.Settings.StartAddonTrialViewModel, m.Bokio.Backbone.Web.Controllers.Settings.StartAddOnTrialErrorDto>> {
				return Client.post(`/${org}/CommonWeb/Subscription/StartAddonTrial`, request)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.TrialEndDate"}));
			}
		}
		export namespace Status {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Backbone.Web.Controllers.Settings.SubscriptionStatusViewModel, m.SimpleError>> {
				return Client.get(`/${org}/CommonWeb/Subscription/Status`)
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.PrioSupportStarted"}));
			}
		}
		export namespace UserExtendTrial {
			export function Post(org: string, dto: m.Bokio.Backbone.Web.Controllers.Settings.UserExtendTrialDto): Promise<m.Envelope<boolean, m.Model.Commands.Billing.UserExtendTrialError>> {
				return Client.post(`/${org}/CommonWeb/Subscription/UserExtendTrial`, dto);
			}
		}
	}
}
export namespace Bokio.Integration {
	export namespace AiProxyController {
		export namespace Chat {
			export function Post(org: string, request: m.Bokio.Common.Contract.Services.AiProxy.AiFeatureRequest): Promise<m.Envelope<m.Bokio.Common.Contract.Services.AiProxy.AiProxyResponse, m.Bokio.Common.Contract.Services.AiProxy.AiServiceError>> {
				return Client.post(`/${org}/CommonWeb/AiProxy/Chat`, request);
			}
		}
		export namespace ChatWithImage {
			export function Post(org: string, request: m.Bokio.Common.Contract.Services.AiProxy.AiFeatureRequest, file: (File | Blob | string)): Promise<m.Envelope<m.Bokio.Common.Contract.Services.AiProxy.AiProxyResponse, m.Bokio.Common.Contract.Services.AiProxy.AiServiceError>> {
				const form = new FormData();
				form.append("request", JSON.stringify(request));
				form.append("file", file);
				return Client.post(`/${org}/CommonWeb/AiProxy/ChatWithImage`, form, true);
			}
		}
		export namespace SubmitFeedback {
			export function Post(org: string, request: m.Bokio.Common.Contract.Services.AiProxy.AiFeedbackRequestDto): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/CommonWeb/AiProxy/SubmitFeedback`, request);
			}
		}
	}
}
export namespace Bokio.PublicApi.Web {
	export namespace PublicApiIntegrationMarketplaceController {
		export namespace GetCategories {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.PublicApi.Web.Models.IntegrationMarketplaceCategoryDto[], m.SimpleError>> {
				return Client.get(`/${org}/PublicApi/PublicApiIntegrationMarketplace/GetCategories`);
			}
		}
		export namespace GetMarketplaceIntegrationDetail {
			export function Get(org: string, integrationId: string, publishInformationId: string): Promise<m.Envelope<m.Bokio.PublicApi.Web.Models.IntegrationMarketplaceIntegrationDetailDto, m.SimpleError>> {
				return Client.get(`/${org}/PublicApi/PublicApiIntegrationMarketplace/GetMarketplaceIntegrationDetail`, { integrationId, publishInformationId });
			}
		}
		export namespace GetMarketplaceIntegrations {
			export function Get(org: string, category?: m.Entities.PublicApi.IntegrationMarketplaceCategory, searchQuery?: string): Promise<m.Envelope<m.Bokio.PublicApi.Web.Models.IntegrationMarketplaceIntegrationListItemDto[], m.SimpleError>> {
				return Client.get(`/${org}/PublicApi/PublicApiIntegrationMarketplace/GetMarketplaceIntegrations`, { category, searchQuery });
			}
		}
	}
	export namespace PublicApiPrivateIntegrationController {
		export namespace CreatePrivateIntegration {
			export function Post(org: string, request: m.Bokio.PublicApi.Web.Models.CreatePublicApiPrivateIntegrationDto): Promise<m.Envelope<m.Bokio.PublicApi.Web.Models.PublicApiPrivateIntegrationDto, m.SimpleError>> {
				return Client.post(`/${org}/PublicApi/PublicApiPrivateIntegration/CreatePrivateIntegration`, request);
			}
		}
		export namespace DeletePrivateIntegration {
			export function Delete(org: string, connectionId: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client._delete(`/${org}/PublicApi/PublicApiPrivateIntegration/DeletePrivateIntegration`, { connectionId });
			}
		}
		export namespace EditPrivateIntegration {
			export function Post(org: string, request: m.Bokio.PublicApi.Web.Models.EditPublicApiPrivateIntegrationDto): Promise<m.Envelope<m.Bokio.PublicApi.Web.Models.PublicApiPrivateIntegrationDto, m.SimpleError>> {
				return Client.post(`/${org}/PublicApi/PublicApiPrivateIntegration/EditPrivateIntegration`, request);
			}
		}
		export namespace GetAvailableScopes {
			export function Get(): Promise<m.Envelope<m.Bokio.Common.Contract.PublicApi.PublicApiScope[], m.SimpleError>> {
				return Client.get("/PublicApi/PublicApiPrivateIntegration/GetAvailableScopes");
			}
		}
		export namespace GetPrivateIntegrations {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.PublicApi.Web.Models.PublicApiPrivateIntegrationDto[], m.SimpleError>> {
				return Client.get(`/${org}/PublicApi/PublicApiPrivateIntegration/GetPrivateIntegrations`);
			}
		}
	}
	export namespace PublicApiPublicIntegrationController {
		export namespace GetAccessibleCompanies {
			export function Get(): Promise<m.Envelope<m.Bokio.PublicApi.Web.Models.OAuthAccessibleCompanyDto[], m.SimpleError>> {
				return Client.get("/PublicApi/PublicApiPublicIntegration/GetAccessibleCompanies");
			}
		}
		export namespace GetIntegrationInfo {
			export function Get(client_id: string): Promise<m.Envelope<string, m.SimpleError>> {
				return Client.get("/PublicApi/PublicApiPublicIntegration/GetIntegrationInfo", { client_id });
			}
		}
		export namespace GetScopeRequestInfo {
			export function Get(scope: string): Promise<m.Envelope<m.Bokio.Common.Contract.PublicApi.PublicApiScopeRequestInfo[], m.SimpleError>> {
				return Client.get("/PublicApi/PublicApiPublicIntegration/GetScopeRequestInfo", { scope });
			}
		}
	}
}
export namespace Common {
	export namespace AccountantPanelController {
		export namespace Comments {
			export function Get(org: string): Promise<m.Envelope<m.Core.Services.Notes.AgencyCommentDto[], m.SimpleError>> {
				return Client.get(`/${org}/AccountantPanel/Comments`)
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.TimeCreated"}, {"type":"Date","key":"Data.NotificationStatus.StatusUpdateDateTime"}, {"type":"Date","key":"Data.UpdateInfo.NoteUpdateDateTime"}));
			}
		}
		export namespace MarkNotesAsSeen {
			export function Post(org: string, noteIds: string[]): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(Client.getPathWithQueryString(`/${org}/AccountantPanel/MarkNotesAsSeen`, { noteIds }), {  });
			}
		}
		export namespace MarkTaskAsDone {
			export function Post(org: string, noteId: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(Client.getPathWithQueryString(`/${org}/AccountantPanel/MarkTaskAsDone`, { noteId }), {  });
			}
		}
		export namespace NotesCount {
			export function Get(org: string): Promise<m.Envelope<number, m.SimpleError>> {
				return Client.get(`/${org}/AccountantPanel/NotesCount`);
			}
		}
		export namespace Tasks {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.BackOffice.Notes.AgencyTaskDto[], m.SimpleError>> {
				return Client.get(`/${org}/AccountantPanel/Tasks`)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.State.DueDate"}, {"type":"Date","key":"Data.TimeCreated"}, {"type":"Date","key":"Data.NotificationStatus.StatusUpdateDateTime"}, {"type":"Date","key":"Data.UpdateInfo.NoteUpdateDateTime"}));
			}
		}
	}
	export namespace AccountingCheckController {
		export namespace CheckVerificationPatterns {
			export function Get(org: string, from: Day, to: Day): Promise<m.Common.Controllers.CheckVerificationsViewModel> {
				return Client.get(`/${org}/Common/AccountingCheck/CheckVerificationPatterns`, { from, to })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Groups.Verifications.Verification.Date"}, {"type":"Day","key":"Groups.Verifications.Verification.ExpectPaymentAt"}, {"type":"Date","key":"Groups.Verifications.Verification.CreatedUtc"}));
			}
		}
		export namespace GetExpenseBalances {
			export function Get(org: string, from: Day, to: Day): Promise<m.Common.Controllers.BalanceListItem[]> {
				return Client.get(`/${org}/Common/AccountingCheck/GetExpenseBalances`, { from, to })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Date"}));
			}
		}
		export namespace GetSupplierInvoiceBalances {
			export function Get(org: string, from: Day, to: Day): Promise<m.Common.Controllers.BalanceListItem[]> {
				return Client.get(`/${org}/Common/AccountingCheck/GetSupplierInvoiceBalances`, { from, to })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Date"}));
			}
		}
		export namespace LedgerReconcileFromEnableBanking {
			export function Get(org: string, account: number, fromDate: Day, toDate: Day): Promise<m.Envelope<m.Common.Controllers.EnableBankingTransactionListResponse, m.SimpleError>> {
				return Client.get(`/${org}/Common/AccountingCheck/LedgerReconcileFromEnableBanking`, { account, fromDate, toDate })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.Items.Date"}, {"type":"Day","key":"Data.DeletedItems.Date"}, {"type":"Day","key":"Data.ManuallyImportedItems.Date"}));
			}
		}
		export namespace LedgerReconcileOptions {
			export function Get(org: string, account: number): Promise<m.Common.Controllers.LedgerRenconcileOptionsDto> {
				return Client.get(`/${org}/Common/AccountingCheck/LedgerReconcileOptions`, { account });
			}
		}
		export namespace ListRecordingChecks {
			export function Get(org: string): Promise<m.Envelope<m.Common.Controllers.ReceiptCheckForListDto[], m.SimpleError>> {
				return Client.get(`/${org}/Common/AccountingCheck/ListRecordingChecks`)
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.CreatedUtc"}, {"type":"Day","key":"Data.FromDate"}, {"type":"Day","key":"Data.ToDate"}));
			}
		}
		export namespace ParseFileAccountStatement {
			export function Post(org: string, file: (File | Blob | string)): Promise<m.Common.Controllers.ParseFileAccountStatementViewModel> {
				const form = new FormData();
				form.append("file", file);
				return Client.post(`/${org}/Common/AccountingCheck/ParseFileAccountStatement`, form, true);
			}
		}
		export namespace ResolveRecordingCheckIssue {
			export function Post(org: string, dto: m.Common.Controllers.ResolveRecordingCheckErrorDto): Promise<m.Envelope<m.Bokio.Common.Contract.Utils.SuccessResultDto, m.SimpleError>> {
				return Client.post(`/${org}/Common/AccountingCheck/ResolveRecordingCheckIssue`, dto);
			}
		}
		export namespace StartRecordingCheck {
			export function Post(org: string, dto: m.Common.Controllers.StartRecordingCheckDto): Promise<m.Envelope<string, m.SimpleError>> {
				return Client.post(`/${org}/Common/AccountingCheck/StartRecordingCheck`, dto);
			}
		}
		export namespace ViewRecordingCheck {
			export function Get(org: string, id: string): Promise<m.Envelope<m.Common.Controllers.ReceiptCheckDetailsDto, m.SimpleError>> {
				return Client.get(`/${org}/Common/AccountingCheck/ViewRecordingCheck/${id}`)
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.CreatedUtc"}, {"type":"Day","key":"Data.FromDate"}, {"type":"Day","key":"Data.ToDate"}, {"type":"Day","key":"Data.Data.Verifications.Date"}, {"type":"Day","key":"Data.Data.BankTransactions.Date"}));
			}
		}
	}
	export namespace BookkeepingCheckController {
		export namespace AddCheckType {
			export function Post(org: string, id: string, dto: m.Common.Controllers.AddCheckTypeDto): Promise<m.Envelope<m.Bokio.Common.Contract.Utils.SuccessResultDto, m.SimpleError>> {
				return Client.post(`/${org}/Common/BookkeepingCheck/AddCheckType/${id}`, dto);
			}
		}
		export namespace BulkResolveResults {
			export function Post(org: string, dto: m.Common.Controllers.BulkResolveBookkeepingCheckResultsDto): Promise<m.Envelope<m.Bokio.Common.Contract.Utils.SuccessResultDto, m.SimpleError>> {
				return Client.post(`/${org}/Common/BookkeepingCheck/BulkResolveResults`, dto);
			}
		}
		export namespace GetBookkeepingCheckItem {
			export function Get(org: string, id: string, verificationId: string): Promise<m.Envelope<m.Common.Controllers.BookkeepingCheckItemDto, m.SimpleError>> {
				return Client.get(`/${org}/Common/BookkeepingCheck/GetBookkeepingCheckItem/${id}`, { verificationId })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.Date"}));
			}
		}
		export namespace ListBookkeepingChecks {
			export function Get(org: string): Promise<m.Envelope<m.Common.Controllers.BookkeepingCheckForListDto[], m.SimpleError>> {
				return Client.get(`/${org}/Common/BookkeepingCheck/ListBookkeepingChecks`)
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.CreatedUtc"}, {"type":"Day","key":"Data.FromDate"}, {"type":"Day","key":"Data.ToDate"}));
			}
		}
		export namespace PreviewBookkeepingCheck {
			export function Get(org: string, fromDate: Date, toDate: Date): Promise<m.Envelope<m.Common.Controllers.PreviewBookkeepingCheckDto, m.SimpleError>> {
				return Client.get(`/${org}/Common/BookkeepingCheck/PreviewBookkeepingCheck`, { fromDate, toDate });
			}
		}
		export namespace RecheckVerification {
			export function Post(org: string, dto: m.Common.Controllers.RecheckVerificationDto): Promise<m.Envelope<m.Common.Controllers.RecheckVerificationResultDto, m.SimpleError>> {
				return Client.post(`/${org}/Common/BookkeepingCheck/RecheckVerification`, dto);
			}
		}
		export namespace RequestLlmAnalysis {
			export function Get(org: string, id: string): Promise<m.Envelope<m.Bokio.Common.Contract.Utils.SuccessResultDto, m.SimpleError>> {
				return Client.get(`/${org}/Common/BookkeepingCheck/RequestLlmAnalysis/${id}`);
			}
		}
		export namespace ResolveResult {
			export function Post(org: string, dto: m.Common.Controllers.ResolveBookkeepingCheckResultDto): Promise<m.Envelope<m.Bokio.Common.Contract.Utils.SuccessResultDto, m.SimpleError>> {
				return Client.post(`/${org}/Common/BookkeepingCheck/ResolveResult`, dto);
			}
		}
		export namespace StartBookkeepingCheck {
			export function Post(org: string, dto: m.Common.Controllers.StartBookkeepingCheckDto): Promise<m.Envelope<string, m.SimpleError>> {
				return Client.post(`/${org}/Common/BookkeepingCheck/StartBookkeepingCheck`, dto);
			}
		}
		export namespace UpdateBookkeepingCheck {
			export function Get(org: string, id: string): Promise<m.Envelope<m.Bokio.Common.Contract.Utils.SuccessResultDto, m.SimpleError>> {
				return Client.get(`/${org}/Common/BookkeepingCheck/UpdateBookkeepingCheck/${id}`);
			}
		}
		export namespace ViewBookkeepingCheck {
			export function Get(org: string, id: string): Promise<m.Envelope<m.Common.Controllers.BookkeepingCheckDetailsDto, m.SimpleError>> {
				return Client.get(`/${org}/Common/BookkeepingCheck/ViewBookkeepingCheck/${id}`)
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.CreatedUtc"}, {"type":"Day","key":"Data.FromDate"}, {"type":"Day","key":"Data.ToDate"}, {"type":"Day","key":"Data.Items.Date"}));
			}
		}
	}
	export namespace BookkeepingCheckIntegrationTestSetupController {
		export namespace InjectFakeLlmPassResults {
			export function Post(org: string, dto: m.Common.Controllers.InjectFakeLlmPassResultsDto): Promise<boolean> {
				return Client.post(`/${org}/Common/BookkeepingCheckIntegrationTestSetup/InjectFakeLlmPassResults`, dto);
			}
		}
		export namespace SetupBookkeepingCheckTestData {
			export function Post(org: string): Promise<m.Common.Controllers.BookkeepingCheckTestSetupResult> {
				return Client.post(`/${org}/Common/BookkeepingCheckIntegrationTestSetup/SetupBookkeepingCheckTestData`, {  })
				             .then(data => convertByKeys(data, {"type":"Date","key":"FromDate"}, {"type":"Date","key":"ToDate"}));
			}
		}
	}
	export namespace CountryController {
		export namespace GetAllCountries {
			export function Get(): Promise<m.Envelope<m.Bokio.Common.Contract.Internationalization.GetCountriesResult, m.SimpleError>> {
				return Client.get("/Common/Country/GetAllCountries")
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.Countries.CountrySubdivisions.EUMembershipHistory.Entry"}, {"type":"Date","key":"Data.Countries.CountrySubdivisions.EUMembershipHistory.Exit"}));
			}
		}
		export namespace GetCountries {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Common.Contract.Internationalization.GetCountriesResult, m.SimpleError>> {
				return Client.get(`/${org}/Common/Country/GetCountries`)
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.Countries.CountrySubdivisions.EUMembershipHistory.Entry"}, {"type":"Date","key":"Data.Countries.CountrySubdivisions.EUMembershipHistory.Exit"}));
			}
		}
	}
	export namespace FeatureRequestController {
		export namespace Add {
			export function Post(request: m.Bokio.Common.Contract.Requests.FeatureRequests.AddFeatureRequest): Promise<m.Envelope<string, m.SimpleError>> {
				return Client.post("/Common/FeatureRequest/Add", request);
			}
		}
		export namespace List {
			export function Get(search: string, showMine: boolean): Promise<m.Envelope<m.Contracts.FeatureRequests.FeatureRequestDto[], m.SimpleError>> {
				return Client.get("/Common/FeatureRequest/List", { search, showMine })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.CreatedAtDate"}, {"type":"Day","key":"Data.DuplicateOf.CreatedAtDate"}, {"type":"Day","key":"Data.DuplicateOf.DuplicateOf.CreatedAtDate"}, {"type":"Day","key":"Data.DuplicateOf.DuplicateOf.DuplicateOf.CreatedAtDate"}, {"type":"Day","key":"Data.DuplicateOf.DuplicateOf.DuplicateOf.DuplicateOf.CreatedAtDate"}));
			}
		}
		export namespace RemoveVote {
			export function Post(request: m.Bokio.Common.Contract.Requests.FeatureRequests.RemoveVoteForFeatureRequest): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post("/Common/FeatureRequest/RemoveVote", request);
			}
		}
		export namespace Vote {
			export function Post(request: m.Bokio.Common.Contract.Requests.FeatureRequests.VoteForFeatureRequest): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post("/Common/FeatureRequest/Vote", request);
			}
		}
	}
	export namespace ImportantDateController {
		export namespace CountOverdueOrDueWithin7Days {
			export function Get(org: string): Promise<number> {
				return Client.get(`/${org}/Common/ImportantDate/CountOverdueOrDueWithin7Days`);
			}
		}
		export namespace CreateCalendarSubscription {
			export function Post(org: string): Promise<m.Envelope<m.Bokio.Common.Contract.ViewData.CalendarSubscriptionViewModel, m.SimpleError>> {
				return Client.post(`/${org}/Common/ImportantDate/CreateCalendarSubscription`, {  })
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.CreatedUtc"}));
			}
		}
		export namespace GetCalendarSubscription {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Common.Contract.ViewData.CalendarSubscriptionViewModel, m.SimpleError>> {
				return Client.get(`/${org}/Common/ImportantDate/GetCalendarSubscription`)
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.CreatedUtc"}));
			}
		}
		export namespace ImportantDatesSetup {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Common.Services.ImportantDates.ImportantDatesSetupDto, m.SimpleError>> {
				return Client.get(`/${org}/Common/ImportantDate/ImportantDatesSetup`);
			}
		}
		export namespace ImportantDatesSetupAnswer {
			export function Post(org: string, answer: m.Bokio.Common.Services.ImportantDates.ImportantDatesSetupAnswerDto): Promise<m.Envelope<m.Bokio.Common.Services.ImportantDates.ImportantDatesSetupDto, m.SimpleError>> {
				return Client.post(`/${org}/Common/ImportantDate/ImportantDatesSetupAnswer`, answer);
			}
		}
		export namespace ImportantDatesSetupGoBack {
			export function Post(org: string): Promise<m.Envelope<m.Bokio.Common.Services.ImportantDates.ImportantDatesSetupDto, m.SimpleError>> {
				return Client.post(`/${org}/Common/ImportantDate/ImportantDatesSetupGoBack`, {  });
			}
		}
		export namespace ImportantDatesSetupReset {
			export function Post(org: string): Promise<m.Envelope<m.Bokio.Common.Services.ImportantDates.ImportantDatesSetupDto, m.SimpleError>> {
				return Client.post(`/${org}/Common/ImportantDate/ImportantDatesSetupReset`, {  });
			}
		}
		export namespace List {
			export function Get(org: string, searchTerm: string, showHidden: boolean, showCompleted: boolean, startDate?: Date): Promise<m.Envelope<m.Core.ViewData.ImportantDateViewModel[], m.Common.Controllers.ListImportantDateErrorInfo>> {
				return Client.get(`/${org}/Common/ImportantDate`, { searchTerm, showHidden, showCompleted, startDate })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.Date"}, {"type":"Day","key":"Data.PeriodStart"}, {"type":"Day","key":"Data.PeriodEnd"}, {"type":"Day","key":"Error.StartDate"}, {"type":"Day","key":"Error.EndDate"}, {"type":"Day","key":"Error.CurrentDate"}));
			}
		}
		export namespace RevokeCalendarSubscription {
			export function Post(org: string): Promise<m.Envelope<m.Bokio.Common.Contract.ViewData.CalendarSubscriptionViewModel, m.SimpleError>> {
				return Client.post(`/${org}/Common/ImportantDate/RevokeCalendarSubscription`, {  })
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.CreatedUtc"}));
			}
		}
		export namespace SetState {
			export function Post(org: string, command: m.Model.Commands.ImportantDate.SetImportantDateStateCommand): Promise<m.Core.ViewData.ImportantDateViewModel> {
				return Client.post(`/${org}/Common/ImportantDate/SetState`, command)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Date"}, {"type":"Day","key":"PeriodStart"}, {"type":"Day","key":"PeriodEnd"}));
			}
		}
		export namespace ToggleHide {
			export function Post(org: string, command: m.Model.Commands.ImportantDate.ToggleHideImportantDateCommand): Promise<m.Core.ViewData.ImportantDateViewModel> {
				return Client.post(`/${org}/Common/ImportantDate/ToggleHide`, command)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Date"}, {"type":"Day","key":"PeriodStart"}, {"type":"Day","key":"PeriodEnd"}));
			}
		}
		export namespace ToggleHideCategory {
			export function Post(org: string, command: m.Model.Commands.ImportantDate.ToggleHideCategoryCommand): Promise<m.Core.ViewData.ImportantDateViewModel> {
				return Client.post(`/${org}/Common/ImportantDate/ToggleHideCategory`, command)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Date"}, {"type":"Day","key":"PeriodStart"}, {"type":"Day","key":"PeriodEnd"}));
			}
		}
		export namespace ValidateFiscalYearSettings {
			export function Get(org: string): Promise<m.Envelope<m.Core.ViewData.FiscalYearSettingValidationResult, m.SimpleError>> {
				return Client.get(`/${org}/Common/ImportantDate/ValidateFiscalYearSettings`);
			}
		}
	}
	export namespace InboxMessagesController {
		export namespace Approve {
			export function Post(org: string, id: string): Promise<m.Envelope<m.Common.ViewModels.InboxMessageDetailsViewModel, m.SimpleError>> {
				return Client.post(`/${org}/Common/InboxMessages/Approve/${id}`, {  })
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.TimeStamp"}));
			}
		}
		export namespace Details {
			export function Get(org: string, id: string): Promise<m.Envelope<m.Common.ViewModels.InboxMessageDetailsViewModel, m.SimpleError>> {
				return Client.get(`/${org}/Common/InboxMessages/Details/${id}`)
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.TimeStamp"}));
			}
		}
		export namespace List {
			export function Get(org: string, filter: m.Common.ViewModels.InboxHistoryFilter): Promise<m.Envelope<m.Common.ViewModels.InboxHistoryViewModel, m.SimpleError>> {
				return Client.get(`/${org}/Common/InboxMessages`, { filter })
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.Items.Message.TimeStamp"}));
			}
		}
		export namespace Reject {
			export function Post(org: string, id: string): Promise<m.Envelope<m.Common.ViewModels.InboxMessageDetailsViewModel, m.SimpleError>> {
				return Client.post(`/${org}/Common/InboxMessages/Reject/${id}`, {  })
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.TimeStamp"}));
			}
		}
	}
	export namespace PreliminaryTaxesController {
		export namespace AddManualTaxPayment {
			export function Post(org: string, dto: m.Common.Controllers.AddManualTaxPaymentDto): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Common/PreliminaryTaxes/AddManualTaxPayment`, dto);
			}
		}
		export namespace AddPreliminaryTaxes {
			export function Post(org: string, dto: m.Common.Controllers.AddPreliminaryTaxesDto): Promise<m.Envelope<m.Bokio.Common.Contract.PreliminaryTaxes.PreliminaryTaxesViewModel, m.SimpleError>> {
				return Client.post(`/${org}/Common/PreliminaryTaxes/AddPreliminaryTaxes`, dto)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.TaxDates.Date"}, {"type":"Day","key":"Data.TaxDates.Payments.Date"}));
			}
		}
		export namespace GetPreliminaryTaxes {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Common.Contract.PreliminaryTaxes.PreliminaryTaxesViewModel[], m.SimpleError>> {
				return Client.get(`/${org}/Common/PreliminaryTaxes/GetPreliminaryTaxes`)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.TaxDates.Date"}, {"type":"Day","key":"Data.TaxDates.Payments.Date"}));
			}
		}
		export namespace GetPreliminaryTaxPaymentDetails {
			export function Get(org: string, id: string): Promise<m.Envelope<m.Bokio.Common.Contract.PreliminaryTaxes.PreliminaryTaxDateViewModel, m.SimpleError>> {
				return Client.get(`/${org}/Common/PreliminaryTaxes/GetPreliminaryTaxPaymentDetails/${id}`)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.Date"}, {"type":"Day","key":"Data.Payments.Date"}));
			}
		}
		export namespace RemoveManualTaxPayment {
			export function Post(org: string, id: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Common/PreliminaryTaxes/RemoveManualTaxPayment/${id}`, {  });
			}
		}
		export namespace UpdatePreliminaryTaxes {
			export function Post(org: string, dto: m.Common.Controllers.UpdateTaxPaymentsDto): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Common/PreliminaryTaxes/UpdatePreliminaryTaxes`, dto);
			}
		}
	}
	export namespace PromotionController {
		export namespace Complete {
			export function Post(org: string, request: m.Model.Commands.Promotions.CompletePromotion): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Common/Promotion/Complete`, request);
			}
		}
		export namespace NotInterested {
			export function Post(org: string, request: m.Model.Commands.Promotions.NotInterestedInPromotion): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Common/Promotion/NotInterested`, request);
			}
		}
		export namespace Postpone {
			export function Post(org: string, request: m.Model.Commands.Promotions.PostponePromotion): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Common/Promotion/Postpone`, request);
			}
		}
	}
	export namespace ResearchController {
		export namespace AnswerResearchQuestion {
			export function Post(dto: m.Bokio.Common.Contract.Research.AnswerResearchQuestionDto): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post("/Common/Research/AnswerResearchQuestion", dto);
			}
		}
		export namespace GetResearchQuestion {
			export function Get(dto: m.Bokio.Common.Contract.Research.ResearchQuestionDto): Promise<m.Envelope<m.Bokio.Common.Contract.Research.ResearchQuestionViewModel, m.SimpleError>> {
				return Client.get("/Common/Research/GetResearchQuestion", { dto });
			}
		}
	}
	export namespace ToDoController {
		export namespace CompleteCustomItem {
			export function Post(org: string, todoItemId: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Common/ToDo/CompleteCustomItem`, { todoItemId });
			}
		}
		export namespace Count {
			export function Get(org: string): Promise<m.Envelope<m.Common.ViewModels.ToDoCountViewModel, m.SimpleError>> {
				return Client.get(`/${org}/Common/ToDo/Count`);
			}
		}
		export namespace CreateCustomTodoItem {
			export function Post(org: string, request: m.Common.Controllers.CreateCustomTodoItemRequest): Promise<m.Envelope<string, m.SimpleError>> {
				return Client.post(`/${org}/Common/ToDo/CreateCustomTodoItem`, request);
			}
		}
		export namespace CreateRecurringCustomTodo {
			export function Post(org: string, request: m.Common.Controllers.CreateRecurringCustomTodoRequest): Promise<m.Envelope<string, m.SimpleError>> {
				return Client.post(`/${org}/Common/ToDo/CreateRecurringCustomTodo`, request);
			}
		}
		export namespace DismissItem {
			export function Post(org: string, todoItemId: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Common/ToDo/DismissItem`, { todoItemId });
			}
		}
		export namespace EditCustomTodoItem {
			export function Post(org: string, id: string, data: m.Classes.Todo.CustomTodoData): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Common/ToDo/EditCustomTodoItem`, { id, data });
			}
		}
		export namespace List {
			export function Get(org: string): Promise<m.Envelope<m.Core.Contracts.Todo.TodoItemDto[], m.SimpleError>> {
				return Client.get(`/${org}/Common/ToDo`)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.Date"}, {"type":"Day","key":"Data.TypedData.CustomTodoData.DueDate"}, {"type":"Day","key":"Data.TypedData.CustomTodoData.StartDate"}, {"type":"Day","key":"Data.TypedData.CheckMissingTransactionsTodoData.StartDate"}, {"type":"Day","key":"Data.TypedData.CheckMissingTransactionsTodoData.EndDate"}, {"type":"Day","key":"Data.TypedData.AnnualReportSubmissionTodoData.StartDate"}, {"type":"Day","key":"Data.TypedData.AnnualReportSubmissionTodoData.EndDate"}, {"type":"Day","key":"Data.TypedData.AnnualReportSubmissionTodoData.DueDate"}, {"type":"Day","key":"Data.Matches.Date"}, {"type":"Day","key":"Data.Matches.Data.Date"}, {"type":"Date","key":"Data.DueDate"}));
			}
		}
		export namespace ListCompletedCustomTodos {
			export function Get(org: string, days: number): Promise<m.Envelope<m.Core.Contracts.Todo.TodoItemDto[], m.SimpleError>> {
				return Client.get(`/${org}/Common/ToDo/ListCompletedCustomTodos`, { days })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.Date"}, {"type":"Day","key":"Data.TypedData.CustomTodoData.DueDate"}, {"type":"Day","key":"Data.TypedData.CustomTodoData.StartDate"}, {"type":"Day","key":"Data.TypedData.CheckMissingTransactionsTodoData.StartDate"}, {"type":"Day","key":"Data.TypedData.CheckMissingTransactionsTodoData.EndDate"}, {"type":"Day","key":"Data.TypedData.AnnualReportSubmissionTodoData.StartDate"}, {"type":"Day","key":"Data.TypedData.AnnualReportSubmissionTodoData.EndDate"}, {"type":"Day","key":"Data.TypedData.AnnualReportSubmissionTodoData.DueDate"}, {"type":"Day","key":"Data.Matches.Date"}, {"type":"Day","key":"Data.Matches.Data.Date"}, {"type":"Date","key":"Data.DueDate"}));
			}
		}
		export namespace UpdateTasksItem {
			export function Post(org: string, noteId: string, taskStatus: m.Entities.Partners.WorkStatusType): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Common/ToDo/UpdateTasksItem`, { noteId, taskStatus });
			}
		}
	}
	export namespace UserPreferencesController {
		export namespace GetPreference {
			export function Get(org: string, type: m.Entities.UserPreferenceType): Promise<m.Envelope<m.Bokio.Common.Contract.Services.UserPreferences.UserPreferencesDto, m.SimpleError>> {
				return Client.get(`/${org}/Common/UserPreferences/GetPreference`, { type })
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.BbaKycModalDismissedPreference.Value"}, {"type":"Date","key":"Data.LastReadWhatsNewDatePreference.Value"}));
			}
		}
		export namespace GetUserPreference {
			export function Get(type: m.Entities.UserPreferenceType): Promise<m.Envelope<m.Bokio.Common.Contract.Services.UserPreferences.UserPreferencesDto, m.SimpleError>> {
				return Client.get("/Common/UserPreferences/GetUserPreference", { type })
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.BbaKycModalDismissedPreference.Value"}, {"type":"Date","key":"Data.LastReadWhatsNewDatePreference.Value"}));
			}
		}
		export namespace SetPreference {
			export function Post(org: string, type: m.Entities.UserPreferenceType, isCompanySpecific: boolean, value: m.Bokio.Common.Contract.Services.UserPreferences.UserPreferencesDto): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Common/UserPreferences/SetPreference`, { type, isCompanySpecific, value });
			}
		}
		export namespace SetUserPreference {
			export function Post(request: m.Common.Controllers.SetPreferenceRequest): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post("/Common/UserPreferences/SetUserPreference", request);
			}
		}
	}
}
export namespace Feedback {
	export namespace FeatureInterestController {
		export namespace ShowInterest {
			export function Post(org: string, request: m.Feedback.Models.ShowInterestDto): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Feedback/FeatureInterest/ShowInterest`, request);
			}
		}
	}
	export namespace NPSCollectorController {
		export namespace SetRating {
			export function Post(command: m.Model.Commands.Feedback.SetNPSRating): Promise<m.Envelope<string, m.Feedback.Controllers.SetRatingErrors>> {
				return Client.post("/Feedback/NPSCollector/SetRating", command);
			}
		}
		export namespace ShouldRate {
			export function Get(): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.get("/Feedback/NPSCollector/ShouldRate");
			}
		}
	}
	export namespace RatingController {
		export namespace HasUserRated {
			export function Get(org: string, type: m.Entities.Feedback.RatingType): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.get(`/${org}/Feedback/Rating/HasUserRated`, { type });
			}
		}
		export namespace Rate {
			export function Post(org: string, rating: m.Bokio.Common.Contract.Metrics.Feedback.Dtos.RatingDto): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Feedback/Rating/Rate`, rating);
			}
		}
	}
	export namespace SignUpSurveyController {
		export namespace SaveSurveyResponse {
			export function Post(org: string, request: m.Feedback.Models.SignUpSurveyDto): Promise<m.Envelope<boolean, m.Feedback.Controllers.SurveyError>> {
				return Client.post(`/${org}/Feedback/SignUpSurvey/SaveSurveyResponse`, request);
			}
		}
	}
}
export namespace Invoices {
	export namespace AlienInvoiceController {
		export namespace Create {
			export function Post(org: string, request: m.Invoices.Contract.Commands.InvoiceCommands.CreateAlienInvoiceCommand): Promise<m.Envelope<string, m.Core.ViewData.AlienInvoiceError[]>> {
				return Client.post(`/${org}/Invoices/AlienInvoice/Create`, request);
			}
		}
		export namespace Delete {
			export function Post(org: string, request: m.Invoices.Contract.Commands.InvoiceCommands.DeleteAlienInvoiceCommand): Promise<m.Envelope<boolean, m.Invoices.Controllers.DeleteAlienInvoiceError>> {
				return Client.post(`/${org}/Invoices/AlienInvoice/Delete`, request);
			}
		}
		export namespace Edit {
			export function Post(org: string, request: m.Invoices.Contract.Commands.InvoiceCommands.EditAlienInvoiceCommand): Promise<m.Envelope<string, m.Core.ViewData.AlienInvoiceError[]>> {
				return Client.post(`/${org}/Invoices/AlienInvoice/Edit`, request);
			}
		}
		export namespace Get {
			export function Get(org: string, id: string): Promise<m.Envelope<m.Invoices.Contract.ViewData.AlienInvoiceForView, m.SimpleError>> {
				return Client.get(`/${org}/Invoices/AlienInvoice/Get/${id}`)
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.InvoiceDate"}, {"type":"Date","key":"Data.Deadline"}));
			}
		}
		export namespace List {
			export function Get(org: string): Promise<m.Envelope<m.Invoices.ViewModels.AlienInvoiceForList[], m.SimpleError>> {
				return Client.get(`/${org}/Invoices/AlienInvoice/List`)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.InvoiceDate"}, {"type":"Day","key":"Data.Deadline"}));
			}
		}
	}
	export namespace ArticleController {
		export namespace AddArticle {
			export function Post(org: string, request: m.Bokio.Sales.Web.ViewModels.AddArticleDto): Promise<m.Invoices.ViewModels.ArticleForList> {
				return Client.post(`/${org}/Invoices/Article/AddArticle`, request);
			}
		}
		export namespace DeleteArticle {
			export function Post(org: string, request: m.Invoices.Contract.Commands.Articles.DeleteArticle): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Invoices/Article/DeleteArticle`, request);
			}
		}
		export namespace DeleteImport {
			export function Post(org: string, importId: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Invoices/Article/DeleteImport`, { importId });
			}
		}
		export namespace GetArticle {
			export function Get(org: string, id: string): Promise<m.Invoices.ViewModels.ArticleForList> {
				return Client.get(`/${org}/Invoices/Article/GetArticle/${id}`);
			}
		}
		export namespace GetDeleteImportPreview {
			export function Get(org: string, importId: string): Promise<m.Envelope<m.Invoices.Controllers.DeleteImportPreviewDto, m.SimpleError>> {
				return Client.get(`/${org}/Invoices/Article/GetDeleteImportPreview`, { importId });
			}
		}
		export namespace GetPossibleArticleAccounts {
			export function Get(org: string, vatRate: number, invoiceRowKind: m.Entities.Invoices.InvoiceRowKind): Promise<m.Envelope<m.Classes.AccountBase[], m.SimpleError>> {
				return Client.get(`/${org}/Invoices/Article/GetPossibleArticleAccounts`, { vatRate, invoiceRowKind });
			}
		}
		export namespace List {
			export function Get(org: string, request: m.Invoices.Controllers.ListRequest): Promise<m.Envelope<m.Invoices.ViewModels.ArticleForList[], m.SimpleError>> {
				return Client.get(`/${org}/Invoices/Article/List`, { request });
			}
		}
		export namespace ListImports {
			export function Get(org: string): Promise<m.Envelope<m.Invoices.Controllers.ArticleImportDto[], m.SimpleError>> {
				return Client.get(`/${org}/Invoices/Article/ListImports`)
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.ImportDate"}));
			}
		}
		export namespace UpdateArticle {
			export function Post(org: string, request: m.Invoices.Contract.Commands.Articles.UpdateArticle): Promise<m.Invoices.ViewModels.ArticleForList> {
				return Client.post(`/${org}/Invoices/Article/UpdateArticle`, request);
			}
		}
	}
	export namespace BookkeepInvoiceController {
		export namespace BookkeepInvoice {
			export function Post(org: string, request: m.Invoices.Contract.Commands.BookkeepCommands.BookkeepInvoiceCommand): Promise<m.Core.Recipes.RegisteredRecipeResult> {
				return Client.post(`/${org}/Invoices/BookkeepInvoice/BookkeepInvoice`, request);
			}
		}
		export namespace BookkeepInvoiceFinancing {
			export function Post(org: string, request: m.Invoices.Contract.Commands.BookkeepCommands.BookkeepInvoiceFinancing): Promise<m.Core.Recipes.RegisteredRecipeResult> {
				return Client.post(`/${org}/Invoices/BookkeepInvoice/BookkeepInvoiceFinancing`, request);
			}
		}
		export namespace BookkeepInvoiceSettlement {
			export function Post(org: string, request: m.Model.Commands.Invoices.BookkeepCommands.BookkeepInvoiceSettlementCommand): Promise<m.Core.Recipes.RegisteredRecipeResult> {
				return Client.post(`/${org}/Invoices/BookkeepInvoice/BookkeepInvoiceSettlement`, request);
			}
		}
		export namespace BookkeepPayment {
			export function Post(org: string, request: m.Invoices.Contract.Commands.BookkeepCommands.BookkeepPaymentCommand): Promise<m.Core.Recipes.RegisteredRecipeResult> {
				return Client.post(`/${org}/Invoices/BookkeepInvoice/BookkeepPayment`, request);
			}
		}
		export namespace BookkeepReminder {
			export function Post(org: string, request: m.Invoices.Contract.Commands.BookkeepCommands.BookkeepReminderCommand): Promise<m.Core.Recipes.RegisteredRecipeResult> {
				return Client.post(`/${org}/Invoices/BookkeepInvoice/BookkeepReminder`, request);
			}
		}
		export namespace List {
			export function Get(org: string, id?: string): Promise<m.Contracts.Invoices.InvoiceItemToBookkeep[]> {
				return Client.get(`/${org}/Invoices/BookkeepInvoice/List/${id}`)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Date"}));
			}
		}
	}
	export namespace CompanyController {
		export namespace ClearCompanyImage {
			export function Post(org: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Invoices/Company/ClearCompanyImage`, {  });
			}
		}
		export namespace GetActiveDecisionForAutomaticChecking {
			export function Get(org: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.get(`/${org}/Invoices/Company/GetActiveDecisionForAutomaticChecking`);
			}
		}
		export namespace GetAutomaticChecking {
			export function Get(org: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.get(`/${org}/Invoices/Company/GetAutomaticChecking`);
			}
		}
		export namespace GetCompanyInvoiceData {
			export function Get(org: string): Promise<m.Envelope<m.Entities.CompanyInvoiceData, m.SimpleError>> {
				return Client.get(`/${org}/Invoices/Company/GetCompanyInvoiceData`);
			}
		}
		export namespace PaymentMethods {
			export function Get(org: string): Promise<m.Invoices.Controllers.InvoicePaymentMethodTemplatesViewModel> {
				return Client.get(`/${org}/Invoices/Company/PaymentMethods`);
			}
		}
		export namespace RotateCompanyImage {
			export function Post(org: string): Promise<m.Envelope<m.Invoices.ViewModels.UploadCompanyImageResult, m.SimpleError>> {
				return Client.post(`/${org}/Invoices/Company/RotateCompanyImage`, {  });
			}
		}
		export namespace SetCompanyAddressPosition {
			export function Post(org: string, request: m.Invoices.Contract.Commands.CompanyCommands.SetCompanyAddressPosition): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Invoices/Company/SetCompanyAddressPosition`, request);
			}
		}
		export namespace SetCompanyColor {
			export function Post(org: string, request: m.Invoices.Contract.Commands.CompanyCommands.SetCompanyColor): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Invoices/Company/SetCompanyColor`, request);
			}
		}
		export namespace SetCompanyInvoiceData {
			export function Post(org: string, request: m.Invoices.Contract.Commands.CompanyCommands.SetCompanyInvoiceData): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Invoices/Company/SetCompanyInvoiceData`, request);
			}
		}
		export namespace SetCompanyInvoiceNumber {
			export function Post(org: string, request: m.Invoices.Contract.Commands.CompanyCommands.SetCompanyInvoiceNumber): Promise<m.Envelope<number, m.Invoices.ViewModels.SetInvoiceNumberError>> {
				return Client.post(`/${org}/Invoices/Company/SetCompanyInvoiceNumber`, request);
			}
		}
		export namespace SetCompanyQuoteNumber {
			export function Post(org: string, request: m.Invoices.Contract.Commands.CompanyCommands.SetCompanyQuoteNumber): Promise<m.Envelope<number, m.Invoices.ViewModels.SetInvoiceNumberError>> {
				return Client.post(`/${org}/Invoices/Company/SetCompanyQuoteNumber`, request);
			}
		}
		export namespace SetStartingNumbers {
			export function Post(org: string, request: m.Invoices.Contract.Commands.CompanyCommands.SetStartingNumbers): Promise<m.Envelope<boolean, string[]>> {
				return Client.post(`/${org}/Invoices/Company/SetStartingNumbers`, request);
			}
		}
		export namespace StartingNumbers {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Common.Contract.ViewData.CompanyInvoicingNumber, m.SimpleError>> {
				return Client.get(`/${org}/Invoices/Company/StartingNumbers`);
			}
		}
		export namespace UpdateAutomaticChecking {
			export function Post(org: string, request: m.Invoices.Contract.Commands.CompanyCommands.UpdateAutomaticChecking): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Invoices/Company/UpdateAutomaticChecking`, request);
			}
		}
		export namespace UploadCompanyImage {
			export function Post(org: string, image: (File | Blob | string)): Promise<m.Envelope<m.Invoices.ViewModels.UploadCompanyImageResult, m.SimpleError>> {
				const form = new FormData();
				form.append("image", image);
				return Client.post(`/${org}/Invoices/Company/UploadCompanyImage`, form, true);
			}
		}
	}
	export namespace CreditInvoiceController {
		export namespace ConnectInvoice {
			export function Post(org: string, command: m.Invoices.Contract.Commands.CreditInvoices.ConnectCreditInvoiceCommand): Promise<m.Envelope<m.Invoices.Contract.ViewData.InvoiceForView, m.SimpleError>> {
				return Client.post(`/${org}/Invoices/CreditInvoice/ConnectInvoice`, command)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.Deadline"}, {"type":"Day","key":"Data.InvoiceDate"}, {"type":"CountrySubdivision","key":"Data.SenderData.CountrySubdivision"}, {"type":"Date","key":"Data.Created"}, {"type":"Date","key":"Data.RotRut.PublishedClaimDate"}, {"type":"Day","key":"Data.InvoicePeriod.StartDate"}, {"type":"Day","key":"Data.InvoicePeriod.EndDate"}, {"type":"Day","key":"Data.TemplateRecurringInvoice.StartedDate"}));
			}
		}
		export namespace GetStandaloneCreditNoteInAgeDebtorsValue {
			export function Get(org: string, invoiceId: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.get(`/${org}/Invoices/CreditInvoice/GetStandaloneCreditNoteInAgeDebtorsValue`, { invoiceId });
			}
		}
		export namespace InvoicesForConnection {
			export function Get(org: string): Promise<m.Invoices.Controllers.InvoiceForConnection[]> {
				return Client.get(`/${org}/Invoices/CreditInvoice/InvoicesForConnection`);
			}
		}
		export namespace ToggleStandaloneCreditNoteInAgeDebtors {
			export function Post(org: string, command: m.Invoices.Contract.Commands.CreditInvoices.ToggleStandaloneCreditNoteInAgeDebtorsCommand): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Invoices/CreditInvoice/ToggleStandaloneCreditNoteInAgeDebtors`, command);
			}
		}
	}
	export namespace CustomerController {
		export namespace AccountsReceivable {
			export function Get(org: string, date: Day): Promise<m.Invoices.Contract.ViewData.AccountsReceivableResult> {
				return Client.get(`/${org}/Invoices/Customer/AccountsReceivable`, { date })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Customers.Invoices.InvoiceDate"}, {"type":"Day","key":"Customers.Invoices.Deadline"}));
			}
		}
		export namespace Create {
			export function Post(org: string, request: m.Invoices.Contract.Commands.CustomerCommands.CreateCustomer): Promise<m.Envelope<m.Invoices.ViewModels.CustomerForView, m.Invoices.ViewModels.CreateCustomerError>> {
				return Client.post(`/${org}/Invoices/Customer/Create`, request);
			}
		}
		export namespace CustomerDetails {
			export function Get(org: string, id: string): Promise<m.Envelope<m.Invoices.Controllers.CustomerDetailsViewModel, m.SimpleError>> {
				return Client.get(`/${org}/Invoices/Customer/CustomerDetails/${id}`)
				             .then(data => convertByKeys(data, {"type":"CountrySubdivision","key":"Data.DefaultInvoiceSenderData.CountrySubdivision"}));
			}
		}
		export namespace Delete {
			export function Post(org: string, request: m.Invoices.Contract.Commands.CustomerCommands.DeleteCustomer): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Invoices/Customer/Delete`, request);
			}
		}
		export namespace EditFullReceiverData {
			export function Post(org: string, request: m.Invoices.Contract.Commands.CustomerCommands.EditFullReceiverData): Promise<m.Envelope<m.Invoices.ViewModels.CustomerForView, m.Invoices.ViewModels.CreateCustomerError>> {
				return Client.post(`/${org}/Invoices/Customer/EditFullReceiverData`, request);
			}
		}
		export namespace Get {
			export function Get(org: string, id: string): Promise<m.Envelope<m.Entities.Invoices.Customer, string>> {
				return Client.get(`/${org}/Invoices/Customer/Get/${id}`)
				             .then(data => convertByKeys(data, {"type":"CountrySubdivision","key":"Data.DefaultInvoiceSenderData.CountrySubdivision"}));
			}
		}
		export namespace List {
			export function Get(org: string, pagination?: m.Bokio.Common.Contract.Pagination.Pagination): Promise<m.Envelope<m.Invoices.Controllers.CustomerListResponse, m.SimpleError>> {
				return Client.get(`/${org}/Invoices/Customer/List`, { pagination });
			}
		}
		export namespace ListBasicDetails {
			export function Get(org: string): Promise<m.Invoices.Controllers.CustomerBasicDetailsListViewModel[]> {
				return Client.get(`/${org}/Invoices/Customer/ListBasicDetails`);
			}
		}
		export namespace ListIdAndName {
			export function Get(org: string): Promise<m.Invoices.Controllers.CustomerBasicDetailsListViewModel[]> {
				return Client.get(`/${org}/Invoices/Customer/ListIdAndName`);
			}
		}
		export namespace ListSimple {
			export function Get(org: string): Promise<m.Invoices.Controllers.SimpleCustomerListResponse> {
				return Client.get(`/${org}/Invoices/Customer/ListSimple`)
				             .then(data => convertByKeys(data, {"type":"CountrySubdivision","key":"Customers.DefaultInvoiceSenderData.CountrySubdivision"}));
			}
		}
	}
	export namespace DailyTakingsController {
		export namespace DeclineToFillGapInDailyTakings {
			export function Post(org: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Invoices/DailyTakings/DeclineToFillGapInDailyTakings`, {  });
			}
		}
		export namespace Disconnect {
			export function Get(org: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.get(`/${org}/Invoices/DailyTakings/Disconnect`);
			}
		}
		export namespace GetActivationStatus {
			export function Get(org: string): Promise<m.Envelope<m.Invoices.Contract.DailyTakingsActivationStatusResult, m.Invoices.Contract.iZettleAuthError>> {
				return Client.get(`/${org}/Invoices/DailyTakings/GetActivationStatus`)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.SyncFromDate"}));
			}
		}
		export namespace GetDailyTakingsByDate {
			export function Get(org: string, year: number, month: number): Promise<m.Envelope<m.Invoices.ViewModels.DailyTakingsByDateForView[], m.SimpleError>> {
				return Client.get(`/${org}/Invoices/DailyTakings/GetDailyTakingsByDate`, { year, month })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.Date"}, {"type":"Date","key":"Data.DailyTakingsVerifications.Date"}, {"type":"Date","key":"Data.LastChangedUtc"}));
			}
		}
		export namespace GetDailyTakingsByMonth {
			export function Get(org: string, pagination?: m.Bokio.Common.Contract.Pagination.Pagination): Promise<m.Envelope<m.Invoices.ViewModels.DailyTakingsByMonthForView[], m.SimpleError>> {
				return Client.get(`/${org}/Invoices/DailyTakings/GetDailyTakingsByMonth`, { pagination });
			}
		}
		export namespace GetHaveDailyTakingsGapDueToFiscalYear {
			export function Get(org: string): Promise<m.Envelope<m.Invoices.ViewModels.DailyTakingGapToFill, m.SimpleError>> {
				return Client.get(`/${org}/Invoices/DailyTakings/GetHaveDailyTakingsGapDueToFiscalYear`)
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.FromDate"}, {"type":"Date","key":"Data.ToDate"}));
			}
		}
		export namespace HandleError {
			export function Post(org: string, dailyTakingsId: string, undo: boolean): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Invoices/DailyTakings/HandleError`, { dailyTakingsId, undo });
			}
		}
		export namespace RequestDailyTakings {
			export function Post(org: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Invoices/DailyTakings/RequestDailyTakings`, {  });
			}
		}
		export namespace RequestToFillGapInDailyTakings {
			export function Post(org: string, startDate: Date, endDate: Date): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Invoices/DailyTakings/RequestToFillGapInDailyTakings`, { startDate, endDate });
			}
		}
		export namespace ResyncDailyTakings {
			export function Post(org: string, request: m.Invoices.Controllers.ResyncDailyTakingsRequest): Promise<m.Envelope<m.Invoices.Controllers.ResyncDailyTakingsResponse, m.SimpleError>> {
				return Client.post(`/${org}/Invoices/DailyTakings/ResyncDailyTakings`, request)
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.Results.Date"}));
			}
		}
	}
	export namespace EInvoiceController {
		export namespace DoCrediflowKyc {
			export function Post(org: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Invoices/EInvoice/DoCrediflowKyc`, {  });
			}
		}
		export namespace GetLatestInviteStatus {
			export function Get(org: string, partyId: string, serviceType: m.Invoices.Contract.EInvoice.EInvoiceInviteServiceType): Promise<m.Envelope<m.Invoices.Contract.EInvoice.EInvoicePartyInviteStatus, m.SimpleError>> {
				return Client.get(`/${org}/Invoices/EInvoice/GetLatestInviteStatus`, { partyId, serviceType })
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.LatestStatusTime"}));
			}
		}
		export namespace GetParty {
			export function Get(org: string): Promise<m.Envelope<m.Invoices.Contract.EInvoice.GetEInvoicePartyDto, m.Invoices.Contract.EInvoice.PartyRegisterError>> {
				return Client.get(`/${org}/Invoices/EInvoice/GetParty`);
			}
		}
		export namespace GetReceiver {
			export function Get(org: string, customerId: string): Promise<m.Envelope<m.Invoices.Contract.EInvoice.EInvoiceParty, m.Invoices.Contract.EInvoice.PartyRegisterError>> {
				return Client.get(`/${org}/Invoices/EInvoice/GetReceiver`, { customerId });
			}
		}
		export namespace InviteSupplier {
			export function Post(org: string, partyId: string, email: string): Promise<m.Envelope<m.Invoices.Contract.EInvoice.EInvoicePartyInviteStatus, m.SimpleError>> {
				return Client.post(`/${org}/Invoices/EInvoice/InviteSupplier`, { partyId, email })
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.LatestStatusTime"}));
			}
		}
		export namespace Publish {
			export function Post(org: string, request: m.Invoices.Contract.Commands.InvoiceCommands.PublishInvoice): Promise<m.Envelope<m.Invoices.Contract.ViewData.InvoiceForView, m.Classes.InvoiceValidationError[]>> {
				return Client.post(`/${org}/Invoices/EInvoice/Publish`, request)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.Deadline"}, {"type":"Day","key":"Data.InvoiceDate"}, {"type":"CountrySubdivision","key":"Data.SenderData.CountrySubdivision"}, {"type":"Date","key":"Data.Created"}, {"type":"Date","key":"Data.RotRut.PublishedClaimDate"}, {"type":"Day","key":"Data.InvoicePeriod.StartDate"}, {"type":"Day","key":"Data.InvoicePeriod.EndDate"}, {"type":"Day","key":"Data.TemplateRecurringInvoice.StartedDate"}));
			}
		}
		export namespace Register {
			export function Post(org: string, party: m.Invoices.Contract.EInvoice.EInvoiceParty): Promise<m.Envelope<m.Invoices.Contract.EInvoice.EInvoiceParty, m.Invoices.Contract.EInvoice.PartyRegisterError>> {
				return Client.post(`/${org}/Invoices/EInvoice/Register`, party);
			}
		}
		export namespace SearchParty {
			export function Get(org: string, searchParams: m.Invoices.ViewModels.EInvoicePartySearchParams): Promise<m.Envelope<m.Invoices.Contract.EInvoice.EInvoiceParty[], m.SimpleError>> {
				return Client.get(`/${org}/Invoices/EInvoice/SearchParty`, { searchParams });
			}
		}
		export namespace Unregister {
			export function Post(org: string): Promise<m.Envelope<boolean, m.Invoices.Contract.EInvoice.PartyRegisterError>> {
				return Client.post(`/${org}/Invoices/EInvoice/Unregister`, {  });
			}
		}
		export namespace Update {
			export function Put(org: string, party: m.Invoices.Contract.EInvoice.EInvoicePartyInfo): Promise<m.Envelope<m.Invoices.Contract.EInvoice.EInvoiceParty, m.Invoices.Contract.EInvoice.PartyRegisterError>> {
				return Client.put(`/${org}/Invoices/EInvoice/Update`, party);
			}
		}
	}
	export namespace FactoringController {
		export namespace DeletePaymentFromCustomer {
			export function Post(org: string, command: m.Invoices.Contract.Commands.Factoring.DeletePaymentFromCustomerToFactoringProvider): Promise<m.Envelope<string, m.SimpleError>> {
				return Client.post(`/${org}/Invoices/Factoring/DeletePaymentFromCustomer`, command);
			}
		}
		export namespace GetCompanyStatus {
			export function Get(org: string): Promise<m.Envelope<m.Invoices.Contract.Factoring.FactoringCompanyStatus, m.Invoices.Controllers.FactoringError>> {
				return Client.get(`/${org}/Invoices/Factoring/GetCompanyStatus`);
			}
		}
		export namespace Publish {
			export function Post(org: string, request: m.Invoices.Contract.Commands.InvoiceCommands.PublishInvoice): Promise<m.Envelope<m.Invoices.ViewModels.FactoringPublishResult, m.Classes.InvoiceValidationError[]>> {
				return Client.post(`/${org}/Invoices/Factoring/Publish`, request);
			}
		}
		export namespace PublishNewAPI {
			export function Post(org: string, request: m.Invoices.Contract.Commands.InvoiceCommands.PublishInvoice): Promise<m.Envelope<boolean, m.Classes.InvoiceValidationError[]>> {
				return Client.post(`/${org}/Invoices/Factoring/PublishNewAPI`, request);
			}
		}
		export namespace RegisterPaymentFromCustomer {
			export function Post(org: string, command: m.Invoices.Contract.Commands.Factoring.RegisterPaymentFromCustomerToFactoringProvider): Promise<m.Envelope<string, m.SimpleError>> {
				return Client.post(`/${org}/Invoices/Factoring/RegisterPaymentFromCustomer`, command);
			}
		}
		export namespace RegisterPaymentFromProvider {
			export function Post(org: string, command: m.Invoices.Contract.Commands.Factoring.RegisterPaymentFromFactoringProvider): Promise<m.Envelope<string, m.SimpleError>> {
				return Client.post(`/${org}/Invoices/Factoring/RegisterPaymentFromProvider`, command);
			}
		}
		export namespace RequestQuote {
			export function Post(org: string, command: m.Invoices.Contract.Commands.Factoring.RequestFactoringQuote): Promise<m.Envelope<m.Invoices.ViewModels.FactoringQuoteViewModel, m.Invoices.Controllers.FactoringError>> {
				return Client.post(`/${org}/Invoices/Factoring/RequestQuote`, command)
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.OfferValidTime"}));
			}
		}
		export namespace SendFactoringEvaluation {
			export function Post(org: string, request: m.Invoices.Contract.Commands.InvoiceDeliveryCommands.SendFactoringRequestDelivery): Promise<m.Envelope<string, m.SimpleError>> {
				return Client.post(`/${org}/Invoices/Factoring/SendFactoringEvaluation`, request);
			}
		}
		export namespace SyncStatusWithFactoringGruppen {
			export function Get(org: string, invoiceId: string): Promise<m.Envelope<boolean, m.Invoices.Controllers.FactoringError>> {
				return Client.get(`/${org}/Invoices/Factoring/SyncStatusWithFactoringGruppen`, { invoiceId });
			}
		}
	}
	export namespace FactoringOnboardingController {
		export namespace GetRedirectLink {
			export function Get(org: string): Promise<m.Envelope<string, m.SimpleError>> {
				return Client.get(`/${org}/Invoices/FactoringOnboarding/GetRedirectLink`);
			}
		}
		export namespace PrepareForOnboardingOnExternalSite {
			export function Post(org: string, onboardingInfo: m.Invoices.ViewModels.FactoringOnboardingViewModel): Promise<m.Envelope<m.Invoices.ViewModels.FactoringExternalOnboardingInformationViewModel, m.Invoices.Controllers.FactoringError>> {
				return Client.post(`/${org}/Invoices/FactoringOnboarding/PrepareForOnboardingOnExternalSite`, onboardingInfo);
			}
		}
		export namespace StartOnboarding {
			export function Get(org: string): Promise<m.Envelope<m.Invoices.Controllers.StartFactoringOnboardingViewModel, m.Invoices.Controllers.FactoringError>> {
				return Client.get(`/${org}/Invoices/FactoringOnboarding/StartOnboarding`);
			}
		}
		export namespace TryCompleteOnboarding {
			export function Get(org: string): Promise<m.Envelope<m.Invoices.ViewModels.CompleteFactoringOnboardingViewModel, m.Invoices.Controllers.FactoringError>> {
				return Client.get(`/${org}/Invoices/FactoringOnboarding/TryCompleteOnboarding`);
			}
		}
	}
	export namespace InvoiceAttachmentController {
		export namespace Attachments {
			export function Get(org: string, invoiceId: string): Promise<m.Envelope<m.Invoices.ViewModels.FileAttachmentViewModel[], m.SimpleError>> {
				return Client.get(`/${org}/Invoices/InvoiceAttachment/Attachments`, { invoiceId });
			}
		}
		export namespace DeleteAttachment {
			export function Post(org: string, request: m.Invoices.Contract.Commands.Attachments.DeleteInvoiceAttachment): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Invoices/InvoiceAttachment/DeleteAttachment`, request);
			}
		}
		export namespace DeleteAttachments {
			export function Post(org: string, request: m.Invoices.Contract.Commands.Attachments.DeleteInvoiceAttachments): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Invoices/InvoiceAttachment/DeleteAttachments`, request);
			}
		}
		export namespace UploadAttachment {
			export function Post(org: string, invoiceId: string, file: (File | Blob | string)): Promise<m.Envelope<m.Invoices.ViewModels.FileAttachmentViewModel, m.SimpleError>> {
				const form = new FormData();
				form.append("invoiceId", invoiceId);
				form.append("file", file);
				return Client.post(`/${org}/Invoices/InvoiceAttachment/UploadAttachment`, form, true);
			}
		}
	}
	export namespace InvoiceBatchController {
		export namespace AddItems {
			export function Post(org: string, request: m.Bokio.Sales.Web.ViewModels.InvoiceBatch.AddInvoiceBatchItemRequest): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Invoices/InvoiceBatch/AddItems`, request);
			}
		}
		export namespace Create {
			export function Post(org: string, request: m.Bokio.Sales.Web.ViewModels.InvoiceBatch.CreateInvoiceBatchRequest): Promise<m.Envelope<m.Bokio.Sales.Web.ViewModels.InvoiceBatch.InvoiceBatchForViewDto, m.SimpleError>> {
				return Client.post(`/${org}/Invoices/InvoiceBatch/Create`, request)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.InvoiceDate"}, {"type":"Day","key":"Data.Deadline"}));
			}
		}
		export namespace DeleteItem {
			export function Post(org: string, itemId: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(Client.getPathWithQueryString(`/${org}/Invoices/InvoiceBatch/DeleteItem`, { itemId }), {  });
			}
		}
		export namespace GenerateInvoices {
			export function Post(org: string, request: m.Bokio.Sales.Web.ViewModels.InvoiceBatch.GenerateInvoicesBatchRequest): Promise<m.Envelope<m.Bokio.Sales.Web.ViewModels.InvoiceBatch.InvoiceBatchForViewDto, m.SimpleError>> {
				return Client.post(`/${org}/Invoices/InvoiceBatch/GenerateInvoices`, request)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.InvoiceDate"}, {"type":"Day","key":"Data.Deadline"}));
			}
		}
		export namespace Get {
			export function Get(org: string, id: string): Promise<m.Envelope<m.Bokio.Sales.Web.ViewModels.InvoiceBatch.InvoiceBatchForViewDto, m.SimpleError>> {
				return Client.get(`/${org}/Invoices/InvoiceBatch/Get/${id}`)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.InvoiceDate"}, {"type":"Day","key":"Data.Deadline"}));
			}
		}
		export namespace List {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Sales.Web.ViewModels.InvoiceBatch.InvoiceBatchListDto[], m.SimpleError>> {
				return Client.get(`/${org}/Invoices/InvoiceBatch/List`)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.InvoiceDate"}, {"type":"Day","key":"Data.Deadline"}));
			}
		}
		export namespace ListArticlesForBatchInvoicing {
			export function Get(org: string): Promise<m.Envelope<m.Invoices.Controllers.ArticleForBatchInvoicing[], m.SimpleError>> {
				return Client.get(`/${org}/Invoices/InvoiceBatch/ListArticlesForBatchInvoicing`);
			}
		}
		export namespace TryMatchCustomers {
			export function Post(org: string, invoiceBatchId: string): Promise<m.Envelope<number, m.SimpleError>> {
				return Client.post(Client.getPathWithQueryString(`/${org}/Invoices/InvoiceBatch/TryMatchCustomers`, { invoiceBatchId }), {  });
			}
		}
	}
	export namespace InvoiceBookkeepingReconciliationController {
		export namespace DatesInDifferentFiscalYear {
			export function Get(org: string, targetPeriodEndDate?: Day): Promise<m.Invoices.Controllers.InvoiceReconcilingForView[]> {
				return Client.get(`/${org}/Invoices/InvoiceBookkeepingReconciliation/DatesInDifferentFiscalYear`, { targetPeriodEndDate })
				             .then(data => convertByKeys(data, {"type":"Date","key":"InvoiceDate"}, {"type":"Date","key":"Deadline"}));
			}
		}
	}
	export namespace InvoiceController {
		export namespace AddReminder {
			export function Post(org: string, id: string, request: m.Invoices.Contract.Commands.InvoiceCommands.AddReminder): Promise<m.Envelope<m.Invoices.Contract.ViewData.InvoiceReminderForView, m.SimpleError>> {
				return Client.post(`/${org}/Invoices/Invoice/AddReminder/${id}`, request);
			}
		}
		export namespace AddRow {
			export function Post(org: string, request: m.Invoices.Contract.Commands.InvoiceCommands.AddRow): Promise<m.Invoices.Contract.ViewData.InvoiceRowForView> {
				return Client.post(`/${org}/Invoices/Invoice/AddRow`, request);
			}
		}
		export namespace All {
			export function Get(org: string, pagination?: m.Bokio.Common.Contract.Pagination.Pagination): Promise<m.Envelope<m.Invoices.ViewModels.InvoiceForList[], m.SimpleError>> {
				return Client.get(`/${org}/Invoices/Invoice/All`, { pagination })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.InvoiceDate"}, {"type":"Day","key":"Data.Deadline"}, {"type":"Date","key":"Data.EmailDeliveryStatus.TimeUtc"}, {"type":"Date","key":"Data.CurrentDeliveryStatus.InvoiceDelivery.TimestampUtc"}, {"type":"Date","key":"Data.CurrentDeliveryStatus.Time"}));
			}
		}
		export namespace ConnectToAutoVerification {
			export function Post(org: string, request: m.Bokio.Sales.Web.ViewModels.ConnectToAutoVerificationRowRequest): Promise<m.Envelope<m.Bokio.Sales.Web.ViewModels.ConnectToAutoVerificationRowResult, m.SimpleError>> {
				return Client.post(`/${org}/Invoices/Invoice/ConnectToAutoVerification`, request);
			}
		}
		export namespace ConnectToAutoVerificationRowPreview {
			export function Get(org: string, invoiceId: string, autoverificationRowId: string, settlementType?: m.Entities.Invoices.InvoiceSettlementType): Promise<m.Envelope<m.Bokio.Sales.Web.ViewModels.ConnectInvoiceToAutoverificationRowPreviewDto, m.SimpleError>> {
				return Client.get(`/${org}/Invoices/Invoice/ConnectToAutoVerificationRowPreview`, { invoiceId, autoverificationRowId, settlementType })
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.PaymentDate"}, {"type":"Date","key":"Data.InvoiceDate"}, {"type":"Date","key":"Data.InvoiceDueDate"}));
			}
		}
		export namespace CopyInvoice {
			export function Post(org: string, request: m.Invoices.Contract.Commands.InvoiceCommands.CopyInvoice): Promise<m.Invoices.Contract.ViewData.InvoiceForView> {
				return Client.post(`/${org}/Invoices/Invoice/CopyInvoice`, request)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Deadline"}, {"type":"Day","key":"InvoiceDate"}, {"type":"CountrySubdivision","key":"SenderData.CountrySubdivision"}, {"type":"Date","key":"Created"}, {"type":"Date","key":"RotRut.PublishedClaimDate"}, {"type":"Day","key":"InvoicePeriod.StartDate"}, {"type":"Day","key":"InvoicePeriod.EndDate"}, {"type":"Day","key":"TemplateRecurringInvoice.StartedDate"}));
			}
		}
		export namespace CreateDownloadDelivery {
			export function Post(org: string, request: m.Invoices.Contract.Commands.InvoiceDeliveryCommands.SendInvoiceDelivery): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Invoices/Invoice/CreateDownloadDelivery`, request);
			}
		}
		export namespace CreateInvoice {
			export function Post(org: string, request: m.Invoices.Contract.Commands.InvoiceCommands.CreateInvoice): Promise<m.Invoices.Contract.ViewData.InvoiceForView> {
				return Client.post(`/${org}/Invoices/Invoice/CreateInvoice`, request)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Deadline"}, {"type":"Day","key":"InvoiceDate"}, {"type":"CountrySubdivision","key":"SenderData.CountrySubdivision"}, {"type":"Date","key":"Created"}, {"type":"Date","key":"RotRut.PublishedClaimDate"}, {"type":"Day","key":"InvoicePeriod.StartDate"}, {"type":"Day","key":"InvoicePeriod.EndDate"}, {"type":"Day","key":"TemplateRecurringInvoice.StartedDate"}));
			}
		}
		export namespace CreateTestCompanyQuickInvoice {
			export function Post(org: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Invoices/Invoice/CreateTestCompanyQuickInvoice`, {  });
			}
		}
		export namespace Delete {
			export function Post(org: string, request: m.Invoices.Contract.Commands.InvoiceCommands.DeleteInvoice): Promise<m.Envelope<m.Invoices.ViewModels.DeleteInvoiceResult, m.SimpleError>> {
				return Client.post(`/${org}/Invoices/Invoice/Delete`, request);
			}
		}
		export namespace DeleteVerifications {
			export function Post(org: string, command: m.Invoices.Contract.Commands.BookkeepCommands.DeleteInvoiceBookkeeping): Promise<m.Envelope<boolean, m.Classes.DeleteVerificationValidationError>> {
				return Client.post(`/${org}/Invoices/Invoice/DeleteVerifications`, command);
			}
		}
		export namespace DeliveryHistory {
			export function Get(org: string, id: string): Promise<m.Invoices.Contract.ViewData.InvoiceDeliveryDto[]> {
				return Client.get(`/${org}/Invoices/Invoice/DeliveryHistory/${id}`)
				             .then(data => convertByKeys(data, {"type":"Date","key":"EmailActivity.TimeUtc"}, {"type":"Date","key":"TimestampUtc"}, {"type":"Date","key":"DeliveryStatus.Time"}));
			}
		}
		export namespace EditInvoiceDates {
			export function Post(org: string, request: m.Invoices.Contract.Commands.InvoiceCommands.EditInvoiceDates): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Invoices/Invoice/EditInvoiceDates`, request);
			}
		}
		export namespace EditInvoiceHasVatFreeMessage {
			export function Post(org: string, request: m.Invoices.Contract.Commands.InvoiceCommands.EditInvoiceHasVatFreeMessage): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Invoices/Invoice/EditInvoiceHasVatFreeMessage`, request);
			}
		}
		export namespace EditPublished {
			export function Post(org: string, command: m.Invoices.Contract.Commands.InvoiceCommands.EditPublishedInvoice): Promise<m.Envelope<m.Invoices.Contract.ViewData.InvoiceForView, m.SimpleError>> {
				return Client.post(`/${org}/Invoices/Invoice/EditPublished`, command)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.Deadline"}, {"type":"Day","key":"Data.InvoiceDate"}, {"type":"CountrySubdivision","key":"Data.SenderData.CountrySubdivision"}, {"type":"Date","key":"Data.Created"}, {"type":"Date","key":"Data.RotRut.PublishedClaimDate"}, {"type":"Day","key":"Data.InvoicePeriod.StartDate"}, {"type":"Day","key":"Data.InvoicePeriod.EndDate"}, {"type":"Day","key":"Data.TemplateRecurringInvoice.StartedDate"}));
			}
		}
		export namespace EditRow {
			export function Post(org: string, request: m.Invoices.Contract.Commands.InvoiceCommands.EditInvoiceRow): Promise<m.Invoices.Contract.ViewData.InvoiceRowForView> {
				return Client.post(`/${org}/Invoices/Invoice/EditRow`, request);
			}
		}
		export namespace ForTodoView {
			export function Get(org: string, id: string): Promise<m.Invoices.Contract.ViewData.InvoiceForTodoView> {
				return Client.get(`/${org}/Invoices/Invoice/ForTodoView/${id}`);
			}
		}
		export namespace ForView {
			export function Get(org: string, id: string): Promise<m.Invoices.Contract.ViewData.InvoiceForView> {
				return Client.get(`/${org}/Invoices/Invoice/ForView/${id}`)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Deadline"}, {"type":"Day","key":"InvoiceDate"}, {"type":"CountrySubdivision","key":"SenderData.CountrySubdivision"}, {"type":"Date","key":"Created"}, {"type":"Date","key":"RotRut.PublishedClaimDate"}, {"type":"Day","key":"InvoicePeriod.StartDate"}, {"type":"Day","key":"InvoicePeriod.EndDate"}, {"type":"Day","key":"TemplateRecurringInvoice.StartedDate"}));
			}
		}
		export namespace GetAdditionalInformation {
			export function Get(org: string, invoiceId: string): Promise<m.Envelope<m.Invoices.ViewModels.AdditionalFieldsListItem[], m.SimpleError>> {
				return Client.get(`/${org}/Invoices/Invoice/GetAdditionalInformation`, { invoiceId });
			}
		}
		export namespace GetAllCurrencieSupportedForInvoices {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Common.CurrencyInfo[], m.SimpleError>> {
				return Client.get(`/${org}/Invoices/Invoice/GetAllCurrencieSupportedForInvoices`);
			}
		}
		export namespace GetAvailableSettlementTypes {
			export function Get(org: string, invoiceId: string): Promise<m.Envelope<m.Entities.Invoices.InvoiceSettlementType[], m.SimpleError>> {
				return Client.get(`/${org}/Invoices/Invoice/GetAvailableSettlementTypes`, { invoiceId });
			}
		}
		export namespace GetCurrency {
			export function Get(org: string, selectedCurrency: string, day: Day): Promise<m.Envelope<m.Entities.ExchangeRate, m.SimpleError>> {
				return Client.get(`/${org}/Invoices/Invoice/GetCurrency`, { selectedCurrency, day })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.Date"}));
			}
		}
		export namespace GetPeriodiseStatus {
			export function Get(org: string, id: string): Promise<m.Invoices.Contract.CustomerInvoices.ToggleCustomerInvoicePeriodisationResult> {
				return Client.get(`/${org}/Invoices/Invoice/GetPeriodiseStatus/${id}`);
			}
		}
		export namespace GetReminderSummaries {
			export function Post(org: string, invoiceIds: string[]): Promise<m.Invoices.ViewModels.InvoiceReminderSummary[]> {
				return Client.post(`/${org}/Invoices/Invoice/GetReminderSummaries`, invoiceIds)
				             .then(data => convertByKeys(data, {"type":"Date","key":"LastReminderDate"}));
			}
		}
		export namespace GetUnsavedDraftValues {
			export function Get(org: string, invoiceType: m.Entities.Invoices.InvoiceType, customerId?: string, recurringInvoiceEnabled?: boolean): Promise<m.Invoices.Contract.ViewData.InvoiceBody> {
				return Client.get(`/${org}/Invoices/Invoice/GetUnsavedDraftValues`, { invoiceType, customerId, recurringInvoiceEnabled })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Deadline"}, {"type":"Day","key":"InvoiceDate"}, {"type":"CountrySubdivision","key":"SenderData.CountrySubdivision"}, {"type":"Date","key":"Created"}, {"type":"Date","key":"RotRut.PublishedClaimDate"}, {"type":"Day","key":"InvoicePeriod.StartDate"}, {"type":"Day","key":"InvoicePeriod.EndDate"}, {"type":"Day","key":"TemplateRecurringInvoice.StartedDate"}));
			}
		}
		export namespace GetVerificationsToDelete {
			export function Get(org: string, invoiceId: string): Promise<m.Envelope<m.Core.ViewData.VerificationForList[], m.SimpleError>> {
				return Client.get(`/${org}/Invoices/Invoice/GetVerificationsToDelete`, { invoiceId })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.Date"}, {"type":"Day","key":"Data.ExpectPaymentAt"}, {"type":"Date","key":"Data.CreatedUtc"}));
			}
		}
		export namespace HasEmptyInvoiceState {
			export function Get(org: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.get(`/${org}/Invoices/Invoice/HasEmptyInvoiceState`);
			}
		}
		export namespace History {
			export function Get(org: string, id: string): Promise<m.Invoices.ViewModels.InvoiceHistoryViewModel[]> {
				return Client.get(`/${org}/Invoices/Invoice/History/${id}`)
				             .then(data => convertByKeys(data, {"type":"Date","key":"RegistredUtc"}, {"type":"Date","key":"Settlement.Date"}, {"type":"Day","key":"Date"}, {"type":"Day","key":"DueDate"}));
			}
		}
		export namespace IsFirstPublish {
			export function Get(org: string): Promise<m.Invoices.Controllers.IsFirstPublishResponse> {
				return Client.get(`/${org}/Invoices/Invoice/IsFirstPublish`);
			}
		}
		export namespace IsFirstPublishedInvoice {
			export function Get(org: string, invoiceId: string): Promise<boolean> {
				return Client.get(`/${org}/Invoices/Invoice/IsFirstPublishedInvoice`, { invoiceId });
			}
		}
		export namespace Pdfs {
			export function Get(org: string, invoiceId: string): Promise<m.Envelope<m.Invoices.ViewModels.PdfDocumentVersionViewModel[], m.SimpleError>> {
				return Client.get(`/${org}/Invoices/Invoice/Pdfs`, { invoiceId })
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.CreatedAt"}));
			}
		}
		export namespace PossibleCorrections {
			export function Get(org: string, id: string): Promise<m.Invoices.Contract.InvoiceCorrectionAction[]> {
				return Client.get(`/${org}/Invoices/Invoice/PossibleCorrections/${id}`);
			}
		}
		export namespace Publish {
			export function Post(org: string, request: m.Invoices.Contract.Commands.InvoiceCommands.PublishInvoice): Promise<m.Envelope<m.Invoices.Contract.ViewData.InvoiceForView, m.Classes.InvoiceValidationError[]>> {
				return Client.post(`/${org}/Invoices/Invoice/Publish`, request)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.Deadline"}, {"type":"Day","key":"Data.InvoiceDate"}, {"type":"CountrySubdivision","key":"Data.SenderData.CountrySubdivision"}, {"type":"Date","key":"Data.Created"}, {"type":"Date","key":"Data.RotRut.PublishedClaimDate"}, {"type":"Day","key":"Data.InvoicePeriod.StartDate"}, {"type":"Day","key":"Data.InvoicePeriod.EndDate"}, {"type":"Day","key":"Data.TemplateRecurringInvoice.StartedDate"}));
			}
		}
		export namespace PublishInvoice {
			export function Post(org: string, request: m.Invoices.Contract.Commands.InvoiceCommands.PublishInvoice): Promise<m.Envelope<m.Invoices.Contract.ViewData.InvoiceForView, m.Classes.InvoiceValidationError[]>> {
				return Client.post(`/${org}/Invoices/Invoice/PublishInvoice`, request)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.Deadline"}, {"type":"Day","key":"Data.InvoiceDate"}, {"type":"CountrySubdivision","key":"Data.SenderData.CountrySubdivision"}, {"type":"Date","key":"Data.Created"}, {"type":"Date","key":"Data.RotRut.PublishedClaimDate"}, {"type":"Day","key":"Data.InvoicePeriod.StartDate"}, {"type":"Day","key":"Data.InvoicePeriod.EndDate"}, {"type":"Day","key":"Data.TemplateRecurringInvoice.StartedDate"}));
			}
		}
		export namespace RemoveRow {
			export function Post(org: string, request: m.Invoices.Contract.Commands.InvoiceCommands.DeleteRow): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Invoices/Invoice/RemoveRow`, request);
			}
		}
		export namespace SaveEditInvoice {
			export function Post(org: string, request: m.Invoices.Contract.Commands.InvoiceCommands.SaveEditInvoice): Promise<m.Envelope<m.Invoices.Contract.ViewData.InvoiceForView, m.Classes.InvoiceValidationError[]>> {
				return Client.post(`/${org}/Invoices/Invoice/SaveEditInvoice`, request)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.Deadline"}, {"type":"Day","key":"Data.InvoiceDate"}, {"type":"CountrySubdivision","key":"Data.SenderData.CountrySubdivision"}, {"type":"Date","key":"Data.Created"}, {"type":"Date","key":"Data.RotRut.PublishedClaimDate"}, {"type":"Day","key":"Data.InvoicePeriod.StartDate"}, {"type":"Day","key":"Data.InvoicePeriod.EndDate"}, {"type":"Day","key":"Data.TemplateRecurringInvoice.StartedDate"}));
			}
		}
		export namespace SendPdf {
			export function Post(org: string, request: m.Invoices.Contract.Commands.InvoiceDeliveryCommands.SendInvoiceDelivery): Promise<m.Envelope<string, m.SimpleError>> {
				return Client.post(`/${org}/Invoices/Invoice/SendPdf`, request);
			}
		}
		export namespace SetCurrency {
			export function Post(org: string, request: m.Invoices.Contract.Commands.InvoiceCommands.SetCurrency): Promise<m.Invoices.Contract.Commands.InvoiceCommands.SetCurrencyResult> {
				return Client.post(`/${org}/Invoices/Invoice/SetCurrency`, request);
			}
		}
		export namespace SetCustomer {
			export function Post(org: string, request: m.Invoices.Contract.Commands.InvoiceCommands.SetCustomer): Promise<m.Invoices.Contract.Commands.InvoiceCommands.SetCustomerResult> {
				return Client.post(`/${org}/Invoices/Invoice/SetCustomer`, request);
			}
		}
		export namespace SetRowOrder {
			export function Post(org: string, request: m.Invoices.Contract.Commands.InvoiceCommands.SetRowOrder): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Invoices/Invoice/SetRowOrder`, request);
			}
		}
		export namespace ShowSurveyAfterPublish {
			export function Get(org: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.get(`/${org}/Invoices/Invoice/ShowSurveyAfterPublish`);
			}
		}
		export namespace Stats {
			export function Get(org: string, customerId?: string): Promise<m.Envelope<m.Invoices.Contract.ViewData.InvoicesStats, m.SimpleError>> {
				return Client.get(`/${org}/Invoices/Invoice/Stats`, { customerId });
			}
		}
		export namespace ToggleBookkeeping {
			export function Post(org: string, dto: m.Invoices.Controllers.ToggleBookkeepingDto): Promise<m.Invoices.Controllers.ToggleBookkeepingResult> {
				return Client.post(`/${org}/Invoices/Invoice/ToggleBookkeeping`, dto);
			}
		}
		export namespace TogglePeriodise {
			export function Post(org: string, dto: m.Invoices.Controllers.TogglePeriodiseDto): Promise<m.Invoices.Contract.CustomerInvoices.ToggleCustomerInvoicePeriodisationResult> {
				return Client.post(`/${org}/Invoices/Invoice/TogglePeriodise`, dto);
			}
		}
		export namespace ToggleRounding {
			export function Post(org: string, dto: m.Invoices.Controllers.ToggleRoundingDto): Promise<m.Invoices.Controllers.ToggleRoundingResult> {
				return Client.post(`/${org}/Invoices/Invoice/ToggleRounding`, dto);
			}
		}
		export namespace ToggleShowVAT {
			export function Post(org: string, dto: m.Invoices.Controllers.ToggleShowVATDto): Promise<m.Envelope<m.Invoices.Controllers.ToggleShowVATResult, m.SimpleError>> {
				return Client.post(`/${org}/Invoices/Invoice/ToggleShowVAT`, dto);
			}
		}
		export namespace UndoPublish {
			export function Post(org: string, request: m.Invoices.Contract.Commands.InvoiceCommands.UndoPublishInvoice): Promise<m.Envelope<m.Invoices.ViewModels.DeleteInvoiceResult, m.SimpleError>> {
				return Client.post(`/${org}/Invoices/Invoice/UndoPublish`, request);
			}
		}
		export namespace UpdateAdditionalInformation {
			export function Post(org: string, invoiceId: string, items: m.Invoices.ViewModels.AdditionalFieldsListItem[]): Promise<m.Envelope<m.Invoices.ViewModels.AdditionalFieldsListItem[], m.SimpleError>> {
				return Client.post(`/${org}/Invoices/Invoice/UpdateAdditionalInformation`, { invoiceId, items });
			}
		}
	}
	export namespace InvoiceLogController {
		export namespace GetLogEntries {
			export function Get(org: string, filter: m.Invoices.Contract.InvoiceLog.InvoiceLogFilterDto): Promise<m.Envelope<m.Invoices.Contract.InvoiceLog.InvoiceLogResultDto, m.SimpleError>> {
				return Client.get(`/${org}/Invoices/InvoiceLog/GetLogEntries`, { filter })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.Items.Date"}, {"type":"Date","key":"Data.Items.RegisteredUtc"}));
			}
		}
	}
	export namespace InvoicePortalController {
		export namespace ForView {
			export function Get(id: string, token: string, messageId?: string): Promise<m.Envelope<m.Invoices.ViewModels.InvoiceForPortal, m.SimpleError>> {
				return Client.get(`/Invoices/InvoicePortal/ForView/${id}`, { token, messageId })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.InvoiceDate"}, {"type":"Day","key":"Data.Deadline"}, {"type":"Date","key":"Data.PaymentIntent.PaidAt"}));
			}
		}
		export namespace MarkAsPaid {
			export function Post(id: string, token: string, request: m.Invoices.Contract.DTOs.MarkInvoiceAsPaidRequestDto): Promise<m.Envelope<m.Invoices.Contract.DTOs.InvoicePortalPaidMarkDto, m.SimpleError>> {
				return Client.post(Client.getPathWithQueryString(`/Invoices/InvoicePortal/MarkAsPaid/${id}`, { token }), request);
			}
		}
		export namespace SendReceipt {
			export function Post(id: string, token: string, receiverEmail: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(Client.getPathWithQueryString(`/Invoices/InvoicePortal/SendReceipt/${id}`, { receiverEmail }), {  });
			}
		}
		export namespace StripePaymentIntent {
			export function Post(id: string, token: string): Promise<m.Envelope<m.Invoices.ViewModels.PaymentIntentViewModel, m.SimpleError>> {
				return Client.post(`/Invoices/InvoicePortal/StripePaymentIntent/${id}`, { token });
			}
		}
		export namespace UpdatePaymentIntentStatus {
			export function Post(id: string, token: string, command: m.Invoices.Contract.Commands.Payments.UpdatePaymentIntentStatusCommand): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(Client.getPathWithQueryString(`/Invoices/InvoicePortal/UpdatePaymentIntentStatus/${id}`, { token, command }), {  });
			}
		}
	}
	export namespace InvoicePortalSettingsController {
		export namespace AddPaymentMethod {
			export function Post(org: string, request: m.Invoices.Contract.DTOs.AddInvoicePortalPaymentMethodRequestDto): Promise<m.Envelope<string, m.SimpleError>> {
				return Client.post(`/${org}/Invoices/InvoicePortalSettings/AddPaymentMethod`, request);
			}
		}
		export namespace ForPreview {
			export function Get(org: string): Promise<m.Envelope<m.Invoices.ViewModels.InvoiceForPortal, m.SimpleError>> {
				return Client.get(`/${org}/Invoices/InvoicePortalSettings/ForPreview`)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.InvoiceDate"}, {"type":"Day","key":"Data.Deadline"}, {"type":"Date","key":"Data.PaymentIntent.PaidAt"}));
			}
		}
		export namespace GetSettings {
			export function Get(org: string): Promise<m.Invoices.Contract.DTOs.InvoicePortalSettingsDto> {
				return Client.get(`/${org}/Invoices/InvoicePortalSettings/GetSettings`);
			}
		}
		export namespace RemovePaymentMethod {
			export function Post(org: string, request: m.Invoices.Contract.DTOs.RemoveInvoicePortalPaymentMethodRequestDto): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Invoices/InvoicePortalSettings/RemovePaymentMethod`, request);
			}
		}
		export namespace SetPortalEnabled {
			export function Post(org: string, request: m.Invoices.Contract.DTOs.SetPortalEnabledRequestDto): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Invoices/InvoicePortalSettings/SetPortalEnabled`, request);
			}
		}
		export namespace TogglePortalForInvoice {
			export function Post(org: string, request: m.Invoices.Contract.Commands.InvoiceCommands.ToggleInvoicePortal): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Invoices/InvoicePortalSettings/TogglePortalForInvoice`, request);
			}
		}
		export namespace UpdatePaymentMethod {
			export function Post(org: string, request: m.Invoices.Contract.DTOs.UpdateInvoicePortalPaymentMethodRequestDto): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Invoices/InvoicePortalSettings/UpdatePaymentMethod`, request);
			}
		}
	}
	export namespace InvoiceReportsController {
		export namespace ArticlesReport {
			export function Get(org: string, fromDate?: Date, toDate?: Date): Promise<m.Envelope<m.Invoices.Contract.ViewData.TopArticleDto[], m.SimpleError>> {
				return Client.get(`/${org}/Invoices/InvoiceReports/ArticlesReport`, { fromDate, toDate });
			}
		}
		export namespace CustomersReport {
			export function Get(org: string, fromDate?: Date, toDate?: Date): Promise<m.Envelope<m.Invoices.Contract.ViewData.TopCustomerDto[], m.SimpleError>> {
				return Client.get(`/${org}/Invoices/InvoiceReports/CustomersReport`, { fromDate, toDate });
			}
		}
		export namespace InvoicesReport {
			export function Get(org: string, includedCustomerIds?: string[], fromDate?: Day, toDate?: Day): Promise<m.Envelope<m.Invoices.Contract.ViewData.InvoicesSumByPeriod, m.SimpleError>> {
				return Client.get(`/${org}/Invoices/InvoiceReports/InvoicesReport`, { includedCustomerIds, fromDate, toDate });
			}
		}
		export namespace PeriodicReport {
			export function Get(org: string, fromDate: Day, toDate: Day, includeNonEUSales?: boolean): Promise<m.Invoices.ViewModels.PeriodicReportViewModel> {
				return Client.get(`/${org}/Invoices/InvoiceReports/PeriodicReport`, { fromDate, toDate, includeNonEUSales })
				             .then(data => convertByKeys(data, {"type":"Day","key":"From"}, {"type":"Day","key":"To"}, {"type":"Date","key":"Customers.Country.EUMembershipHistory.Entry"}, {"type":"Date","key":"Customers.Country.EUMembershipHistory.Exit"}, {"type":"Date","key":"Customers.Country.CountrySubdivision.EUMembershipHistory.Entry"}, {"type":"Date","key":"Customers.Country.CountrySubdivision.EUMembershipHistory.Exit"}));
			}
		}
	}
	export namespace iZettleController {
		export namespace FetchAuthUrl {
			export function Get(org: string, payoutAccount?: number, fromDate?: Day, shouldRefetchData?: boolean): Promise<m.Envelope<m.Invoices.Contract.iZettleAuthUrlState, m.Invoices.Contract.iZettleAuthError>> {
				return Client.get(`/${org}/Invoices/iZettle/FetchAuthUrl`, { payoutAccount, fromDate, shouldRefetchData });
			}
		}
		export namespace GetEarliestFromDate {
			export function Get(org: string): Promise<m.Envelope<m.Invoices.Contract.Sales.CanFetchFromDto, m.SimpleError>> {
				return Client.get(`/${org}/Invoices/iZettle/GetEarliestFromDate`)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.Day"}));
			}
		}
		export namespace GetToken {
			export function Get(org: string, accessToken: string): Promise<m.Envelope<boolean, m.Invoices.Contract.iZettleAuthError>> {
				return Client.get(`/${org}/Invoices/iZettle/GetToken`, { accessToken });
			}
		}
	}
	export namespace PaymentController {
		export namespace Delete {
			export function Post(org: string, request: m.Invoices.Contract.Commands.Payments.DeletePayment): Promise<m.Envelope<m.Invoices.Contract.ViewData.InvoiceForView, m.Invoices.Controllers.InvoiceDeletePaymentError>> {
				return Client.post(`/${org}/Invoices/Payment/Delete`, request)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.Deadline"}, {"type":"Day","key":"Data.InvoiceDate"}, {"type":"CountrySubdivision","key":"Data.SenderData.CountrySubdivision"}, {"type":"Date","key":"Data.Created"}, {"type":"Date","key":"Data.RotRut.PublishedClaimDate"}, {"type":"Day","key":"Data.InvoicePeriod.StartDate"}, {"type":"Day","key":"Data.InvoicePeriod.EndDate"}, {"type":"Day","key":"Data.TemplateRecurringInvoice.StartedDate"}));
			}
		}
		export namespace PaymentData {
			export function Get(org: string, id: string): Promise<m.Envelope<m.Invoices.Controllers.PaymentDataViewModel, m.SimpleError>> {
				return Client.get(`/${org}/Invoices/Payment/PaymentData/${id}`)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.PaymentDate"}, {"type":"Day","key":"Data.PeriodisationWarningFromDate"}));
			}
		}
		export namespace Register {
			export function Post(org: string, request: m.Invoices.Contract.ViewData.RegisterPaymentViewModel, autoVerificationRowId?: string, rowVersion?: string): Promise<m.Envelope<m.Invoices.Contract.ViewData.RegisterPaymentDto, m.SimpleError>> {
				return Client.post(`/${org}/Invoices/Payment/Register`, { request, autoVerificationRowId, rowVersion });
			}
		}
	}
	export namespace QuoteAttachmentController {
		export namespace Attachments {
			export function Get(org: string, quoteId: string): Promise<m.Envelope<m.Invoices.ViewModels.FileAttachmentViewModel[], m.SimpleError>> {
				return Client.get(`/${org}/Invoices/QuoteAttachment/Attachments`, { quoteId });
			}
		}
		export namespace DeleteAttachment {
			export function Post(org: string, request: m.Invoices.Contract.Commands.QuoteAttachments.DeleteQuoteAttachment): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Invoices/QuoteAttachment/DeleteAttachment`, request);
			}
		}
		export namespace DeleteAttachments {
			export function Post(org: string, request: m.Invoices.Contract.Commands.QuoteAttachments.DeleteQuoteAttachments): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Invoices/QuoteAttachment/DeleteAttachments`, request);
			}
		}
		export namespace UploadAttachment {
			export function Post(org: string, quoteId: string, file: (File | Blob | string)): Promise<m.Envelope<m.Invoices.ViewModels.FileAttachmentViewModel, m.SimpleError>> {
				const form = new FormData();
				form.append("quoteId", quoteId);
				form.append("file", file);
				return Client.post(`/${org}/Invoices/QuoteAttachment/UploadAttachment`, form, true);
			}
		}
	}
	export namespace QuoteController {
		export namespace All {
			export function Get(org: string, pagination?: m.Bokio.Common.Contract.Pagination.Pagination): Promise<m.Envelope<m.Invoices.ViewModels.QuoteForList[], m.SimpleError>> {
				return Client.get(`/${org}/Invoices/Quote/All`, { pagination })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.ValidToDate"}, {"type":"Day","key":"Data.ValidFromDate"}, {"type":"Date","key":"Data.EmailDeliveryStatus.TimeUtc"}));
			}
		}
		export namespace ConvertToInvoice {
			export function Post(org: string, request: m.Invoices.Contract.Commands.Quotes.ConvertToInvoice): Promise<m.Envelope<m.Invoices.Contract.ViewData.InvoiceForView, m.SimpleError>> {
				return Client.post(`/${org}/Invoices/Quote/ConvertToInvoice`, request)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.Deadline"}, {"type":"Day","key":"Data.InvoiceDate"}, {"type":"CountrySubdivision","key":"Data.SenderData.CountrySubdivision"}, {"type":"Date","key":"Data.Created"}, {"type":"Date","key":"Data.RotRut.PublishedClaimDate"}, {"type":"Day","key":"Data.InvoicePeriod.StartDate"}, {"type":"Day","key":"Data.InvoicePeriod.EndDate"}, {"type":"Day","key":"Data.TemplateRecurringInvoice.StartedDate"}));
			}
		}
		export namespace Copy {
			export function Post(org: string, request: m.Invoices.Contract.Commands.Quotes.CopyQuote): Promise<m.Envelope<m.Invoices.Contract.ViewData.QuoteForView, m.SimpleError>> {
				return Client.post(`/${org}/Invoices/Quote/Copy`, request)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.ValidFromDate"}, {"type":"Day","key":"Data.ValidToDate"}, {"type":"CountrySubdivision","key":"Data.SenderData.CountrySubdivision"}, {"type":"Date","key":"Data.Created"}, {"type":"Date","key":"Data.RotRut.PublishedClaimDate"}, {"type":"Day","key":"Data.InvoicePeriod.StartDate"}, {"type":"Day","key":"Data.InvoicePeriod.EndDate"}));
			}
		}
		export namespace Create {
			export function Post(org: string, command: m.Invoices.Contract.Commands.Quotes.CreateQuoteCommand): Promise<m.Envelope<m.Invoices.Contract.ViewData.QuoteForView, m.SimpleError>> {
				return Client.post(`/${org}/Invoices/Quote/Create`, command)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.ValidFromDate"}, {"type":"Day","key":"Data.ValidToDate"}, {"type":"CountrySubdivision","key":"Data.SenderData.CountrySubdivision"}, {"type":"Date","key":"Data.Created"}, {"type":"Date","key":"Data.RotRut.PublishedClaimDate"}, {"type":"Day","key":"Data.InvoicePeriod.StartDate"}, {"type":"Day","key":"Data.InvoicePeriod.EndDate"}));
			}
		}
		export namespace CreateDownloadDelivery {
			export function Post(org: string, request: m.Invoices.Contract.Commands.Quotes.SendQuoteDelivery): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Invoices/Quote/CreateDownloadDelivery`, request);
			}
		}
		export namespace Delete {
			export function Post(org: string, request: m.Invoices.Contract.Commands.Quotes.DeleteQuote): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Invoices/Quote/Delete`, request);
			}
		}
		export namespace EditQuote {
			export function Post(org: string, request: m.Invoices.Contract.Commands.Quotes.EditQuote): Promise<m.Envelope<m.Invoices.Contract.ViewData.QuoteForView, m.SimpleError>> {
				return Client.post(`/${org}/Invoices/Quote/EditQuote`, request)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.ValidFromDate"}, {"type":"Day","key":"Data.ValidToDate"}, {"type":"CountrySubdivision","key":"Data.SenderData.CountrySubdivision"}, {"type":"Date","key":"Data.Created"}, {"type":"Date","key":"Data.RotRut.PublishedClaimDate"}, {"type":"Day","key":"Data.InvoicePeriod.StartDate"}, {"type":"Day","key":"Data.InvoicePeriod.EndDate"}));
			}
		}
		export namespace EditQuoteDate {
			export function Post(org: string, request: m.Invoices.Contract.Commands.Quotes.EditQuoteDate): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Invoices/Quote/EditQuoteDate`, request);
			}
		}
		export namespace EditState {
			export function Post(org: string, request: m.Invoices.Contract.Commands.Quotes.EditQuoteState): Promise<m.Envelope<m.Invoices.Contract.ViewData.QuoteForView, m.SimpleError>> {
				return Client.post(`/${org}/Invoices/Quote/EditState`, request)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.ValidFromDate"}, {"type":"Day","key":"Data.ValidToDate"}, {"type":"CountrySubdivision","key":"Data.SenderData.CountrySubdivision"}, {"type":"Date","key":"Data.Created"}, {"type":"Date","key":"Data.RotRut.PublishedClaimDate"}, {"type":"Day","key":"Data.InvoicePeriod.StartDate"}, {"type":"Day","key":"Data.InvoicePeriod.EndDate"}));
			}
		}
		export namespace Get {
			export function Get(org: string, quoteId: string): Promise<m.Envelope<m.Invoices.Contract.ViewData.QuoteForView, m.SimpleError>> {
				return Client.get(`/${org}/Invoices/Quote/Get`, { quoteId })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.ValidFromDate"}, {"type":"Day","key":"Data.ValidToDate"}, {"type":"CountrySubdivision","key":"Data.SenderData.CountrySubdivision"}, {"type":"Date","key":"Data.Created"}, {"type":"Date","key":"Data.RotRut.PublishedClaimDate"}, {"type":"Day","key":"Data.InvoicePeriod.StartDate"}, {"type":"Day","key":"Data.InvoicePeriod.EndDate"}));
			}
		}
		export namespace GetAdditionalInformation {
			export function Get(org: string, quoteId: string): Promise<m.Envelope<m.Invoices.ViewModels.AdditionalFieldsListItem[], m.SimpleError>> {
				return Client.get(`/${org}/Invoices/Quote/GetAdditionalInformation`, { quoteId });
			}
		}
		export namespace Histories {
			export function Get(org: string, quoteId: string): Promise<m.Envelope<m.Invoices.ViewModels.QuoteHistoryViewModel[], m.SimpleError>> {
				return Client.get(`/${org}/Invoices/Quote/Histories`, { quoteId })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.CreatedAt"}, {"type":"Date","key":"Data.QuoteDeliveryDto.EmailActivity.TimeUtc"}, {"type":"Date","key":"Data.QuoteDeliveryDto.TimestampUtc"}));
			}
		}
		export namespace IsFirstPublish {
			export function Get(org: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.get(`/${org}/Invoices/Quote/IsFirstPublish`);
			}
		}
		export namespace New {
			export function Get(org: string): Promise<m.Envelope<m.Invoices.Contract.ViewData.QuoteBody, m.SimpleError>> {
				return Client.get(`/${org}/Invoices/Quote/New`)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.ValidFromDate"}, {"type":"Day","key":"Data.ValidToDate"}, {"type":"CountrySubdivision","key":"Data.SenderData.CountrySubdivision"}, {"type":"Date","key":"Data.Created"}, {"type":"Date","key":"Data.RotRut.PublishedClaimDate"}, {"type":"Day","key":"Data.InvoicePeriod.StartDate"}, {"type":"Day","key":"Data.InvoicePeriod.EndDate"}));
			}
		}
		export namespace Publish {
			export function Post(org: string, request: m.Invoices.Contract.Commands.Quotes.PublishQuote): Promise<m.Envelope<m.Invoices.Contract.ViewData.QuoteForView, m.Classes.QuoteValidationError[]>> {
				return Client.post(`/${org}/Invoices/Quote/Publish`, request)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.ValidFromDate"}, {"type":"Day","key":"Data.ValidToDate"}, {"type":"CountrySubdivision","key":"Data.SenderData.CountrySubdivision"}, {"type":"Date","key":"Data.Created"}, {"type":"Date","key":"Data.RotRut.PublishedClaimDate"}, {"type":"Day","key":"Data.InvoicePeriod.StartDate"}, {"type":"Day","key":"Data.InvoicePeriod.EndDate"}));
			}
		}
		export namespace SaveEditQuote {
			export function Post(org: string, request: m.Invoices.Contract.Commands.Quotes.SaveEditQuote): Promise<m.Envelope<m.Invoices.Contract.ViewData.QuoteForView, m.Classes.QuoteValidationError[]>> {
				return Client.post(`/${org}/Invoices/Quote/SaveEditQuote`, request)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.ValidFromDate"}, {"type":"Day","key":"Data.ValidToDate"}, {"type":"CountrySubdivision","key":"Data.SenderData.CountrySubdivision"}, {"type":"Date","key":"Data.Created"}, {"type":"Date","key":"Data.RotRut.PublishedClaimDate"}, {"type":"Day","key":"Data.InvoicePeriod.StartDate"}, {"type":"Day","key":"Data.InvoicePeriod.EndDate"}));
			}
		}
		export namespace SendPdf {
			export function Post(org: string, request: m.Invoices.Contract.Commands.Quotes.SendQuoteDelivery): Promise<m.Envelope<string, m.SimpleError>> {
				return Client.post(`/${org}/Invoices/Quote/SendPdf`, request);
			}
		}
		export namespace SetCurrency {
			export function Post(org: string, command: m.Invoices.Contract.Commands.Quotes.SetQuoteCurrency): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Invoices/Quote/SetCurrency`, command);
			}
		}
		export namespace SetCustomer {
			export function Post(org: string, command: m.Invoices.Contract.Commands.Quotes.SetQuoteCustomer): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Invoices/Quote/SetCustomer`, command);
			}
		}
		export namespace ShowSurveyAfterPublish {
			export function Get(org: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.get(`/${org}/Invoices/Quote/ShowSurveyAfterPublish`);
			}
		}
		export namespace Stats {
			export function Get(org: string, customerId?: string): Promise<m.Envelope<m.Invoices.Contract.ViewData.QuotesStats, m.SimpleError>> {
				return Client.get(`/${org}/Invoices/Quote/Stats`, { customerId });
			}
		}
		export namespace ToggleRounding {
			export function Post(org: string, request: m.Invoices.Contract.Commands.Quotes.ToggleQuoteRounding): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Invoices/Quote/ToggleRounding`, request);
			}
		}
		export namespace ToggleShowVAT {
			export function Post(org: string, request: m.Invoices.Contract.Commands.Quotes.ToggleQuoteShowVAT): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Invoices/Quote/ToggleShowVAT`, request);
			}
		}
		export namespace UpdateAdditionalInformation {
			export function Post(org: string, quoteId: string, items: m.Invoices.ViewModels.AdditionalFieldsListItem[]): Promise<m.Envelope<m.Invoices.ViewModels.AdditionalFieldsListItem[], m.SimpleError>> {
				return Client.post(`/${org}/Invoices/Quote/UpdateAdditionalInformation`, { quoteId, items });
			}
		}
	}
	export namespace QuoteRotRutController {
		export namespace Create {
			export function Post(org: string, request: m.Invoices.Contract.Commands.Quotes.CreateQuoteRotRut): Promise<m.Envelope<m.Invoices.Contract.ViewData.RotRutForView, m.SimpleError>> {
				return Client.post(`/${org}/Invoices/QuoteRotRut/Create`, request)
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.PublishedClaimDate"}));
			}
		}
		export namespace Delete {
			export function Post(org: string, request: m.Invoices.Contract.Commands.Quotes.DeleteQuoteRotRut): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Invoices/QuoteRotRut/Delete`, request);
			}
		}
		export namespace Edit {
			export function Post(org: string, request: m.Invoices.Contract.Commands.Quotes.EditQuoteRotRut): Promise<m.Envelope<m.Invoices.Contract.ViewData.RotRutForView, m.SimpleError>> {
				return Client.post(`/${org}/Invoices/QuoteRotRut/Edit`, request)
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.PublishedClaimDate"}));
			}
		}
		export namespace Get {
			export function Get(org: string, quoteId: string, rotRutId: string): Promise<m.Envelope<m.Invoices.Contract.ViewData.RotRutForView, boolean>> {
				return Client.get(`/${org}/Invoices/QuoteRotRut/Get`, { quoteId, rotRutId })
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.PublishedClaimDate"}));
			}
		}
	}
	export namespace QuoteRowController {
		export namespace AddRow {
			export function Post(org: string, request: m.Invoices.Contract.Commands.Quotes.AddQuoteRow): Promise<m.Envelope<m.Invoices.Contract.ViewData.QuoteRowForView, m.SimpleError>> {
				return Client.post(`/${org}/Invoices/QuoteRow/AddRow`, request);
			}
		}
		export namespace EditRow {
			export function Post(org: string, request: m.Invoices.Contract.Commands.Quotes.EditQuoteRow): Promise<m.Envelope<m.Invoices.Contract.ViewData.QuoteRowForView, m.SimpleError>> {
				return Client.post(`/${org}/Invoices/QuoteRow/EditRow`, request);
			}
		}
		export namespace RemoveRow {
			export function Post(org: string, request: m.Invoices.Contract.Commands.Quotes.DeleteQuoteRow): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Invoices/QuoteRow/RemoveRow`, request);
			}
		}
		export namespace SetRowOrder {
			export function Post(org: string, request: m.Invoices.Contract.Commands.Quotes.SetQuoteRowOrder): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Invoices/QuoteRow/SetRowOrder`, request);
			}
		}
	}
	export namespace RecurringInvoiceController {
		export namespace ActivateRecurringInvoice {
			export function Put(org: string, request: m.Invoices.Contract.Commands.RecurringInvoiceCommands.ActivateRecurringInvoice): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.put(`/${org}/Invoices/RecurringInvoice/ActivateRecurringInvoice`, request);
			}
		}
		export namespace Copy {
			export function Post(org: string, request: m.Invoices.Contract.Commands.RecurringInvoiceCommands.CopyRecurringInvoice): Promise<m.Envelope<m.Invoices.Contract.Commands.RecurringInvoiceCommands.CopyRecurringInvoice, m.SimpleError>> {
				return Client.post(`/${org}/Invoices/RecurringInvoice/Copy`, request);
			}
		}
		export namespace Create {
			export function Post(org: string, request: m.Invoices.Contract.Commands.RecurringInvoiceCommands.CreateRecurringInvoice): Promise<m.Envelope<m.Bokio.Sales.Web.ViewModels.RecurringInvoiceForView, m.SimpleError>> {
				return Client.post(`/${org}/Invoices/RecurringInvoice/Create`, request)
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.Created"}, {"type":"Date","key":"Data.Updated"}, {"type":"Day","key":"Data.RecurringInvoiceScheduling.StartDate"}));
			}
		}
		export namespace Delete {
			export function Delete(org: string, request: m.Invoices.Contract.Commands.RecurringInvoiceCommands.DeleteRecurringInvoice): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client._delete(`/${org}/Invoices/RecurringInvoice/Delete`, { request });
			}
		}
		export namespace Edit {
			export function Post(org: string, request: m.Invoices.Contract.Commands.RecurringInvoiceCommands.EditRecurringInvoice): Promise<m.Envelope<m.Bokio.Sales.Web.ViewModels.RecurringInvoiceForView, m.SimpleError>> {
				return Client.post(`/${org}/Invoices/RecurringInvoice/Edit`, request)
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.Created"}, {"type":"Date","key":"Data.Updated"}, {"type":"Day","key":"Data.RecurringInvoiceScheduling.StartDate"}));
			}
		}
		export namespace Get {
			export function Get(org: string, recurringId: string): Promise<m.Envelope<m.Bokio.Sales.Web.ViewModels.RecurringInvoiceForView, boolean>> {
				return Client.get(`/${org}/Invoices/RecurringInvoice/Get`, { recurringId })
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.Created"}, {"type":"Date","key":"Data.Updated"}, {"type":"Day","key":"Data.RecurringInvoiceScheduling.StartDate"}));
			}
		}
		export namespace GetDetails {
			export function Get(org: string, recurringId: string): Promise<m.Envelope<m.Bokio.Sales.Web.ViewModels.RecurringInvoiceDetailsView, m.SimpleError>> {
				return Client.get(`/${org}/Invoices/RecurringInvoice/GetDetails`, { recurringId })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.RecurringInvoiceScheduling.StartDate"}, {"type":"Date","key":"Data.RecurringInvoiceList.CreatedOrPublishedDate"}, {"type":"Date","key":"Data.RecurringInvoiceList.PublishStamp"}, {"type":"Day","key":"Data.CreatedDate"}, {"type":"Day","key":"Data.NextScheduledInvoiceDate"}, {"type":"Date","key":"Data.LastUpdatedInvoiceDate"}));
			}
		}
		export namespace GetEvents {
			export function Get(org: string, recurringId: string): Promise<m.Envelope<m.Bokio.Sales.Web.ViewModels.RecurringInvoiceEvent[], m.SimpleError>> {
				return Client.get(`/${org}/Invoices/RecurringInvoice/GetEvents`, { recurringId })
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.Date"}));
			}
		}
		export namespace List {
			export function Get(org: string, pagination?: m.Bokio.Common.Contract.Pagination.Pagination): Promise<m.Envelope<m.Bokio.Sales.Web.ViewModels.RecurringInvoiceForList[], m.SimpleError>> {
				return Client.get(`/${org}/Invoices/RecurringInvoice/List`, { pagination })
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.LastSentDate"}, {"type":"Date","key":"Data.NextSentDate"}));
			}
		}
		export namespace Publish {
			export function Post(org: string, request: m.Invoices.Contract.Commands.RecurringInvoiceCommands.PublishRecurringInvoice): Promise<m.Envelope<m.Bokio.Sales.Web.ViewModels.RecurringInvoiceForView, m.SimpleError>> {
				return Client.post(`/${org}/Invoices/RecurringInvoice/Publish`, request)
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.Created"}, {"type":"Date","key":"Data.Updated"}, {"type":"Day","key":"Data.RecurringInvoiceScheduling.StartDate"}));
			}
		}
		export namespace SaveEdited {
			export function Post(org: string, request: m.Invoices.Contract.Commands.RecurringInvoiceCommands.SaveEditedRecurringInvoice): Promise<m.Envelope<m.Bokio.Sales.Web.ViewModels.RecurringInvoiceForView, m.SimpleError>> {
				return Client.post(`/${org}/Invoices/RecurringInvoice/SaveEdited`, request)
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.Created"}, {"type":"Date","key":"Data.Updated"}, {"type":"Day","key":"Data.RecurringInvoiceScheduling.StartDate"}));
			}
		}
		export namespace StopRecurringInvoice {
			export function Put(org: string, request: m.Invoices.Contract.Commands.RecurringInvoiceCommands.StopRecurringInvoice): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.put(`/${org}/Invoices/RecurringInvoice/StopRecurringInvoice`, request);
			}
		}
		export namespace Update {
			export function Put(org: string, request: m.Invoices.Contract.Commands.RecurringInvoiceCommands.UpdateRecurringInvoiceSettings): Promise<m.Envelope<m.Bokio.Sales.Web.ViewModels.RecurringInvoiceForView, m.SimpleError>> {
				return Client.put(`/${org}/Invoices/RecurringInvoice/Update`, request)
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.Created"}, {"type":"Date","key":"Data.Updated"}, {"type":"Day","key":"Data.RecurringInvoiceScheduling.StartDate"}));
			}
		}
	}
	export namespace RotRutController {
		export namespace ClaimInvoice {
			export function Post(org: string, request: m.Invoices.Contract.Commands.RotRuts.ClaimRotRut): Promise<m.Envelope<m.Invoices.Contract.ViewData.InvoiceForView, boolean>> {
				return Client.post(`/${org}/Invoices/RotRut/ClaimInvoice`, request)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.Deadline"}, {"type":"Day","key":"Data.InvoiceDate"}, {"type":"CountrySubdivision","key":"Data.SenderData.CountrySubdivision"}, {"type":"Date","key":"Data.Created"}, {"type":"Date","key":"Data.RotRut.PublishedClaimDate"}, {"type":"Day","key":"Data.InvoicePeriod.StartDate"}, {"type":"Day","key":"Data.InvoicePeriod.EndDate"}, {"type":"Day","key":"Data.TemplateRecurringInvoice.StartedDate"}));
			}
		}
		export namespace Create {
			export function Post(org: string, request: m.Invoices.Contract.Commands.RotRuts.CreateRotRut): Promise<m.Envelope<m.Invoices.Contract.ViewData.RotRutForView, m.SimpleError>> {
				return Client.post(`/${org}/Invoices/RotRut/Create`, request)
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.PublishedClaimDate"}));
			}
		}
		export namespace Delete {
			export function Post(org: string, request: m.Invoices.Contract.Commands.RotRuts.DeleteRotRut): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Invoices/RotRut/Delete`, request);
			}
		}
		export namespace Edit {
			export function Post(org: string, request: m.Invoices.Contract.Commands.RotRuts.EditRotRut): Promise<m.Envelope<m.Invoices.Contract.ViewData.RotRutForView, m.SimpleError>> {
				return Client.post(`/${org}/Invoices/RotRut/Edit`, request)
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.PublishedClaimDate"}));
			}
		}
		export namespace Get {
			export function Get(org: string, rotRutId: string): Promise<m.Envelope<m.Invoices.Contract.ViewData.RotRutForView, boolean>> {
				return Client.get(`/${org}/Invoices/RotRut/Get`, { rotRutId })
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.PublishedClaimDate"}));
			}
		}
		export namespace GetRotRutDeductionRules {
			export function Get(org: string): Promise<m.Envelope<m.Invoices.Contract.RotRuts.DeductionRule[], m.SimpleError>> {
				return Client.get(`/${org}/Invoices/RotRut/GetRotRutDeductionRules`)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.EffectiveFrom"}, {"type":"Day","key":"Data.EffectiveTo"}));
			}
		}
		export namespace List {
			export function Get(org: string): Promise<m.Envelope<m.Invoices.Contract.ViewData.RotRutForList[], string>> {
				return Client.get(`/${org}/Invoices/RotRut/List`)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.InvoiceDueDate"}, {"type":"Day","key":"Data.PaymentDate"}));
			}
		}
		export namespace SetRotRutStatus {
			export function Post(org: string, request: m.Invoices.Contract.Commands.RotRuts.SetRotRutStatus): Promise<m.Envelope<m.Invoices.Contract.ViewData.RotRutForView, m.Classes.RotRutValidationError[]>> {
				return Client.post(`/${org}/Invoices/RotRut/SetRotRutStatus`, request)
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.PublishedClaimDate"}));
			}
		}
	}
	export namespace SettlementController {
		export namespace Register {
			export function Post(org: string, request: m.Invoices.Contract.Commands.Payments.RegisterInvoiceSettlement): Promise<m.Envelope<string, m.SimpleError>> {
				return Client.post(`/${org}/Invoices/Settlement/Register`, request);
			}
		}
		export namespace Remove {
			export function Post(org: string, request: m.Invoices.Contract.Commands.Payments.RemoveInvoiceSettlement): Promise<m.Envelope<m.Invoices.Contract.ViewData.InvoiceForView, m.SimpleError>> {
				return Client.post(`/${org}/Invoices/Settlement/Remove`, request)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.Deadline"}, {"type":"Day","key":"Data.InvoiceDate"}, {"type":"CountrySubdivision","key":"Data.SenderData.CountrySubdivision"}, {"type":"Date","key":"Data.Created"}, {"type":"Date","key":"Data.RotRut.PublishedClaimDate"}, {"type":"Day","key":"Data.InvoicePeriod.StartDate"}, {"type":"Day","key":"Data.InvoicePeriod.EndDate"}, {"type":"Day","key":"Data.TemplateRecurringInvoice.StartedDate"}));
			}
		}
	}
	export namespace StripeController {
		export namespace Disconnect {
			export function Post(org: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Invoices/Stripe/Disconnect`, {  });
			}
		}
		export namespace GetCompanyStatus {
			export function Get(org: string): Promise<m.Envelope<m.Invoices.Contract.Commands.Stripe.StripeCompanyStatus, m.SimpleError>> {
				return Client.get(`/${org}/Invoices/Stripe/GetCompanyStatus`);
			}
		}
		export namespace GetOnboardingUrl {
			export function Get(org: string): Promise<m.Envelope<string, m.SimpleError>> {
				return Client.get(`/${org}/Invoices/Stripe/GetOnboardingUrl`);
			}
		}
		export namespace GetToken {
			export function Get(org: string, accessToken: string): Promise<m.Envelope<m.Invoices.Contract.Commands.Stripe.StripeCompanyStatus, m.SimpleError>> {
				return Client.get(`/${org}/Invoices/Stripe/GetToken`, { accessToken });
			}
		}
		export namespace InitiateOnboarding {
			export function Post(org: string): Promise<m.Envelope<m.Invoices.Contract.Commands.Stripe.StripeCompanyStatus, m.SimpleError>> {
				return Client.post(`/${org}/Invoices/Stripe/InitiateOnboarding`, {  });
			}
		}
		export namespace ToggleEnableStripePayments {
			export function Post(org: string, request: m.Invoices.Contract.Commands.InvoiceCommands.ToggleEnableStripePayments): Promise<m.Envelope<m.Bokio.Sales.Web.ViewModels.ToggleEnableStripePaymentsResults, m.SimpleError>> {
				return Client.post(`/${org}/Invoices/Stripe/ToggleEnableStripePayments`, request);
			}
		}
	}
	export namespace TimeTrackingController {
		export namespace CreateAccount {
			export function Post(org: string, request: m.Invoices.Contract.Commands.TimeTrackingCommands.CreateTimeTrackingAccount): Promise<m.Invoices.ViewModels.TimeTrackingAccountForView> {
				return Client.post(`/${org}/Invoices/TimeTracking/CreateAccount`, request);
			}
		}
		export namespace CreateImport {
			export function Post(org: string, request: m.Invoices.Contract.Commands.TimeTrackingCommands.CreateTimeTrackingImport): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Invoices/TimeTracking/CreateImport`, request);
			}
		}
		export namespace DeleteAccount {
			export function Post(org: string, request: m.Invoices.Contract.Commands.TimeTrackingCommands.DeleteTimeTrackingAccount): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Invoices/TimeTracking/DeleteAccount`, request);
			}
		}
		export namespace GetAccountEntries {
			export function Post(org: string, request: m.Invoices.Contract.TimeTracking.TrackingAccountRangeRequest): Promise<m.Envelope<m.Invoices.Infrastructure.TimeTracking.TimeTrackingEntry[], m.SimpleError>> {
				return Client.post(`/${org}/Invoices/TimeTracking/GetAccountEntries`, request)
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.Start"}, {"type":"Date","key":"Data.Stop"}));
			}
		}
		export namespace GetCompanyAccounts {
			export function Get(org: string): Promise<m.Entities.Invoices.TimeTrackingAccount[]> {
				return Client.get(`/${org}/Invoices/TimeTracking/GetCompanyAccounts`);
			}
		}
		export namespace GetWorkspaces {
			export function Get(org: string, request: m.Invoices.Contract.TimeTracking.TrackingAccountRequest): Promise<m.Envelope<m.Invoices.Infrastructure.TimeTracking.TimeTrackingWorkspace[], m.SimpleError>> {
				return Client.get(`/${org}/Invoices/TimeTracking/GetWorkspaces`, { request });
			}
		}
	}
}
export namespace Notifications {
	export namespace IncomingWebJobController {
		export namespace SendWebRefreshPing {
			export function Post(job: m.Core.Services.Notifications.Dtos.NotificationWebRefreshPingJobDto): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post("/Notifications/IncomingWebJob/SendWebRefreshPing", job);
			}
		}
	}
	export namespace NotificationController {
		export namespace GetNewNotificationsCount {
			export function Get(org: string): Promise<m.Envelope<number, m.SimpleError>> {
				return Client.get(`/${org}/Notifications/Notification/GetNewNotificationsCount`);
			}
		}
		export namespace GetNotificationItemRouteData {
			export function Get(org: string, itemId: string, itemType: m.Entities.Notifications.NotificationItemType): Promise<m.Envelope<m.Bokio.Common.Services.Notifications.Dtos.NotificationItemRouteDto, m.SimpleError>> {
				return Client.get(`/${org}/Notifications/Notification/GetNotificationItemRouteData`, { itemId, itemType })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.Payroll.PayDate"}));
			}
		}
		export namespace GetNotificationSettings {
			export function Get(org: string): Promise<m.Envelope<m.Core.Services.Notifications.Dtos.NotificationSettingGroupByAreaDto[], m.SimpleError>> {
				return Client.get(`/${org}/Notifications/Notification/GetNotificationSettings`);
			}
		}
		export namespace GetNotificationsForUser {
			export function Get(org: string): Promise<m.Envelope<m.Core.Services.Notifications.Dtos.NotificationDto[], m.SimpleError>> {
				return Client.get(`/${org}/Notifications/Notification/GetNotificationsForUser`)
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.Timestamp"}));
			}
		}
		export namespace SetNotificationsStatuses {
			export function Put(org: string, notificationIds: string[], statusType: m.Entities.Notifications.NotificationStatusTypes): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.put(`/${org}/Notifications/Notification/SetNotificationsStatuses`, { notificationIds, statusType });
			}
		}
		export namespace UpdateNotificationSetting {
			export function Post(org: string, area: m.Entities.Notifications.NotificationArea, areaType: m.Entities.Notifications.NotificationAreaType, target: m.Entities.Notifications.NotificationTarget, enable: boolean): Promise<m.Envelope<m.Core.Services.Notifications.Dtos.NotificationSettingDto, m.SimpleError>> {
				return Client.post(`/${org}/Notifications/Notification/UpdateNotificationSetting`, { area, areaType, target, enable });
			}
		}
	}
	export namespace UserNotificationController {
		export namespace GetNewUserNotificationsCount {
			export function Get(): Promise<m.Envelope<number, m.SimpleError>> {
				return Client.get("/Notifications/UserNotification/GetNewUserNotificationsCount");
			}
		}
		export namespace GetUserNotifications {
			export function Get(): Promise<m.Envelope<m.Core.Services.Notifications.Dtos.NotificationDto[], m.SimpleError>> {
				return Client.get("/Notifications/UserNotification/GetUserNotifications")
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.Timestamp"}));
			}
		}
		export namespace SetUserNotificationsStatuses {
			export function Put(notificationIds: string[], statusType: m.Entities.Notifications.NotificationStatusTypes): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.put("/Notifications/UserNotification/SetUserNotificationsStatuses", { notificationIds, statusType });
			}
		}
	}
}
export namespace Partner {
	export namespace JoinController {
		export namespace AcceptInvitation {
			export function Post(partnerId: string, inviteId: string, request: m.Partner.Controllers.AcceptInvitationFormData): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${partnerId}/Partner/Join/AcceptInvitation`, { inviteId, request });
			}
		}
	}
	export namespace PartnerStatusController {
		export namespace GetStatus {
			export function Get(partnerId: string): Promise<m.Partner.Controllers.PartnerStatusViewModel> {
				return Client.get(`/${partnerId}/Partner/PartnerStatus/GetStatus`);
			}
		}
	}
}
export namespace Salary {
	export namespace AbsenceController {
		export namespace Active {
			export function Get(org: string): Promise<m.Bokio.Salary.Web.Viewmodels.Absences.AbsenceForList[]> {
				return Client.get(`/${org}/Salary/Api/v1/Absence/Active`)
				             .then(data => convertByKeys(data, {"type":"Day","key":"StartDate"}, {"type":"Day","key":"EndDate"}));
			}
		}
		export namespace Create {
			export function Post(org: string, command: m.Bokio.Salary.Contract.Absences.Commands.CreateAbsence): Promise<m.Bokio.Salary.Web.Viewmodels.Absences.AbsenceDetails> {
				return Client.post(`/${org}/Salary/Api/v1/Absence/Create`, command)
				             .then(data => convertByKeys(data, {"type":"Day","key":"StartDate"}, {"type":"Day","key":"EndDate"}, {"type":"Day","key":"Days.Date"}));
			}
		}
		export namespace Edit {
			export function Post(org: string, command: m.Bokio.Salary.Contract.Absences.Commands.EditAbsence): Promise<m.Bokio.Salary.Web.Viewmodels.Absences.AbsenceDetails> {
				return Client.post(`/${org}/Salary/Api/v1/Absence/Edit`, command)
				             .then(data => convertByKeys(data, {"type":"Day","key":"StartDate"}, {"type":"Day","key":"EndDate"}, {"type":"Day","key":"Days.Date"}));
			}
		}
		export namespace Get {
			export function Get(org: string, id: string): Promise<m.Bokio.Salary.Web.Viewmodels.Absences.AbsenceDetails> {
				return Client.get(`/${org}/Salary/Api/v1/Absence/Get/${id}`)
				             .then(data => convertByKeys(data, {"type":"Day","key":"StartDate"}, {"type":"Day","key":"EndDate"}, {"type":"Day","key":"Days.Date"}));
			}
		}
		export namespace List {
			export function Get(org: string, from?: Day, to?: Day): Promise<m.Bokio.Salary.Web.Viewmodels.Absences.AbsenceForList[]> {
				return Client.get(`/${org}/Salary/Api/v1/Absence/List`, { from, to })
				             .then(data => convertByKeys(data, {"type":"Day","key":"StartDate"}, {"type":"Day","key":"EndDate"}));
			}
		}
	}
	export namespace AGIController {
		export namespace ForMonth {
			export function Get(org: string, year: number, month: number): Promise<m.Envelope<m.Bokio.Salary.Web.Controllers.AGIViewModel, m.Bokio.Salary.Web.Controllers.AGIErrors>> {
				return Client.get(`/${org}/Salary/Api/v1/AGI/ForMonth`, { year, month });
			}
		}
	}
	export namespace BookkeepController {
		export namespace BookkeepSalaries {
			export function Post(org: string, command: m.Bokio.Salary.Contract.Payrolls.Commands.BookkeepSalaries): Promise<m.Envelope<m.Core.ViewData.VerificationForList[], m.Core.Recipes.FailReason>> {
				return Client.post(`/${org}/Salary/Api/v1/Bookkeep/BookkeepSalaries`, command)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.Date"}, {"type":"Day","key":"Data.ExpectPaymentAt"}, {"type":"Date","key":"Data.CreatedUtc"}));
			}
		}
		export namespace BookkeepTaxes {
			export function Post(org: string, request: m.Bokio.Salary.Web.Viewmodels.BookkeepTaxRequest): Promise<m.Envelope<m.Core.ViewData.VerificationForList[], m.SimpleError>> {
				return Client.post(`/${org}/Salary/Api/v1/Bookkeep/BookkeepTaxes`, request)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.Date"}, {"type":"Day","key":"Data.ExpectPaymentAt"}, {"type":"Date","key":"Data.CreatedUtc"}));
			}
		}
		export namespace BookkeepVacationTransactions {
			export function Post(org: string): Promise<m.Envelope<m.Core.ViewData.VerificationForList, m.SimpleError>> {
				return Client.post(`/${org}/Salary/Api/v1/Bookkeep/BookkeepVacationTransactions`, {  })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.Date"}, {"type":"Day","key":"Data.ExpectPaymentAt"}, {"type":"Date","key":"Data.CreatedUtc"}));
			}
		}
		export namespace BookkeepVacationYearEnd {
			export function Post(org: string, request: m.Bokio.Salary.Web.Viewmodels.Vacation.BookkeepVacationYearEndRequest): Promise<m.Envelope<m.Bokio.Salary.Web.Viewmodels.Vacation.VacationYearEndVerifications, m.SimpleError>> {
				return Client.post(`/${org}/Salary/Api/v1/Bookkeep/BookkeepVacationYearEnd`, request)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.ResetVerification.Date"}, {"type":"Day","key":"Data.ResetVerification.ExpectPaymentAt"}, {"type":"Date","key":"Data.ResetVerification.CreatedUtc"}, {"type":"Day","key":"Data.UpdatedVacationVerification.Date"}, {"type":"Day","key":"Data.UpdatedVacationVerification.ExpectPaymentAt"}, {"type":"Date","key":"Data.UpdatedVacationVerification.CreatedUtc"}));
			}
		}
		export namespace PreviewSalaryVerifications {
			export function Get(org: string, year: number, month: number, independentpayrollid?: string, account?: number): Promise<m.Core.ViewData.VerificationForList[]> {
				return Client.get(`/${org}/Salary/Api/v1/Bookkeep/PreviewSalaryVerifications/${year}/${month}/${account}`, { independentpayrollid })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Date"}, {"type":"Day","key":"ExpectPaymentAt"}, {"type":"Date","key":"CreatedUtc"}));
			}
		}
		export namespace PreviewTaxVerification {
			export function Get(org: string, year: number, month: number, account?: number): Promise<m.Core.ViewData.VerificationForList[]> {
				return Client.get(`/${org}/Salary/Api/v1/Bookkeep/PreviewTaxVerification/${year}/${month}/${account}`)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Date"}, {"type":"Day","key":"ExpectPaymentAt"}, {"type":"Date","key":"CreatedUtc"}));
			}
		}
		export namespace PreviewVacationTransactionVerifications {
			export function Get(org: string): Promise<m.Envelope<m.Core.ViewData.VerificationForList, m.SimpleError>> {
				return Client.get(`/${org}/Salary/Api/v1/Bookkeep/PreviewVacationTransactionVerifications`)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.Date"}, {"type":"Day","key":"Data.ExpectPaymentAt"}, {"type":"Date","key":"Data.CreatedUtc"}));
			}
		}
		export namespace PreviewVacationYearEndVerifications {
			export function Get(org: string, vacationYearEndId: string): Promise<m.Envelope<m.Bokio.Salary.Web.Viewmodels.Vacation.VacationYearEndVerifications, m.SimpleError>> {
				return Client.get(`/${org}/Salary/Api/v1/Bookkeep/PreviewVacationYearEndVerifications`, { vacationYearEndId })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.ResetVerification.Date"}, {"type":"Day","key":"Data.ResetVerification.ExpectPaymentAt"}, {"type":"Date","key":"Data.ResetVerification.CreatedUtc"}, {"type":"Day","key":"Data.UpdatedVacationVerification.Date"}, {"type":"Day","key":"Data.UpdatedVacationVerification.ExpectPaymentAt"}, {"type":"Date","key":"Data.UpdatedVacationVerification.CreatedUtc"}));
			}
		}
		export namespace UndoBookkeepSalaries {
			export function Post(org: string, command: m.Bokio.Salary.Contract.Payrolls.Commands.UndoBookkeepMonthSalaries): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Salary/Api/v1/Bookkeep/UndoBookkeepSalaries`, command);
			}
		}
		export namespace UndoBookkeepTax {
			export function Post(org: string, command: m.Bokio.Salary.Contract.Payrolls.Commands.UndoBookkeepMonthTax): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Salary/Api/v1/Bookkeep/UndoBookkeepTax`, command);
			}
		}
	}
	export namespace CompanyController {
		export namespace Index {
			export function Get(org: string): Promise<m.Bokio.Salary.Web.Viewmodels.CompanyViewModel> {
				return Client.get(`/${org}/Salary/Api/v1/Company`)
				             .then(data => convertByKeys(data, {"type":"CountrySubdivision","key":"SenderData.CountrySubdivision"}));
			}
		}
	}
	export namespace DirectorsPayrollSetupFlowController {
		export namespace Complete {
			export function Post(org: string, request: m.Bokio.Salary.Contract.Hmrc.Requests.CompleteRequest): Promise<m.Envelope<m.Bokio.Salary.Web.Viewmodels.Hmrc.DirectorsPayrollSetupFlowDto, m.SimpleError>> {
				return Client.post(`/${org}/Salary/Api/v1/DirectorsPayrollSetupFlow/Complete`, request)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.DateOfBirth"}, {"type":"Day","key":"Data.EmployementStartDate"}, {"type":"Day","key":"Data.StudentLoans.FromDate"}, {"type":"Day","key":"Data.StudentLoans.ToDate"}));
			}
		}
		export namespace CreateDirector {
			export function Post(org: string, request: m.Bokio.Salary.Contract.Hmrc.Requests.CreateDirectorRequest): Promise<m.Envelope<m.Bokio.Salary.Web.Viewmodels.Hmrc.DirectorsPayrollSetupFlowDto, m.SimpleError>> {
				return Client.post(`/${org}/Salary/Api/v1/DirectorsPayrollSetupFlow/CreateDirector`, request)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.DateOfBirth"}, {"type":"Day","key":"Data.EmployementStartDate"}, {"type":"Day","key":"Data.StudentLoans.FromDate"}, {"type":"Day","key":"Data.StudentLoans.ToDate"}));
			}
		}
		export namespace GetDirectorsPayrollSetupFlow {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Salary.Web.Viewmodels.Hmrc.DirectorsPayrollSetupFlowDto, m.SimpleError>> {
				return Client.get(`/${org}/Salary/Api/v1/DirectorsPayrollSetupFlow/GetDirectorsPayrollSetupFlow`)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.DateOfBirth"}, {"type":"Day","key":"Data.EmployementStartDate"}, {"type":"Day","key":"Data.StudentLoans.FromDate"}, {"type":"Day","key":"Data.StudentLoans.ToDate"}));
			}
		}
		export namespace GetEmployerSetup {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Salary.Web.Viewmodels.Hmrc.DirectorsPayrollSetupFlowDto, m.SimpleError>> {
				return Client.get(`/${org}/Salary/Api/v1/DirectorsPayrollSetupFlow/GetEmployerSetup`)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.DateOfBirth"}, {"type":"Day","key":"Data.EmployementStartDate"}, {"type":"Day","key":"Data.StudentLoans.FromDate"}, {"type":"Day","key":"Data.StudentLoans.ToDate"}));
			}
		}
		export namespace SaveDirectorDetails {
			export function Post(org: string, request: m.Bokio.Salary.Contract.Hmrc.Requests.SaveDirectorDetailsRequest): Promise<m.Envelope<m.Bokio.Salary.Web.Viewmodels.Hmrc.DirectorsPayrollSetupFlowDto, m.SimpleError>> {
				return Client.post(`/${org}/Salary/Api/v1/DirectorsPayrollSetupFlow/SaveDirectorDetails`, request)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.DateOfBirth"}, {"type":"Day","key":"Data.EmployementStartDate"}, {"type":"Day","key":"Data.StudentLoans.FromDate"}, {"type":"Day","key":"Data.StudentLoans.ToDate"}));
			}
		}
		export namespace SaveEmployementDetails {
			export function Post(org: string, request: m.Bokio.Salary.Contract.Hmrc.Requests.SaveEmployementDetailsRequest): Promise<m.Envelope<m.Bokio.Salary.Web.Viewmodels.Hmrc.DirectorsPayrollSetupFlowDto, m.SimpleError>> {
				return Client.post(`/${org}/Salary/Api/v1/DirectorsPayrollSetupFlow/SaveEmployementDetails`, request)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.DateOfBirth"}, {"type":"Day","key":"Data.EmployementStartDate"}, {"type":"Day","key":"Data.StudentLoans.FromDate"}, {"type":"Day","key":"Data.StudentLoans.ToDate"}));
			}
		}
		export namespace SaveTaxes {
			export function Post(org: string, request: m.Bokio.Salary.Contract.Hmrc.Requests.SaveTaxesRequest): Promise<m.Envelope<m.Bokio.Salary.Web.Viewmodels.Hmrc.DirectorsPayrollSetupFlowDto, m.SimpleError>> {
				return Client.post(`/${org}/Salary/Api/v1/DirectorsPayrollSetupFlow/SaveTaxes`, request)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.DateOfBirth"}, {"type":"Day","key":"Data.EmployementStartDate"}, {"type":"Day","key":"Data.StudentLoans.FromDate"}, {"type":"Day","key":"Data.StudentLoans.ToDate"}));
			}
		}
		export namespace SetupEmployer {
			export function Post(org: string, request: m.Bokio.Salary.Contract.Hmrc.Requests.SetupEmployerRequest): Promise<m.Envelope<m.Bokio.Salary.Web.Viewmodels.Hmrc.DirectorsPayrollSetupFlowDto, m.SimpleError>> {
				return Client.post(`/${org}/Salary/Api/v1/DirectorsPayrollSetupFlow/SetupEmployer`, request)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.DateOfBirth"}, {"type":"Day","key":"Data.EmployementStartDate"}, {"type":"Day","key":"Data.StudentLoans.FromDate"}, {"type":"Day","key":"Data.StudentLoans.ToDate"}));
			}
		}
	}
	export namespace EmployeesController {
		export namespace AddPlaceOfEmployment {
			export function Post(org: string, req: m.Bokio.Salary.Contract.Employees.Requests.AddPlaceOfEmploymentRequest): Promise<m.Envelope<m.Bokio.Salary.Web.Viewmodels.Employees.PlaceOfEmploymentViewModel, m.SimpleError>> {
				return Client.post(`/${org}/Salary/Api/v1/Employees/AddPlaceOfEmployment`, req);
			}
		}
		export namespace Create {
			export function Post(org: string): Promise<m.Bokio.Salary.Web.Viewmodels.Employees.EmployeeDetails> {
				return Client.post(`/${org}/Salary/Api/v1/Employees/Create`, {  })
				             .then(data => convertByKeys(data, {"type":"Date","key":"EmployeePeriodSetting.Employee.EmployedSinceUTC"}, {"type":"Date","key":"EmployeePeriodSetting.Employee.CreatedUTC"}, {"type":"Day","key":"EmployeePeriodSetting.Employee.DateOfBirth"}, {"type":"Date","key":"EmployeePeriodSetting.Employee.OnboardingDateUtc"}, {"type":"Day","key":"EmployeePeriodSetting.FromDate"}, {"type":"Day","key":"EmployeePeriodSetting.ToDate"}, {"type":"Day","key":"EmployeePeriodSetting.VacationSettings.DiscardVacationDebtDate"}));
			}
		}
		export namespace CreateDraftEmployee {
			export function Post(org: string, command: m.Bokio.Salary.Web.Viewmodels.Employees.CreateDraftEmployeeDto): Promise<m.Bokio.Salary.Web.Viewmodels.Employees.EmployeeDetails> {
				return Client.post(`/${org}/Salary/Api/v1/Employees/CreateDraftEmployee`, command)
				             .then(data => convertByKeys(data, {"type":"Date","key":"EmployeePeriodSetting.Employee.EmployedSinceUTC"}, {"type":"Date","key":"EmployeePeriodSetting.Employee.CreatedUTC"}, {"type":"Day","key":"EmployeePeriodSetting.Employee.DateOfBirth"}, {"type":"Date","key":"EmployeePeriodSetting.Employee.OnboardingDateUtc"}, {"type":"Day","key":"EmployeePeriodSetting.FromDate"}, {"type":"Day","key":"EmployeePeriodSetting.ToDate"}, {"type":"Day","key":"EmployeePeriodSetting.VacationSettings.DiscardVacationDebtDate"}));
			}
		}
		export namespace CreateEmployeeAndPeriodSetting {
			export function Post(org: string, dto: m.Bokio.Salary.Contract.Employees.Dtos.CreateEmployeeAndPeriodSettingDto): Promise<m.Envelope<m.Bokio.Salary.Web.Controllers.CreateEmployeeAndPeriodSettingResult, m.SimpleError>> {
				return Client.post(`/${org}/Salary/Api/v1/Employees/CreateEmployeeAndPeriodSetting`, dto)
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.Employee.EmployeePeriodSetting.Employee.EmployedSinceUTC"}, {"type":"Date","key":"Data.Employee.EmployeePeriodSetting.Employee.CreatedUTC"}, {"type":"Day","key":"Data.Employee.EmployeePeriodSetting.Employee.DateOfBirth"}, {"type":"Date","key":"Data.Employee.EmployeePeriodSetting.Employee.OnboardingDateUtc"}, {"type":"Day","key":"Data.Employee.EmployeePeriodSetting.FromDate"}, {"type":"Day","key":"Data.Employee.EmployeePeriodSetting.ToDate"}, {"type":"Day","key":"Data.Employee.EmployeePeriodSetting.VacationSettings.DiscardVacationDebtDate"}, {"type":"Date","key":"Data.PeriodSetting.Employee.EmployedSinceUTC"}, {"type":"Date","key":"Data.PeriodSetting.Employee.CreatedUTC"}, {"type":"Day","key":"Data.PeriodSetting.Employee.DateOfBirth"}, {"type":"Date","key":"Data.PeriodSetting.Employee.OnboardingDateUtc"}, {"type":"Day","key":"Data.PeriodSetting.FromDate"}, {"type":"Day","key":"Data.PeriodSetting.ToDate"}, {"type":"Day","key":"Data.PeriodSetting.VacationSettings.DiscardVacationDebtDate"}));
			}
		}
		export namespace CreatePeriodSetting {
			export function Post(org: string, request: m.Bokio.Salary.Contract.Employees.Dtos.CreatePeriodSettingRequest): Promise<m.Envelope<m.Bokio.Salary.Web.Viewmodels.Employees.EmployeePeriodSettingViewModel, m.SimpleError>> {
				return Client.post(`/${org}/Salary/Api/v1/Employees/CreatePeriodSetting`, request)
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.Employee.EmployedSinceUTC"}, {"type":"Date","key":"Data.Employee.CreatedUTC"}, {"type":"Day","key":"Data.Employee.DateOfBirth"}, {"type":"Date","key":"Data.Employee.OnboardingDateUtc"}, {"type":"Day","key":"Data.FromDate"}, {"type":"Day","key":"Data.ToDate"}, {"type":"Day","key":"Data.VacationSettings.DiscardVacationDebtDate"}));
			}
		}
		export namespace CreateUK {
			export function Post(org: string, request: m.Bokio.Salary.Web.Viewmodels.Hmrc.DirectorsPayrollSetupFlowDto): Promise<m.Envelope<m.Bokio.Salary.Web.Viewmodels.Employees.EmployeeDetails, m.SimpleError>> {
				return Client.post(`/${org}/Salary/Api/v1/Employees/CreateUK`, request)
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.EmployeePeriodSetting.Employee.EmployedSinceUTC"}, {"type":"Date","key":"Data.EmployeePeriodSetting.Employee.CreatedUTC"}, {"type":"Day","key":"Data.EmployeePeriodSetting.Employee.DateOfBirth"}, {"type":"Date","key":"Data.EmployeePeriodSetting.Employee.OnboardingDateUtc"}, {"type":"Day","key":"Data.EmployeePeriodSetting.FromDate"}, {"type":"Day","key":"Data.EmployeePeriodSetting.ToDate"}, {"type":"Day","key":"Data.EmployeePeriodSetting.VacationSettings.DiscardVacationDebtDate"}));
			}
		}
		export namespace CreateWithDetails {
			export function Post(org: string, request: m.Bokio.Salary.Contract.Employees.Dtos.CreateWithDetailsRequest): Promise<m.Bokio.Salary.Web.Viewmodels.Employees.EmployeeDetails> {
				return Client.post(`/${org}/Salary/Api/v1/Employees/CreateWithDetails`, request)
				             .then(data => convertByKeys(data, {"type":"Date","key":"EmployeePeriodSetting.Employee.EmployedSinceUTC"}, {"type":"Date","key":"EmployeePeriodSetting.Employee.CreatedUTC"}, {"type":"Day","key":"EmployeePeriodSetting.Employee.DateOfBirth"}, {"type":"Date","key":"EmployeePeriodSetting.Employee.OnboardingDateUtc"}, {"type":"Day","key":"EmployeePeriodSetting.FromDate"}, {"type":"Day","key":"EmployeePeriodSetting.ToDate"}, {"type":"Day","key":"EmployeePeriodSetting.VacationSettings.DiscardVacationDebtDate"}));
			}
		}
		export namespace Delete {
			export function Delete(org: string, employeeId: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client._delete(`/${org}/Salary/Api/v1/Employees/Delete`, { employeeId });
			}
		}
		export namespace DeletePeriodSetting {
			export function Post(org: string, command: m.Bokio.Salary.Contract.Employees.Commands.DeletePeriodSetting): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Salary/Api/v1/Employees/DeletePeriodSetting`, command);
			}
		}
		export namespace DeletePlaceOfEmployment {
			export function Delete(org: string, id: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client._delete(`/${org}/Salary/Api/v1/Employees/DeletePlaceOfEmployment/${id}`, {  });
			}
		}
		export namespace Edit {
			export function Post(org: string, id: string, request: m.Bokio.Salary.Contract.Employees.Dtos.EditEmployeeRequest): Promise<m.Bokio.Salary.Web.Viewmodels.Employees.EmployeeDetails> {
				return Client.post(`/${org}/Salary/Api/v1/Employees/Edit/${id}`, request)
				             .then(data => convertByKeys(data, {"type":"Date","key":"EmployeePeriodSetting.Employee.EmployedSinceUTC"}, {"type":"Date","key":"EmployeePeriodSetting.Employee.CreatedUTC"}, {"type":"Day","key":"EmployeePeriodSetting.Employee.DateOfBirth"}, {"type":"Date","key":"EmployeePeriodSetting.Employee.OnboardingDateUtc"}, {"type":"Day","key":"EmployeePeriodSetting.FromDate"}, {"type":"Day","key":"EmployeePeriodSetting.ToDate"}, {"type":"Day","key":"EmployeePeriodSetting.VacationSettings.DiscardVacationDebtDate"}));
			}
		}
		export namespace EditEmployeeAndPeriodSetting {
			export function Post(org: string, request: m.Bokio.Salary.Contract.Employees.Dtos.EditEmployeeAndPeriodSettingRequest): Promise<m.Envelope<m.Bokio.Salary.Web.Controllers.CreateEmployeeAndPeriodSettingResult, m.SimpleError>> {
				return Client.post(`/${org}/Salary/Api/v1/Employees/EditEmployeeAndPeriodSetting`, request)
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.Employee.EmployeePeriodSetting.Employee.EmployedSinceUTC"}, {"type":"Date","key":"Data.Employee.EmployeePeriodSetting.Employee.CreatedUTC"}, {"type":"Day","key":"Data.Employee.EmployeePeriodSetting.Employee.DateOfBirth"}, {"type":"Date","key":"Data.Employee.EmployeePeriodSetting.Employee.OnboardingDateUtc"}, {"type":"Day","key":"Data.Employee.EmployeePeriodSetting.FromDate"}, {"type":"Day","key":"Data.Employee.EmployeePeriodSetting.ToDate"}, {"type":"Day","key":"Data.Employee.EmployeePeriodSetting.VacationSettings.DiscardVacationDebtDate"}, {"type":"Date","key":"Data.PeriodSetting.Employee.EmployedSinceUTC"}, {"type":"Date","key":"Data.PeriodSetting.Employee.CreatedUTC"}, {"type":"Day","key":"Data.PeriodSetting.Employee.DateOfBirth"}, {"type":"Date","key":"Data.PeriodSetting.Employee.OnboardingDateUtc"}, {"type":"Day","key":"Data.PeriodSetting.FromDate"}, {"type":"Day","key":"Data.PeriodSetting.ToDate"}, {"type":"Day","key":"Data.PeriodSetting.VacationSettings.DiscardVacationDebtDate"}));
			}
		}
		export namespace EditPeriodSetting {
			export function Post(org: string, request: m.Bokio.Salary.Contract.Employees.Dtos.EditPeriodSettingRequest): Promise<m.Envelope<m.Bokio.Salary.Web.Viewmodels.Employees.EmployeePeriodSettingViewModel, m.SimpleError>> {
				return Client.post(`/${org}/Salary/Api/v1/Employees/EditPeriodSetting`, request)
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.Employee.EmployedSinceUTC"}, {"type":"Date","key":"Data.Employee.CreatedUTC"}, {"type":"Day","key":"Data.Employee.DateOfBirth"}, {"type":"Date","key":"Data.Employee.OnboardingDateUtc"}, {"type":"Day","key":"Data.FromDate"}, {"type":"Day","key":"Data.ToDate"}, {"type":"Day","key":"Data.VacationSettings.DiscardVacationDebtDate"}));
			}
		}
		export namespace EditVactionSettings {
			export function Post(org: string, request: m.Bokio.Salary.Contract.Employees.Dtos.EditVacationSettingsRequest): Promise<m.Envelope<m.Bokio.Salary.Web.Controllers.CreateEmployeeAndPeriodSettingResult, m.SimpleError>> {
				return Client.post(`/${org}/Salary/Api/v1/Employees/EditVactionSettings`, request)
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.Employee.EmployeePeriodSetting.Employee.EmployedSinceUTC"}, {"type":"Date","key":"Data.Employee.EmployeePeriodSetting.Employee.CreatedUTC"}, {"type":"Day","key":"Data.Employee.EmployeePeriodSetting.Employee.DateOfBirth"}, {"type":"Date","key":"Data.Employee.EmployeePeriodSetting.Employee.OnboardingDateUtc"}, {"type":"Day","key":"Data.Employee.EmployeePeriodSetting.FromDate"}, {"type":"Day","key":"Data.Employee.EmployeePeriodSetting.ToDate"}, {"type":"Day","key":"Data.Employee.EmployeePeriodSetting.VacationSettings.DiscardVacationDebtDate"}, {"type":"Date","key":"Data.PeriodSetting.Employee.EmployedSinceUTC"}, {"type":"Date","key":"Data.PeriodSetting.Employee.CreatedUTC"}, {"type":"Day","key":"Data.PeriodSetting.Employee.DateOfBirth"}, {"type":"Date","key":"Data.PeriodSetting.Employee.OnboardingDateUtc"}, {"type":"Day","key":"Data.PeriodSetting.FromDate"}, {"type":"Day","key":"Data.PeriodSetting.ToDate"}, {"type":"Day","key":"Data.PeriodSetting.VacationSettings.DiscardVacationDebtDate"}));
			}
		}
		export namespace Get {
			export function Get(org: string, id: string): Promise<m.Bokio.Salary.Web.Viewmodels.Employees.EmployeeDetails> {
				return Client.get(`/${org}/Salary/Api/v1/Employees/Get/${id}`)
				             .then(data => convertByKeys(data, {"type":"Date","key":"EmployeePeriodSetting.Employee.EmployedSinceUTC"}, {"type":"Date","key":"EmployeePeriodSetting.Employee.CreatedUTC"}, {"type":"Day","key":"EmployeePeriodSetting.Employee.DateOfBirth"}, {"type":"Date","key":"EmployeePeriodSetting.Employee.OnboardingDateUtc"}, {"type":"Day","key":"EmployeePeriodSetting.FromDate"}, {"type":"Day","key":"EmployeePeriodSetting.ToDate"}, {"type":"Day","key":"EmployeePeriodSetting.VacationSettings.DiscardVacationDebtDate"}));
			}
		}
		export namespace GetAll {
			export function Get(org: string, id: string, periodSettingId?: string): Promise<m.Envelope<m.Bokio.Salary.Web.Controllers.CreateEmployeeAndPeriodSettingResult, m.SimpleError>> {
				return Client.get(`/${org}/Salary/Api/v1/Employees/GetAll/${id}`, { periodSettingId })
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.Employee.EmployeePeriodSetting.Employee.EmployedSinceUTC"}, {"type":"Date","key":"Data.Employee.EmployeePeriodSetting.Employee.CreatedUTC"}, {"type":"Day","key":"Data.Employee.EmployeePeriodSetting.Employee.DateOfBirth"}, {"type":"Date","key":"Data.Employee.EmployeePeriodSetting.Employee.OnboardingDateUtc"}, {"type":"Day","key":"Data.Employee.EmployeePeriodSetting.FromDate"}, {"type":"Day","key":"Data.Employee.EmployeePeriodSetting.ToDate"}, {"type":"Day","key":"Data.Employee.EmployeePeriodSetting.VacationSettings.DiscardVacationDebtDate"}, {"type":"Date","key":"Data.PeriodSetting.Employee.EmployedSinceUTC"}, {"type":"Date","key":"Data.PeriodSetting.Employee.CreatedUTC"}, {"type":"Day","key":"Data.PeriodSetting.Employee.DateOfBirth"}, {"type":"Date","key":"Data.PeriodSetting.Employee.OnboardingDateUtc"}, {"type":"Day","key":"Data.PeriodSetting.FromDate"}, {"type":"Day","key":"Data.PeriodSetting.ToDate"}, {"type":"Day","key":"Data.PeriodSetting.VacationSettings.DiscardVacationDebtDate"}));
			}
		}
		export namespace GetAllowedPeriodSettingOperations {
			export function Get(org: string, employeeId: string, periodSettingId: string): Promise<m.Envelope<m.Bokio.Salary.Web.Viewmodels.Employees.EmployeePeriodSettingsOperationsViewModel, m.SimpleError>> {
				return Client.get(`/${org}/Salary/Api/v1/Employees/GetAllowedPeriodSettingOperations`, { employeeId, periodSettingId });
			}
		}
		export namespace GetAllowedPeriodSettingOperationsCurrentPeriodSetting {
			export function Get(org: string, employeeId: string): Promise<m.Envelope<m.Bokio.Salary.Web.Viewmodels.Employees.EmployeePeriodSettingsOperationsViewModel, m.SimpleError>> {
				return Client.get(`/${org}/Salary/Api/v1/Employees/GetAllowedPeriodSettingOperationsCurrentPeriodSetting`, { employeeId });
			}
		}
		export namespace GetCurrentEmployeeBillingPlan {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Salary.Web.Viewmodels.Employees.EmployeeBillingPlanViewModel, m.SimpleError>> {
				return Client.get(`/${org}/Salary/Api/v1/Employees/GetCurrentEmployeeBillingPlan`)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.FreeSeatOverrideValidUntil"}));
			}
		}
		export namespace GetDirectorDetails {
			export function Get(org: string, employeeId: string): Promise<m.Envelope<m.Bokio.Salary.Web.Viewmodels.Hmrc.DirectorsPayrollSetupFlowDto, m.SimpleError>> {
				return Client.get(`/${org}/Salary/Api/v1/Employees/GetDirectorDetails`, { employeeId })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.DateOfBirth"}, {"type":"Day","key":"Data.EmployementStartDate"}, {"type":"Day","key":"Data.StudentLoans.FromDate"}, {"type":"Day","key":"Data.StudentLoans.ToDate"}));
			}
		}
		export namespace GetEmployee {
			export function Get(org: string, id: string): Promise<m.Envelope<m.Bokio.Salary.Web.Viewmodels.Employees.EmployeeWithPeriodSettings, m.SimpleError>> {
				return Client.get(`/${org}/Salary/Api/v1/Employees/GetEmployee/${id}`)
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.CurrentPeriodSetting.Employee.EmployedSinceUTC"}, {"type":"Date","key":"Data.CurrentPeriodSetting.Employee.CreatedUTC"}, {"type":"Day","key":"Data.CurrentPeriodSetting.Employee.DateOfBirth"}, {"type":"Date","key":"Data.CurrentPeriodSetting.Employee.OnboardingDateUtc"}, {"type":"Day","key":"Data.CurrentPeriodSetting.FromDate"}, {"type":"Day","key":"Data.CurrentPeriodSetting.ToDate"}, {"type":"Day","key":"Data.CurrentPeriodSetting.VacationSettings.DiscardVacationDebtDate"}, {"type":"Date","key":"Data.EmployeePeriodSettings.Employee.EmployedSinceUTC"}, {"type":"Date","key":"Data.EmployeePeriodSettings.Employee.CreatedUTC"}, {"type":"Day","key":"Data.EmployeePeriodSettings.Employee.DateOfBirth"}, {"type":"Date","key":"Data.EmployeePeriodSettings.Employee.OnboardingDateUtc"}, {"type":"Day","key":"Data.EmployeePeriodSettings.FromDate"}, {"type":"Day","key":"Data.EmployeePeriodSettings.ToDate"}, {"type":"Day","key":"Data.EmployeePeriodSettings.VacationSettings.DiscardVacationDebtDate"}, {"type":"Day","key":"Data.VacationBalance.Transactions.PayDate"}, {"type":"Day","key":"Data.VacationBalance.Transactions.FromDate"}, {"type":"Day","key":"Data.VacationBalance.Transactions.ToDate"}, {"type":"Day","key":"Data.VacationBalance.Transactions.TransactionDate"}, {"type":"Day","key":"Data.VacationBalance.AccrualTransactions.TransactionDate"}, {"type":"Day","key":"Data.VacationBalance.AccrualTransactions.PayDate"}));
			}
		}
		export namespace GetEmployeeDetails {
			export function Get(org: string, periodSettingId?: string): Promise<m.Envelope<m.Bokio.Salary.Web.Controllers.CreateEmployeeAndPeriodSettingResult, m.SimpleError>> {
				return Client.get(`/${org}/Salary/Api/v1/Employees/GetEmployeeDetails`, { periodSettingId })
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.Employee.EmployeePeriodSetting.Employee.EmployedSinceUTC"}, {"type":"Date","key":"Data.Employee.EmployeePeriodSetting.Employee.CreatedUTC"}, {"type":"Day","key":"Data.Employee.EmployeePeriodSetting.Employee.DateOfBirth"}, {"type":"Date","key":"Data.Employee.EmployeePeriodSetting.Employee.OnboardingDateUtc"}, {"type":"Day","key":"Data.Employee.EmployeePeriodSetting.FromDate"}, {"type":"Day","key":"Data.Employee.EmployeePeriodSetting.ToDate"}, {"type":"Day","key":"Data.Employee.EmployeePeriodSetting.VacationSettings.DiscardVacationDebtDate"}, {"type":"Date","key":"Data.PeriodSetting.Employee.EmployedSinceUTC"}, {"type":"Date","key":"Data.PeriodSetting.Employee.CreatedUTC"}, {"type":"Day","key":"Data.PeriodSetting.Employee.DateOfBirth"}, {"type":"Date","key":"Data.PeriodSetting.Employee.OnboardingDateUtc"}, {"type":"Day","key":"Data.PeriodSetting.FromDate"}, {"type":"Day","key":"Data.PeriodSetting.ToDate"}, {"type":"Day","key":"Data.PeriodSetting.VacationSettings.DiscardVacationDebtDate"}));
			}
		}
		export namespace GetEmployees {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Salary.Web.Viewmodels.Employees.EmployeeWithPeriodSettings[], m.SimpleError>> {
				return Client.get(`/${org}/Salary/Api/v1/Employees/GetEmployees`)
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.CurrentPeriodSetting.Employee.EmployedSinceUTC"}, {"type":"Date","key":"Data.CurrentPeriodSetting.Employee.CreatedUTC"}, {"type":"Day","key":"Data.CurrentPeriodSetting.Employee.DateOfBirth"}, {"type":"Date","key":"Data.CurrentPeriodSetting.Employee.OnboardingDateUtc"}, {"type":"Day","key":"Data.CurrentPeriodSetting.FromDate"}, {"type":"Day","key":"Data.CurrentPeriodSetting.ToDate"}, {"type":"Day","key":"Data.CurrentPeriodSetting.VacationSettings.DiscardVacationDebtDate"}, {"type":"Date","key":"Data.EmployeePeriodSettings.Employee.EmployedSinceUTC"}, {"type":"Date","key":"Data.EmployeePeriodSettings.Employee.CreatedUTC"}, {"type":"Day","key":"Data.EmployeePeriodSettings.Employee.DateOfBirth"}, {"type":"Date","key":"Data.EmployeePeriodSettings.Employee.OnboardingDateUtc"}, {"type":"Day","key":"Data.EmployeePeriodSettings.FromDate"}, {"type":"Day","key":"Data.EmployeePeriodSettings.ToDate"}, {"type":"Day","key":"Data.EmployeePeriodSettings.VacationSettings.DiscardVacationDebtDate"}, {"type":"Day","key":"Data.VacationBalance.Transactions.PayDate"}, {"type":"Day","key":"Data.VacationBalance.Transactions.FromDate"}, {"type":"Day","key":"Data.VacationBalance.Transactions.ToDate"}, {"type":"Day","key":"Data.VacationBalance.Transactions.TransactionDate"}, {"type":"Day","key":"Data.VacationBalance.AccrualTransactions.TransactionDate"}, {"type":"Day","key":"Data.VacationBalance.AccrualTransactions.PayDate"}));
			}
		}
		export namespace GetEmployeesInfoForMonth {
			export function Get(org: string, request: m.Bokio.Salary.Web.Controllers.GetFirstEmployeeRequest): Promise<m.Envelope<m.Bokio.Salary.Web.Controllers.EmployeesInfoForMonthViewModel, m.SimpleError>> {
				return Client.get(`/${org}/Salary/Api/v1/Employees/GetEmployeesInfoForMonth`, { request });
			}
		}
		export namespace GetExpenseEmployees {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Salary.Web.Viewmodels.Employees.ExpenseEmployees, m.SimpleError>> {
				return Client.get(`/${org}/Salary/Api/v1/Employees/GetExpenseEmployees`);
			}
		}
		export namespace GetJobTitleList {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Salary.Web.Viewmodels.Employees.JobTitleList[], m.SimpleError>> {
				return Client.get(`/${org}/Salary/Api/v1/Employees/GetJobTitleList`);
			}
		}
		export namespace GetMyEmployee {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Salary.Web.Viewmodels.Employees.EmployeeWithPeriodSettings, m.SimpleError>> {
				return Client.get(`/${org}/Salary/Api/v1/Employees/GetMyEmployee`)
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.CurrentPeriodSetting.Employee.EmployedSinceUTC"}, {"type":"Date","key":"Data.CurrentPeriodSetting.Employee.CreatedUTC"}, {"type":"Day","key":"Data.CurrentPeriodSetting.Employee.DateOfBirth"}, {"type":"Date","key":"Data.CurrentPeriodSetting.Employee.OnboardingDateUtc"}, {"type":"Day","key":"Data.CurrentPeriodSetting.FromDate"}, {"type":"Day","key":"Data.CurrentPeriodSetting.ToDate"}, {"type":"Day","key":"Data.CurrentPeriodSetting.VacationSettings.DiscardVacationDebtDate"}, {"type":"Date","key":"Data.EmployeePeriodSettings.Employee.EmployedSinceUTC"}, {"type":"Date","key":"Data.EmployeePeriodSettings.Employee.CreatedUTC"}, {"type":"Day","key":"Data.EmployeePeriodSettings.Employee.DateOfBirth"}, {"type":"Date","key":"Data.EmployeePeriodSettings.Employee.OnboardingDateUtc"}, {"type":"Day","key":"Data.EmployeePeriodSettings.FromDate"}, {"type":"Day","key":"Data.EmployeePeriodSettings.ToDate"}, {"type":"Day","key":"Data.EmployeePeriodSettings.VacationSettings.DiscardVacationDebtDate"}, {"type":"Day","key":"Data.VacationBalance.Transactions.PayDate"}, {"type":"Day","key":"Data.VacationBalance.Transactions.FromDate"}, {"type":"Day","key":"Data.VacationBalance.Transactions.ToDate"}, {"type":"Day","key":"Data.VacationBalance.Transactions.TransactionDate"}, {"type":"Day","key":"Data.VacationBalance.AccrualTransactions.TransactionDate"}, {"type":"Day","key":"Data.VacationBalance.AccrualTransactions.PayDate"}));
			}
		}
		export namespace GetMyP60List {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Salary.Contract.Payrolls.Dtos.P60ViewModel[], m.SimpleError>> {
				return Client.get(`/${org}/Salary/Api/v1/Employees/GetMyP60List`);
			}
		}
		export namespace GetMyPayslips {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Salary.Web.Viewmodels.Payrolls.EmployeeSummaryRow[], m.SimpleError>> {
				return Client.get(`/${org}/Salary/Api/v1/Employees/GetMyPayslips`)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.PeriodFrom"}, {"type":"Day","key":"Data.PeriodTo"}, {"type":"Day","key":"Data.PayDate"}, {"type":"Day","key":"Data.LastDayOfEmployment"}));
			}
		}
		export namespace GetMyPayslipsConnectedToCurrentPeriodSetting {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Salary.Web.Viewmodels.Payrolls.EmployeeSummaryRow[], m.SimpleError>> {
				return Client.get(`/${org}/Salary/Api/v1/Employees/GetMyPayslipsConnectedToCurrentPeriodSetting`)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.PeriodFrom"}, {"type":"Day","key":"Data.PeriodTo"}, {"type":"Day","key":"Data.PayDate"}, {"type":"Day","key":"Data.LastDayOfEmployment"}));
			}
		}
		export namespace GetMyPayslipsConnectedToPeriodSetting {
			export function Get(org: string, periodSettingId: string): Promise<m.Envelope<m.Bokio.Salary.Web.Viewmodels.Payrolls.EmployeeSummaryRow[], m.SimpleError>> {
				return Client.get(`/${org}/Salary/Api/v1/Employees/GetMyPayslipsConnectedToPeriodSetting`, { periodSettingId })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.PeriodFrom"}, {"type":"Day","key":"Data.PeriodTo"}, {"type":"Day","key":"Data.PayDate"}, {"type":"Day","key":"Data.LastDayOfEmployment"}));
			}
		}
		export namespace GetOverridesData {
			export function Get(org: string, id: string, periodSettingId: string): Promise<m.Envelope<m.Bokio.Salary.Web.Viewmodels.Employees.EmployeePeriodSettingViewModel, m.SimpleError>> {
				return Client.get(`/${org}/Salary/Api/v1/Employees/GetOverridesData/${id}`, { periodSettingId })
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.Employee.EmployedSinceUTC"}, {"type":"Date","key":"Data.Employee.CreatedUTC"}, {"type":"Day","key":"Data.Employee.DateOfBirth"}, {"type":"Date","key":"Data.Employee.OnboardingDateUtc"}, {"type":"Day","key":"Data.FromDate"}, {"type":"Day","key":"Data.ToDate"}, {"type":"Day","key":"Data.VacationSettings.DiscardVacationDebtDate"}));
			}
		}
		export namespace GetPeriodSetting {
			export function Get(org: string, id: string, periodSettingId: string): Promise<m.Envelope<m.Bokio.Salary.Web.Viewmodels.Employees.EmployeePeriodSettingViewModel, m.SimpleError>> {
				return Client.get(`/${org}/Salary/Api/v1/Employees/GetPeriodSetting/${id}`, { periodSettingId })
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.Employee.EmployedSinceUTC"}, {"type":"Date","key":"Data.Employee.CreatedUTC"}, {"type":"Day","key":"Data.Employee.DateOfBirth"}, {"type":"Date","key":"Data.Employee.OnboardingDateUtc"}, {"type":"Day","key":"Data.FromDate"}, {"type":"Day","key":"Data.ToDate"}, {"type":"Day","key":"Data.VacationSettings.DiscardVacationDebtDate"}));
			}
		}
		export namespace GetRequiredDataForActivation {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Salary.Web.Viewmodels.Employees.RequiredDataForEmployeeActivationViewModel, m.SimpleError>> {
				return Client.get(`/${org}/Salary/Api/v1/Employees/GetRequiredDataForActivation`);
			}
		}
		export namespace Index {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Salary.Web.Viewmodels.Employees.EmployeeDetails[], m.SimpleError>> {
				return Client.get(`/${org}/Salary/Api/v1/Employees`)
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.EmployeePeriodSetting.Employee.EmployedSinceUTC"}, {"type":"Date","key":"Data.EmployeePeriodSetting.Employee.CreatedUTC"}, {"type":"Day","key":"Data.EmployeePeriodSetting.Employee.DateOfBirth"}, {"type":"Date","key":"Data.EmployeePeriodSetting.Employee.OnboardingDateUtc"}, {"type":"Day","key":"Data.EmployeePeriodSetting.FromDate"}, {"type":"Day","key":"Data.EmployeePeriodSetting.ToDate"}, {"type":"Day","key":"Data.EmployeePeriodSetting.VacationSettings.DiscardVacationDebtDate"}));
			}
		}
		export namespace List {
			export function Get(org: string): Promise<m.Bokio.Salary.Web.Viewmodels.Employees.EmployeeForList[]> {
				return Client.get(`/${org}/Salary/Api/v1/Employees/List`);
			}
		}
		export namespace Me {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Salary.Web.Viewmodels.Employees.EmployeeDetails, m.SimpleError>> {
				return Client.get(`/${org}/Salary/Api/v1/Employees/Me`)
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.EmployeePeriodSetting.Employee.EmployedSinceUTC"}, {"type":"Date","key":"Data.EmployeePeriodSetting.Employee.CreatedUTC"}, {"type":"Day","key":"Data.EmployeePeriodSetting.Employee.DateOfBirth"}, {"type":"Date","key":"Data.EmployeePeriodSetting.Employee.OnboardingDateUtc"}, {"type":"Day","key":"Data.EmployeePeriodSetting.FromDate"}, {"type":"Day","key":"Data.EmployeePeriodSetting.ToDate"}, {"type":"Day","key":"Data.EmployeePeriodSetting.VacationSettings.DiscardVacationDebtDate"}));
			}
		}
		export namespace MyLastDateOfEmploymentForP45 {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Salary.Contract.Payrolls.Dtos.P45ViewModel, m.SimpleError>> {
				return Client.get(`/${org}/Salary/Api/v1/Employees/MyLastDateOfEmploymentForP45`)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.LastDayOfEmployment"}));
			}
		}
		export namespace Payslips {
			export function Get(org: string, id: string): Promise<m.Envelope<m.Bokio.Salary.Web.Viewmodels.Payrolls.EmployeeSummaryRow[], m.SimpleError>> {
				return Client.get(`/${org}/Salary/Api/v1/Employees/Payslips/${id}`)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.PeriodFrom"}, {"type":"Day","key":"Data.PeriodTo"}, {"type":"Day","key":"Data.PayDate"}, {"type":"Day","key":"Data.LastDayOfEmployment"}));
			}
		}
		export namespace PayslipsConnectedToCurrentPeriodSetting {
			export function Get(org: string, employeeId: string): Promise<m.Envelope<m.Bokio.Salary.Web.Viewmodels.Payrolls.EmployeeSummaryRow[], m.SimpleError>> {
				return Client.get(`/${org}/Salary/Api/v1/Employees/PayslipsConnectedToCurrentPeriodSetting`, { employeeId })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.PeriodFrom"}, {"type":"Day","key":"Data.PeriodTo"}, {"type":"Day","key":"Data.PayDate"}, {"type":"Day","key":"Data.LastDayOfEmployment"}));
			}
		}
		export namespace PayslipsConnectedToPeriodSetting {
			export function Get(org: string, employeeId: string, periodSettingId: string): Promise<m.Envelope<m.Bokio.Salary.Web.Viewmodels.Payrolls.EmployeeSummaryRow[], m.SimpleError>> {
				return Client.get(`/${org}/Salary/Api/v1/Employees/PayslipsConnectedToPeriodSetting`, { employeeId, periodSettingId })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.PeriodFrom"}, {"type":"Day","key":"Data.PeriodTo"}, {"type":"Day","key":"Data.PayDate"}, {"type":"Day","key":"Data.LastDayOfEmployment"}));
			}
		}
		export namespace PlaceOfEmploymentList {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Salary.Web.Viewmodels.Employees.PlaceOfEmploymentViewModel[], m.SimpleError>> {
				return Client.get(`/${org}/Salary/Api/v1/Employees/PlaceOfEmploymentList`);
			}
		}
		export namespace SetLastDateOfEmployment {
			export function Post(org: string, command: m.Bokio.Salary.Contract.Employees.Commands.SetLastDateOfEmployment): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Salary/Api/v1/Employees/SetLastDateOfEmployment`, command);
			}
		}
		export namespace SetSalaryValues {
			export function Post(org: string, command: m.Bokio.Salary.Contract.Employees.Commands.CreateSalaryValues): Promise<m.Envelope<m.Bokio.Salary.Web.Controllers.CreateEmployeeAndPeriodSettingResult, m.SimpleError>> {
				return Client.post(`/${org}/Salary/Api/v1/Employees/SetSalaryValues`, command)
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.Employee.EmployeePeriodSetting.Employee.EmployedSinceUTC"}, {"type":"Date","key":"Data.Employee.EmployeePeriodSetting.Employee.CreatedUTC"}, {"type":"Day","key":"Data.Employee.EmployeePeriodSetting.Employee.DateOfBirth"}, {"type":"Date","key":"Data.Employee.EmployeePeriodSetting.Employee.OnboardingDateUtc"}, {"type":"Day","key":"Data.Employee.EmployeePeriodSetting.FromDate"}, {"type":"Day","key":"Data.Employee.EmployeePeriodSetting.ToDate"}, {"type":"Day","key":"Data.Employee.EmployeePeriodSetting.VacationSettings.DiscardVacationDebtDate"}, {"type":"Date","key":"Data.PeriodSetting.Employee.EmployedSinceUTC"}, {"type":"Date","key":"Data.PeriodSetting.Employee.CreatedUTC"}, {"type":"Day","key":"Data.PeriodSetting.Employee.DateOfBirth"}, {"type":"Date","key":"Data.PeriodSetting.Employee.OnboardingDateUtc"}, {"type":"Day","key":"Data.PeriodSetting.FromDate"}, {"type":"Day","key":"Data.PeriodSetting.ToDate"}, {"type":"Day","key":"Data.PeriodSetting.VacationSettings.DiscardVacationDebtDate"}));
			}
		}
		export namespace UndoDelete {
			export function Post(org: string, command: m.Bokio.Salary.Contract.Employees.Commands.UndoDeleteEmployee): Promise<m.Bokio.Salary.Web.Viewmodels.Employees.EmployeeDetails> {
				return Client.post(`/${org}/Salary/Api/v1/Employees/UndoDelete`, command)
				             .then(data => convertByKeys(data, {"type":"Date","key":"EmployeePeriodSetting.Employee.EmployedSinceUTC"}, {"type":"Date","key":"EmployeePeriodSetting.Employee.CreatedUTC"}, {"type":"Day","key":"EmployeePeriodSetting.Employee.DateOfBirth"}, {"type":"Date","key":"EmployeePeriodSetting.Employee.OnboardingDateUtc"}, {"type":"Day","key":"EmployeePeriodSetting.FromDate"}, {"type":"Day","key":"EmployeePeriodSetting.ToDate"}, {"type":"Day","key":"EmployeePeriodSetting.VacationSettings.DiscardVacationDebtDate"}));
			}
		}
		export namespace UpdateDirectorUK {
			export function Post(org: string, request: m.Bokio.Salary.Web.Viewmodels.Hmrc.DirectorsPayrollSetupFlowDto): Promise<m.Envelope<m.Bokio.Salary.Web.Viewmodels.Hmrc.DirectorsPayrollSetupFlowDto, m.SimpleError>> {
				return Client.post(`/${org}/Salary/Api/v1/Employees/UpdateDirectorUK`, request)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.DateOfBirth"}, {"type":"Day","key":"Data.EmployementStartDate"}, {"type":"Day","key":"Data.StudentLoans.FromDate"}, {"type":"Day","key":"Data.StudentLoans.ToDate"}));
			}
		}
		export namespace UpdateEmployeeStatus {
			export function Post(org: string, request: m.Bokio.Salary.Contract.Employees.Requests.UpdateEmployeeStatusRequest): Promise<m.Envelope<number, m.SimpleError>> {
				return Client.post(`/${org}/Salary/Api/v1/Employees/UpdateEmployeeStatus`, request);
			}
		}
	}
	export namespace HmrcIntegrationTestController {
		export namespace SendFullPaymentSubmission {
			export function Post(org: string, independentPayrollId: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Salary/Api/v1/HmrcIntegrationTest/SendFullPaymentSubmission`, { independentPayrollId });
			}
		}
	}
	export namespace NetAdjustmentController {
		export namespace GetNetAdjustmentRows {
			export function Get(org: string, year: number, month: number, independentPayrollId?: string): Promise<m.Bokio.Salary.Web.Controllers.NetAdjustmentViewModel> {
				return Client.get(`/${org}/Salary/Api/v1/NetAdjustment/GetNetAdjustmentRows`, { year, month, independentPayrollId });
			}
		}
		export namespace SaveAdjustments {
			export function Post(org: string, command: m.Bokio.Salary.Contract.Payrolls.Commands.SetPayrollNetAdjustments): Promise<m.Bokio.Salary.Web.Controllers.NetAdjustmentViewModel> {
				return Client.post(`/${org}/Salary/Api/v1/NetAdjustment/SaveAdjustments`, command);
			}
		}
	}
	export namespace PayrollController {
		export namespace CreateIndependentPayroll {
			export function Post(org: string, createIndependentPayroll: m.Bokio.Salary.Contract.Payrolls.Requests.CreateIndependentPayrollRequest): Promise<m.Envelope<m.Bokio.Salary.Web.Viewmodels.Payrolls.SummaryViewModel, m.SimpleError>> {
				return Client.post(`/${org}/Salary/Api/v1/Payroll/CreateIndependentPayroll`, createIndependentPayroll)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.Payslips.PayDate"}, {"type":"Day","key":"Data.Payslips.LastDayOfEmployment"}, {"type":"Day","key":"Data.PayDate"}, {"type":"Day","key":"Data.TaxDate"}, {"type":"Day","key":"Data.TaxPaymentDate"}, {"type":"Day","key":"Data.BookkeepingExport.ExportDate"}, {"type":"Day","key":"Data.BookkeepingExport.PayDate"}, {"type":"Day","key":"Data.BookkeepingExport.VerificationDate"}, {"type":"Day","key":"Data.TaxBookkeeping.ExportDate"}, {"type":"Day","key":"Data.TaxBookkeeping.PayDate"}, {"type":"Day","key":"Data.TaxBookkeeping.VerificationDate"}, {"type":"Day","key":"Data.MaxAllowedPayDate"}, {"type":"Day","key":"Data.PayslipsEmailedAt"}));
			}
		}
		export namespace CreateTestCompanyQuickPayroll {
			export function Post(org: string, request: m.Bokio.Salary.Contract.Payrolls.Requests.CreateTestCompanyQuickPayrollRequest): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Salary/Api/v1/Payroll/CreateTestCompanyQuickPayroll`, request);
			}
		}
		export namespace DeleteIndependentPayroll {
			export function Post(org: string, request: m.Bokio.Salary.Web.Viewmodels.Payrolls.DeleteIndependentPayrollRequest): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Salary/Api/v1/Payroll/DeleteIndependentPayroll`, request);
			}
		}
		export namespace EmailPayslips {
			export function Post(org: string, year: number, month: number, request: m.Bokio.Salary.Web.Viewmodels.Payrolls.EmailPayslipsRequest): Promise<m.Core.ViewData.BatchMailResponseDto> {
				return Client.post(`/${org}/Salary/Api/v1/Payroll/${year}/${month}/EmailPayslips`, request)
				             .then(data => convertByKeys(data, {"type":"Date","key":"Responses.Sent"}));
			}
		}
		export namespace GetBgSpec {
			export function Get(org: string, year: number, month: number, paydate?: Day, independentPayrollId?: string): Promise<m.Classes.Payments.ExternalPaymentFileSpecification> {
				return Client.get(`/${org}/Salary/Api/v1/Payroll/${year}/${month}/GetBgSpec`, { paydate, independentPayrollId })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Payments.Date"}));
			}
		}
		export namespace GetDirectorsPayrollPlanDetails {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Salary.Web.Viewmodels.Employees.EmployeeBillingPlanViewModel, m.SimpleError>> {
				return Client.get(`/${org}/Salary/Api/v1/Payroll/GetDirectorsPayrollPlanDetails`)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.FreeSeatOverrideValidUntil"}));
			}
		}
		export namespace GetHmrcFullPaymentSubmissionResponse {
			export function Get(org: string, independentPayrollId: string, payDate: Day): Promise<m.Envelope<m.Bokio.Salary.Contract.Payrolls.Dtos.FullPaymentSubmissionResult[], m.SimpleError>> {
				return Client.get(`/${org}/Salary/Api/v1/Payroll/GetHmrcFullPaymentSubmissionResponse`, { independentPayrollId, payDate })
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.HmrcFullPaymentSubmissionResponse.AcceptedTime"}, {"type":"Date","key":"Data.RequestedTime"}));
			}
		}
		export namespace GetPayrollTellerPayment {
			export function Get(org: string, payDate: Day, independentPayrollId: string): Promise<m.Envelope<m.Bokio.Salary.Web.Viewmodels.Payrolls.PayrollTellerPaymentViewModel, m.SimpleError>> {
				return Client.get(`/${org}/Salary/Api/v1/Payroll/GetPayrollTellerPayment`, { payDate, independentPayrollId })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.GroupInfo.RequestedPaymentDate"}));
			}
		}
		export namespace GetSalaryFrequencyUk {
			export function Get(org: string): Promise<m.Envelope<m.Entities.Salary.SalaryFrequency, m.SimpleError>> {
				return Client.get(`/${org}/Salary/Api/v1/Payroll/GetSalaryFrequencyUk`);
			}
		}
		export namespace Lock {
			export function Post(org: string, command: m.Bokio.Salary.Contract.Payrolls.Commands.LockPayroll): Promise<m.Bokio.Salary.Web.Viewmodels.Payrolls.LockPayrollResult> {
				return Client.post(`/${org}/Salary/Api/v1/Payroll/Lock`, command)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Payslips.PeriodFrom"}, {"type":"Day","key":"Payslips.PeriodTo"}, {"type":"Day","key":"Payslips.PayDate"}, {"type":"CountrySubdivision","key":"Payslips.SenderData.CountrySubdivision"}, {"type":"Day","key":"Payslips.Rows.FromDate"}, {"type":"Day","key":"Payslips.Rows.ToDate"}, {"type":"Day","key":"Payslips.VacationBalanceDetail.Transactions.PayDate"}, {"type":"Day","key":"Payslips.VacationBalanceDetail.Transactions.FromDate"}, {"type":"Day","key":"Payslips.VacationBalanceDetail.Transactions.ToDate"}, {"type":"Day","key":"Payslips.VacationBalanceDetail.Transactions.TransactionDate"}, {"type":"Day","key":"Payslips.VacationBalanceDetail.AccrualTransactions.TransactionDate"}, {"type":"Day","key":"Payslips.VacationBalanceDetail.AccrualTransactions.PayDate"}));
			}
		}
		export namespace ManuallyRecordPayroll {
			export function Post(org: string, year: number, month: number, request: m.Bokio.Salary.Web.Viewmodels.Payrolls.ManuallyRecordPayrollRequest): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Salary/Api/v1/Payroll/${year}/${month}/ManuallyRecordPayroll`, request);
			}
		}
		export namespace ManuallyRecordTaxroll {
			export function Post(org: string, year: number, month: number, request: m.Bokio.Salary.Web.Viewmodels.Payrolls.ManuallyRecordTaxrollRequest): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Salary/Api/v1/Payroll/${year}/${month}/ManuallyRecordTaxroll`, request);
			}
		}
		export namespace Payrolls {
			export function Get(org: string, year?: number, month?: number, payDate?: Day, independentPayrollId?: string, excludeZeroTaxPayrolls?: boolean): Promise<m.Envelope<m.Bokio.Salary.Web.Viewmodels.Payrolls.SummaryViewModel[], m.SimpleError>> {
				return Client.get(`/${org}/Salary/Api/v1/Payroll/${year}/${month}/Payrolls`, { payDate, independentPayrollId, excludeZeroTaxPayrolls })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.Payslips.PayDate"}, {"type":"Day","key":"Data.Payslips.LastDayOfEmployment"}, {"type":"Day","key":"Data.PayDate"}, {"type":"Day","key":"Data.TaxDate"}, {"type":"Day","key":"Data.TaxPaymentDate"}, {"type":"Day","key":"Data.BookkeepingExport.ExportDate"}, {"type":"Day","key":"Data.BookkeepingExport.PayDate"}, {"type":"Day","key":"Data.BookkeepingExport.VerificationDate"}, {"type":"Day","key":"Data.TaxBookkeeping.ExportDate"}, {"type":"Day","key":"Data.TaxBookkeeping.PayDate"}, {"type":"Day","key":"Data.TaxBookkeeping.VerificationDate"}, {"type":"Day","key":"Data.MaxAllowedPayDate"}, {"type":"Day","key":"Data.PayslipsEmailedAt"}));
			}
		}
		export namespace ScheduleTellerPayrollPayments {
			export function Post(org: string, request: m.Bokio.Salary.Contract.Payrolls.Requests.SchedulePayrollPaymentRequest): Promise<m.Envelope<string, m.Bokio.Bank.Contract.Dtos.BankError>> {
				return Client.post(`/${org}/Salary/Api/v1/Payroll/ScheduleTellerPayrollPayments`, request);
			}
		}
		export namespace SendFullPaymentSubmissionToHmrc {
			export function Post(org: string, request: m.Bokio.Salary.Contract.Hmrc.Requests.SendFullPaymentSubmissionRequest): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Salary/Api/v1/Payroll/SendFullPaymentSubmissionToHmrc`, request);
			}
		}
		export namespace SetDates {
			export function Post(org: string, command: m.Bokio.Salary.Contract.Payrolls.Commands.SetPayrollPaydate): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Salary/Api/v1/Payroll/SetDates`, command);
			}
		}
		export namespace SetExemptFromLoweredSocialTaxDueToCovid {
			export function Post(org: string, request: m.Bokio.Salary.Web.Viewmodels.Payrolls.SetExemptFromLoweredSocialTaxDueToCovidRequest): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Salary/Api/v1/Payroll/SetExemptFromLoweredSocialTaxDueToCovid`, request);
			}
		}
		export namespace SetIndependentPayrollInterval {
			export function Post(org: string, request: m.Bokio.Salary.Web.Viewmodels.Payrolls.SetIndependentPayrollIntervalRequest): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Salary/Api/v1/Payroll/SetIndependentPayrollInterval`, request);
			}
		}
		export namespace SetIndependentPayrollPaymentData {
			export function Post(org: string, paymentDataVM: m.Bokio.Salary.Contract.Payrolls.Requests.SetPayrollPaymentDataRequest): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Salary/Api/v1/Payroll/SetIndependentPayrollPaymentData`, paymentDataVM);
			}
		}
		export namespace SetIndependentPayrollPaymentMethod {
			export function Post(org: string, request: m.Bokio.Salary.Web.Viewmodels.Payrolls.SetIndependentPayrollPaymentMethodRequest): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Salary/Api/v1/Payroll/SetIndependentPayrollPaymentMethod`, request);
			}
		}
		export namespace ShouldAllowAnyDateAsLastEmploymentDate {
			export function Get(org: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.get(`/${org}/Salary/Api/v1/Payroll/ShouldAllowAnyDateAsLastEmploymentDate`);
			}
		}
		export namespace Taxreport {
			export function Get(org: string, year: number, month: number): Promise<m.Core.Salary.Calculations.Taxreports.TaxReportResult> {
				return Client.get(`/${org}/Salary/Api/v1/Payroll/${year}/${month}/Taxreport`);
			}
		}
		export namespace Unlock {
			export function Post(org: string, command: m.Bokio.Salary.Contract.Payrolls.Commands.UnlockPayroll): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Salary/Api/v1/Payroll/Unlock`, command);
			}
		}
	}
	export namespace PayrollSystemApplicationController {
		export namespace AdvancedPayrollOnboardingStatus {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Salary.Contract.Payrolls.Dtos.AdvancedPayrollOnboardingViewModel, m.SimpleError>> {
				return Client.get(`/${org}/Salary/Api/v1/PayrollSystemApplication/AdvancedPayrollOnboardingStatus`);
			}
		}
		export namespace CreatePayrollApplication {
			export function Post(org: string): Promise<m.Envelope<string, m.SimpleError>> {
				return Client.post(`/${org}/Salary/Api/v1/PayrollSystemApplication/CreatePayrollApplication`, {  });
			}
		}
		export namespace GetAdvancedPayrollVerifications {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Salary.Contract.Payrolls.Dtos.AdvancedPayrollVerificationList, m.SimpleError>> {
				return Client.get(`/${org}/Salary/Api/v1/PayrollSystemApplication/GetAdvancedPayrollVerifications`)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.Verifications.Date"}));
			}
		}
	}
	export namespace PayslipsController {
		export namespace AddRows {
			export function Post(org: string, id: string, command: m.Bokio.Salary.Contract.Payslips.Commands.AddPayslipRows): Promise<m.Bokio.Salary.Web.Viewmodels.Payslips.PayslipViewModel> {
				return Client.post(`/${org}/Salary/Api/v1/Payslips/AddRows/${id}`, command)
				             .then(data => convertByKeys(data, {"type":"Day","key":"PeriodFrom"}, {"type":"Day","key":"PeriodTo"}, {"type":"Day","key":"PayDate"}, {"type":"CountrySubdivision","key":"SenderData.CountrySubdivision"}, {"type":"Day","key":"Rows.FromDate"}, {"type":"Day","key":"Rows.ToDate"}, {"type":"Day","key":"VacationBalanceDetail.Transactions.PayDate"}, {"type":"Day","key":"VacationBalanceDetail.Transactions.FromDate"}, {"type":"Day","key":"VacationBalanceDetail.Transactions.ToDate"}, {"type":"Day","key":"VacationBalanceDetail.Transactions.TransactionDate"}, {"type":"Day","key":"VacationBalanceDetail.AccrualTransactions.TransactionDate"}, {"type":"Day","key":"VacationBalanceDetail.AccrualTransactions.PayDate"}));
			}
		}
		export namespace Calculate {
			export function Get(org: string, id: string): Promise<m.Bokio.Salary.Web.Viewmodels.Payslips.CalculationResultViewModel> {
				return Client.get(`/${org}/Salary/Api/v1/Payslips/Calculate/${id}`);
			}
		}
		export namespace CalculateTotals {
			export function Get(org: string, id: string): Promise<m.Bokio.Salary.Web.Controllers.YearlySummaryResult> {
				return Client.get(`/${org}/Salary/Api/v1/Payslips/CalculateTotals/${id}`);
			}
		}
		export namespace Categories {
			export function Get(org: string, id: string): Promise<{ [key: string]: m.Bokio.Salary.Web.Viewmodels.Payrolls.CategoryViewModel; }> {
				return Client.get(`/${org}/Salary/Api/v1/Payslips/Categories/${id}`);
			}
		}
		export namespace ConnectToAutoVerificationRow {
			export function Post(org: string, dto: m.Bokio.Salary.Web.Viewmodels.SalaryTaxPeriods.MatchPayslipWithTransactionDto): Promise<m.Envelope<m.Bokio.Common.Contract.ViewData.VerificationRecordingResult, m.SimpleError>> {
				return Client.post(`/${org}/Salary/Api/v1/Payslips/ConnectToAutoVerificationRow`, dto);
			}
		}
		export namespace CreatePayslips {
			export function Post(org: string, dto: m.Bokio.Salary.Contract.Payrolls.Dtos.CreatePayslipsDto): Promise<m.Envelope<m.Bokio.Salary.Contract.Payslips.Dtos.CreatePayslipsViewModel, m.Bokio.Salary.Contract.Payslips.Dtos.PayslipErrorType>> {
				return Client.post(`/${org}/Salary/Api/v1/Payslips/CreatePayslips`, dto);
			}
		}
		export namespace Delete {
			export function Post(org: string, command: m.Bokio.Salary.Contract.Payslips.Commands.DeletePayslip): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Salary/Api/v1/Payslips/Delete`, command);
			}
		}
		export namespace DeletePayslipRow {
			export function Delete(org: string, id: string, command: m.Bokio.Salary.Contract.Payslips.Commands.DeletePayslipRow): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client._delete(`/${org}/Salary/Api/v1/Payslips/DeletePayslipRow/${id}`, { command });
			}
		}
		export namespace Edit {
			export function Post(org: string, id: string, request: m.Bokio.Salary.Contract.Employees.Dtos.EditEmployeeRequest): Promise<m.Bokio.Salary.Web.Viewmodels.Payslips.PayslipViewModel> {
				return Client.post(`/${org}/Salary/Api/v1/Payslips/Edit/${id}`, request)
				             .then(data => convertByKeys(data, {"type":"Day","key":"PeriodFrom"}, {"type":"Day","key":"PeriodTo"}, {"type":"Day","key":"PayDate"}, {"type":"CountrySubdivision","key":"SenderData.CountrySubdivision"}, {"type":"Day","key":"Rows.FromDate"}, {"type":"Day","key":"Rows.ToDate"}, {"type":"Day","key":"VacationBalanceDetail.Transactions.PayDate"}, {"type":"Day","key":"VacationBalanceDetail.Transactions.FromDate"}, {"type":"Day","key":"VacationBalanceDetail.Transactions.ToDate"}, {"type":"Day","key":"VacationBalanceDetail.Transactions.TransactionDate"}, {"type":"Day","key":"VacationBalanceDetail.AccrualTransactions.TransactionDate"}, {"type":"Day","key":"VacationBalanceDetail.AccrualTransactions.PayDate"}));
			}
		}
		export namespace EditRow {
			export function Post(org: string, id: string, command: m.Bokio.Salary.Contract.Payslips.Commands.EditPayslipRow): Promise<m.Bokio.Salary.Web.Viewmodels.Payslips.PayslipRowViewModel> {
				return Client.post(`/${org}/Salary/Api/v1/Payslips/EditRow/${id}`, command)
				             .then(data => convertByKeys(data, {"type":"Day","key":"FromDate"}, {"type":"Day","key":"ToDate"}));
			}
		}
		export namespace Get {
			export function Get(org: string, id: string): Promise<m.Bokio.Salary.Web.Viewmodels.Payslips.PayslipViewModel> {
				return Client.get(`/${org}/Salary/Api/v1/Payslips/Get/${id}`)
				             .then(data => convertByKeys(data, {"type":"Day","key":"PeriodFrom"}, {"type":"Day","key":"PeriodTo"}, {"type":"Day","key":"PayDate"}, {"type":"CountrySubdivision","key":"SenderData.CountrySubdivision"}, {"type":"Day","key":"Rows.FromDate"}, {"type":"Day","key":"Rows.ToDate"}, {"type":"Day","key":"VacationBalanceDetail.Transactions.PayDate"}, {"type":"Day","key":"VacationBalanceDetail.Transactions.FromDate"}, {"type":"Day","key":"VacationBalanceDetail.Transactions.ToDate"}, {"type":"Day","key":"VacationBalanceDetail.Transactions.TransactionDate"}, {"type":"Day","key":"VacationBalanceDetail.AccrualTransactions.TransactionDate"}, {"type":"Day","key":"VacationBalanceDetail.AccrualTransactions.PayDate"}));
			}
		}
		export namespace Regions {
			export function Get(org: string): Promise<m.Core.Salary.Calculations.PopulationData.PopulationRegion[]> {
				return Client.get(`/${org}/Salary/Api/v1/Payslips/Regions`);
			}
		}
		export namespace UpdateUkSalaryRow {
			export function Post(org: string, request: m.Bokio.Salary.Contract.Payslips.Requests.UpdateUkSalaryRowRequest): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Salary/Api/v1/Payslips/UpdateUkSalaryRow`, request);
			}
		}
	}
	export namespace PensionCalloutController {
		export namespace GetPensionCalloutMetadata {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Salary.Web.Viewmodels.Ads.PensionCalloutMetadataViewModel, m.SimpleError>> {
				return Client.get(`/${org}/Salary/Api/v1/PensionCallout/GetPensionCalloutMetadata`);
			}
		}
		export namespace SetPensionCalloutMetadata {
			export function Post(org: string, pensionStatus: m.Bokio.Salary.Web.Viewmodels.Ads.PensionCalloutMetadataViewModel): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Salary/Api/v1/PensionCallout/SetPensionCalloutMetadata`, pensionStatus);
			}
		}
	}
	export namespace SalaryIntegrationTestSetupController {
		export namespace SetupCompanyForSalariesUsingSveaBba {
			export function Post(org: string): Promise<m.Envelope<m.Bokio.Salary.Web.Controllers.SetupCompanyForSalariesDto, m.SimpleError>> {
				return Client.post(`/${org}/SalaryIntegrationTestSetup/SetupCompanyForSalariesUsingSveaBba`, {  })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.NextSalaryDay"}, {"type":"Date","key":"Data.CreateEmployeeResult.Employee.EmployeePeriodSetting.Employee.EmployedSinceUTC"}, {"type":"Date","key":"Data.CreateEmployeeResult.Employee.EmployeePeriodSetting.Employee.CreatedUTC"}, {"type":"Day","key":"Data.CreateEmployeeResult.Employee.EmployeePeriodSetting.Employee.DateOfBirth"}, {"type":"Date","key":"Data.CreateEmployeeResult.Employee.EmployeePeriodSetting.Employee.OnboardingDateUtc"}, {"type":"Day","key":"Data.CreateEmployeeResult.Employee.EmployeePeriodSetting.FromDate"}, {"type":"Day","key":"Data.CreateEmployeeResult.Employee.EmployeePeriodSetting.ToDate"}, {"type":"Day","key":"Data.CreateEmployeeResult.Employee.EmployeePeriodSetting.VacationSettings.DiscardVacationDebtDate"}, {"type":"Date","key":"Data.CreateEmployeeResult.PeriodSetting.Employee.EmployedSinceUTC"}, {"type":"Date","key":"Data.CreateEmployeeResult.PeriodSetting.Employee.CreatedUTC"}, {"type":"Day","key":"Data.CreateEmployeeResult.PeriodSetting.Employee.DateOfBirth"}, {"type":"Date","key":"Data.CreateEmployeeResult.PeriodSetting.Employee.OnboardingDateUtc"}, {"type":"Day","key":"Data.CreateEmployeeResult.PeriodSetting.FromDate"}, {"type":"Day","key":"Data.CreateEmployeeResult.PeriodSetting.ToDate"}, {"type":"Day","key":"Data.CreateEmployeeResult.PeriodSetting.VacationSettings.DiscardVacationDebtDate"}));
			}
		}
		export namespace SetupSalariesAndAutoVerificationsForTestingTaxPeriods {
			export function Post(org: string): Promise<boolean> {
				return Client.post(`/${org}/SalaryIntegrationTestSetup/SetupSalariesAndAutoVerificationsForTestingTaxPeriods`, {  });
			}
		}
		export namespace SetupSalariesForBbaPaymentTesting {
			export function Post(org: string): Promise<boolean> {
				return Client.post(`/${org}/SalaryIntegrationTestSetup/SetupSalariesForBbaPaymentTesting`, {  });
			}
		}
	}
	export namespace SalaryReportController {
		export namespace EmployeesById {
			export function Post(org: string, employeeIds: string[]): Promise<m.Envelope<m.Bokio.Salary.Web.Viewmodels.Employees.EmployeeForList[], m.SimpleError>> {
				return Client.post(`/${org}/Salary/Api/v1/SalaryReport/EmployeesById`, employeeIds);
			}
		}
		export namespace GroupedEmployees {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Salary.Web.Viewmodels.Reports.GroupedEmployeesViewModel, m.SimpleError>> {
				return Client.get(`/${org}/Salary/Api/v1/SalaryReport/GroupedEmployees`);
			}
		}
		export namespace HourlyPaid {
			export function Post(org: string, request: m.Bokio.Salary.Web.Viewmodels.Reports.SalaryReportRequest): Promise<m.Envelope<m.Bokio.Salary.Web.Viewmodels.Reports.HourlyPaidViewModel, m.SimpleError>> {
				return Client.post(`/${org}/Salary/Api/v1/SalaryReport/HourlyPaid`, request)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.Rows.PayslipDate"}, {"type":"Day","key":"Data.DateRange.From"}, {"type":"Day","key":"Data.DateRange.To"}));
			}
		}
		export namespace SalaryTotal {
			export function Post(org: string, request: m.Bokio.Salary.Web.Viewmodels.Reports.SalaryReportRequest): Promise<m.Envelope<m.Bokio.Salary.Web.Viewmodels.Reports.SalaryTotalViewModel, m.SimpleError>> {
				return Client.post(`/${org}/Salary/Api/v1/SalaryReport/SalaryTotal`, request)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.Rows.PayslipDate"}, {"type":"Day","key":"Data.DateRange.From"}, {"type":"Day","key":"Data.DateRange.To"}));
			}
		}
		export namespace SickDays {
			export function Post(org: string, request: m.Bokio.Salary.Web.Viewmodels.Reports.SalaryReportRequest): Promise<m.Envelope<m.Bokio.Salary.Web.Viewmodels.Reports.SickDaysViewModel, m.SimpleError>> {
				return Client.post(`/${org}/Salary/Api/v1/SalaryReport/SickDays`, request)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.Rows.PayslipDate"}, {"type":"Day","key":"Data.DateRange.From"}, {"type":"Day","key":"Data.DateRange.To"}));
			}
		}
		export namespace VacationDebt {
			export function Post(org: string, request: m.Bokio.Salary.Web.Viewmodels.Reports.VacationDebtReportRequest): Promise<m.Envelope<m.Bokio.Salary.Web.Viewmodels.Reports.VacationDebtReportViewModel, m.SimpleError>> {
				return Client.post(`/${org}/Salary/Api/v1/SalaryReport/VacationDebt`, request)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.PrintDate"}, {"type":"Day","key":"Data.AccrualFromDate"}, {"type":"Day","key":"Data.AccrualToDate"}, {"type":"Day","key":"Data.UsageFromDate"}, {"type":"Day","key":"Data.UsageToDate"}));
			}
		}
		export namespace VacationSummary {
			export function Post(org: string, request: m.Bokio.Salary.Web.Viewmodels.Reports.SalaryReportRequest): Promise<m.Envelope<m.Bokio.Salary.Web.Viewmodels.Reports.VacationSummaryViewModel, m.SimpleError>> {
				return Client.post(`/${org}/Salary/Api/v1/SalaryReport/VacationSummary`, request)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.Rows.PayslipDate"}, {"type":"Day","key":"Data.DateRange.From"}, {"type":"Day","key":"Data.DateRange.To"}));
			}
		}
	}
	export namespace SalarySettingsController {
		export namespace Get {
			export function Get(org: string): Promise<m.Bokio.Salary.Web.Controllers.SalarySettingsViewModel> {
				return Client.get(`/${org}/Salary/Api/v1/SalarySettings/Get`)
				             .then(data => convertByKeys(data, {"type":"Day","key":"VacationYearStartDate"}));
			}
		}
		export namespace SetV1CompanyVacationSettings {
			export function Post(org: string, request: m.Bokio.Salary.Contract.Requests.SetV1CompanyVacationSettingsRequest): Promise<m.Envelope<m.Bokio.Salary.Web.Controllers.SalarySettingsViewModel, m.SimpleError>> {
				return Client.post(`/${org}/Salary/Api/v1/SalarySettings/SetV1CompanyVacationSettings`, request)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.VacationYearStartDate"}));
			}
		}
		export namespace SetV1Settings {
			export function Post(org: string, request: m.Bokio.Salary.Contract.Requests.SetV1SalarySettingsRequest): Promise<m.Bokio.Salary.Web.Controllers.SalarySettingsViewModel> {
				return Client.post(`/${org}/Salary/Api/v1/SalarySettings/SetV1Settings`, request)
				             .then(data => convertByKeys(data, {"type":"Day","key":"VacationYearStartDate"}));
			}
		}
	}
	export namespace SalaryTaxPeriodController {
		export namespace List {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Salary.Web.Viewmodels.SalaryTaxPeriods.SalaryTaxPeriodForList[], m.SimpleError>> {
				return Client.get(`/${org}/Salary/Api/v1/SalaryTaxPeriod/List`)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.TaxDeadline"}));
			}
		}
		export namespace LockPeriod {
			export function Post(org: string, id: string): Promise<m.Envelope<string, m.SimpleError>> {
				return Client.post(`/${org}/Salary/Api/v1/SalaryTaxPeriod/LockPeriod/${id}`, {  });
			}
		}
		export namespace MarkAsDeclared {
			export function Post(org: string, id: string): Promise<m.Envelope<string, m.SimpleError>> {
				return Client.post(`/${org}/Salary/Api/v1/SalaryTaxPeriod/MarkAsDeclared/${id}`, {  });
			}
		}
		export namespace MarkAsTaxesAsRecordedManually {
			export function Post(org: string, id: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Salary/Api/v1/SalaryTaxPeriod/MarkAsTaxesAsRecordedManually/${id}`, {  });
			}
		}
		export namespace MarkAsTaxesPaid {
			export function Post(org: string, id: string): Promise<m.Envelope<string, m.SimpleError>> {
				return Client.post(`/${org}/Salary/Api/v1/SalaryTaxPeriod/MarkAsTaxesPaid/${id}`, {  });
			}
		}
		export namespace PreviewTaxVerifications {
			export function Get(org: string, id: string): Promise<m.Envelope<m.Core.ViewData.VerificationForList[], m.SimpleError>> {
				return Client.get(`/${org}/Salary/Api/v1/SalaryTaxPeriod/PreviewTaxVerifications/${id}`)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.Date"}, {"type":"Day","key":"Data.ExpectPaymentAt"}, {"type":"Date","key":"Data.CreatedUtc"}));
			}
		}
		export namespace RecordIncomeTaxesFromBankRow {
			export function Post(org: string, id: string, dto: m.Bokio.Salary.Web.Viewmodels.SalaryTaxPeriods.RecordIncomeTaxesFromTransactionDto): Promise<m.Envelope<m.Bokio.Common.Contract.ViewData.VerificationRecordingResult, m.Bokio.Salary.Web.Viewmodels.SalaryTaxPeriods.RecordTaxesFromBankRowError>> {
				return Client.post(`/${org}/Salary/Api/v1/SalaryTaxPeriod/RecordIncomeTaxesFromBankRow/${id}`, dto);
			}
		}
		export namespace RecordSocialFeesFromBankRow {
			export function Post(org: string, id: string, dto: m.Bokio.Salary.Web.Viewmodels.SalaryTaxPeriods.RecordSocialFeesFromTransactionDto): Promise<m.Envelope<m.Bokio.Common.Contract.ViewData.VerificationRecordingResult, m.Bokio.Salary.Web.Viewmodels.SalaryTaxPeriods.RecordTaxesFromBankRowError>> {
				return Client.post(`/${org}/Salary/Api/v1/SalaryTaxPeriod/RecordSocialFeesFromBankRow/${id}`, dto);
			}
		}
		export namespace RecordTaxes {
			export function Post(org: string, id: string, dto: m.Bokio.Salary.Web.Viewmodels.SalaryTaxPeriods.RecordTaxesDto): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Salary/Api/v1/SalaryTaxPeriod/RecordTaxes/${id}`, dto);
			}
		}
		export namespace ScheduleTaxPayment {
			export function Post(org: string, id: string, request: m.Bokio.Salary.Web.Viewmodels.SalaryTaxPeriods.ScheduleSalaryTaxPaymentRequest): Promise<m.Envelope<string, m.Bokio.Salary.Web.Viewmodels.SalaryTaxPeriods.ScheduleTaxPaymentError>> {
				return Client.post(`/${org}/Salary/Api/v1/SalaryTaxPeriod/ScheduleTaxPayment/${id}`, request);
			}
		}
		export namespace SetSalaryTaxPeriodSocialFeeDiscount {
			export function Post(org: string, id: string, dto: m.Bokio.Salary.Web.Viewmodels.SalaryTaxPeriods.SetSocialFeeDiscountDto): Promise<m.Envelope<string, m.SimpleError>> {
				return Client.post(`/${org}/Salary/Api/v1/SalaryTaxPeriod/SetSalaryTaxPeriodSocialFeeDiscount/${id}`, dto);
			}
		}
		export namespace UndoMarkAsDeclared {
			export function Post(org: string, id: string): Promise<m.Envelope<string, m.SimpleError>> {
				return Client.post(`/${org}/Salary/Api/v1/SalaryTaxPeriod/UndoMarkAsDeclared/${id}`, {  });
			}
		}
		export namespace UndoMarkAsTaxesPaid {
			export function Post(org: string, id: string): Promise<m.Envelope<string, m.SimpleError>> {
				return Client.post(`/${org}/Salary/Api/v1/SalaryTaxPeriod/UndoMarkAsTaxesPaid/${id}`, {  });
			}
		}
		export namespace UndoRecordTaxes {
			export function Post(org: string, id: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Salary/Api/v1/SalaryTaxPeriod/UndoRecordTaxes/${id}`, {  });
			}
		}
		export namespace UnlockPeriod {
			export function Post(org: string, id: string): Promise<m.Envelope<string, m.SimpleError>> {
				return Client.post(`/${org}/Salary/Api/v1/SalaryTaxPeriod/UnlockPeriod/${id}`, {  });
			}
		}
		export namespace ViewPeriod {
			export function Get(org: string, year: number, month: number): Promise<m.Envelope<m.Bokio.Salary.Web.Viewmodels.SalaryTaxPeriods.SalaryTaxPeriodForView, m.SimpleError>> {
				return Client.get(`/${org}/Salary/Api/v1/SalaryTaxPeriod/ViewPeriod`, { year, month })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.Payrolls.PayDate"}, {"type":"Day","key":"Data.TaxVerifications.VerificationDate"}, {"type":"Day","key":"Data.TaxDeadline"}, {"type":"Day","key":"Data.SuggestedTaxPaymentDate"}, {"type":"Day","key":"Data.ScheduledPayments.RequestedDate"}));
			}
		}
	}
	export namespace VacationsController {
		export namespace ConfirmVacationYearEnd {
			export function Put(org: string, request: m.Bokio.Salary.Web.Viewmodels.Vacation.ConfirmVacationYearEndRequest): Promise<m.Envelope<m.Bokio.Salary.Web.Viewmodels.Vacation.VacationYearEndViewModel, m.SimpleError>> {
				return Client.put(`/${org}/Salary/Api/v1/Vacations/ConfirmVacationYearEnd`, request)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.VacationYearStartDate"}));
			}
		}
		export namespace ConfirmVacationYearEndEmployee {
			export function Put(org: string, request: m.Bokio.Salary.Web.Viewmodels.Vacation.ConfirmVacationYearEndEmployeeRequest): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.put(`/${org}/Salary/Api/v1/Vacations/ConfirmVacationYearEndEmployee`, request);
			}
		}
		export namespace CreateVacationYearEndEmployee {
			export function Post(org: string, request: m.Bokio.Salary.Web.Viewmodels.Vacation.CreateVacationYearEndEmployeeRequest): Promise<m.Envelope<m.Bokio.Salary.Web.Viewmodels.Vacation.VacationYearEndEmployeeDetail, m.SimpleError>> {
				return Client.post(`/${org}/Salary/Api/v1/Vacations/CreateVacationYearEndEmployee`, request)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.ThisYearStartDate"}, {"type":"Day","key":"Data.ThisYearEndDate"}, {"type":"Day","key":"Data.NextYearStartDate"}, {"type":"Day","key":"Data.NextYearEndDate"}, {"type":"Day","key":"Data.EmployeePeriodSettingDataForExample.WorkloadData.FromDate"}, {"type":"Day","key":"Data.EmployeePeriodSettingDataForExample.WorkloadData.ToDate"}));
			}
		}
		export namespace DisableVacationTracking {
			export function Post(org: string, periodSettingId: string): Promise<m.Envelope<m.Bokio.Salary.Web.Viewmodels.Employees.EmployeePeriodSettingViewModel, m.SimpleError>> {
				return Client.post(`/${org}/Salary/Api/v1/Vacations/DisableVacationTracking`, { periodSettingId })
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.Employee.EmployedSinceUTC"}, {"type":"Date","key":"Data.Employee.CreatedUTC"}, {"type":"Day","key":"Data.Employee.DateOfBirth"}, {"type":"Date","key":"Data.Employee.OnboardingDateUtc"}, {"type":"Day","key":"Data.FromDate"}, {"type":"Day","key":"Data.ToDate"}, {"type":"Day","key":"Data.VacationSettings.DiscardVacationDebtDate"}));
			}
		}
		export namespace EnableVacationTracking {
			export function Post(org: string, request: m.Bokio.Salary.Contract.Vacation.Requests.EnableVacationTrackingRequest): Promise<m.Envelope<m.Bokio.Salary.Web.Viewmodels.Employees.EmployeePeriodSettingViewModel, m.SimpleError>> {
				return Client.post(`/${org}/Salary/Api/v1/Vacations/EnableVacationTracking`, request)
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.Employee.EmployedSinceUTC"}, {"type":"Date","key":"Data.Employee.CreatedUTC"}, {"type":"Day","key":"Data.Employee.DateOfBirth"}, {"type":"Date","key":"Data.Employee.OnboardingDateUtc"}, {"type":"Day","key":"Data.FromDate"}, {"type":"Day","key":"Data.ToDate"}, {"type":"Day","key":"Data.VacationSettings.DiscardVacationDebtDate"}));
			}
		}
		export namespace GetVacationBalanceAndAccrual {
			export function Get(org: string, employeeId: string, includeLocked?: boolean): Promise<m.Envelope<m.Bokio.Salary.Web.Viewmodels.Vacation.VacationBalanceAndAccrualForList, m.SimpleError>> {
				return Client.get(`/${org}/Salary/Api/v1/Vacations/GetVacationBalanceAndAccrual`, { employeeId, includeLocked })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.DiscardVacationDebtDate"}, {"type":"Day","key":"Data.FirstContractStartDate"}));
			}
		}
		export namespace GetVacationBalanceAndAccrualForOnBoarding {
			export function Get(org: string, employeeId: string): Promise<m.Envelope<m.Bokio.Salary.Web.Viewmodels.Vacation.VacationBalanceAndAccrualOnBoardingViewModel, m.SimpleError>> {
				return Client.get(`/${org}/Salary/Api/v1/Vacations/GetVacationBalanceAndAccrualForOnBoarding`, { employeeId })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.VacationYearStartDate"}, {"type":"Day","key":"Data.VacationEndCalculationDate"}, {"type":"Day","key":"Data.DiscardVacationDebtDate"}, {"type":"Day","key":"Data.CurrentContractStartDate"}, {"type":"Day","key":"Data.FirstContractStartDate"}));
			}
		}
		export namespace GetVacationBalanceAndAccruals {
			export function Get(org: string, includeLocked?: boolean, maxDate?: Date): Promise<m.Envelope<m.Bokio.Salary.Web.Viewmodels.Vacation.VacationBalanceAndAccrualForList[], m.SimpleError>> {
				return Client.get(`/${org}/Salary/Api/v1/Vacations/GetVacationBalanceAndAccruals`, { includeLocked, maxDate })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.DiscardVacationDebtDate"}, {"type":"Day","key":"Data.FirstContractStartDate"}));
			}
		}
		export namespace GetVacationBalanceDetail {
			export function Get(org: string, employeeId: string, includeLocked?: boolean, cutoffDate?: Day): Promise<m.Envelope<m.Bokio.Salary.Web.Viewmodels.Vacation.VacationBalanceDetail, m.SimpleError>> {
				return Client.get(`/${org}/Salary/Api/v1/Vacations/GetVacationBalanceDetail`, { employeeId, includeLocked, cutoffDate })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.Transactions.PayDate"}, {"type":"Day","key":"Data.Transactions.FromDate"}, {"type":"Day","key":"Data.Transactions.ToDate"}, {"type":"Day","key":"Data.Transactions.TransactionDate"}, {"type":"Day","key":"Data.AccrualTransactions.TransactionDate"}, {"type":"Day","key":"Data.AccrualTransactions.PayDate"}));
			}
		}
		export namespace GetVacationBalanceDetailsForRecording {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Salary.Web.Viewmodels.Vacation.VacationBalanceDetail[], m.SimpleError>> {
				return Client.get(`/${org}/Salary/Api/v1/Vacations/GetVacationBalanceDetailsForRecording`)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.Transactions.PayDate"}, {"type":"Day","key":"Data.Transactions.FromDate"}, {"type":"Day","key":"Data.Transactions.ToDate"}, {"type":"Day","key":"Data.Transactions.TransactionDate"}, {"type":"Day","key":"Data.AccrualTransactions.TransactionDate"}, {"type":"Day","key":"Data.AccrualTransactions.PayDate"}));
			}
		}
		export namespace GetVacationBalances {
			export function Get(org: string, includeLocked?: boolean): Promise<m.Envelope<m.Bokio.Salary.Web.Viewmodels.Vacation.VacationBalanceForList[], m.SimpleError>> {
				return Client.get(`/${org}/Salary/Api/v1/Vacations/GetVacationBalances`, { includeLocked });
			}
		}
		export namespace GetVacationYearEnd {
			export function Get(org: string, vacationYearStartDate: Day): Promise<m.Envelope<m.Bokio.Salary.Web.Viewmodels.Vacation.VacationYearEndViewModel, m.Bokio.Salary.Contract.Vacation.Dtos.VacationYearEndError>> {
				return Client.get(`/${org}/Salary/Api/v1/Vacations/GetVacationYearEnd`, { vacationYearStartDate })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.VacationYearStartDate"}));
			}
		}
		export namespace GetVacationYearEndBalanceHistory {
			export function Get(org: string, vacationYearEndId: string, employeeId: string): Promise<m.Envelope<m.Bokio.Salary.Contract.Vacation.Dtos.VacationYearEndBalanceHistory, m.SimpleError>> {
				return Client.get(`/${org}/Salary/Api/v1/Vacations/GetVacationYearEndBalanceHistory`, { vacationYearEndId, employeeId })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.Rows.TransactionDate"}, {"type":"Day","key":"Data.Rows.PayslipDate"}));
			}
		}
		export namespace GetVacationYearEndEmployee {
			export function Get(org: string, vacationYearEndEmployeeId: string): Promise<m.Envelope<m.Bokio.Salary.Web.Viewmodels.Vacation.VacationYearEndEmployeeDetail, m.SimpleError>> {
				return Client.get(`/${org}/Salary/Api/v1/Vacations/GetVacationYearEndEmployee`, { vacationYearEndEmployeeId })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.ThisYearStartDate"}, {"type":"Day","key":"Data.ThisYearEndDate"}, {"type":"Day","key":"Data.NextYearStartDate"}, {"type":"Day","key":"Data.NextYearEndDate"}, {"type":"Day","key":"Data.EmployeePeriodSettingDataForExample.WorkloadData.FromDate"}, {"type":"Day","key":"Data.EmployeePeriodSettingDataForExample.WorkloadData.ToDate"}));
			}
		}
		export namespace GetVacationYearEndMetadata {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Salary.Web.Viewmodels.Vacation.VacationYearEndMetaData, m.SimpleError>> {
				return Client.get(`/${org}/Salary/Api/v1/Vacations/GetVacationYearEndMetadata`)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.VacationYearStartDate"}));
			}
		}
		export namespace SetVacationBalanceAndAccrual {
			export function Post(org: string, vacationValues: m.Bokio.Salary.Web.Viewmodels.Vacation.VacationBalanceAndAccrualOnBoardingViewModel): Promise<m.Envelope<m.Bokio.Salary.Web.Viewmodels.Vacation.VacationBalanceAndAccrualForList, m.SimpleError>> {
				return Client.post(`/${org}/Salary/Api/v1/Vacations/SetVacationBalanceAndAccrual`, vacationValues)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.DiscardVacationDebtDate"}, {"type":"Day","key":"Data.FirstContractStartDate"}));
			}
		}
		export namespace StartVacationYearEnd {
			export function Post(org: string, request: m.Bokio.Salary.Web.Viewmodels.Vacation.StartVacationYearEndRequest): Promise<m.Envelope<m.Bokio.Salary.Web.Viewmodels.Vacation.VacationYearEndViewModel, m.SimpleError>> {
				return Client.post(`/${org}/Salary/Api/v1/Vacations/StartVacationYearEnd`, request)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.VacationYearStartDate"}));
			}
		}
		export namespace UpdateVacationBalanceAndAccrual {
			export function Post(org: string, newVacationValues: m.Bokio.Salary.Web.Viewmodels.Vacation.VacationBalanceUpdate): Promise<m.Envelope<m.Bokio.Salary.Web.Viewmodels.Vacation.VacationBalanceAndAccrualForList, m.SimpleError>> {
				return Client.post(`/${org}/Salary/Api/v1/Vacations/UpdateVacationBalanceAndAccrual`, newVacationValues)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.DiscardVacationDebtDate"}, {"type":"Day","key":"Data.FirstContractStartDate"}));
			}
		}
		export namespace UpdateVacationYearEndEmployee {
			export function Put(org: string, request: m.Bokio.Salary.Web.Viewmodels.Vacation.UpdateVacationYearEndEmployeeRequest): Promise<m.Envelope<m.Bokio.Salary.Web.Viewmodels.Vacation.VacationYearEndEmployeeDetail, m.SimpleError>> {
				return Client.put(`/${org}/Salary/Api/v1/Vacations/UpdateVacationYearEndEmployee`, request)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.ThisYearStartDate"}, {"type":"Day","key":"Data.ThisYearEndDate"}, {"type":"Day","key":"Data.NextYearStartDate"}, {"type":"Day","key":"Data.NextYearEndDate"}, {"type":"Day","key":"Data.EmployeePeriodSettingDataForExample.WorkloadData.FromDate"}, {"type":"Day","key":"Data.EmployeePeriodSettingDataForExample.WorkloadData.ToDate"}));
			}
		}
	}
}
export namespace Settings {
	export namespace AssetSettingsController {
		export namespace SaveDepreciationSettings {
			export function Post(org: string, request: m.Settings.Requests.SaveDepreciationSettingsRequest): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Settings/AssetSettings/SaveDepreciationSettings`, request);
			}
		}
	}
	export namespace AuditHistoryController {
		export namespace GetExportAuditHistoryMetaData {
			export function Get(org: string): Promise<m.Envelope<m.Settings.ViewModels.ExportAuditHistoryMetaData, m.SimpleError>> {
				return Client.get(`/${org}/Settings/AuditHistory/GetExportAuditHistoryMetaData`);
			}
		}
		export namespace Index {
			export function Get(org: string, page?: number): Promise<m.Settings.Controllers.AuditHistoryViewModel> {
				return Client.get(`/${org}/Settings/AuditHistory`, { page })
				             .then(data => convertByKeys(data, {"type":"Date","key":"Items.TimeUtc"}));
			}
		}
	}
	export namespace AuthenticateCompanyController {
		export namespace Authenticate {
			export function Post(org: string): Promise<m.Envelope<m.Bokio.Backbone.Web.Controllers.Accounts.StartBankIdLoginResponse, m.Bokio.Common.Contract.BankId.BankIdError>> {
				return Client.post(`/${org}/Settings/AuthenticateCompany/Authenticate`, {  });
			}
		}
		export namespace VerifyCompany {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Backbone.Web.Controllers.Accounts.ConfirmBankIdLoginResponse, m.Bokio.Common.Contract.BankId.BankIdError>> {
				return Client.get(`/${org}/Settings/AuthenticateCompany/VerifyCompany`);
			}
		}
	}
	export namespace BokioPayBankIdAuthSettingsController {
		export namespace ConfirmDisableBokioPayBankIdAuth {
			export function Post(): Promise<m.Envelope<m.Bokio.Backbone.Web.Controllers.Accounts.ConfirmBankIdLoginResponse, m.Bokio.Common.Contract.BankId.BankIdError>> {
				return Client.post("/Setting/BokioPayBankIdAuthSettings/ConfirmDisableBokioPayBankIdAuth", {  });
			}
		}
		export namespace ConfirmEnableBokioPayBankIdAuth {
			export function Post(): Promise<m.Envelope<m.Bokio.Backbone.Web.Controllers.Accounts.ConfirmBankIdLoginResponse, m.Bokio.Common.Contract.BankId.BankIdError>> {
				return Client.post("/Setting/BokioPayBankIdAuthSettings/ConfirmEnableBokioPayBankIdAuth", {  });
			}
		}
		export namespace HasBokioPayBankIdAuthEnabled {
			export function Get(): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.get("/Setting/BokioPayBankIdAuthSettings/HasBokioPayBankIdAuthEnabled");
			}
		}
		export namespace StartDisableBokioPayBankIdAuth {
			export function Post(request: m.Settings.Controllers.StartDisableBankIdRequest): Promise<m.Envelope<m.Bokio.Backbone.Web.Controllers.Accounts.StartBankIdLoginResponse, m.Bokio.Common.Contract.BankId.BankIdError>> {
				return Client.post("/Setting/BokioPayBankIdAuthSettings/StartDisableBokioPayBankIdAuth", request);
			}
		}
		export namespace StartEnableBokioPayBankIdAuth {
			export function Post(request: m.Settings.Controllers.StartEnableBokioPayBankIdAuthRequest): Promise<m.Envelope<m.Bokio.Backbone.Web.Controllers.Accounts.StartBankIdLoginResponse, m.Bokio.Common.Contract.BankId.BankIdError>> {
				return Client.post("/Setting/BokioPayBankIdAuthSettings/StartEnableBokioPayBankIdAuth", request);
			}
		}
	}
	export namespace CompanyController {
		export namespace AddSavedPaymentMethod {
			export function Post(org: string, request: m.Settings.Requests.AddCompanySavedPaymentMethodRequestDto): Promise<m.Envelope<m.Settings.Viewmodels.CompanyPaymentMethodViewModel, m.SimpleError>> {
				return Client.post(`/${org}/Settings/Company/AddSavedPaymentMethod`, request);
			}
		}
		export namespace EditCompanyVatSetting {
			export function Post(org: string, request: m.Settings.Requests.EditCompanyVatSettingRequestDto): Promise<m.Envelope<boolean, m.Bokio.Accounting.Contract.Errors.VatSettingValidationError>> {
				return Client.post(`/${org}/Settings/Company/EditCompanyVatSetting`, request)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Error.DateRanges.Start"}, {"type":"Day","key":"Error.DateRanges.End"}, {"type":"Day","key":"Error.LatestVatSettingStartDate"}, {"type":"Day","key":"Error.FirstFiscalYearStartDate"}, {"type":"Day","key":"Error.DateAfterWhichAllowed"}));
			}
		}
		export namespace EditSavedPaymentMethod {
			export function Post(org: string, request: m.Settings.Requests.EditCompanySavedPaymentMethodRequestDto): Promise<m.Envelope<m.Settings.Viewmodels.CompanyPaymentMethodViewModel, m.SimpleError>> {
				return Client.post(`/${org}/Settings/Company/EditSavedPaymentMethod`, request);
			}
		}
		export namespace Get2 {
			export function Get(org: string): Promise<m.Settings.Viewmodels.CompanyViewModel> {
				return Client.get(`/${org}/Settings/Company/Get2`)
				             .then(data => convertByKeys(data, {"type":"CountrySubdivision","key":"SenderData.CountrySubdivision"}));
			}
		}
		export namespace GetCompanyVatSetting {
			export function Get(org: string, settingId: string): Promise<m.Envelope<m.Core.ViewData.CompanyVatSettingDto, m.SimpleError>> {
				return Client.get(`/${org}/Settings/Company/GetCompanyVatSetting`, { settingId })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.StartDate"}, {"type":"Day","key":"Data.EndDate"}));
			}
		}
		export namespace GetSavedPaymentMethods {
			export function Get(org: string): Promise<m.Envelope<m.Settings.Viewmodels.CompanyPaymentMethodViewModel[], m.SimpleError>> {
				return Client.get(`/${org}/Settings/Company/GetSavedPaymentMethods`);
			}
		}
		export namespace ListVatSettings {
			export function Get(org: string): Promise<m.Envelope<m.Core.ViewData.CompanyVatSettingDto[], m.SimpleError>> {
				return Client.get(`/${org}/Settings/Company/ListVatSettings`)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.StartDate"}, {"type":"Day","key":"Data.EndDate"}));
			}
		}
		export namespace RemoveAgencyFromCompany {
			export function Delete(org: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client._delete(`/${org}/Settings/Company/RemoveAgencyFromCompany`, {  });
			}
		}
		export namespace RemoveCompanyVatSetting {
			export function Post(org: string, request: m.Settings.Requests.RemoveCompanyVatSettingRequestDto): Promise<m.Envelope<boolean, m.Bokio.Accounting.Contract.Errors.VatSettingValidationError>> {
				return Client.post(`/${org}/Settings/Company/RemoveCompanyVatSetting`, request)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Error.DateRanges.Start"}, {"type":"Day","key":"Error.DateRanges.End"}, {"type":"Day","key":"Error.LatestVatSettingStartDate"}, {"type":"Day","key":"Error.FirstFiscalYearStartDate"}, {"type":"Day","key":"Error.DateAfterWhichAllowed"}));
			}
		}
		export namespace SetAccountingMethod {
			export function Post(org: string, request: m.Settings.Requests.SetAccountingMethodRequestDto): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Settings/Company/SetAccountingMethod`, request);
			}
		}
		export namespace SetCompanySystem {
			export function Post(org: string, request: m.Settings.ViewModels.SetCompanySystemDto): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Settings/Company/SetCompanySystem`, request);
			}
		}
		export namespace SetCompanyType {
			export function Post(org: string, request: m.Settings.Requests.SetCompanyTypeRequestDto): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Settings/Company/SetCompanyType`, request);
			}
		}
		export namespace SetCountrySubdivision {
			export function Post(org: string, subdivisionCode: CountrySubdivision): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Settings/Company/SetCountrySubdivision`, { subdivisionCode });
			}
		}
		export namespace SetNewVatSetting {
			export function Post(org: string, request: m.Settings.Requests.SetNewCompanyVatSettingRequestDto): Promise<m.Envelope<boolean, m.Bokio.Accounting.Contract.Errors.VatSettingValidationError>> {
				return Client.post(`/${org}/Settings/Company/SetNewVatSetting`, request)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Error.DateRanges.Start"}, {"type":"Day","key":"Error.DateRanges.End"}, {"type":"Day","key":"Error.LatestVatSettingStartDate"}, {"type":"Day","key":"Error.FirstFiscalYearStartDate"}, {"type":"Day","key":"Error.DateAfterWhichAllowed"}));
			}
		}
		export namespace UpdateSenderData {
			export function Post(org: string, request: m.Settings.Requests.SetSenderDataRequestDto): Promise<m.Envelope<m.Settings.Viewmodels.CompanyViewModel, m.Settings.Controllers.UpdateSenderDataError>> {
				return Client.post(`/${org}/Settings/Company/UpdateSenderData`, request)
				             .then(data => convertByKeys(data, {"type":"CountrySubdivision","key":"Data.SenderData.CountrySubdivision"}));
			}
		}
		export namespace UpdateVatRegistrationNumber {
			export function Post(org: string, newVatRegistrationNumber: string): Promise<m.Envelope<m.Settings.Viewmodels.CompanyViewModel, m.SimpleError>> {
				return Client.post(`/${org}/Settings/Company/UpdateVatRegistrationNumber`, { newVatRegistrationNumber })
				             .then(data => convertByKeys(data, {"type":"CountrySubdivision","key":"Data.SenderData.CountrySubdivision"}));
			}
		}
	}
	export namespace CompanyDataStorageSettingsController {
		export namespace GetDataStorageSettingsForAllOwnedCompanies {
			export function Get(): Promise<m.Envelope<m.Bokio.Backbone.Web.Controllers.Settings.CompanyDataStorageSettingDto[], m.SimpleError>> {
				return Client.get("/Settings/CompanyDataStorageSettings/GetDataStorageSettingsForAllOwnedCompanies");
			}
		}
		export namespace SaveCompanyDataStorageSetting {
			export function Post(request: m.Bokio.Backbone.Web.Controllers.Settings.SaveCompanyDataStorageSettingRequest): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post("/Settings/CompanyDataStorageSettings/SaveCompanyDataStorageSetting", request);
			}
		}
	}
	export namespace CompanyDraftController {
		export namespace Create {
			export function Post(request: m.Settings.Controllers.CreateCompanyDraftRequest): Promise<m.Envelope<m.Core.Services.CompanyDrafts.CompanyDraftForView, m.SimpleError>> {
				return Client.post("/Settings/CompanyDraft/Create", request)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.StartDate"}, {"type":"Day","key":"Data.EndDate"}, {"type":"Day","key":"Data.StartedAt"}, {"type":"Day","key":"Data.ActiveFiscalFromSearch.StartDate"}, {"type":"Day","key":"Data.ActiveFiscalFromSearch.EndDate"}));
			}
		}
		export namespace CreateTestCompanyFromCompany {
			export function Post(org: string, dto: m.Settings.Controllers.SetupTestCompanyThroughPortalDto): Promise<m.Envelope<string, m.Settings.Controllers.CompanyDraftGenericError>> {
				return Client.post(`/${org}/Settings/CompanyDraft/CreateTestCompanyFromCompany`, dto);
			}
		}
		export namespace EditClientCompanyOwner {
			export function Post(id: string, dto: m.Settings.Controllers.EditClientCompanyOwnerDto): Promise<m.Envelope<boolean, m.Settings.Controllers.CompanyDraftGenericError>> {
				return Client.post(`/Settings/CompanyDraft/EditClientCompanyOwner/${id}`, dto);
			}
		}
		export namespace Get {
			export function Get(id: string): Promise<m.Envelope<m.Core.Services.CompanyDrafts.CompanyDraftForView, m.SimpleError>> {
				return Client.get(`/Settings/CompanyDraft/Get/${id}`)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.StartDate"}, {"type":"Day","key":"Data.EndDate"}, {"type":"Day","key":"Data.StartedAt"}, {"type":"Day","key":"Data.ActiveFiscalFromSearch.StartDate"}, {"type":"Day","key":"Data.ActiveFiscalFromSearch.EndDate"}));
			}
		}
		export namespace GetLatestDraftId {
			export function Get(): Promise<m.Envelope<string, m.SimpleError>> {
				return Client.get("/Settings/CompanyDraft/GetLatestDraftId");
			}
		}
		export namespace PickCompany {
			export function Post(id: string, dto: m.Settings.Controllers.PickCompanyDto): Promise<m.Envelope<m.Core.Services.CompanyDrafts.CompanyDraftForView, m.Settings.Controllers.CompanyDraftGenericError>> {
				return Client.post(`/Settings/CompanyDraft/PickCompany/${id}`, dto)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.StartDate"}, {"type":"Day","key":"Data.EndDate"}, {"type":"Day","key":"Data.StartedAt"}, {"type":"Day","key":"Data.ActiveFiscalFromSearch.StartDate"}, {"type":"Day","key":"Data.ActiveFiscalFromSearch.EndDate"}));
			}
		}
		export namespace RegisterSearchCompany {
			export function Post(id: string, dto: m.Settings.Controllers.RegisterSearchDto): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/Settings/CompanyDraft/RegisterSearchCompany/${id}`, dto);
			}
		}
		export namespace RemoveCompanyDraft {
			export function Delete(id: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client._delete(`/Settings/CompanyDraft/RemoveCompanyDraft/${id}`, {  });
			}
		}
		export namespace ResetCompanyDraft {
			export function Post(id: string): Promise<m.Envelope<m.Core.Services.CompanyDrafts.CompanyDraftForView, m.Settings.Controllers.CompanyDraftGenericError>> {
				return Client.post(`/Settings/CompanyDraft/ResetCompanyDraft/${id}`, {  })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.StartDate"}, {"type":"Day","key":"Data.EndDate"}, {"type":"Day","key":"Data.StartedAt"}, {"type":"Day","key":"Data.ActiveFiscalFromSearch.StartDate"}, {"type":"Day","key":"Data.ActiveFiscalFromSearch.EndDate"}));
			}
		}
		export namespace SetAccountingDetails {
			export function Post(id: string, dto: m.Settings.Controllers.AccountingDetailsDto): Promise<m.Envelope<m.Core.Services.CompanyDrafts.CompanyDraftForView, m.Settings.Controllers.SetAccountDetailsError[]>> {
				return Client.post(`/Settings/CompanyDraft/SetAccountingDetails/${id}`, dto)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.StartDate"}, {"type":"Day","key":"Data.EndDate"}, {"type":"Day","key":"Data.StartedAt"}, {"type":"Day","key":"Data.ActiveFiscalFromSearch.StartDate"}, {"type":"Day","key":"Data.ActiveFiscalFromSearch.EndDate"}));
			}
		}
		export namespace SetAndInviteClientCompanyOwner {
			export function Post(id: string, request: m.Bokio.Common.Contract.CompanyDrafts.Dtos.ClientOwnershipDto): Promise<m.Envelope<m.Core.Services.CompanyDrafts.CompanyDraftForView, m.Settings.Controllers.CompanyDraftGenericError>> {
				return Client.post(`/Settings/CompanyDraft/SetAndInviteClientCompanyOwner/${id}`, request)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.StartDate"}, {"type":"Day","key":"Data.EndDate"}, {"type":"Day","key":"Data.StartedAt"}, {"type":"Day","key":"Data.ActiveFiscalFromSearch.StartDate"}, {"type":"Day","key":"Data.ActiveFiscalFromSearch.EndDate"}));
			}
		}
		export namespace SetCompanyDetails {
			export function Post(id: string, dto: m.Settings.Controllers.SetCompanyDetailsDto): Promise<m.Envelope<m.Core.Services.CompanyDrafts.CompanyDraftForView, m.Settings.Controllers.CompanyDraftGenericError>> {
				return Client.post(`/Settings/CompanyDraft/SetCompanyDetails/${id}`, dto)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.StartDate"}, {"type":"Day","key":"Data.EndDate"}, {"type":"Day","key":"Data.StartedAt"}, {"type":"Day","key":"Data.ActiveFiscalFromSearch.StartDate"}, {"type":"Day","key":"Data.ActiveFiscalFromSearch.EndDate"}));
			}
		}
		export namespace SetRegistrationDate {
			export function Post(id: string, dto: m.Settings.Controllers.SetRegistrationDateDto): Promise<m.Envelope<m.Core.Services.CompanyDrafts.CompanyDraftForView, m.Settings.Controllers.SetRegistrationDateError>> {
				return Client.post(`/Settings/CompanyDraft/SetRegistrationDate/${id}`, dto)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.StartDate"}, {"type":"Day","key":"Data.EndDate"}, {"type":"Day","key":"Data.StartedAt"}, {"type":"Day","key":"Data.ActiveFiscalFromSearch.StartDate"}, {"type":"Day","key":"Data.ActiveFiscalFromSearch.EndDate"}));
			}
		}
		export namespace SetType {
			export function Post(id: string, dto: m.Settings.Controllers.SetTypeDto): Promise<m.Envelope<m.Core.Services.CompanyDrafts.CompanyDraftForView, m.Settings.Controllers.CompanyDraftGenericError>> {
				return Client.post(`/Settings/CompanyDraft/SetType/${id}`, dto)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.StartDate"}, {"type":"Day","key":"Data.EndDate"}, {"type":"Day","key":"Data.StartedAt"}, {"type":"Day","key":"Data.ActiveFiscalFromSearch.StartDate"}, {"type":"Day","key":"Data.ActiveFiscalFromSearch.EndDate"}));
			}
		}
		export namespace SetupAgencyClientTestCompany {
			export function Post(dto: m.Settings.Controllers.SetupAgencyTestCompanyDto): Promise<m.Envelope<m.Core.Services.CompanyDrafts.CompanyDraftForView, m.Settings.Controllers.CompanyDraftGenericError>> {
				return Client.post("/Settings/CompanyDraft/SetupAgencyClientTestCompany", dto)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.StartDate"}, {"type":"Day","key":"Data.EndDate"}, {"type":"Day","key":"Data.StartedAt"}, {"type":"Day","key":"Data.ActiveFiscalFromSearch.StartDate"}, {"type":"Day","key":"Data.ActiveFiscalFromSearch.EndDate"}));
			}
		}
		export namespace SetupTestCompany {
			export function Post(id: string, dto: m.Settings.Controllers.SetupTestCompanyDto): Promise<m.Envelope<m.Core.Services.CompanyDrafts.CompanyDraftForView, m.Settings.Controllers.CompanyDraftGenericError>> {
				return Client.post(`/Settings/CompanyDraft/SetupTestCompany/${id}`, dto)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.StartDate"}, {"type":"Day","key":"Data.EndDate"}, {"type":"Day","key":"Data.StartedAt"}, {"type":"Day","key":"Data.ActiveFiscalFromSearch.StartDate"}, {"type":"Day","key":"Data.ActiveFiscalFromSearch.EndDate"}));
			}
		}
	}
	export namespace ConversionBalancesController {
		export namespace Get {
			export function Get(org: string): Promise<m.Envelope<m.Settings.Viewmodels.ConversionBalancesForView, m.Settings.Controllers.ConversionBalanceErrors>> {
				return Client.get(`/${org}/Settings/ConversionBalances/Get`)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.ConversionDate"}));
			}
		}
		export namespace SetConversionBalances {
			export function Post(org: string, conversionBalances: m.Model.Commands.Accounting.Imports.ConversionBalance[], conversionDate: Day): Promise<m.Envelope<string, m.Settings.Controllers.ConversionBalanceErrors>> {
				return Client.post(`/${org}/Settings/ConversionBalances/SetConversionBalances`, { conversionBalances, conversionDate });
			}
		}
	}
	export namespace DisconnectCompanyController {
		export namespace CanDelete {
			export function Get(org: string): Promise<m.Envelope<m.Settings.Controllers.RequiredDeleteCompanyActionDto[], m.SimpleError>> {
				return Client.get(`/${org}/Settings/DisconnectCompany/CanDelete`);
			}
		}
		export namespace CanLeave {
			export function Get(org: string): Promise<m.Envelope<m.Settings.Controllers.CanLeaveCompanyDto, m.SimpleError>> {
				return Client.get(`/${org}/Settings/DisconnectCompany/CanLeave`);
			}
		}
		export namespace DeleteCompany {
			export function Post(org: string, feedback: m.Settings.ViewModels.ExitFeedbackDto, request: m.Model.Commands.Settings.DeleteCompany): Promise<m.Envelope<m.Bokio.Utils.RecentLoginProtectedResult<boolean>, m.SimpleError>> {
				return Client.post(`/${org}/Settings/DisconnectCompany/DeleteCompany`, { feedback, request });
			}
		}
		export namespace LeaveCompany {
			export function Post(org: string, feedback: m.Settings.ViewModels.ExitFeedbackDto, request: m.Model.Commands.Settings.LeaveCompany): Promise<m.Envelope<m.Bokio.Utils.RecentLoginProtectedResult<boolean>, m.SimpleError>> {
				return Client.post(`/${org}/Settings/DisconnectCompany/LeaveCompany`, { feedback, request });
			}
		}
	}
	export namespace ExportCompanyController {
		export namespace AddExportReason2 {
			export function Post(org: string, request: m.Model.Commands.Settings.AddExportReason): Promise<boolean> {
				return Client.post(`/${org}/Settings/ExportCompany/AddExportReason2`, request);
			}
		}
		export namespace ListYears {
			export function Get(org: string): Promise<m.Settings.Controllers.ExportYearsViewModel[]> {
				return Client.get(`/${org}/Settings/ExportCompany/ListYears`)
				             .then(data => convertByKeys(data, {"type":"Day","key":"StartDate"}, {"type":"Day","key":"EndDate"}));
			}
		}
	}
	export namespace FeatureToggleController {
		export namespace List {
			export function Get(org: string): Promise<m.Core.Services.FeatureToggles.FeatureToggleViewModel[]> {
				return Client.get(`/${org}/Settings/FeatureToggle/List`)
				             .then(data => convertByKeys(data, {"type":"Date","key":"AlwaysEnabledFromDateTimeUtc"}));
			}
		}
		export namespace Toggle {
			export function Post(org: string, request: m.Core.Services.FeatureToggles.ToggleFeatureDto): Promise<m.Core.Services.FeatureToggles.FeatureToggleViewModel[]> {
				return Client.post(`/${org}/Settings/FeatureToggle/Toggle`, request)
				             .then(data => convertByKeys(data, {"type":"Date","key":"AlwaysEnabledFromDateTimeUtc"}));
			}
		}
	}
	export namespace HelpController {
		export namespace Categories {
			export function Get(): Promise<m.Envelope<{ [key: string]: string; }, m.SimpleError>> {
				return Client.get("/Settings/Help/Categories");
			}
		}
		export namespace Create {
			export function Post(org: string, request: m.Contracts.HelpRequest, files: (File | Blob | string)[]): Promise<m.Envelope<m.Settings.Controllers.HelpCreateResult, m.SimpleError>> {
				const form = new FormData();
				form.append("request", JSON.stringify(request));
				files.forEach(item => form.append("files", item));
				return Client.post(`/${org}/Settings/Help/Create`, form, true);
			}
		}
		export namespace CreateNotAuthenticated {
			export function Post(request: m.Contracts.HelpRequest, files: (File | Blob | string)[]): Promise<m.Envelope<m.Settings.Controllers.HelpCreateResult, m.SimpleError>> {
				const form = new FormData();
				form.append("request", JSON.stringify(request));
				files.forEach(item => form.append("files", item));
				return Client.post("/Settings/Help/CreateNotAuthenticated", form, true);
			}
		}
		export namespace GetLiveChatInfo {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Integration.HubSpot.LiveChatInfo, m.SimpleError>> {
				return Client.get(`/${org}/Settings/Help/GetLiveChatInfo`);
			}
		}
		export namespace IsRequestCallFeatureEnabled {
			export function Get(): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.get("/Settings/Help/IsRequestCallFeatureEnabled");
			}
		}
		export namespace SupportCategories {
			export function Get(request: m.Contracts.GetSupportCategoriesRequest): Promise<m.Envelope<m.Contracts.SupportMessageCategories, m.SimpleError>> {
				return Client.get("/Settings/Help/SupportCategories", { request });
			}
		}
	}
	export namespace ImportBookkeepingStateController {
		export namespace AccountantStepDone {
			export function Post(org: string): Promise<m.Envelope<m.Bokio.Accounting.Web.Settings.Controllers.BookkeepingImportStateVM, m.SimpleError>> {
				return Client.post(`/${org}/Settings/ImportBookkeepingState/AccountantStepDone`, {  });
			}
		}
		export namespace Get {
			export function Get(org: string, createIfNotExists: boolean): Promise<m.Envelope<m.Bokio.Accounting.Web.Settings.Controllers.BookkeepingImportStateVM, m.SimpleError>> {
				return Client.get(`/${org}/Settings/ImportBookkeepingState/Get`, { createIfNotExists });
			}
		}
		export namespace GoBack {
			export function Post(org: string): Promise<m.Envelope<m.Bokio.Accounting.Web.Settings.Controllers.BookkeepingImportStateVM, m.SimpleError>> {
				return Client.post(`/${org}/Settings/ImportBookkeepingState/GoBack`, {  });
			}
		}
		export namespace SetImportMethod {
			export function Post(org: string, dto: m.Bokio.Accounting.Web.Settings.Controllers.SaveCompanyImportMethodDto): Promise<m.Envelope<m.Bokio.Accounting.Web.Settings.Controllers.BookkeepingImportStateVM, m.SimpleError>> {
				return Client.post(`/${org}/Settings/ImportBookkeepingState/SetImportMethod`, dto);
			}
		}
		export namespace SetPreviousBookkeepingMethod {
			export function Post(org: string, dto: m.Bokio.Accounting.Web.Settings.Controllers.SavePreviousBookkeepingMethodDto): Promise<m.Envelope<m.Bokio.Accounting.Web.Settings.Controllers.BookkeepingImportStateVM, m.SimpleError>> {
				return Client.post(`/${org}/Settings/ImportBookkeepingState/SetPreviousBookkeepingMethod`, dto);
			}
		}
		export namespace SetPreviousBookkeepingTool {
			export function Post(org: string, dto: m.Bokio.Accounting.Web.Settings.Controllers.SavePreviousBookkeepingToolDto): Promise<m.Envelope<m.Bokio.Accounting.Web.Settings.Controllers.BookkeepingImportStateVM, m.SimpleError>> {
				return Client.post(`/${org}/Settings/ImportBookkeepingState/SetPreviousBookkeepingTool`, dto);
			}
		}
		export namespace Skip {
			export function Post(org: string): Promise<m.Envelope<m.Bokio.Accounting.Web.Settings.Controllers.BookkeepingImportStateVM, m.SimpleError>> {
				return Client.post(`/${org}/Settings/ImportBookkeepingState/Skip`, {  });
			}
		}
	}
	export namespace ImportCompanyController {
		export namespace Abandon2 {
			export function Post(org: string): Promise<m.Envelope<m.Settings.Controllers.ImportResult, m.SimpleError>> {
				return Client.post(`/${org}/Settings/ImportCompany/Abandon2`, {  });
			}
		}
		export namespace ImportYears {
			export function Post(org: string, request: m.Bokio.Accounting.Web.Settings.Models.ImportYearsDto): Promise<m.Envelope<m.Settings.Controllers.ImportYearsResult, m.Settings.Controllers.ImportYearsError>> {
				return Client.post(`/${org}/Settings/ImportCompany/ImportYears`, request);
			}
		}
		export namespace UploadFile2 {
			export function Post(org: string, files: (File | Blob | string)[]): Promise<m.Envelope<m.Settings.Controllers.UploadedFileAndConfirmDto, m.Settings.Controllers.UploadedFileError>> {
				const form = new FormData();
				files.forEach(item => form.append("files", item));
				return Client.post(`/${org}/Settings/ImportCompany/UploadFile2`, form, true)
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.Spec.Years.FiscalYear.StartDate"}, {"type":"Day","key":"Data.Spec.Years.FiscalYear.EndDate"}, {"type":"Day","key":"Data.Spec.Years.Verifications.Verification.Date"}, {"type":"Day","key":"Data.Spec.Years.Verifications.Verification.ExpectPaymentAt"}, {"type":"Date","key":"Data.Spec.Years.Verifications.Verification.CreatedUtc"}, {"type":"Day","key":"Data.Spec.Years.FaultyVerifications.Date"}, {"type":"Day","key":"Data.Spec.Years.Setting.FiscalYear.StartDate"}, {"type":"Day","key":"Data.Spec.Years.Setting.FiscalYear.EndDate"}, {"type":"Day","key":"Data.Spec.Years.IgnoredVerifications.Verification.Date"}, {"type":"Day","key":"Data.Spec.Years.IgnoredVerifications.Verification.ExpectPaymentAt"}, {"type":"Date","key":"Data.Spec.Years.IgnoredVerifications.Verification.CreatedUtc"}, {"type":"Date","key":"Data.Spec.FiscalYearMismatches.FirstYearEndDate"}, {"type":"Date","key":"Data.Spec.FiscalYearMismatches.SecondYearStartDate"}, {"type":"Day","key":"Data.Spec.AccountsToAdd.Settings.FiscalYear.StartDate"}, {"type":"Day","key":"Data.Spec.AccountsToAdd.Settings.FiscalYear.EndDate"}, {"type":"Day","key":"Data.Spec.FiscalYearsNeedingToBeOpened.StartDate"}, {"type":"Day","key":"Data.Spec.FiscalYearsNeedingToBeOpened.EndDate"}));
			}
		}
		export namespace Verify2 {
			export function Post(org: string): Promise<m.Envelope<m.Settings.Controllers.ImportResult2, m.SimpleError>> {
				return Client.post(`/${org}/Settings/ImportCompany/Verify2`, {  })
				             .then(data => convertByKeys(data, {"type":"Day","key":"Data.ImportSpec.Years.FiscalYear.StartDate"}, {"type":"Day","key":"Data.ImportSpec.Years.FiscalYear.EndDate"}, {"type":"Day","key":"Data.ImportSpec.Years.Verifications.Verification.Date"}, {"type":"Day","key":"Data.ImportSpec.Years.Verifications.Verification.ExpectPaymentAt"}, {"type":"Date","key":"Data.ImportSpec.Years.Verifications.Verification.CreatedUtc"}, {"type":"Day","key":"Data.ImportSpec.Years.FaultyVerifications.Date"}, {"type":"Day","key":"Data.ImportSpec.Years.Setting.FiscalYear.StartDate"}, {"type":"Day","key":"Data.ImportSpec.Years.Setting.FiscalYear.EndDate"}, {"type":"Day","key":"Data.ImportSpec.Years.IgnoredVerifications.Verification.Date"}, {"type":"Day","key":"Data.ImportSpec.Years.IgnoredVerifications.Verification.ExpectPaymentAt"}, {"type":"Date","key":"Data.ImportSpec.Years.IgnoredVerifications.Verification.CreatedUtc"}, {"type":"Date","key":"Data.ImportSpec.FiscalYearMismatches.FirstYearEndDate"}, {"type":"Date","key":"Data.ImportSpec.FiscalYearMismatches.SecondYearStartDate"}, {"type":"Day","key":"Data.ImportSpec.AccountsToAdd.Settings.FiscalYear.StartDate"}, {"type":"Day","key":"Data.ImportSpec.AccountsToAdd.Settings.FiscalYear.EndDate"}, {"type":"Day","key":"Data.ImportSpec.FiscalYearsNeedingToBeOpened.StartDate"}, {"type":"Day","key":"Data.ImportSpec.FiscalYearsNeedingToBeOpened.EndDate"}));
			}
		}
	}
	export namespace InboxController {
		export namespace AddToWhitelist {
			export function Post(org: string, request: m.Settings.Requests.AddToInboxWhitelistRequestDto): Promise<m.Bokio.Services.Inboxes.InboxStateDto> {
				return Client.post(`/${org}/Settings/Inbox/AddToWhitelist`, request)
				             .then(data => convertByKeys(data, {"type":"Date","key":"Inbox.Whitelist.Timestamp"}, {"type":"Date","key":"Inbox.OwnerGroupedWhiteList.WhitelistItems.Timestamp"}));
			}
		}
		export namespace Create {
			export function Post(org: string, request: m.Settings.Requests.CreateInboxRequestDto): Promise<m.Bokio.Services.Inboxes.InboxStateDto> {
				return Client.post(`/${org}/Settings/Inbox/Create`, request)
				             .then(data => convertByKeys(data, {"type":"Date","key":"Inbox.Whitelist.Timestamp"}, {"type":"Date","key":"Inbox.OwnerGroupedWhiteList.WhitelistItems.Timestamp"}));
			}
		}
		export namespace Delete {
			export function Post(org: string, request: m.Settings.Requests.DeleteInboxRequestDto): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Settings/Inbox/Delete`, request);
			}
		}
		export namespace InboxesOrDefault {
			export function Get(org: string): Promise<m.Bokio.Services.Inboxes.InboxDto[]> {
				return Client.get(`/${org}/Settings/Inbox/InboxesOrDefault`)
				             .then(data => convertByKeys(data, {"type":"Date","key":"Whitelist.Timestamp"}, {"type":"Date","key":"OwnerGroupedWhiteList.WhitelistItems.Timestamp"}));
			}
		}
		export namespace RemoveFromWhitelist {
			export function Post(org: string, request: m.Settings.Requests.RemoveFromInboxWhitelistRequestDto): Promise<m.Bokio.Services.Inboxes.InboxStateDto> {
				return Client.post(`/${org}/Settings/Inbox/RemoveFromWhitelist`, request)
				             .then(data => convertByKeys(data, {"type":"Date","key":"Inbox.Whitelist.Timestamp"}, {"type":"Date","key":"Inbox.OwnerGroupedWhiteList.WhitelistItems.Timestamp"}));
			}
		}
		export namespace SetFraudThreshold {
			export function Post(org: string, request: m.Settings.Requests.SetSenderFraudThresholdRequestDto): Promise<m.Bokio.Services.Inboxes.InboxStateDto> {
				return Client.post(`/${org}/Settings/Inbox/SetFraudThreshold`, request)
				             .then(data => convertByKeys(data, {"type":"Date","key":"Inbox.Whitelist.Timestamp"}, {"type":"Date","key":"Inbox.OwnerGroupedWhiteList.WhitelistItems.Timestamp"}));
			}
		}
		export namespace Update {
			export function Post(org: string, request: m.Settings.Requests.UpdateInboxRequestDto): Promise<m.Envelope<m.Bokio.Services.Inboxes.InboxStateDto, m.Bokio.Services.Inboxes.UpdateInboxError>> {
				return Client.post(`/${org}/Settings/Inbox/Update`, request)
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.Inbox.Whitelist.Timestamp"}, {"type":"Date","key":"Data.Inbox.OwnerGroupedWhiteList.WhitelistItems.Timestamp"}));
			}
		}
	}
	export namespace MoneyAccountsController {
		export namespace GetManualImportableMoneyAccounts {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Bank.Contract.MoneyAccount.MoneyAccountForView[], m.SimpleError>> {
				return Client.get(`/${org}/Settings/MoneyAccounts/GetManualImportableMoneyAccounts`);
			}
		}
		export namespace GetMoneyAccounts {
			export function Get(org: string): Promise<m.Envelope<m.Settings.Viewmodels.MoneyAccountsViewModel, m.SimpleError>> {
				return Client.get(`/${org}/Settings/MoneyAccounts/GetMoneyAccounts`);
			}
		}
		export namespace UpdateMoneyAccounts {
			export function Post(org: string, request: m.Settings.Models.UpdateMoneyAccountRequest): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Settings/MoneyAccounts/UpdateMoneyAccounts`, request);
			}
		}
	}
	export namespace PrivacySettingsController {
		export namespace SetTrackingPreference {
			export function Post(value: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(Client.getPathWithQueryString("/Settings/PrivacySettings/SetTrackingPreference", { value }), {  });
			}
		}
	}
	export namespace StatusController {
		export namespace FeatureAvailability {
			export function Get(org: string): Promise<m.Envelope<m.Config.FeatureAvailabilityConfig, m.SimpleError>> {
				return Client.get(`/${org}/Settings/Status/FeatureAvailability`);
			}
		}
		export namespace FiscalYears {
			export function Get(org: string): Promise<m.Settings.Controllers.FiscalYearAndAccountingType[]> {
				return Client.get(`/${org}/Settings/Status/FiscalYears`)
				             .then(data => convertByKeys(data, {"type":"Day","key":"FiscalYear.StartDate"}, {"type":"Day","key":"FiscalYear.EndDate"}));
			}
		}
		export namespace Get {
			export function Get(org: string): Promise<m.Settings.Controllers.StatusDto> {
				return Client.get(`/${org}/Settings/Status/Get`)
				             .then(data => convertByKeys(data, {"type":"CountryCode","key":"Company.Country"}, {"type":"CountrySubdivision","key":"Company.CountrySubdivision"}, {"type":"Day","key":"Company.CompanyVatSettings.StartDate"}, {"type":"Day","key":"Company.CompanyVatSettings.EndDate"}, {"type":"Date","key":"Company.RegisteredUtc"}, {"type":"Date","key":"Company.StartFirstFiscalYear"}, {"type":"CountryCode","key":"Company.CountryMetadata.CountryCode"}, {"type":"Date","key":"Company.ActiveBankConnections.KycInformation.Date"}, {"type":"Date","key":"EmailConfirmedUtc"}));
			}
		}
		export namespace Memberships {
			export function Get(): Promise<m.SettingsNoConflict.ViewModels.CompanyMembershipDto[]> {
				return Client.get("/Settings/Status/Memberships");
			}
		}
		export namespace PartnerMemberships {
			export function Get(): Promise<m.Settings.Controllers.PartnerMembershipDto[]> {
				return Client.get("/Settings/Status/PartnerMemberships");
			}
		}
	}
	export namespace SupportMessagesController {
		export namespace Approve {
			export function Post(org: string, supportMessageId: string): Promise<m.Envelope<m.Bokio.Utils.RecentLoginProtectedResult<boolean>, m.SimpleError>> {
				return Client.post(`/${org}/Settings/SupportMessages/Approve`, { supportMessageId });
			}
		}
		export namespace Dismiss {
			export function Post(org: string, supportMessageId: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Settings/SupportMessages/Dismiss`, { supportMessageId });
			}
		}
		export namespace Index {
			export function Get(org: string, onlyBlocking?: boolean): Promise<m.Envelope<m.Bokio.Common.Contract.ViewData.SupportMessageActiveDto[], m.SimpleError>> {
				return Client.get(`/${org}/Settings/SupportMessages`, { onlyBlocking })
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.CreatedAt"}));
			}
		}
		export namespace Reactivate {
			export function Post(org: string, supportMessageId: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Settings/SupportMessages/Reactivate`, { supportMessageId });
			}
		}
		export namespace Reject {
			export function Post(org: string, supportMessageId: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Settings/SupportMessages/Reject`, { supportMessageId });
			}
		}
		export namespace Resolve {
			export function Post(org: string, supportMessageId: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Settings/SupportMessages/Resolve`, { supportMessageId });
			}
		}
		export namespace Resolved {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Common.Contract.ViewData.SupportMessageResolvedDto[], m.SimpleError>> {
				return Client.get(`/${org}/Settings/SupportMessages/Resolved`)
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.ResolvedAt"}, {"type":"Date","key":"Data.CreatedAt"}));
			}
		}
	}
	export namespace TagTypeController {
		export namespace AddAllowedValue {
			export function Post(org: string, dto: m.Bokio.Backbone.Web.Controllers.Settings.AddAllowedTagTypeValueDto): Promise<m.Envelope<boolean, m.Bokio.Backbone.Web.Controllers.Settings.EditAllowedTagTypeValueError>> {
				return Client.post(`/${org}/Settings/TagType/AddAllowedValue`, dto);
			}
		}
		export namespace AddTagType {
			export function Post(org: string, dto: m.Bokio.Backbone.Web.Controllers.Settings.CreateTagTypeDto): Promise<m.Envelope<string, m.Bokio.Backbone.Web.Controllers.Settings.EditTagTypeError>> {
				return Client.post(`/${org}/Settings/TagType/AddTagType`, dto);
			}
		}
		export namespace DeleteAllowedValue {
			export function Post(org: string, dto: m.Bokio.Backbone.Web.Controllers.Settings.DeleteAllowedTagTypeValueDto): Promise<m.Envelope<boolean, m.Bokio.Backbone.Web.Controllers.Settings.DeleteAllowedTagTypeValueError>> {
				return Client.post(`/${org}/Settings/TagType/DeleteAllowedValue`, dto);
			}
		}
		export namespace DeleteTagType {
			export function Post(org: string, dto: m.Bokio.Backbone.Web.Controllers.Settings.DeleteTagTypeDto): Promise<m.Envelope<boolean, m.Bokio.Backbone.Web.Controllers.Settings.DeleteTagTypeError>> {
				return Client.post(`/${org}/Settings/TagType/DeleteTagType`, dto);
			}
		}
		export namespace List {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Backbone.Web.Controllers.Settings.TagTypeForListDto[], m.SimpleError>> {
				return Client.get(`/${org}/Settings/TagType/List`);
			}
		}
		export namespace UpdateAllowedValue {
			export function Post(org: string, dto: m.Bokio.Backbone.Web.Controllers.Settings.UpdateAllowedTagTypeValueDto): Promise<m.Envelope<boolean, m.Bokio.Backbone.Web.Controllers.Settings.EditAllowedTagTypeValueError>> {
				return Client.post(`/${org}/Settings/TagType/UpdateAllowedValue`, dto);
			}
		}
		export namespace UpdateTagType {
			export function Post(org: string, dto: m.Bokio.Backbone.Web.Controllers.Settings.UpdateTagTypeDto): Promise<m.Envelope<boolean, m.Bokio.Backbone.Web.Controllers.Settings.EditTagTypeError>> {
				return Client.post(`/${org}/Settings/TagType/UpdateTagType`, dto);
			}
		}
	}
	export namespace TwoFactorSettingsController {
		export namespace ConfirmEnableTOTP {
			export function Post(model: m.Bokio.Services.Account.TOTPEnableCommand): Promise<m.Envelope<boolean, m.Bokio.Services.Account.EnableTotpErrorType>> {
				return Client.post("/Settings/TwoFactorSettings/ConfirmEnableTOTP", model);
			}
		}
		export namespace DisableTOTP {
			export function Post(model: m.Bokio.Services.Account.TOTPDisableCommand): Promise<m.Envelope<boolean, m.Bokio.Services.Account.EnableTotpErrorType>> {
				return Client.post("/Settings/TwoFactorSettings/DisableTOTP", model);
			}
		}
		export namespace HasTwoFactorEnabled {
			export function Get(): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.get("/Settings/TwoFactorSettings/HasTwoFactorEnabled");
			}
		}
		export namespace StartEnableTOTP {
			export function Post(): Promise<m.Envelope<m.Bokio.Services.Account.TOTPEnableViewModel, m.SimpleError>> {
				return Client.post("/Settings/TwoFactorSettings/StartEnableTOTP", {  });
			}
		}
	}
	export namespace UserController {
		export namespace ConfirmUpdateEmail {
			export function Post(requestId: string, secret: string): Promise<m.Envelope<boolean, m.Model.Commands.Settings.UpdateUserEmailError>> {
				return Client.post("/Settings/User/ConfirmUpdateEmail", { requestId, secret });
			}
		}
		export namespace DismissNotification {
			export function Post(request: m.Bokio.Backbone.Web.Controllers.Settings.DismissNotificationRequest): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post("/Settings/User/DismissNotification", request);
			}
		}
		export namespace DoesUserPassCompanySecurityRequirements {
			export function Get(org: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.get(`/${org}/Settings/User/DoesUserPassCompanySecurityRequirements`);
			}
		}
		export namespace Edit {
			export function Post(command: m.Model.Commands.Settings.UpdateUser): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post("/Settings/User/Edit", command);
			}
		}
		export namespace GetUpdateUsernamePreview {
			export function Get(): Promise<m.Envelope<m.Bokio.Backbone.Web.Controllers.Settings.Models.UpdateUsernamePreviewViewModel, m.SimpleError>> {
				return Client.get("/Settings/User/GetUpdateUsernamePreview");
			}
		}
		export namespace GetUserRoles {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Backbone.Web.Controllers.Settings.Models.CompanyUserRolesViewModel, m.SimpleError>> {
				return Client.get(`/${org}/Settings/User/GetUserRoles`);
			}
		}
		export namespace Index {
			export function Get(): Promise<m.Bokio.Backbone.Web.Controllers.Settings.Models.UserViewModel> {
				return Client.get("/Settings/User");
			}
		}
		export namespace MemberedCompanyPlans {
			export function Get(): Promise<m.Envelope<m.Bokio.Common.Contract.ViewData.MemberedCompanyPlanDto[], m.SimpleError>> {
				return Client.get("/Settings/User/MemberedCompanyPlans")
				             .then(data => convertByKeys(data, {"type":"Date","key":"Data.RegisteredUtc"}));
			}
		}
		export namespace UpdateEmail {
			export function Post(newEmail: string): Promise<m.Envelope<m.Bokio.Utils.RecentLoginProtectedResult<string>, m.Model.Commands.Settings.UpdateUserEmailError>> {
				return Client.post("/Settings/User/UpdateEmail", { newEmail });
			}
		}
	}
	export namespace UserFeatureToggleController {
		export namespace List {
			export function Get(): Promise<m.Envelope<m.Bokio.Common.Services.UserFeatureToggles.UserFeatureToggleViewModel[], m.SimpleError>> {
				return Client.get("/Settings/UserFeatureToggle/List");
			}
		}
		export namespace ListForDev {
			export function Get(): Promise<m.Envelope<m.Bokio.Common.Services.UserFeatureToggles.UserFeatureToggleForDevViewModel[], m.SimpleError>> {
				return Client.get("/Settings/UserFeatureToggle/ListForDev");
			}
		}
		export namespace Toggle {
			export function Post(featureKey: m.Entities.UserFeatures, enabled: boolean): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post("/Settings/UserFeatureToggle/Toggle", { featureKey, enabled });
			}
		}
	}
	export namespace UsersController {
		export namespace CancelRequestToAgency {
			export function Delete(org: string, request: m.Bokio.Common.Contract.Requests.Users.CancelRequestToAgencyRequest): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client._delete(`/${org}/Settings/Users/CancelRequestToAgency`, { request });
			}
		}
		export namespace ConnectEmployeeToUser {
			export function Post(org: string, request: m.Settings.Requests.ConnectEmployeeToUserRequestDto): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Settings/Users/ConnectEmployeeToUser`, request);
			}
		}
		export namespace DeleteActiveUsers {
			export function Post(org: string, membershipUserId: string): Promise<m.Envelope<boolean, m.Settings.Controllers.DeleteActiveUserError>> {
				return Client.post(`/${org}/Settings/Users/DeleteActiveUsers`, { membershipUserId });
			}
		}
		export namespace EditAgencyDefaultPermission {
			export function Post(org: string, request: m.Settings.Controllers.EditAgencyDefaultPermissionViewModel): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Settings/Users/EditAgencyDefaultPermission`, request);
			}
		}
		export namespace EditPermission {
			export function Post(org: string, request: m.Settings.Controllers.EditPermissionViewModel): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Settings/Users/EditPermission`, request);
			}
		}
		export namespace GetEligibleOwners {
			export function Get(org: string): Promise<m.Envelope<m.Settings.Controllers.UsersModel, m.SimpleError>> {
				return Client.get(`/${org}/Settings/Users/GetEligibleOwners`);
			}
		}
		export namespace GetRoles {
			export function Get(org: string): Promise<m.Envelope<m.Bokio.Backbone.Web.Controllers.Settings.Models.CompanyUserRolesViewModel, m.SimpleError>> {
				return Client.get(`/${org}/Settings/Users/GetRoles`);
			}
		}
		export namespace InviteAgencyToCompany {
			export function Post(org: string, request: m.Model.Commands.Accounting.CompanyMembershipCommands.InviteAgencyToCompanyRequest): Promise<m.Envelope<string, m.Model.Commands.Settings.InviteAccountantFromAgencyError>> {
				return Client.post(`/${org}/Settings/Users/InviteAgencyToCompany`, request);
			}
		}
		export namespace InviteExpenseUser {
			export function Post(org: string, request: m.Settings.Controllers.CompanyExpenseInvitationRequest): Promise<m.Envelope<m.Settings.ViewModels.InviteViewModel, m.SimpleError>> {
				return Client.post(`/${org}/Settings/Users/InviteExpenseUser`, request);
			}
		}
		export namespace InviteNewAccountantToCompany {
			export function Post(org: string, request: m.Model.Commands.Accounting.CompanyMembershipCommands.InviteNewAccountantToCompanyRequest): Promise<m.Envelope<string, m.SimpleError>> {
				return Client.post(`/${org}/Settings/Users/InviteNewAccountantToCompany`, request);
			}
		}
		export namespace InviteUser {
			export function Post(org: string, request: m.Settings.Controllers.CreateUserInvitationRequest): Promise<m.Envelope<m.Settings.ViewModels.InviteViewModel, m.SimpleError>> {
				return Client.post(`/${org}/Settings/Users/InviteUser`, request);
			}
		}
		export namespace IsUsingUserSeat {
			export function Post(dto: m.Settings.Controllers.IsUsingUserSeatDto): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post("/Settings/Users/IsUsingUserSeat", dto);
			}
		}
		export namespace ListAgencyMemberships {
			export function Get(org: string, email: string): Promise<m.Envelope<m.Settings.Controllers.AllAgencyForView, m.SimpleError>> {
				return Client.get(`/${org}/Settings/Users/ListAgencyMemberships`, { email });
			}
		}
		export namespace RemoveInvite {
			export function Post(org: string, companyInvitationId: string): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Settings/Users/RemoveInvite`, { companyInvitationId });
			}
		}
		export namespace ResendInvitation {
			export function Post(org: string, companyInvitationId: string): Promise<m.Envelope<m.Settings.ViewModels.InviteViewModel, m.SimpleError>> {
				return Client.post(`/${org}/Settings/Users/ResendInvitation`, { companyInvitationId });
			}
		}
		export namespace ResendInviteAgencyToCompany {
			export function Post(org: string, request: m.Settings.Controllers.ResendInviteAgencyToCompanyRequest): Promise<m.Envelope<string, m.Model.Commands.Settings.InviteAccountantFromAgencyError>> {
				return Client.post(`/${org}/Settings/Users/ResendInviteAgencyToCompany`, request);
			}
		}
		export namespace Revoke {
			export function Post(org: string, request: m.Model.Commands.Accounting.CompanyMembershipCommands.RemoveCompanyMembership): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Settings/Users/Revoke`, request);
			}
		}
		export namespace TransferRole {
			export function Post(org: string, role: m.Settings.Requests.TransferRoleRequestDto): Promise<m.Envelope<boolean, m.Settings.Controllers.TransferRoleError>> {
				return Client.post(`/${org}/Settings/Users/TransferRole`, role);
			}
		}
		export namespace UndoConnectEmployeeToUser {
			export function Post(org: string, request: m.Settings.Requests.UndoConnectEmployeeToUserRequestDto): Promise<m.Envelope<boolean, m.SimpleError>> {
				return Client.post(`/${org}/Settings/Users/UndoConnectEmployeeToUser`, request);
			}
		}
		export namespace UserPermissions {
			export function Get(org: string): Promise<m.Envelope<m.Settings.Controllers.UserPermissionModel, m.SimpleError>> {
				return Client.get(`/${org}/Settings/Users/UserPermissions`);
			}
		}
		export namespace UsersToInvite {
			export function Get(org: string): Promise<m.Settings.Controllers.UserToInvite[]> {
				return Client.get(`/${org}/Settings/Users/UsersToInvite`);
			}
		}
	}
}
